export const religious_data = [
  {
   "OBJECTID": 3096,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Beijing",
   "NAME_1": "北京",
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "China. The Association of Religion Data Archives. (2015) http:\/\/www.thearda.com\/internationalData\/countries\/Country_52_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 3097,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "TIanjin",
   "NAME_1": "天津",
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2010
  },
  {
   "OBJECTID": 3098,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Hebei",
   "NAME_1": "河北",
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2010
  },
  {
   "OBJECTID": 3099,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Shanxi",
   "NAME_1": "山西",
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2010
  },
  {
   "OBJECTID": 3100,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Liaoning",
   "NAME_1": "辽宁",
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2010
  },
  {
   "OBJECTID": 3101,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Jilin",
   "NAME_1": "吉林",
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2010
  },
  {
   "OBJECTID": 3102,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Heilongjiang",
   "NAME_1": "黑龙江",
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2010
  },
  {
   "OBJECTID": 3103,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Shanghai",
   "NAME_1": "上海",
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2010
  },
  {
   "OBJECTID": 3104,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Jiangsu",
   "NAME_1": "江苏",
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2010
  },
  {
   "OBJECTID": 3105,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Zhejiang",
   "NAME_1": "浙江",
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2010
  },
  {
   "OBJECTID": 3106,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Anhui",
   "NAME_1": "安徽",
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2010
  },
  {
   "OBJECTID": 3107,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Fujian",
   "NAME_1": "福建",
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2010
  },
  {
   "OBJECTID": 3108,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Jiangxi",
   "NAME_1": "江西",
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2010
  },
  {
   "OBJECTID": 3109,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Shandong",
   "NAME_1": "山东",
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2010
  },
  {
   "OBJECTID": 3110,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Henan",
   "NAME_1": "河南",
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2010
  },
  {
   "OBJECTID": 3111,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Hubei",
   "NAME_1": "湖北",
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2010
  },
  {
   "OBJECTID": 3112,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Hunan",
   "NAME_1": "湖南",
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2010
  },
  {
   "OBJECTID": 3113,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Guangdong",
   "NAME_1": "广东",
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2010
  },
  {
   "OBJECTID": 3114,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Hainan",
   "NAME_1": "海南",
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2010
  },
  {
   "OBJECTID": 3115,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Chongqing",
   "NAME_1": "重庆",
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2010
  },
  {
   "OBJECTID": 3116,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Sichuan",
   "NAME_1": "四川",
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2010
  },
  {
   "OBJECTID": 3117,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Guizhou",
   "NAME_1": "贵州",
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2010
  },
  {
   "OBJECTID": 3118,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Yunnan",
   "NAME_1": "云南",
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2010
  },
  {
   "OBJECTID": 3119,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Shaanxi",
   "NAME_1": "陕西",
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2010
  },
  {
   "OBJECTID": 3120,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Gansu",
   "NAME_1": "甘肃",
   "Ethnic1": "Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "90.57%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/www.gsei.com.cn\/html\/1385\/2016-04-18\/content-65769.html",
   "Year": 2016
  },
  {
   "OBJECTID": 3121,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Qinghai",
   "NAME_1": "青海",
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2010
  },
  {
   "OBJECTID": 3122,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Hong Kong SAR",
   "NAME_1": "香港",
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2010
  },
  {
   "OBJECTID": 3123,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Macau SAR",
   "NAME_1": "澳门",
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2010
  },
  {
   "OBJECTID": 3124,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Inner Mongolia Autonomous Region",
   "NAME_1": "内蒙古自治区",
   "Ethnic1": "Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "79.54 %",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "国务院人口普查办公室、国家统计局人口和就业统计司 (编). 中国统计出版社. [2018-10-27].",
   "Year": 2018
  },
  {
   "OBJECTID": 3125,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Guangxi Zhuang Autonomous Region",
   "NAME_1": "广西壮族自治区",
   "Ethnic1": "Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "61.62 %",
   "Numerical": 70,
   "Ethnic2": "Zhuang",
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "32.4 %",
   "Nummeric_1": 40,
   "DataSource": "http:\/\/www.gxzf.gov.cn\/mlgxi\/gxrw\/ftrq\/t1003601.shtml",
   "Year": 2019
  },
  {
   "OBJECTID": 3126,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Tibet Autonomous Region",
   "NAME_1": "西藏自治区",
   "Ethnic1": "Tibetan",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Tibetan Buddhism)",
   "ReligCatP": "91.83 %",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/www.xizang.gov.cn\/rsxz\/qqjj\/rk\/201812\/t20181219_33388.html",
   "Year": 2019
  },
  {
   "OBJECTID": 3127,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Ningxia Hui Autonomous Region",
   "NAME_1": "宁夏回族自治区",
   "Ethnic1": "Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "63.31 %",
   "Numerical": 70,
   "Ethnic2": "Hui",
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Sunni)",
   "SReligCatp": "36.69 %",
   "Nummeric_1": 40,
   "DataSource": "http:\/\/www.nx.gov.cn\/ssjn\/",
   "Year": 2019
  },
  {
   "OBJECTID": 3128,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Xinjiang Uygur Autonomous Region",
   "NAME_1": "新疆维吾尔自治区",
   "Ethnic1": "Uyghurs",
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "63 %",
   "Numerical": 70,
   "Ethnic2": "Han",
   "SecRelig0": "East Asian Religiosity",
   "SecRelig": "East Asian Religiosity",
   "SReligCatp": "37 %",
   "Nummeric_1": 40,
   "DataSource": "https:\/\/www.xinjiang.gov.cn\/xinjiang\/mzfb\/201912\/0b11b8d2628349928517198e5aca49a5.shtml",
   "Year": 2014
  },
  {
   "OBJECTID": 3129,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Qinglong Manchu Autonomous County",
   "NAME_1": "青龙满族自治县",
   "Ethnic1": "Manchu, Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "61.03 %",
   "Numerical": 70,
   "Ethnic2": "Manchu",
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "27.44 %",
   "Nummeric_1": 30,
   "DataSource": "http:\/\/www.chinaqinglong.gov.cn\/syscolumn\/xq\/qlgk\/index.html",
   "Year": 2019
  },
  {
   "OBJECTID": 3130,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Fengning Manchu Autonomous County",
   "NAME_1": "丰宁满族自治县",
   "Ethnic1": "Manchu, Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "56.57 %",
   "Numerical": 60,
   "Ethnic2": "Manchu",
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "26 %",
   "Nummeric_1": 30,
   "DataSource": "http:\/\/www.fengning.gov.cn\/col\/col3213\/index.html",
   "Year": 2019
  },
  {
   "OBJECTID": 3131,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Kuancheng Manchu Autonomous County",
   "NAME_1": "宽城满族自治县",
   "Ethnic1": "Manchu, Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "64.36 %",
   "Numerical": 70,
   "Ethnic2": "Manchu",
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "25.8 %",
   "Nummeric_1": 30,
   "DataSource": "http:\/\/www.hbkc.gov.cn\/col\/col3676\/index.html",
   "Year": 2019
  },
  {
   "OBJECTID": 3132,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Weichang Manchu and Mongolian Autonomous County",
   "NAME_1": "围场满族蒙古族自治县",
   "Ethnic1": "Manchu, Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "50.04 %",
   "Numerical": 60,
   "Ethnic2": "Mongolian",
   "SecRelig0": "Buddhism",
   "SecRelig": "Buddhists(Tibetan Buddhism)",
   "SReligCatp": "20.41 %",
   "Nummeric_1": 30,
   "DataSource": "https:\/\/baike.baidu.com\/item\/%E5%9B%B4%E5%9C%BA%E6%BB%A1%E6%97%8F%E8%92%99%E5%8F%A4%E6%97%8F%E8%87%AA%E6%B2%BB%E5%8E%BF#4",
   "Year": 2016
  },
  {
   "OBJECTID": 3133,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Mengcun Hui Autonomous County",
   "NAME_1": "孟村回族自治县",
   "Ethnic1": "Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "73.95 %",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "中华人民共和国国家民族事务委员会2018年民族自治地方国民经济与社会发展主要指标",
   "Year": 2018
  },
  {
   "OBJECTID": 3134,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Dachang Hui Autonomous County",
   "NAME_1": "大厂回族自治县",
   "Ethnic1": "Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "72.71 %",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/baike.baidu.com\/item\/%E5%A4%A7%E5%8E%82%E5%9B%9E%E6%97%8F%E8%87%AA%E6%B2%BB%E5%8E%BF#5",
   "Year": 2012
  },
  {
   "OBJECTID": 3135,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Moridawa Daur Autonomous Banner",
   "NAME_1": "莫力达瓦达斡尔族自治旗",
   "Ethnic1": "Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "91 %",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/www.mldw.gov.cn\/content\/detail\/55ee7b12672a1094189f3267.html",
   "Year": 2019
  },
  {
   "OBJECTID": 3136,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Oroqen Autonomous Banner",
   "NAME_1": "鄂伦春自治旗",
   "Ethnic1": "Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "83.74 %",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/baike.baidu.com\/reference\/1951507\/3795ozOHO69RONfJ9YDmKfT39nwFNd0Ck1DgnBsUj0BDkhikn5LXDqxIiS7PX6rODgwxjPyIETYY4KP_Gtcf80ps",
   "Year": 2019
  },
  {
   "OBJECTID": 3137,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Evenki Autonomous Banner",
   "NAME_1": "鄂温克族自治旗",
   "Ethnic1": "Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "57.7 %",
   "Numerical": 60,
   "Ethnic2": "Mongolian",
   "SecRelig0": "Buddhism",
   "SecRelig": "Buddhists(Tibetan Buddhism)",
   "SReligCatp": "20 %",
   "Nummeric_1": 20,
   "DataSource": "https:\/\/baike.baidu.com\/reference\/1952070\/62c5M4YN2W13ny2cDEii7dySALa6-8DPterR4wQ1EegGKbSd_42mY6RCc4YHAu_ZZ74MCwbLjfhuO-hxhGzalq2LdJYq",
   "Year": 2016
  },
  {
   "OBJECTID": 3138,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Xiuyan Manchu Autonomous County",
   "NAME_1": "岫岩满族自治县",
   "Ethnic1": "Manchu, Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "48.88 %",
   "Numerical": 50,
   "Ethnic2": "Manchu",
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "36 %",
   "Nummeric_1": 30,
   "DataSource": "http:\/\/www.xiuyan.gov.cn\/xyxzf\/ydfc\/index.html",
   "Year": 2019
  },
  {
   "OBJECTID": 3139,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Xinbin Manchu Autonomous County",
   "NAME_1": "新宾满族自治县",
   "Ethnic1": "Manchu, Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "47.59 %",
   "Numerical": 50,
   "Ethnic2": "Manchu",
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "28 %",
   "Nummeric_1": 30,
   "DataSource": "http:\/\/www.xinbin.gov.cn\/list.asp?s=51",
   "Year": 2019
  },
  {
   "OBJECTID": 3140,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Qingyuan Manchu Autonomous County",
   "NAME_1": "清原满族自治县",
   "Ethnic1": "Manchu, Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "52.67 %",
   "Numerical": 60,
   "Ethnic2": "Manchu",
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "22.78 %",
   "Nummeric_1": 30,
   "DataSource": "http:\/\/www.qingyuan.gov.cn\/ins.asp?s=62&i=31",
   "Year": 2010
  },
  {
   "OBJECTID": 3141,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Benxi Manchu Autonomous County",
   "NAME_1": "本溪满族自治县",
   "Ethnic1": "Manchu, Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "60.25 %",
   "Numerical": 70,
   "Ethnic2": "Manchu",
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "25.2 %",
   "Nummeric_1": 30,
   "DataSource": "http:\/\/www.bx.gov.cn\/zjmx\/bxgk",
   "Year": 2019
  },
  {
   "OBJECTID": 3142,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Huanren Manchu Autonomous County",
   "NAME_1": "桓仁满族自治县",
   "Ethnic1": "Manchu, Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "44.3 %",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/www.hr.gov.cn\/zjhr\/hrgk",
   "Year": 2018
  },
  {
   "OBJECTID": 3143,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Kuandian Manchu Autonomous County",
   "NAME_1": "宽甸满族自治县",
   "Ethnic1": "Manchu, Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "68 %",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/www.lnkd.gov.cn\/zjkd\/",
   "Year": 2002
  },
  {
   "OBJECTID": 3144,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Fuxin Mongolian Autonomous County",
   "NAME_1": "阜新蒙古族自治县",
   "Ethnic1": "Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "79.71 %",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/baike.baidu.com\/item\/%E9%98%9C%E6%96%B0%E8%92%99%E5%8F%A4%E6%97%8F%E8%87%AA%E6%B2%BB%E5%8E%BF#3",
   "Year": 2018
  },
  {
   "OBJECTID": 3145,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Karaqin left wing Mongolian Autonomous County",
   "NAME_1": "喀喇沁左翼蒙古族自治县",
   "Ethnic1": "Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "76.92 %",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.neac.gov.cn\/seac\/ztzl\/201207\/1067823.shtml",
   "Year": 2018
  },
  {
   "OBJECTID": 3146,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Yitong Manchu Autonomous County",
   "NAME_1": "伊通满族自治县",
   "Ethnic1": "Manchu, Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "76.55 %",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/www.yitong.gov.cn\/xq\/rkmz\/",
   "Year": 2019
  },
  {
   "OBJECTID": 3147,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Changbai Korean Autonomous County",
   "NAME_1": "长白朝鲜族自治县",
   "Ethnic1": "Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "81.95 %",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/www.changbai.gov.cn\/cbgk\/cbxq\/201801\/t20180108_257116.html",
   "Year": 2019
  },
  {
   "OBJECTID": 3148,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Qiangorros Mongolian Autonomous County",
   "NAME_1": "前郭尔罗斯蒙古族自治县",
   "Ethnic1": "Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "86.57 %",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/www.qianguo.gov.cn\/zjqg\/qyrk\/201604\/t20160421_101549.html",
   "Year": 2018
  },
  {
   "OBJECTID": 3149,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Durbert Mongolian Autonomous County",
   "NAME_1": "杜尔伯特蒙古族自治县",
   "Ethnic1": "Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "79.6 %",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/baike.baidu.com\/item\/%E6%9D%9C%E5%B0%94%E4%BC%AF%E7%89%B9%E8%92%99%E5%8F%A4%E6%97%8F%E8%87%AA%E6%B2%BB%E5%8E%BF#6",
   "Year": 2019
  },
  {
   "OBJECTID": 3150,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Jingning She Autonomous County",
   "NAME_1": "景宁畲族自治县",
   "Ethnic1": "Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "88.32 %",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/www.jingning.gov.cn\/col\/col1376099\/index.html",
   "Year": 2019
  },
  {
   "OBJECTID": 3151,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "changyang tujia autonomous county",
   "NAME_1": "长阳土家族自治县",
   "Ethnic1": "Tujia",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": ">51 %",
   "Numerical": 60,
   "Ethnic2": "Han",
   "SecRelig0": "East Asian Religiosity",
   "SecRelig": "East Asian Religiosity",
   "SReligCatp": "35 %",
   "Nummeric_1": 40,
   "DataSource": "https:\/\/www.neac.gov.cn\/seac\/ztzl\/201207\/1067838.shtml",
   "Year": 2004
  },
  {
   "OBJECTID": 3152,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Wufeng Tujia Autonomous County",
   "NAME_1": "五峰土家族自治县",
   "Ethnic1": "Tujia",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "84.77 %",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/www.hbwf.gov.cn\/list-36-1.html",
   "Year": 2000
  },
  {
   "OBJECTID": 3153,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Chengbu Miao Autonomous County",
   "NAME_1": "城步苗族自治县",
   "Ethnic1": "Miao",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "59.14 %",
   "Numerical": 60,
   "Ethnic2": "Han",
   "SecRelig0": "East Asian Religiosity",
   "SecRelig": "East Asian Religiosity",
   "SReligCatp": "37.53 %",
   "Nummeric_1": 40,
   "DataSource": "http:\/\/www.chengbu.gov.cn\/chengbu\/rkymz\/list_tt.shtml",
   "Year": 2010
  },
  {
   "OBJECTID": 3154,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Jianghua Yao Autonomous County",
   "NAME_1": "江华瑶族自治县",
   "Ethnic1": "Yao",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "66.7 %",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/www.jh.gov.cn\/jh\/xqjs\/list_tt.shtml",
   "Year": 2019
  },
  {
   "OBJECTID": 3155,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Mayang Miao Autonomous County",
   "NAME_1": "麻阳苗族自治县",
   "Ethnic1": "Miao",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": ">78.8 %",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/www.mayang.gov.cn\/mayang\/c105439\/list_tt.shtml",
   "Year": 2007
  },
  {
   "OBJECTID": 3156,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Xinhuang Dong Autonomous County",
   "NAME_1": "新晃侗族自治县",
   "Ethnic1": "Dong",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "80.13 %",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/www.xinhuang.gov.cn\/xinhuang\/c112122\/xh_xhfq.shtml",
   "Year": 2019
  },
  {
   "OBJECTID": 3157,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Zhijiang Dong Autonomous County",
   "NAME_1": "芷江侗族自治县",
   "Ethnic1": "Dong",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": ">65 %",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/chnzj.gov.cn\/chnzj\/c102439\/202004\/63815aa4fcfb4f01b8b2d6b0b4dbc207.shtml",
   "Year": 2019
  },
  {
   "OBJECTID": 3158,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Jingzhou Miao and Dong Autonomous County",
   "NAME_1": "靖州苗族侗族自治县",
   "Ethnic1": "Miao, Dong",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": ">74.4 %",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/www.jzx.gov.cn\/jzx\/c116329\/singleArticle2020.shtml",
   "Year": 2019
  },
  {
   "OBJECTID": 3159,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Tongdao Dong Autonomous County",
   "NAME_1": "通道侗族自治县",
   "Ethnic1": "Dong",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "77.9 %",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/www.tongdao.gov.cn\/tongdao\/c101124\/singleList.shtml",
   "Year": 2019
  },
  {
   "OBJECTID": 3160,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Ruyuan Yao Autonomous County",
   "NAME_1": "乳源瑶族自治县",
   "Ethnic1": "Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "88.31 %",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "2018年民族自治地方国民经济与社会发展主要指标, 中华人民共和国国家民族事务委员会",
   "Year": 2018
  },
  {
   "OBJECTID": 3161,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Lianshan Zhuang Yao Autonomous County",
   "NAME_1": "连山壮族瑶族自治县",
   "Ethnic1": "Zhuang, Yao",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": ">63.61 %",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/www.gdls.gov.cn\/zlls\/lsgl\/mzzj\/index.html",
   "Year": 2015
  },
  {
   "OBJECTID": 3162,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Liannan Yao Autonomous County",
   "NAME_1": "连南瑶族自治县",
   "Ethnic1": "Yao",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "55.82 %",
   "Numerical": 60,
   "Ethnic2": "Han",
   "SecRelig0": "East Asian Religiosity",
   "SecRelig": "East Asian Religiosity",
   "SReligCatp": "42.85 %",
   "Nummeric_1": 50,
   "DataSource": "https:\/\/baike.baidu.com\/item\/%E8%BF%9E%E5%8D%97%E7%91%B6%E6%97%8F%E8%87%AA%E6%B2%BB%E5%8E%BF#4",
   "Year": 2017
  },
  {
   "OBJECTID": 3163,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Rongshui Miao Autonomous County",
   "NAME_1": "融水苗族自治县",
   "Ethnic1": "Miao, Yao, Zhuang",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "76.13 %",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/www.rongshui.gov.cn\/zjrs\/xzqh\/",
   "Year": 2019
  },
  {
   "OBJECTID": 3164,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Sanjiang Dong Autonomous County",
   "NAME_1": "三江侗族自治县",
   "Ethnic1": "Dong, Yao, Zhuang",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "86.42 %",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/www.sjx.gov.cn\/zjlj\/sjgk\/",
   "Year": 2019
  },
  {
   "OBJECTID": 3165,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Longsheng Autonomous County",
   "NAME_1": "龙胜各族自治县",
   "Ethnic1": "Miao, Dong, Yao, Zhuang",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "76 %",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "龙胜各族自治县2017年 国民经济和社会发展统计公报 ．龙胜各族自治县人民政府",
   "Year": 2001
  },
  {
   "OBJECTID": 3166,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Gongcheng Yao Autonomous County",
   "NAME_1": "恭城瑶族自治县",
   "Ethnic1": "Yao",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": ">65 %",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "人文地理 ．恭城瑶族自治县人民政府. http:\/\/www.gongcheng.gov.cn\/",
   "Year": 2016
  },
  {
   "OBJECTID": 3167,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Longlin Autonomous County",
   "NAME_1": "隆林各族自治县",
   "Ethnic1": "Zhuang,Gelao",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "78.18 %",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "隆林年鉴编纂委员会．隆林年鉴（2011-2012）：广西人民出版社，2014",
   "Year": 2012
  },
  {
   "OBJECTID": 3168,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Fuchuan Yao Autonomous County",
   "NAME_1": "富川瑶族自治县",
   "Ethnic1": "Yao",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": ">57.4 %",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/www.gxfc.gov.cn\/fcgk\/fcrw\/t2173269.shtml",
   "Year": 2019
  },
  {
   "OBJECTID": 3169,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Luocheng Mulao Autonomous County",
   "NAME_1": "罗城仫佬族自治县",
   "Ethnic1": "Gelao, Zhuang",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": ">65 %",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/www.luocheng.gov.cn\/zjlc\/zrdl\/t533040.shtml",
   "Year": 2019
  },
  {
   "OBJECTID": 3170,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Huanjiang Maonan Autonomous County",
   "NAME_1": "环江毛南族自治县",
   "Ethnic1": "Maonan, Zhuang, Yao",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": ">65 %",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/baike.baidu.com\/item\/%E7%8E%AF%E6%B1%9F%E6%AF%9B%E5%8D%97%E6%97%8F%E8%87%AA%E6%B2%BB%E5%8E%BF#3",
   "Year": 2016
  },
  {
   "OBJECTID": 3171,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Bama Yao Autonomous County",
   "NAME_1": "巴马瑶族自治县",
   "Ethnic1": "Yao, Zhuang",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": ">65 %",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/www.bama.gov.cn\/zjbm\/qhrk\/t651993.shtml",
   "Year": 2016
  },
  {
   "OBJECTID": 3172,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Du'an Yao Autonomous County",
   "NAME_1": "都安瑶族自治县",
   "Ethnic1": "Zhuang, Yao",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "95.62 %",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/www.duan.gov.cn\/zjda\/qhrk\/t503626.shtml",
   "Year": 2012
  },
  {
   "OBJECTID": 3173,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Dahua Yao Autonomous County",
   "NAME_1": "大化瑶族自治县",
   "Ethnic1": "Yao, Zhuang",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": ">65 %",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/www.gxdh.gov.cn\/zjdh\/qhrk\/t885234.shtml",
   "Year": 2019
  },
  {
   "OBJECTID": 3174,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Jinxiu Yao Autonomous County",
   "NAME_1": "金秀瑶族自治县",
   "Ethnic1": "Yao",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": ">65 %",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/www.jinxiu.gov.cn\/zjjx\/rwdl\/t5492736.shtml",
   "Year": 2019
  },
  {
   "OBJECTID": 3175,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Baisha Li Autonomous County",
   "NAME_1": "白沙黎族自治县",
   "Ethnic1": "Hlai, Miao",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": ">63.64 %",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/baisha.hainan.gov.cn\/baisha\/zjbs\/bsgk\/201203\/t20120316_392923.html",
   "Year": 2019
  },
  {
   "OBJECTID": 3176,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Changjiang Li Autonomous County",
   "NAME_1": "昌江黎族自治县",
   "Ethnic1": "Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "60.42 %",
   "Numerical": 70,
   "Ethnic2": "Hlai",
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "38.01 %",
   "Nummeric_1": 40,
   "DataSource": "https:\/\/baike.baidu.com\/item\/%E6%98%8C%E6%B1%9F%E9%BB%8E%E6%97%8F%E8%87%AA%E6%B2%BB%E5%8E%BF#5",
   "Year": 2010
  },
  {
   "OBJECTID": 3177,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Ledong Li Autonomous County",
   "NAME_1": "乐东黎族自治县",
   "Ethnic1": "Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "60.81 %",
   "Numerical": 70,
   "Ethnic2": "Hlai, Miao",
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "38.7 %",
   "Nummeric_1": 40,
   "DataSource": "https:\/\/baike.baidu.com\/item\/%E4%B9%90%E4%B8%9C%E9%BB%8E%E6%97%8F%E8%87%AA%E6%B2%BB%E5%8E%BF#5",
   "Year": 2015
  },
  {
   "OBJECTID": 3178,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Lingshui Li Autonomous County",
   "NAME_1": "陵水黎族自治县",
   "Ethnic1": "Hlai",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "56.74 %",
   "Numerical": 60,
   "Ethnic2": "Han",
   "SecRelig0": "East Asian Religiosity",
   "SecRelig": "East Asian Religiosity",
   "SReligCatp": "42.63 %",
   "Nummeric_1": 50,
   "DataSource": "http:\/\/lingshui.hainan.gov.cn\/mlls_57671\/lsgl\/rkmz\/201507\/t20150715_1133251.html",
   "Year": 2019
  },
  {
   "OBJECTID": 3179,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Baoting Li and Miao Autonomous County",
   "NAME_1": "保亭黎族苗族自治县",
   "Ethnic1": "Hlai, Miao",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "66.9 %",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/baoting.hainan.gov.cn\/zjbt\/btgk\/202004\/t20200421_2777748.html",
   "Year": 2018
  },
  {
   "OBJECTID": 3180,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Qiongzhong Li and Miao Autonomous County",
   "NAME_1": "琼中黎族苗族自治县",
   "Ethnic1": "Hlai",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "57.59 %",
   "Numerical": 60,
   "Ethnic2": "Han",
   "SecRelig0": "East Asian Religiosity",
   "SecRelig": "East Asian Religiosity",
   "SReligCatp": "38.41 %",
   "Nummeric_1": 40,
   "DataSource": "https:\/\/baike.baidu.com\/item\/%E7%90%BC%E4%B8%AD%E9%BB%8E%E6%97%8F%E8%8B%97%E6%97%8F%E8%87%AA%E6%B2%BB%E5%8E%BF#5",
   "Year": 2015
  },
  {
   "OBJECTID": 3181,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Shizhu Tujia Autonomous County",
   "NAME_1": "石柱土家族自治县",
   "Ethnic1": "Tujia",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "79.3 %",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/cqszx.gov.cn\/zjsz\/szgk\/202002\/t20200224_5421035.html",
   "Year": 2019
  },
  {
   "OBJECTID": 3182,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Xiushan Tujia and Miao Autonomous County",
   "NAME_1": "秀山土家族苗族自治县",
   "Ethnic1": "Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "48 %",
   "Numerical": 50,
   "Ethnic2": "Tujia, Miao",
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": ">29.32 %",
   "Nummeric_1": 30,
   "DataSource": "秀山土家族苗族自治县统计局.秀山县2010年第六次全国人口普查主要数据公报，2011-10-09.",
   "Year": 2010
  },
  {
   "OBJECTID": 3183,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Youyang Tujia and Miao Autonomous County",
   "NAME_1": "酉阳土家族苗族自治县",
   "Ethnic1": "Tujia, Miao",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "80.72 %",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/youyang.gov.cn\/zjyy\/rkzk\/202001\/t20200110_4507655.html",
   "Year": 2018
  },
  {
   "OBJECTID": 3184,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "pengshui miao and tujia autonomous county",
   "NAME_1": "彭水苗族土家族自治县",
   "Ethnic1": "Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "46.15 %",
   "Numerical": 50,
   "Ethnic2": "Miao, Tujia",
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "53.38 %",
   "Nummeric_1": 60,
   "DataSource": "https:\/\/baike.baidu.com\/item\/%E5%BD%AD%E6%B0%B4%E8%8B%97%E6%97%8F%E5%9C%9F%E5%AE%B6%E6%97%8F%E8%87%AA%E6%B2%BB%E5%8E%BF#5",
   "Year": 2010
  },
  {
   "OBJECTID": 3185,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Beichuan Qiang Autonomous County",
   "NAME_1": "北川羌族自治县",
   "Ethnic1": "Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "63.35 %",
   "Numerical": 70,
   "Ethnic2": "Qiang",
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "34.88 %",
   "Nummeric_1": 40,
   "DataSource": "http:\/\/www.beichuan.gov.cn\/zjbc\/bcgl\/rkymz\/20140371.html",
   "Year": 2017
  },
  {
   "OBJECTID": 3186,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Ebian Yi Autonomous County",
   "NAME_1": "峨边彝族自治县",
   "Ethnic1": "Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "59 %",
   "Numerical": 60,
   "Ethnic2": "Yi",
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": ">36.61 %",
   "Nummeric_1": 40,
   "DataSource": "http:\/\/www.eb.gov.cn\/ebyzzzx\/ebgkxx\/201909\/d8d3cc523649492b88f72f5aaf2e57e2.shtml",
   "Year": 2019
  },
  {
   "OBJECTID": 3187,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Mabian Yi Autonomous County",
   "NAME_1": "马边彝族自治县",
   "Ethnic1": "Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "51.45 %",
   "Numerical": 60,
   "Ethnic2": "Yi",
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "47.51 %",
   "Nummeric_1": 50,
   "DataSource": "http:\/\/www.mabian.gov.cn\/mbyzzzx\/mbxgk\/201906\/6dc940af21fc4a499a8800158203e809.shtml",
   "Year": 2019
  },
  {
   "OBJECTID": 3188,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Muli Tibetan Autonomous County",
   "NAME_1": "木里藏族自治县",
   "Ethnic1": "Tibetan, Mongolian",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Tibetan Buddhism)",
   "ReligCatP": "39.28 %",
   "Numerical": 40,
   "Ethnic2": "Yi, Miao",
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "36.67 %",
   "Nummeric_1": 40,
   "DataSource": "https:\/\/baike.baidu.com\/item\/%E6%9C%A8%E9%87%8C%E8%97%8F%E6%97%8F%E8%87%AA%E6%B2%BB%E5%8E%BF#5",
   "Year": 2016
  },
  {
   "OBJECTID": 3189,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Daozhen Gelao and Miao Autonomous County",
   "NAME_1": "道真仡佬族苗族自治县",
   "Ethnic1": "Gelao, Miao",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "73.76 %",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/mzw.guizhou.gov.cn\/zfxxgk\/fdzdgknr\/tjxx\/202007\/t20200706_61342799.html",
   "Year": 2019
  },
  {
   "OBJECTID": 3190,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Wuchuan Gelao and Miao Autonomous County",
   "NAME_1": "务川仡佬族苗族自治县",
   "Ethnic1": "Gelao, Miao",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": ">85 %",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/mzw.guizhou.gov.cn\/zfxxgk\/fdzdgknr\/tjxx\/202007\/t20200706_61342807.html",
   "Year": 2019
  },
  {
   "OBJECTID": 3191,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Zhenning Buyi and Miao Autonomous County",
   "NAME_1": "镇宁布依族苗族自治县",
   "Ethnic1": "Buyi, Miao",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": ">65 %",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/mzw.guizhou.gov.cn\/zfxxgk\/fdzdgknr\/tjxx\/202007\/t20200706_61342796.html",
   "Year": 2019
  },
  {
   "OBJECTID": 3192,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Guanling Buyi and Miao Autonomous County",
   "NAME_1": "关岭布依族苗族自治县",
   "Ethnic1": "Buyi, Miao",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "61.15 %",
   "Numerical": 70,
   "Ethnic2": "Han",
   "SecRelig0": "East Asian Religiosity",
   "SecRelig": "East Asian Religiosity",
   "SReligCatp": "38.85 %",
   "Nummeric_1": 40,
   "DataSource": "http:\/\/mzw.guizhou.gov.cn\/zfxxgk\/fdzdgknr\/tjxx\/202007\/t20200706_61342802.html",
   "Year": 2019
  },
  {
   "OBJECTID": 3193,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Ziyun Miao Buyi Autonomous County",
   "NAME_1": "紫云苗族布依族自治县",
   "Ethnic1": "Buyi, Miao",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "68.43 %",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/mzw.guizhou.gov.cn\/zfxxgk\/fdzdgknr\/tjxx\/202007\/t20200706_61342804.html",
   "Year": 2019
  },
  {
   "OBJECTID": 3194,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Weining Yi, Hui and Miao Autonomous County",
   "NAME_1": "威宁彝族回族苗族自治县",
   "Ethnic1": "Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "75 %",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/mzw.guizhou.gov.cn\/zfxxgk\/fdzdgknr\/tjxx\/202007\/t20200706_61342803.html",
   "Year": 2019
  },
  {
   "OBJECTID": 3195,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Yuping Dong Autonomous County",
   "NAME_1": "玉屏侗族自治县",
   "Ethnic1": "Dong",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": ">80 %",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/www.yuping.gov.cn\/zjyp\/ypjj\/",
   "Year": 2019
  },
  {
   "OBJECTID": 3196,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Yinjiang Tujia and Miao Autonomous County",
   "NAME_1": "印江土家族苗族自治县",
   "Ethnic1": "Miao,Tujia",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": ">70.5 %",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/mzw.guizhou.gov.cn\/zfxxgk\/fdzdgknr\/tjxx\/202007\/t20200706_61342806.html",
   "Year": 2019
  },
  {
   "OBJECTID": 3197,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Yanhe Tujia Autonomous County",
   "NAME_1": "沿河土家族自治县",
   "Ethnic1": "Tujia, Miao, Dong",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": ">65 %",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/www.yanhe.gov.cn\/zjyh\/rkmz\/201807\/t20180704_21654522.html",
   "Year": 2019
  },
  {
   "OBJECTID": 3198,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Songtao Miao Autonomous County",
   "NAME_1": "松桃苗族自治县",
   "Ethnic1": "Miao",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "68.1 %",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/baike.baidu.com\/item\/%E6%9D%BE%E6%A1%83%E8%8B%97%E6%97%8F%E8%87%AA%E6%B2%BB%E5%8E%BF#5",
   "Year": 2018
  },
  {
   "OBJECTID": 3199,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Sandu Autonomous County",
   "NAME_1": "三都水族自治县",
   "Ethnic1": "Sui",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "64.8 %",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/mzw.guizhou.gov.cn\/zfxxgk\/fdzdgknr\/tjxx\/202007\/t20200706_61342801.html",
   "Year": 2019
  },
  {
   "OBJECTID": 3200,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Shilin Yi Autonomous County",
   "NAME_1": "石林彝族自治县",
   "Ethnic1": "Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "65.3 %",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/kmsl.gov.cn\/slgk\/",
   "Year": 2019
  },
  {
   "OBJECTID": 3201,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Luquan Yi and Miao Autonomous County",
   "NAME_1": "禄劝彝族苗族自治县",
   "Ethnic1": "Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "69.24 %",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/kmlq.gov.cn\/c\/2016-09-01\/1213546.shtml",
   "Year": 2016
  },
  {
   "OBJECTID": 3202,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "XUNDIAN Hui and Yi Autonomous County",
   "NAME_1": "寻甸回族彝族自治县",
   "Ethnic1": "Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "76.28 %",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.neac.gov.cn\/seac\/ztzl\/201207\/1067903.shtml",
   "Year": 2012
  },
  {
   "OBJECTID": 3203,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Eshan Yi Autonomous County",
   "NAME_1": "峨山彝族自治县",
   "Ethnic1": "Yi",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "56.7 %",
   "Numerical": 60,
   "Ethnic2": "Han",
   "SecRelig0": "East Asian Religiosity",
   "SecRelig": "East Asian Religiosity",
   "SReligCatp": "31.6 %",
   "Nummeric_1": 40,
   "DataSource": "峨山县统计局.2017年峨山彝族自治县国民经济和社会发展统计公报，2018.",
   "Year": 2017
  },
  {
   "OBJECTID": 3204,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Xinping Yi Dai Autonomous County",
   "NAME_1": "新平彝族傣族自治县",
   "Ethnic1": "Yi",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "32.4 %",
   "Numerical": 70,
   "Ethnic2": "Dai",
   "SecRelig0": "Buddhism",
   "SecRelig": "Buddhists(Theravada)",
   "SReligCatp": "32.4 %",
   "Nummeric_1": 40,
   "DataSource": "新平县统计局.2017年新平县国民经济和社会发展统计公报，2018.",
   "Year": 2017
  },
  {
   "OBJECTID": 3205,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Yuanjiang Hani Yi Dai Autonomous County",
   "NAME_1": "元江哈尼族彝族傣族自治县",
   "Ethnic1": "Hani, Yi",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": ">65.48 %",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.neac.gov.cn\/seac\/ztzl\/201207\/1067904.shtml",
   "Year": 2012
  },
  {
   "OBJECTID": 3206,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Yulong Naxi Autonomous County",
   "NAME_1": "玉龙纳西族自治县",
   "Ethnic1": "Naxi, Lisu",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": ">68.14 %",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/baike.baidu.com\/reference\/10539040\/6dc0NyEONjcmtZIyr2D0-y363pP3sryCIHDjjvRoqljKjPDmUodI6pb05bm4qy7H1SiY77yQN0nGpDEc_H_rDZv2F2yIPSKYCw",
   "Year": 2012
  },
  {
   "OBJECTID": 3207,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Ninglang Yi Autonomous County",
   "NAME_1": "宁蒗彝族自治县",
   "Ethnic1": "Yi",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": ">63 %",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/baike.baidu.com\/item\/%E5%AE%81%E8%92%97%E5%BD%9D%E6%97%8F%E8%87%AA%E6%B2%BB%E5%8E%BF\/10539079?fromtitle=%E5%AE%81%E8%92%97%E5%8E%BF&fromid=1200423#5",
   "Year": 2011
  },
  {
   "OBJECTID": 3208,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Ning'er Hani and Yi Autonomous County",
   "NAME_1": "宁洱哈尼族彝族自治县",
   "Ethnic1": "Hani, Yi",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "55 %",
   "Numerical": 60,
   "Ethnic2": "Han",
   "SecRelig0": "East Asian Religiosity",
   "SecRelig": "East Asian Religiosity",
   "SReligCatp": "45 %",
   "Nummeric_1": 50,
   "DataSource": "http:\/\/www.ne.gov.cn\/info\/1008\/18106.htm",
   "Year": 2019
  },
  {
   "OBJECTID": 3209,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Mojiang Hani Autonomous County",
   "NAME_1": "墨江哈尼族自治县",
   "Ethnic1": "Hani",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "61.63 %",
   "Numerical": 70,
   "Ethnic2": "Han",
   "SecRelig0": "East Asian Religiosity",
   "SecRelig": "East Asian Religiosity",
   "SReligCatp": "24.79 %",
   "Nummeric_1": 30,
   "DataSource": "https:\/\/baike.baidu.com\/item\/%E5%A2%A8%E6%B1%9F%E5%93%88%E5%B0%BC%E6%97%8F%E8%87%AA%E6%B2%BB%E5%8E%BF\/10538160?fromtitle=%E5%A2%A8%E6%B1%9F%E5%8E%BF&fromid=5460991#5",
   "Year": 2010
  },
  {
   "OBJECTID": 3210,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Jingdong Yi Autonomous County",
   "NAME_1": "景东彝族自治县",
   "Ethnic1": "Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "49.2 %",
   "Numerical": 50,
   "Ethnic2": "Yi",
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "42.9 %",
   "Nummeric_1": 50,
   "DataSource": "https:\/\/baike.baidu.com\/item\/%E6%99%AF%E4%B8%9C%E5%BD%9D%E6%97%8F%E8%87%AA%E6%B2%BB%E5%8E%BF#4",
   "Year": 2019
  },
  {
   "OBJECTID": 3211,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Jinggu Dai and Yi Autonomous County",
   "NAME_1": "景谷傣族彝族自治县",
   "Ethnic1": "Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "53.7 %",
   "Numerical": 60,
   "Ethnic2": "Yi, Lahu, Hani",
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "46.3 %",
   "Nummeric_1": 50,
   "DataSource": "https:\/\/www.neac.gov.cn\/seac\/ztzl\/201207\/1067912.shtml",
   "Year": 2012
  },
  {
   "OBJECTID": 3212,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Zhenyuan Yi Hani Lahu Autonomous County",
   "NAME_1": "镇沅彝族哈尼族拉祜族自治县",
   "Ethnic1": "Yi, Hani, Lahu",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "53.2 %",
   "Numerical": 60,
   "Ethnic2": "Han",
   "SecRelig0": "East Asian Religiosity",
   "SecRelig": "East Asian Religiosity",
   "SReligCatp": "43.13 %",
   "Nummeric_1": 40,
   "DataSource": "http:\/\/pezhenyuan.gov.cn\/zygk1\/rkmz1.htm",
   "Year": 2019
  },
  {
   "OBJECTID": 3213,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Jiangcheng Hani and Yi Autonomous County",
   "NAME_1": "江城哈尼族彝族自治县",
   "Ethnic1": "Hani, Yi",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": ">65 %",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/www.jcx.gov.cn\/ysjc\/jcgk.htm",
   "Year": 2019
  },
  {
   "OBJECTID": 3214,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Menglian Dai Lahu Wa Autonomous County",
   "NAME_1": "孟连傣族拉祜族佤族自治县",
   "Ethnic1": "Lahu,Wa",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "54.05 %",
   "Numerical": 60,
   "Ethnic2": "Dai",
   "SecRelig0": "Buddhism",
   "SecRelig": "Buddhists(Theravada)",
   "SReligCatp": "20.50 %",
   "Nummeric_1": 30,
   "DataSource": "https:\/\/www.neac.gov.cn\/seac\/ztzl\/201207\/1067890.shtml",
   "Year": 2012
  },
  {
   "OBJECTID": 3215,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Lancang Lahu Autonomous County",
   "NAME_1": "澜沧拉祜族自治县",
   "Ethnic1": "Lahu, Wa, Hani",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": ">79 %",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/www.lancang.gov.cn\/lcgk1\/lcgk.htm",
   "Year": 2019
  },
  {
   "OBJECTID": 3216,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Ximeng Vazu Zizhixian",
   "NAME_1": "西盟佤族自治县",
   "Ethnic1": "Wa",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "71.59 %",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/baike.baidu.com\/item\/%E8%A5%BF%E7%9B%9F%E4%BD%A4%E6%97%8F%E8%87%AA%E6%B2%BB%E5%8E%BF#5",
   "Year": 2015
  },
  {
   "OBJECTID": 3217,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Shuangjiang Lahu, WA, Bulang and Dai Autonomous County",
   "NAME_1": "双江拉祜族佤族布朗族傣族自治县",
   "Ethnic1": "Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "53 %",
   "Numerical": 60,
   "Ethnic2": "Lihu, Wa",
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "47 %",
   "Nummeric_1": 50,
   "DataSource": "http:\/\/www.lincang.gov.cn\/lcsrmzf\/lcszf\/zjlc\/xzqh\/9974\/index.html",
   "Year": 2019
  },
  {
   "OBJECTID": 3218,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Gengma Dai and Wa Autonomous County",
   "NAME_1": "耿马傣族佤族自治县",
   "Ethnic1": "Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "44.62 %",
   "Numerical": 50,
   "Ethnic2": "Dai",
   "SecRelig0": "Buddhism",
   "SecRelig": "Buddhists(Theravada)",
   "SReligCatp": "19.21 %",
   "Nummeric_1": 20,
   "DataSource": "https:\/\/baike.baidu.com\/item\/%E8%80%BF%E9%A9%AC%E5%82%A3%E6%97%8F%E4%BD%A4%E6%97%8F%E8%87%AA%E6%B2%BB%E5%8E%BF\/10538682?fromtitle=%E8%80%BF%E9%A9%AC%E5%8E%BF&fromid=253115#4",
   "Year": 2010
  },
  {
   "OBJECTID": 3219,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Cangyuan Wa Autonomous County",
   "NAME_1": "沧源佤族自治县",
   "Ethnic1": "Wa",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": ">85.2 %",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/www.cangyuan.gov.cn\/cyxrmzf\/zjcy\/cygk\/index.html",
   "Year": 2019
  },
  {
   "OBJECTID": 3220,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Pingbian Miao Autonomous County",
   "NAME_1": "屏边苗族自治县",
   "Ethnic1": "Miao",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": ">46.66 %",
   "Numerical": 50,
   "Ethnic2": "Han",
   "SecRelig0": "East Asian Religiosity",
   "SecRelig": "East Asian Religiosity",
   "SReligCatp": "46 %",
   "Nummeric_1": 50,
   "DataSource": "http:\/\/www.pb.hh.gov.cn\/mlpb\/pbgk\/202003\/t20200327_399272.html",
   "Year": 2019
  },
  {
   "OBJECTID": 3221,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Jinping Miao Yao Dai Autonomous County",
   "NAME_1": "金平苗族瑶族傣族自治县",
   "Ethnic1": "Miao, Hani, Yi, Yao, Zhuang",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "90 %",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/www.jp.hh.gov.cn\/bcjp\/jpgk\/201907\/t20190711_353507.html",
   "Year": 2019
  },
  {
   "OBJECTID": 3222,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Hekou Yao Autonomous County",
   "NAME_1": "河口瑶族自治县",
   "Ethnic1": "Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "38.42 %",
   "Numerical": 40,
   "Ethnic2": "Yao, Zhuang",
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "34.46 %",
   "Nummeric_1": 40,
   "DataSource": "https:\/\/baike.baidu.com\/item\/%E6%B2%B3%E5%8F%A3%E7%91%B6%E6%97%8F%E8%87%AA%E6%B2%BB%E5%8E%BF#5",
   "Year": 2010
  },
  {
   "OBJECTID": 3223,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Yangbi Yi Autonomous County",
   "NAME_1": "漾濞彝族自治县",
   "Ethnic1": "Yi",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "48.96 %",
   "Numerical": 50,
   "Ethnic2": "Han, Bai",
   "SecRelig0": "East Asian Religiosity",
   "SecRelig": "East Asian Religiosity",
   "SReligCatp": "32.4 %",
   "Nummeric_1": 40,
   "DataSource": "http:\/\/www.yangbi.gov.cn\/ybyz\/c102191\/201906\/4adb864eeaa84b4dbc6197f7db7e8588.shtml",
   "Year": 2019
  },
  {
   "OBJECTID": 3224,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Jiannan Yi Autonomous County",
   "NAME_1": "南涧彝族自治县",
   "Ethnic1": "Yi",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "49.69 %",
   "Numerical": 50,
   "Ethnic2": "Han",
   "SecRelig0": "East Asian Religiosity",
   "SecRelig": "East Asian Religiosity",
   "SReligCatp": "46.35 %",
   "Nummeric_1": 50,
   "DataSource": "https:\/\/baike.baidu.com\/item\/%E5%8D%97%E6%B6%A7%E5%BD%9D%E6%97%8F%E8%87%AA%E6%B2%BB%E5%8E%BF#5",
   "Year": 2016
  },
  {
   "OBJECTID": 3225,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Weishan Yi and Hui Autonomous County",
   "NAME_1": "巍山彝族回族自治县",
   "Ethnic1": "Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "53.87 %",
   "Numerical": 60,
   "Ethnic2": "Yi",
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "35.16 %",
   "Nummeric_1": 40,
   "DataSource": "https:\/\/baike.baidu.com\/item\/%E5%B7%8D%E5%B1%B1%E5%BD%9D%E6%97%8F%E5%9B%9E%E6%97%8F%E8%87%AA%E6%B2%BB%E5%8E%BF#5",
   "Year": 2018
  },
  {
   "OBJECTID": 3226,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Gongshan Dulong Nu Autonomous County",
   "NAME_1": "贡山独龙族怒族自治县",
   "Ethnic1": "Dulong, Nu",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": ">65 %",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/baike.baidu.com\/item\/%E8%B4%A1%E5%B1%B1%E7%8B%AC%E9%BE%99%E6%97%8F%E6%80%92%E6%97%8F%E8%87%AA%E6%B2%BB%E5%8E%BF#5",
   "Year": 2010
  },
  {
   "OBJECTID": 3227,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Lanping Bai Pumi Autonomous County",
   "NAME_1": "兰坪白族普米族自治县",
   "Ethnic1": "Bai, Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "54.8 %",
   "Numerical": 60,
   "Ethnic2": "Pumi, Lisu",
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "45.2 %",
   "Nummeric_1": 50,
   "DataSource": "https:\/\/baike.baidu.com\/item\/%E5%85%B0%E5%9D%AA%E7%99%BD%E6%97%8F%E6%99%AE%E7%B1%B3%E6%97%8F%E8%87%AA%E6%B2%BB%E5%8E%BF#5",
   "Year": 2012
  },
  {
   "OBJECTID": 3228,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Weixi Lisu Autonomous County",
   "NAME_1": "维西傈僳族自治县",
   "Ethnic1": "Lisu",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": ">56.4 %",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/www.weixi.gov.cn\/Item\/40144.aspx",
   "Year": 2019
  },
  {
   "OBJECTID": 3229,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Zhangjiachuan Hui Autonomous County",
   "NAME_1": "张家川回族自治县",
   "Ethnic1": "Hui",
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "69.35 %",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/baike.baidu.com\/item\/%E5%BC%A0%E5%AE%B6%E5%B7%9D%E5%9B%9E%E6%97%8F%E8%87%AA%E6%B2%BB%E5%8E%BF#5",
   "Year": 2010
  },
  {
   "OBJECTID": 3230,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Tianzhu Tibetan Autonomous County",
   "NAME_1": "天祝藏族自治县",
   "Ethnic1": "Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "58.55 %",
   "Numerical": 60,
   "Ethnic2": "Tibetan",
   "SecRelig0": "Buddhism",
   "SecRelig": "Buddhists(Tibetan Buddhism)",
   "SReligCatp": "33.77 %",
   "Nummeric_1": 40,
   "DataSource": "http:\/\/www.gstianzhu.gov.cn\/zjtz\/lsrw\/rkqk\/201606\/t20160615_5093.html",
   "Year": 2005
  },
  {
   "OBJECTID": 3231,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Sunan Yugur Autonomous County",
   "NAME_1": "肃南裕固族自治县",
   "Ethnic1": "Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "42.88 %",
   "Numerical": 50,
   "Ethnic2": "Yugu",
   "SecRelig0": "Buddhism",
   "SecRelig": "Buddhists(Tibetan Buddhism)",
   "SReligCatp": "27 %",
   "Nummeric_1": 30,
   "DataSource": "http:\/\/www.gssn.gov.cn\/sngk\/sngk\/201810\/t20181029_126803.html",
   "Year": 2012
  },
  {
   "OBJECTID": 3232,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Subei Mongolian Autonomous County",
   "NAME_1": "肃北蒙古族自治县",
   "Ethnic1": "Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "58.38 %",
   "Numerical": 60,
   "Ethnic2": "Mongolian",
   "SecRelig0": "Buddhism",
   "SecRelig": "Buddhists(Tibetan Buddhism)",
   "SReligCatp": "38.11 %",
   "Nummeric_1": 40,
   "DataSource": "http:\/\/www.subei.gov.cn\/SortHtml\/1\/List_10.html",
   "Year": 2019
  },
  {
   "OBJECTID": 3233,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Aksai Kazak Autonomous County",
   "NAME_1": "阿克塞哈萨克族自治县",
   "Ethnic1": "Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "61.44 %",
   "Numerical": 70,
   "Ethnic2": "Kazakh",
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Sunni)",
   "SReligCatp": "41.3 %",
   "Nummeric_1": 50,
   "DataSource": "https:\/\/www.neac.gov.cn\/seac\/ztzl\/201207\/1067921.shtml",
   "Year": 2012
  },
  {
   "OBJECTID": 3234,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Dongxiang Autonomous County",
   "NAME_1": "东乡族自治县",
   "Ethnic1": "Dongxiang",
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": ">87.04 %",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/baike.baidu.com\/item\/%E4%B8%9C%E4%B9%A1%E6%97%8F%E8%87%AA%E6%B2%BB%E5%8E%BF#4",
   "Year": 2012
  },
  {
   "OBJECTID": 3235,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Jishishan Baoan Dongxiang Salar Autonomous County",
   "NAME_1": "积石山保安族东乡族撒拉族自治县",
   "Ethnic1": "Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "46.1 %",
   "Numerical": 50,
   "Ethnic2": "Hui, Dongxiang, Baoan",
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Sunni)",
   "SReligCatp": "31.7 %",
   "Nummeric_1": 40,
   "DataSource": "https:\/\/baike.baidu.com\/item\/%E7%A7%AF%E7%9F%B3%E5%B1%B1%E4%BF%9D%E5%AE%89%E6%97%8F%E4%B8%9C%E4%B9%A1%E6%97%8F%E6%92%92%E6%8B%89%E6%97%8F%E8%87%AA%E6%B2%BB%E5%8E%BF#5",
   "Year": 2017
  },
  {
   "OBJECTID": 3236,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Datong Hui and Tu Autonomous County",
   "NAME_1": "大通回族土族自治县",
   "Ethnic1": "Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "48.11 %",
   "Numerical": 50,
   "Ethnic2": "Hui",
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Sunni)",
   "SReligCatp": "27 %",
   "Nummeric_1": 30,
   "DataSource": "http:\/\/www.datong.gov.cn\/index.php?c=category&id=2",
   "Year": 2019
  },
  {
   "OBJECTID": 3237,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Minhe Hui and Tu Autonomous County",
   "NAME_1": "民和回族土族自治县",
   "Ethnic1": "Hui",
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "46.15 %",
   "Numerical": 50,
   "Ethnic2": "Han",
   "SecRelig0": "East Asian Religiosity",
   "SecRelig": "East Asian Religiosity",
   "SReligCatp": "44.51 %",
   "Nummeric_1": 50,
   "DataSource": "https:\/\/www.neac.gov.cn\/seac\/ztzl\/201207\/1067928.shtml",
   "Year": 2012
  },
  {
   "OBJECTID": 3238,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Huzhu Tu Autonomous County",
   "NAME_1": "互助土族自治县",
   "Ethnic1": "Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "72.2 %",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/www.huzhu.gov.cn\/zmhz\/hzgk.htm",
   "Year": 2019
  },
  {
   "OBJECTID": 3239,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Hualong Hui Autonomous County",
   "NAME_1": "化隆回族自治县",
   "Ethnic1": "Hui",
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "72.1 %",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/www.hualongxian.gov.cn\/html\/1143\/294809.html",
   "Year": 2019
  },
  {
   "OBJECTID": 3240,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Xunhua Salar Autonomous County",
   "NAME_1": "循化撒拉族自治县",
   "Ethnic1": "Salar, Hui",
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": ">65 %",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/www.xunhua.gov.cn\/html\/1998\/135171.html",
   "Year": 2019
  },
  {
   "OBJECTID": 3241,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Menyuan Hui Autonomous County",
   "NAME_1": "门源回族自治县",
   "Ethnic1": "Hui",
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "45.8 %",
   "Numerical": 50,
   "Ethnic2": "Han",
   "SecRelig0": "East Asian Religiosity",
   "SecRelig": "East Asian Religiosity",
   "SReligCatp": "35.22 %",
   "Nummeric_1": 40,
   "DataSource": "https:\/\/baike.baidu.com\/item\/%E9%97%A8%E6%BA%90%E5%9B%9E%E6%97%8F%E8%87%AA%E6%B2%BB%E5%8E%BF\/5015576?fromtitle=%E9%97%A8%E6%BA%90%E5%8E%BF&fromid=8644231#5",
   "Year": 2013
  },
  {
   "OBJECTID": 3242,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Henan Mongolian Autonomous County",
   "NAME_1": "河南蒙古族自治县",
   "Ethnic1": "Mongolian",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Tibetan Buddhism)",
   "ReligCatP": "93 %",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/baike.baidu.com\/reference\/10539499\/0382XM8adwrm9BYQqVpQHbUMucOttmRq7snl6NGgWbjCNnmvMDKJdTAMqa5JRknzas3czlnxynxMt843fcHHZDVGyCmDXBn82DXn3FisYgZANX7tJxOWHQ",
   "Year": 2012
  },
  {
   "OBJECTID": 3243,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Balikun Kazakh Autonomous County",
   "NAME_1": "巴里坤哈萨克自治县",
   "Ethnic1": "Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "61.36 %",
   "Numerical": 70,
   "Ethnic2": "Kazakh",
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Sunni)",
   "SReligCatp": ">35 %",
   "Nummeric_1": 40,
   "DataSource": "https:\/\/baike.baidu.com\/reference\/10539754\/aca9ksFFIdj70nfOA44pJhecsCkZxBOvDPcwDpqx6clpC5gxOap0NX9aqNPBtrW-ApPG33Vl1LMwlM5Ot3jRPiECDVtNDIyobCWdqvYls7AL8plZKCdl2V5hOJRR",
   "Year": 2010
  },
  {
   "OBJECTID": 3244,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Mulei Kazakh Autonomous County",
   "NAME_1": "木垒哈萨克自治县",
   "Ethnic1": "Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "61.5 %",
   "Numerical": 70,
   "Ethnic2": "Kazakh",
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Sunni)",
   "SReligCatp": "25.7 %",
   "Nummeric_1": 30,
   "DataSource": "https:\/\/baike.baidu.com\/item\/%E6%9C%A8%E5%9E%92%E5%93%88%E8%90%A8%E5%85%8B%E8%87%AA%E6%B2%BB%E5%8E%BF#5",
   "Year": 2013
  },
  {
   "OBJECTID": 3245,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Yanqi Hui Autonomous County",
   "NAME_1": "焉耆回族自治县",
   "Ethnic1": "Uyghurs, Hui",
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "59.4 %",
   "Numerical": 60,
   "Ethnic2": "Han",
   "SecRelig0": "East Asian Religiosity",
   "SecRelig": "East Asian Religiosity",
   "SReligCatp": "38.3 %",
   "Nummeric_1": 40,
   "DataSource": "http:\/\/www.xjyq.gov.cn\/page.do?danwei=1&fenlei=8000&nian=2020&liushui=36",
   "Year": 2019
  },
  {
   "OBJECTID": 3246,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Tashkurgan Tajik Autonomous County",
   "NAME_1": "塔什库尔干塔吉克自治县",
   "Ethnic1": "Tajik",
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80.9 %",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/www.tskeg.gov.cn\/tskeg\/gkxx\/202006\/c54e8dabe06c4f7eb0ad6fe13a20d7b1.shtml",
   "Year": 2019
  },
  {
   "OBJECTID": 3247,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Qapqal Xibe Autonomous County",
   "NAME_1": "察布查尔锡伯自治县",
   "Ethnic1": "Uyghurs, Kazakh",
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "67.52 %",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/www.xjcbcr.gov.cn\/mljx\/about\/jjsh.htm",
   "Year": 2019
  },
  {
   "OBJECTID": 3248,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Hebukeser Mongolian Autonomous County",
   "NAME_1": "和布克赛尔蒙古自治县",
   "Ethnic1": "Mongolian",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Tibetan Buddhism)",
   "ReligCatP": "63.68 %",
   "Numerical": 70,
   "Ethnic2": "Han",
   "SecRelig0": "East Asian Religiosity",
   "SecRelig": "East Asian Religiosity",
   "SReligCatp": "36.32 %",
   "Nummeric_1": 40,
   "DataSource": "http:\/\/www.xjhbk.gov.cn\/xjhbk\/hbksegk\/202004\/c12adbd3aff94961a33a89ee4441f2ac.shtml",
   "Year": 2019
  },
  {
   "OBJECTID": 3249,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Yanbian Korean Autonomous Prefecture",
   "NAME_1": "延边朝鲜族自治州",
   "Ethnic1": "Han, Koreans",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "74.42 %",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/zfxxgk.yanbian.gov.cn\/tjgb\/202005\/t20200526_150588.html",
   "Year": 2019
  },
  {
   "OBJECTID": 3250,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Enshi Tujia and Miao Autonomous Prefecture",
   "NAME_1": "恩施土家族苗族自治州",
   "Ethnic1": "Tujia",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "54.04 %",
   "Numerical": 60,
   "Ethnic2": "Han",
   "SecRelig0": "East Asian Religiosity",
   "SecRelig": "East Asian Religiosity",
   "SReligCatp": "45.32 %",
   "Nummeric_1": 50,
   "DataSource": "湖北省人口普查辦公室、湖北省統計局. 《湖北省2010年人口普查資料》. 中國統計出版社. 2012年6月. ISBN 978-7-5037-6545-2.",
   "Year": 2010
  },
  {
   "OBJECTID": 3251,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Xiangxi Tujia and Miao Autonomous Prefecture",
   "NAME_1": "湘西土家族苗族自治州",
   "Ethnic1": "Tujia, Miao",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": ">80.84 %",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/www.xxz.gov.cn\/zjxx\/xxgk_63925\/zqjs\/",
   "Year": 2019
  },
  {
   "OBJECTID": 3252,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Aba Tibetan and Qiang Autonomous Prefecture",
   "NAME_1": "阿坝藏族羌族自治州",
   "Ethnic1": "Tibetan",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Tibetan Buddhism)",
   "ReligCatP": "59.27 %",
   "Numerical": 60,
   "Ethnic2": "Han",
   "SecRelig0": "East Asian Religiosity",
   "SecRelig": "East Asian Religiosity",
   "SReligCatp": "18.84 %",
   "Nummeric_1": 20,
   "DataSource": "https:\/\/www.abazhou.gov.cn\/abazhou\/c104359u\/l_c.shtml",
   "Year": 2018
  },
  {
   "OBJECTID": 3253,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Ganzi Tibetan Autonomous Prefecture",
   "NAME_1": "甘孜藏族自治州",
   "Ethnic1": "Tibetan",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Tibetan Buddhism)",
   "ReligCatP": "78.29 %",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "四川省人口普查办公室、四川省统计局. 《四川省2010年人口普查数据》. 中国统计出版社. 2012年6月. ISBN 978-7-5037-6547-6.",
   "Year": 2010
  },
  {
   "OBJECTID": 3254,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Liangshan Yi Autonomous Prefecture",
   "NAME_1": "凉山彝族自治州",
   "Ethnic1": "Yi",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "53.84 %",
   "Numerical": 60,
   "Ethnic2": "Han",
   "SecRelig0": "East Asian Religiosity",
   "SecRelig": "East Asian Religiosity",
   "SReligCatp": "42.75 %",
   "Nummeric_1": 50,
   "DataSource": "http:\/\/www.lsz.gov.cn\/wcls\/lsgk\/lsgk_21388\/202007\/t20200709_1644995.html",
   "Year": 2019
  },
  {
   "OBJECTID": 3255,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Qianxinan Buyei and Miao Autonomous Prefecture",
   "NAME_1": "黔西南布依族苗族自治州",
   "Ethnic1": "Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "60.62 %",
   "Numerical": 70,
   "Ethnic2": "Bouyei",
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "36.87 %",
   "Nummeric_1": 40,
   "DataSource": "贵州省第六次全国人口普查领导小组办公室. 《贵州省2010年人口普查数据》. 中国统计出版社. 2012年7月. ISBN 978-7-5037-6534-6.",
   "Year": 2010
  },
  {
   "OBJECTID": 3256,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Qiandongnan Miao and Dong Autonomous Prefecture",
   "NAME_1": "黔东南苗族侗族自治州",
   "Ethnic1": "Miao, Dong",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "73.7 %",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/www.qdn.gov.cn\/dmqdn\/qdngk\/202006\/t20200618_61151361.html",
   "Year": 2019
  },
  {
   "OBJECTID": 3257,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Qiannan Buyi and Miao Autonomous Prefecture",
   "NAME_1": "黔南布依族苗族自治州",
   "Ethnic1": "Buyi, Miao, Sui",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "56.81 %",
   "Numerical": 60,
   "Ethnic2": "Han",
   "SecRelig0": "East Asian Religiosity",
   "SecRelig": "East Asian Religiosity",
   "SReligCatp": "42 %",
   "Nummeric_1": 50,
   "DataSource": "http:\/\/www.qiannan.gov.cn\/zjqn\/mzzj\/",
   "Year": 2019
  },
  {
   "OBJECTID": 3258,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Chuxiong Yi Autonomous Prefecture",
   "NAME_1": "楚雄彝族自治州",
   "Ethnic1": "Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "66.94 %",
   "Numerical": 70,
   "Ethnic2": "Yi",
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "26.7 %",
   "Nummeric_1": 30,
   "DataSource": "云南省人口普查办公室、云南省统计局. 《云南省2010年人口普查数据》. 中国统计出版社. 2012年9月. ISBN 978-7-5037-6548-3.",
   "Year": 2010
  },
  {
   "OBJECTID": 3259,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Honghe Hani and Yi Autonomous Prefecture",
   "NAME_1": "红河哈尼族彝族自治州",
   "Ethnic1": "Han",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "48.24 %",
   "Numerical": 50,
   "Ethnic2": "Yi, Hani",
   "SecRelig0": "East Asian Religiosity",
   "SecRelig": "East Asian Religiosity",
   "SReligCatp": "40.74 %",
   "Nummeric_1": 50,
   "DataSource": "云南省人口普查办公室、云南省统计局. 《云南省2010年人口普查数据》. 中国统计出版社. 2012年9月. ISBN 978-7-5037-6548-3.",
   "Year": 2010
  },
  {
   "OBJECTID": 3260,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Wenshan Zhuang and Miao Autonomous Prefecture",
   "NAME_1": "文山壮族苗族自治州",
   "Ethnic1": "Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "42.69 %",
   "Numerical": 50,
   "Ethnic2": "Zhuang, Yao",
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "31.95 %",
   "Nummeric_1": 40,
   "DataSource": "云南省人口普查办公室、云南省统计局. 《云南省2010年人口普查数据》. 中国统计出版社. 2012年9月. ISBN 978-7-5037-6548-3.",
   "Year": 2010
  },
  {
   "OBJECTID": 3261,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Xishuangbanna Dai Autonomous Prefecture",
   "NAME_1": "西双版纳傣族自治州",
   "Ethnic1": "Dai",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "33.57 %",
   "Numerical": 40,
   "Ethnic2": "Hani, Yi",
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "36.21 %",
   "Nummeric_1": 40,
   "DataSource": "https:\/\/www.xsbn.gov.cn\/88.news.detail.dhtml?news_id=34206",
   "Year": 2019
  },
  {
   "OBJECTID": 3262,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Dali Bai Autonomous Prefecture",
   "NAME_1": "大理白族自治州",
   "Ethnic1": "Han, Bai",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "82.88 %",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "云南省人口普查办公室、云南省统计局. 《云南省2010年人口普查数据》. 中国统计出版社. 2012年9月. ISBN 978-7-5037-6548-3.",
   "Year": 2010
  },
  {
   "OBJECTID": 3263,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Dehong Dai Jingpo Autonomous Prefecture",
   "NAME_1": "德宏傣族景颇族自治州",
   "Ethnic1": "Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "51.93 %",
   "Numerical": 60,
   "Ethnic2": "Dai",
   "SecRelig0": "Buddhism",
   "SecRelig": "Buddhists(Theravada)",
   "SReligCatp": "28.88 %",
   "Nummeric_1": 30,
   "DataSource": "云南省人口普查办公室、云南省统计局. 《云南省2010年人口普查数据》. 中国统计出版社. 2012年9月. ISBN 978-7-5037-6548-3.",
   "Year": 2010
  },
  {
   "OBJECTID": 3264,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Nujiang Lisu Autonomous Prefecture",
   "NAME_1": "怒江傈僳族自治州",
   "Ethnic1": "Lisu",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "48.21 %",
   "Numerical": 50,
   "Ethnic2": "Bai, Han",
   "SecRelig0": "East Asian Religiosity",
   "SecRelig": "East Asian Religiosity",
   "SReligCatp": "38.39 %",
   "Nummeric_1": 40,
   "DataSource": "云南省人口普查办公室、云南省统计局. 《云南省2010年人口普查数据》. 中国统计出版社. 2012年9月. ISBN 978-7-5037-6548-3.",
   "Year": 2010
  },
  {
   "OBJECTID": 3265,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Diqing Tibetan Autonomous Prefecture",
   "NAME_1": "迪庆藏族自治州",
   "Ethnic1": "Lisu, Naxi",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "42.51 %",
   "Numerical": 50,
   "Ethnic2": "Tibetan",
   "SecRelig0": "Buddhism",
   "SecRelig": "Buddhists(Tibetan Buddhism)",
   "SReligCatp": "37.48 %",
   "Nummeric_1": 40,
   "DataSource": "云南省人口普查办公室、云南省统计局. 《云南省2010年人口普查数据》. 中国统计出版社. 2012年9月. ISBN 978-7-5037-6548-3.",
   "Year": 2010
  },
  {
   "OBJECTID": 3266,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Linxia Hui Autonomous Prefecture",
   "NAME_1": "临夏回族自治州",
   "Ethnic1": "Hui, Dongxiang",
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "57.58 %",
   "Numerical": 60,
   "Ethnic2": "Han",
   "SecRelig0": "East Asian Religiosity",
   "SecRelig": "East Asian Religiosity",
   "SReligCatp": "39.7 %",
   "Nummeric_1": 40,
   "DataSource": "甘肃省人口普查办公室、甘肃省统计局. 《甘肃省2010年人口普查数据》. 中国统计出版社. 2012年7月. ISBN 978-7-5037-6561-2.",
   "Year": 2010
  },
  {
   "OBJECTID": 3267,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Gannan Tibetan Autonomous Prefecture",
   "NAME_1": "甘南藏族自治州",
   "Ethnic1": "Tibetan",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Tibetan Buddhism)",
   "ReligCatP": "54.64 %",
   "Numerical": 60,
   "Ethnic2": "Han",
   "SecRelig0": "East Asian Religiosity",
   "SecRelig": "East Asian Religiosity",
   "SReligCatp": "38.7 %",
   "Nummeric_1": 40,
   "DataSource": "甘肃省人口普查办公室、甘肃省统计局. 《甘肃省2010年人口普查数据》. 中国统计出版社. 2012年7月. ISBN 978-7-5037-6561-2.",
   "Year": 2010
  },
  {
   "OBJECTID": 3268,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Haibei Tibetan Autonomous Prefecture",
   "NAME_1": "海北藏族自治州",
   "Ethnic1": "Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "35.88 %",
   "Numerical": 40,
   "Ethnic2": "Hui",
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Sunni)",
   "SReligCatp": "31.92 %",
   "Nummeric_1": 40,
   "DataSource": "青海省统计局、青海省第六次人口普查办公室. 《青海省2010年人口普查数据》. 中国统计出版社. 2012年6月. ISBN 978-7-5037-6521-6.",
   "Year": 2010
  },
  {
   "OBJECTID": 3269,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Huangnan Tibetan Autonomous Prefecture",
   "NAME_1": "黄南藏族自治州",
   "Ethnic1": "Tibetan",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Tibetan Buddhism)",
   "ReligCatP": "68.55 %",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "青海省统计局、青海省第六次人口普查办公室. 《青海省2010年人口普查数据》. 中国统计出版社. 2012年6月. ISBN 978-7-5037-6521-6.",
   "Year": 2010
  },
  {
   "OBJECTID": 3270,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Hainan Tibetan Autonomous Prefecture",
   "NAME_1": "海南藏族自治州",
   "Ethnic1": "Tibetan",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Tibetan Buddhism)",
   "ReligCatP": "66.31 %",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "青海省统计局、青海省第六次人口普查办公室. 《青海省2010年人口普查数据》. 中国统计出版社. 2012年6月. ISBN 978-7-5037-6521-6.",
   "Year": 2010
  },
  {
   "OBJECTID": 3271,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Golog Tibetan Autonomous Prefecture",
   "NAME_1": "果洛藏族自治州",
   "Ethnic1": "Tibetan",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Tibetan Buddhism)",
   "ReligCatP": "91.86 %",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "青海省统计局、青海省第六次人口普查办公室. 《青海省2010年人口普查数据》. 中国统计出版社. 2012年6月. ISBN 978-7-5037-6521-6.",
   "Year": 2010
  },
  {
   "OBJECTID": 3272,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Yushu Tibetan Autonomous Prefecture",
   "NAME_1": "玉树藏族自治州",
   "Ethnic1": "Tibetan",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Tibetan Buddhism)",
   "ReligCatP": "96.49 %",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "青海省统计局、青海省第六次人口普查办公室. 《青海省2010年人口普查数据》. 中国统计出版社. 2012年6月. ISBN 978-7-5037-6521-6.",
   "Year": 2010
  },
  {
   "OBJECTID": 3273,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Haixi Mongol and Tibetan Autonomous Prefecture",
   "NAME_1": "海西蒙古族藏族自治州",
   "Ethnic1": "Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "66.01 %",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "青海省统计局、青海省第六次人口普查办公室. 《青海省2010年人口普查数据》. 中国统计出版社. 2012年6月. ISBN 978-7-5037-6521-6.",
   "Year": 2010
  },
  {
   "OBJECTID": 3274,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Changji Hui Autonomous Prefecture",
   "NAME_1": "昌吉回族自治州",
   "Ethnic1": "Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "75.31 %",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "新疆维吾尔自治区人民政府人口普查领导小组办公室. 《新疆维吾尔自治区2010年人口普查数据》. 中国统计出版社. 2012年8月. ISBN 978-7-5037-6516-2.",
   "Year": 2010
  },
  {
   "OBJECTID": 3275,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Bortala Mongolian Autonomous Prefecture",
   "NAME_1": "博尔塔拉蒙古自治州",
   "Ethnic1": "Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "64.96 %",
   "Numerical": 70,
   "Ethnic2": "Uyghurs, Kazakh",
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Sunni)",
   "SReligCatp": "23.33 %",
   "Nummeric_1": 30,
   "DataSource": "新疆维吾尔自治区人民政府人口普查领导小组办公室. 《新疆维吾尔自治区2010年人口普查数据》. 中国统计出版社. 2012年8月. ISBN 978-7-5037-6516-2.",
   "Year": 2010
  },
  {
   "OBJECTID": 3276,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Bayingolin Mongolian Autonomous Prefecture",
   "NAME_1": "巴音郭楞蒙古自治州",
   "Ethnic1": "Han",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "59.29 %",
   "Numerical": 60,
   "Ethnic2": "Uyghurs",
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Sunni)",
   "SReligCatp": "36.92 %",
   "Nummeric_1": 40,
   "DataSource": "新疆维吾尔自治区人民政府人口普查领导小组办公室. 《新疆维吾尔自治区2010年人口普查数据》. 中国统计出版社. 2012年8月. ISBN 978-7-5037-6516-2.",
   "Year": 2010
  },
  {
   "OBJECTID": 3277,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Kizilsu Kirgiz Autonomous Prefecture",
   "NAME_1": "克孜勒苏柯尔克孜自治州",
   "Ethnic1": "Uyghurs, Kirgiz",
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "92.6 %",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/www.xjkz.gov.cn\/zjkz\/kzgk\/kzjg\/135.htm",
   "Year": 2019
  },
  {
   "OBJECTID": 3278,
   "Continent": "Asia",
   "Country": "China",
   "ProvName": "Yili Kazakh Autonomous Prefecture",
   "NAME_1": "伊犁哈萨克自治州",
   "Ethnic1": "Uyghurs, Kazakh, Hui",
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "57.55 %",
   "Numerical": 60,
   "Ethnic2": "Han",
   "SecRelig0": "East Asian Religiosity",
   "SecRelig": "East Asian Religiosity",
   "SReligCatp": "36.56 %",
   "Nummeric_1": 40,
   "DataSource": "http:\/\/www.xjyl.gov.cn\/info\/1717\/311586.htm",
   "Year": 2015
  },
  {
   "OBJECTID": 212,
   "Continent": "South America",
   "Country": "Uruguay",
   "ProvName": "Durazno",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Uruguay. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_235_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 213,
   "Continent": "South America",
   "Country": "Uruguay",
   "ProvName": "Rocha",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Uruguay. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_235_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 214,
   "Continent": "South America",
   "Country": "Uruguay",
   "ProvName": "Rivera",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Uruguay. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_235_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 215,
   "Continent": "South America",
   "Country": "Uruguay",
   "ProvName": "Treinta y Tres",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Uruguay. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_235_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 216,
   "Continent": "Europe",
   "Country": "Montenegro",
   "ProvName": "Tivat",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 217,
   "Continent": "South America",
   "Country": "Uruguay",
   "ProvName": "Tacuarembó",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Uruguay. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_235_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 218,
   "Continent": "South America",
   "Country": "Uruguay",
   "ProvName": "Canelones",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Uruguay. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_235_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 219,
   "Continent": "Europe",
   "Country": "Montenegro",
   "ProvName": "Savnik",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 220,
   "Continent": "South America",
   "Country": "Uruguay",
   "ProvName": "Florida",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Uruguay. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_235_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 221,
   "Continent": "South America",
   "Country": "Uruguay",
   "ProvName": "Montevideo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Uruguay. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_235_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 222,
   "Continent": "South America",
   "Country": "Uruguay",
   "ProvName": "Colonia",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Uruguay. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_235_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 223,
   "Continent": "South America",
   "Country": "Uruguay",
   "ProvName": "Lavalleja",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Uruguay. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_235_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 224,
   "Continent": "South America",
   "Country": "Uruguay",
   "ProvName": "Maldonado",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Uruguay. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_235_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 225,
   "Continent": "Africa",
   "Country": "Tunisia",
   "ProvName": "Bin Arus",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "\"Chapter 1: Religious Affiliation\". The World’s Muslims: Unity and Diversity. Pew Research Center's Religion & Public Life Project. August 9, 2012.",
   "Year": 2012
  },
  {
   "OBJECTID": 226,
   "Continent": "South America",
   "Country": "Venezuela",
   "ProvName": "Falcón",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Venezuela. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_238_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 227,
   "Continent": "Africa",
   "Country": "Malawi",
   "ProvName": "Likoma",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "Malawi. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_138_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 228,
   "Continent": "Africa",
   "Country": "Somalia",
   "ProvName": "Bari",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 229,
   "Continent": "Europe",
   "Country": "Belgium",
   "ProvName": "Wallonia",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Special Eurobarometer 493, European Union: European Commission, September 2019, pages 229-230",
   "Year": 2019
  },
  {
   "OBJECTID": 230,
   "Continent": "South America",
   "Country": "Uruguay",
   "ProvName": "San José",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Uruguay. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_235_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 231,
   "Continent": "Europe",
   "Country": "Montenegro",
   "ProvName": "Zabljak",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 232,
   "Continent": "Europe",
   "Country": "Belgium",
   "ProvName": "Flanders",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Special Eurobarometer 493, European Union: European Commission, September 2019, pages 229-230",
   "Year": 2019
  },
  {
   "OBJECTID": 233,
   "Continent": "Europe",
   "Country": "Moldova",
   "ProvName": "Donduseni",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 234,
   "Continent": "South America",
   "Country": "Uruguay",
   "ProvName": "Artigas",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Uruguay. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_235_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 235,
   "Continent": "South America",
   "Country": "Uruguay",
   "ProvName": "Flores",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Uruguay. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_235_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 236,
   "Continent": "Asia",
   "Country": "Cambodia",
   "ProvName": "Prey Veaeng",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 237,
   "Continent": "South America",
   "Country": "Uruguay",
   "ProvName": "Paysandú",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Uruguay. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_235_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 238,
   "Continent": "South America",
   "Country": "Venezuela",
   "ProvName": "Carabobo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Venezuela. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_238_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 239,
   "Continent": "South America",
   "Country": "Uruguay",
   "ProvName": "Río Negro",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Uruguay. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_235_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 240,
   "Continent": "Europe",
   "Country": "Russia",
   "ProvName": "Kaliningrad",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "30-35%",
   "Numerical": 35,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 241,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Lampang",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 242,
   "Continent": "South America",
   "Country": "Uruguay",
   "ProvName": "Salto",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Uruguay. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_235_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 243,
   "Continent": "Africa",
   "Country": "Niger",
   "ProvName": "Niamey",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 244,
   "Continent": "South America",
   "Country": "Uruguay",
   "ProvName": "Soriano",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Uruguay. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_235_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 245,
   "Continent": "South America",
   "Country": "Uruguay",
   "ProvName": "Cerro Largo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Uruguay. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_235_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 246,
   "Continent": "South America",
   "Country": "Venezuela",
   "ProvName": "Apure",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Venezuela. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_238_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 247,
   "Continent": "South America",
   "Country": "Venezuela",
   "ProvName": "Barinas",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Venezuela. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_238_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 248,
   "Continent": "North America",
   "Country": "Trinidad & Tobago",
   "ProvName": "Couva\/Tabaquite\/Talparo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "20-25%",
   "Nummeric_1": 25,
   "DataSource": "Trinidad and Tobago. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_224_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 249,
   "Continent": "North America",
   "Country": "Trinidad & Tobago",
   "ProvName": "Penal\/Debe",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "20-25%",
   "Nummeric_1": 25,
   "DataSource": "Trinidad and Tobago. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_224_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 250,
   "Continent": "North America",
   "Country": "Trinidad & Tobago",
   "ProvName": "Point Fortin",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "20-25%",
   "Nummeric_1": 25,
   "DataSource": "Trinidad and Tobago. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_224_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 251,
   "Continent": "Asia",
   "Country": "Qatar",
   "ProvName": "ash-Shamal",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 252,
   "Continent": "South America",
   "Country": "Venezuela",
   "ProvName": "Mérida",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Venezuela. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_238_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 253,
   "Continent": "Europe",
   "Country": "Portugal",
   "ProvName": "Algarve",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Portugal. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_181_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 254,
   "Continent": "South America",
   "Country": "Venezuela",
   "ProvName": "Táchira",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Venezuela. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_238_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 255,
   "Continent": "Europe",
   "Country": "Slovenia",
   "ProvName": "Savinjska",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Eurobarometer 90.4 (December 2018): Attitudes of Europeans towards Biodiversity, Awareness and Perceptions of EU customs, and Perceptions of Antisemitism",
   "Year": 2018
  },
  {
   "OBJECTID": 256,
   "Continent": "South America",
   "Country": "Venezuela",
   "ProvName": "Trujillo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Venezuela. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_238_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 257,
   "Continent": "South America",
   "Country": "Venezuela",
   "ProvName": "Zulia",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Venezuela. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_238_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 258,
   "Continent": "South America",
   "Country": "Venezuela",
   "ProvName": "Yaracuy",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Venezuela. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_238_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 259,
   "Continent": "South America",
   "Country": "Venezuela",
   "ProvName": "Cojedes",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Venezuela. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_238_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 260,
   "Continent": "South America",
   "Country": "Suriname",
   "ProvName": "Nickerie",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Hinduism",
   "HighRelig": "Hindus",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 261,
   "Continent": "South America",
   "Country": "Venezuela",
   "ProvName": "Amazonas",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Venezuela. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_238_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 262,
   "Continent": "South America",
   "Country": "Venezuela",
   "ProvName": "Bolívar",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Venezuela. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_238_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 263,
   "Continent": "South America",
   "Country": "Venezuela",
   "ProvName": "Anzoátegui",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Venezuela. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_238_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 264,
   "Continent": "South America",
   "Country": "Venezuela",
   "ProvName": "Lara",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Venezuela. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_238_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 265,
   "Continent": "Oceania",
   "Country": "Samoa",
   "ProvName": "North Western Upolu",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Samoa. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_193_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 266,
   "Continent": "Oceania",
   "Country": "Samoa",
   "ProvName": "Apia Urban Area",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Samoa. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_193_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 267,
   "Continent": "South America",
   "Country": "Venezuela",
   "ProvName": "Portuguesa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Venezuela. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_238_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 268,
   "Continent": "South America",
   "Country": "Venezuela",
   "ProvName": "Dependencias Federales",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Venezuela. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_238_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 269,
   "Continent": "South America",
   "Country": "Venezuela",
   "ProvName": "Guarico",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Venezuela. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_238_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 270,
   "Continent": "South America",
   "Country": "Venezuela",
   "ProvName": "Aragua",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Venezuela. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_238_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 271,
   "Continent": "North America",
   "Country": "Trinidad & Tobago",
   "ProvName": "Diego Martin",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "20-25%",
   "Nummeric_1": 25,
   "DataSource": "Trinidad and Tobago. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_224_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 272,
   "Continent": "South America",
   "Country": "Trinidad & Tobago",
   "ProvName": "Siparia",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "20-25%",
   "Nummeric_1": 25,
   "DataSource": "Trinidad and Tobago. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_224_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 273,
   "Continent": "North America",
   "Country": "Trinidad & Tobago",
   "ProvName": "Arima",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "20-25%",
   "Nummeric_1": 25,
   "DataSource": "Trinidad and Tobago. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_224_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 274,
   "Continent": "Asia",
   "Country": "Qatar",
   "ProvName": "Umm Salal",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 275,
   "Continent": "South America",
   "Country": "Venezuela",
   "ProvName": "Vargas",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Venezuela. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_238_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 276,
   "Continent": "South America",
   "Country": "Venezuela",
   "ProvName": "Distrito Federal",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Venezuela. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_238_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 277,
   "Continent": "North America",
   "Country": "Trinidad & Tobago",
   "ProvName": "Sangre Grande",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "20-25%",
   "Nummeric_1": 25,
   "DataSource": "Trinidad and Tobago. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_224_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 278,
   "Continent": "North America",
   "Country": "Trinidad & Tobago",
   "ProvName": "Mayaro\/Rio Claro",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "20-25%",
   "Nummeric_1": 25,
   "DataSource": "Trinidad and Tobago. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_224_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 279,
   "Continent": "South America",
   "Country": "Venezuela",
   "ProvName": "Monagas",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Venezuela. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_238_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 280,
   "Continent": "South America",
   "Country": "Venezuela",
   "ProvName": "Miranda",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Venezuela. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_238_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 281,
   "Continent": "North America",
   "Country": "Trinidad & Tobago",
   "ProvName": "San Juan\/Laventille",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "20-25%",
   "Nummeric_1": 25,
   "DataSource": "Trinidad and Tobago. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_224_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 282,
   "Continent": "Africa",
   "Country": "Sudan",
   "ProvName": "Kassalâ (Kassala)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 283,
   "Continent": "Europe",
   "Country": "Austria",
   "ProvName": "Steiermark",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Austrian Catholic Church data 2017. https:\/\/www.katholisch.at\/aktuelles\/2018\/01\/09\/statistik-2017-wieder-leichter-rueckgang-bei-kirchenaustritten",
   "Year": 2017
  },
  {
   "OBJECTID": 284,
   "Continent": "South America",
   "Country": "Venezuela",
   "ProvName": "Nueva Esparta",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Venezuela. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_238_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 285,
   "Continent": "South America",
   "Country": "Venezuela",
   "ProvName": "Sucre",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Venezuela. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_238_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 286,
   "Continent": "North America",
   "Country": "Trinidad & Tobago",
   "ProvName": "Tobago",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "20-25%",
   "Nummeric_1": 25,
   "DataSource": "Trinidad and Tobago. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_224_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 287,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Lamphun",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 288,
   "Continent": "South America",
   "Country": "Suriname",
   "ProvName": "Paramaribo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "2012 Suriname Census Definitive Results. Algemeen Bureau voor de Statistiek - Suriname.",
   "Year": 2012
  },
  {
   "OBJECTID": 289,
   "Continent": "Africa",
   "Country": "Tunisia",
   "ProvName": "Tunis",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "\"Chapter 1: Religious Affiliation\". The World’s Muslims: Unity and Diversity. Pew Research Center's Religion & Public Life Project. August 9, 2012.",
   "Year": 2012
  },
  {
   "OBJECTID": 290,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Nan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 291,
   "Continent": "North America",
   "Country": "Trinidad & Tobago",
   "ProvName": "Princes Town",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "20-25%",
   "Nummeric_1": 25,
   "DataSource": "Trinidad and Tobago. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_224_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 292,
   "Continent": "Europe",
   "Country": "Serbia",
   "ProvName": "Vojvodina",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/en.wikipedia.org\/wiki\/Religion_in_Vojvodina#cite_note-1",
   "Year": 2011
  },
  {
   "OBJECTID": 293,
   "Continent": "Europe",
   "Country": "Norway",
   "ProvName": "Finnmark",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Norway. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_170_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 294,
   "Continent": "Europe",
   "Country": "Slovenia",
   "ProvName": "Jugovzhodna Slovenija",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Eurobarometer 90.4 (December 2018): Attitudes of Europeans towards Biodiversity, Awareness and Perceptions of EU customs, and Perceptions of Antisemitism",
   "Year": 2018
  },
  {
   "OBJECTID": 295,
   "Continent": "Europe",
   "Country": "Slovenia",
   "ProvName": "Osrednjeslovenska",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Eurobarometer 90.4 (December 2018): Attitudes of Europeans towards Biodiversity, Awareness and Perceptions of EU customs, and Perceptions of Antisemitism",
   "Year": 2018
  },
  {
   "OBJECTID": 296,
   "Continent": "Europe",
   "Country": "Spain",
   "ProvName": "Extremadura",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Spain. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_208_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 297,
   "Continent": "Europe",
   "Country": "Portugal",
   "ProvName": "Alentejo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Portugal. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_181_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 298,
   "Continent": "Africa",
   "Country": "Burundi",
   "ProvName": "Bubanza",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Anthony Appiah; Henry Louis Gates (2010). Encyclopedia of Africa. Oxford University Press. p. 221. ISBN 978-0-19-533770-9.",
   "Year": 2010
  },
  {
   "OBJECTID": 299,
   "Continent": "Europe",
   "Country": "Portugal",
   "ProvName": "Lisboa e Vale do Tejo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Portugal. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_181_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 300,
   "Continent": "Oceania",
   "Country": "Samoa",
   "ProvName": "Rest of Upolu",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Samoa. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_193_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 301,
   "Continent": "Europe",
   "Country": "Portugal",
   "ProvName": "Norte",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Portugal. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_181_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 302,
   "Continent": "Africa",
   "Country": "Tunisia",
   "ProvName": "al-Kaf",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "\"Chapter 1: Religious Affiliation\". The World’s Muslims: Unity and Diversity. Pew Research Center's Religion & Public Life Project. August 9, 2012.",
   "Year": 2012
  },
  {
   "OBJECTID": 303,
   "Continent": "Africa",
   "Country": "Mauritius",
   "ProvName": "Rodrigues",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mauritius. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_147_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 304,
   "Continent": "Europe",
   "Country": "Portugal",
   "ProvName": "Centro",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Portugal. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_181_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 305,
   "Continent": "Africa",
   "Country": "Sao Tome & Principe",
   "ProvName": "Príncipe",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sao Tome and Principe. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_195_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 306,
   "Continent": "Africa",
   "Country": "Sudan",
   "ProvName": "Janûb Kurdufân (South Kordufan)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 307,
   "Continent": "Africa",
   "Country": "Sudan",
   "ProvName": "Shamâl Kurdufân (North Kordufan)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 308,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Phayao",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 309,
   "Continent": "Asia",
   "Country": "Saudi Arabia",
   "ProvName": "Al-Baha",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 310,
   "Continent": "Asia",
   "Country": "Saudi Arabia",
   "ProvName": "Aseer",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 311,
   "Continent": "South America",
   "Country": "Ecuador",
   "ProvName": "El Oro",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 312,
   "Continent": "Asia",
   "Country": "Saudi Arabia",
   "ProvName": "Jazan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 313,
   "Continent": "Asia",
   "Country": "Saudi Arabia",
   "ProvName": "Makkah Al-Mokarramah",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 314,
   "Continent": "Africa",
   "Country": "Kenya",
   "ProvName": "Eastern",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "35-40%",
   "Nummeric_1": 40,
   "DataSource": "Kenya. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_121_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 315,
   "Continent": "Africa",
   "Country": "Kenya",
   "ProvName": "Rift Valley",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "35-40%",
   "Nummeric_1": 40,
   "DataSource": "Kenya. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_121_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 316,
   "Continent": "Asia",
   "Country": "Timor-Leste",
   "ProvName": "Ambeno (Oecussi)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Timor-Leste: Demographic and Health Survey, 2016\" (PDF). General Directorate of Statistics, Ministry of Planning and Finance & Ministry of Health. p. 35.",
   "Year": 2016
  },
  {
   "OBJECTID": 317,
   "Continent": "South America",
   "Country": "Argentina",
   "ProvName": "Salta",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"PEW Research Center: Religion in Latin America 2014\".",
   "Year": 2014
  },
  {
   "OBJECTID": 318,
   "Continent": "Europe",
   "Country": "Slovakia",
   "ProvName": "Zilina",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Slovakia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_202_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 319,
   "Continent": "Asia",
   "Country": "Cyprus",
   "ProvName": "Famagusta",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 320,
   "Continent": "Europe",
   "Country": "Slovakia",
   "ProvName": "Nitra",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Slovakia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_202_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 321,
   "Continent": "Europe",
   "Country": "Slovakia",
   "ProvName": "Trencin",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Slovakia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_202_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 322,
   "Continent": "Europe",
   "Country": "Slovakia",
   "ProvName": "Trnava",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Slovakia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_202_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 323,
   "Continent": "Asia",
   "Country": "Jordan",
   "ProvName": "Tafiela",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 324,
   "Continent": "Europe",
   "Country": "Slovakia",
   "ProvName": "Kosice",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Slovakia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_202_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 325,
   "Continent": "Europe",
   "Country": "Slovakia",
   "ProvName": "Presov",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Slovakia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_202_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 326,
   "Continent": "South America",
   "Country": "Ecuador",
   "ProvName": "Loja",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 327,
   "Continent": "South America",
   "Country": "Ecuador",
   "ProvName": "Bolívar",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 328,
   "Continent": "North America",
   "Country": "Dominica",
   "ProvName": "St. Joseph",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "Dominica. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_69_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 329,
   "Continent": "South America",
   "Country": "Ecuador",
   "ProvName": "Zamora Chinchipe",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 330,
   "Continent": "Asia",
   "Country": "Cambodia",
   "ProvName": "Kandal",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 331,
   "Continent": "South America",
   "Country": "Ecuador",
   "ProvName": "Galápagos",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 332,
   "Continent": "South America",
   "Country": "Argentina",
   "ProvName": "Santa Cruz",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"PEW Research Center: Religion in Latin America 2014\".",
   "Year": 2014
  },
  {
   "OBJECTID": 333,
   "Continent": "South America",
   "Country": "Argentina",
   "ProvName": "Tierra del Fuego",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"PEW Research Center: Religion in Latin America 2014\".",
   "Year": 2014
  },
  {
   "OBJECTID": 334,
   "Continent": "South America",
   "Country": "Argentina",
   "ProvName": "San Juan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"PEW Research Center: Religion in Latin America 2014\".",
   "Year": 2014
  },
  {
   "OBJECTID": 335,
   "Continent": "South America",
   "Country": "Argentina",
   "ProvName": "Chubut",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"PEW Research Center: Religion in Latin America 2014\".",
   "Year": 2014
  },
  {
   "OBJECTID": 336,
   "Continent": "South America",
   "Country": "Argentina",
   "ProvName": "Mendoza",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"PEW Research Center: Religion in Latin America 2014\".",
   "Year": 2014
  },
  {
   "OBJECTID": 337,
   "Continent": "South America",
   "Country": "Argentina",
   "ProvName": "Neuquén",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"PEW Research Center: Religion in Latin America 2014\".",
   "Year": 2014
  },
  {
   "OBJECTID": 338,
   "Continent": "Asia",
   "Country": "Yemen",
   "ProvName": "Dhamar",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "Integrated Regional Information Networks (IRIN), Yemen: The conflict in Saada Governorate - analysis, 24 July 2008, available at: http:\/\/www.unhcr.org\/refworld\/docid\/488f180d1e.html",
   "Year": 2008
  },
  {
   "OBJECTID": 339,
   "Continent": "Asia",
   "Country": "Cambodia",
   "ProvName": "Kampong Cham",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 340,
   "Continent": "Asia",
   "Country": "Cambodia",
   "ProvName": "Kampong Chhnang",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 341,
   "Continent": "Asia",
   "Country": "Cambodia",
   "ProvName": "Kampong Spueu",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 342,
   "Continent": "Asia",
   "Country": "Cambodia",
   "ProvName": "Kampong Thum",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 343,
   "Continent": "Asia",
   "Country": "Cambodia",
   "ProvName": "Phnom Penh",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 344,
   "Continent": "Asia",
   "Country": "Cambodia",
   "ProvName": "Preah Vihear",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 345,
   "Continent": "Europe",
   "Country": "United Kingdom",
   "ProvName": "Essex",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "United Kingdom. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_233_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 346,
   "Continent": "Asia",
   "Country": "Cambodia",
   "ProvName": "Stueng Traeng",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 347,
   "Continent": "South America",
   "Country": "Suriname",
   "ProvName": "Brokopondo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "2012 Suriname Census Definitive Results. Algemeen Bureau voor de Statistiek - Suriname.",
   "Year": 2012
  },
  {
   "OBJECTID": 348,
   "Continent": "South America",
   "Country": "Suriname",
   "ProvName": "Marowijne",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "2012 Suriname Census Definitive Results. Algemeen Bureau voor de Statistiek - Suriname.",
   "Year": 2012
  },
  {
   "OBJECTID": 349,
   "Continent": "Asia",
   "Country": "Cambodia",
   "ProvName": "Kracheh",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 350,
   "Continent": "Europe",
   "Country": "Gibraltar",
   "ProvName": "Gibraltar",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Gibraltar. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_92_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 351,
   "Continent": "Europe",
   "Country": "Spain",
   "ProvName": "Castilla La Mancha",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Spain. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_208_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 352,
   "Continent": "Africa",
   "Country": "Tunisia",
   "ProvName": "Zaghwan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "\"Chapter 1: Religious Affiliation\". The World’s Muslims: Unity and Diversity. Pew Research Center's Religion & Public Life Project. August 9, 2012.",
   "Year": 2012
  },
  {
   "OBJECTID": 353,
   "Continent": "Europe",
   "Country": "Serbia",
   "ProvName": "Serbia",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/en.wikipedia.org\/wiki\/Religion_in_Serbia",
   "Year": 2011
  },
  {
   "OBJECTID": 354,
   "Continent": "Asia",
   "Country": "Cambodia",
   "ProvName": "Mondol Kiri",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 355,
   "Continent": "Africa",
   "Country": "Somalia",
   "ProvName": "Jubbada Dhexe",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 356,
   "Continent": "Africa",
   "Country": "Somalia",
   "ProvName": "Shabeellaha Hoose",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 357,
   "Continent": "Asia",
   "Country": "Yemen",
   "ProvName": "Hajjah",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "Integrated Regional Information Networks (IRIN), Yemen: The conflict in Saada Governorate - analysis, 24 July 2008, available at: http:\/\/www.unhcr.org\/refworld\/docid\/488f180d1e.html",
   "Year": 2008
  },
  {
   "OBJECTID": 358,
   "Continent": "Europe",
   "Country": "United Kingdom",
   "ProvName": "East Anglia",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "United Kingdom. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_233_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 359,
   "Continent": "Europe",
   "Country": "Austria",
   "ProvName": "Vorarlberg",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Austrian Catholic Church data 2017. https:\/\/www.katholisch.at\/aktuelles\/2018\/01\/09\/statistik-2017-wieder-leichter-rueckgang-bei-kirchenaustritten",
   "Year": 2017
  },
  {
   "OBJECTID": 360,
   "Continent": "Asia",
   "Country": "Russia",
   "ProvName": "Sakha",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "10-15%",
   "Nummeric_1": 15,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 361,
   "Continent": "Europe",
   "Country": "Russia",
   "ProvName": "Moscow City",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "55-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 362,
   "Continent": "Europe",
   "Country": "Switzerland",
   "ProvName": "Appenzell Ausser-Rhoden",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "\"Religions\" (official statistics). Neuchâtel, Switzerland: Federal Statistical Office FSO. 2020.",
   "Year": 2018
  },
  {
   "OBJECTID": 363,
   "Continent": "Europe",
   "Country": "Austria",
   "ProvName": "Burgenland",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Austrian Catholic Church data 2017. https:\/\/www.katholisch.at\/aktuelles\/2018\/01\/09\/statistik-2017-wieder-leichter-rueckgang-bei-kirchenaustritten",
   "Year": 2017
  },
  {
   "OBJECTID": 364,
   "Continent": "North America",
   "Country": "Trinidad & Tobago",
   "ProvName": "Tunapuna\/Piarco",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "20-25%",
   "Nummeric_1": 25,
   "DataSource": "Trinidad and Tobago. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_224_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 365,
   "Continent": "North America",
   "Country": "Trinidad & Tobago",
   "ProvName": "San Fernando",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "20-25%",
   "Nummeric_1": 25,
   "DataSource": "Trinidad and Tobago. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_224_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 366,
   "Continent": "North America",
   "Country": "Trinidad & Tobago",
   "ProvName": "Chaguanas",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "20-25%",
   "Nummeric_1": 25,
   "DataSource": "Trinidad and Tobago. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_224_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 367,
   "Continent": "North America",
   "Country": "Trinidad & Tobago",
   "ProvName": "Port-of-Spain",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "20-25%",
   "Nummeric_1": 25,
   "DataSource": "Trinidad and Tobago. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_224_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 368,
   "Continent": "South America",
   "Country": "Venezuela",
   "ProvName": "Delta Amacuro",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Venezuela. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_238_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 369,
   "Continent": "South America",
   "Country": "Suriname",
   "ProvName": "Para",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "2012 Suriname Census Definitive Results. Algemeen Bureau voor de Statistiek - Suriname.",
   "Year": 2012
  },
  {
   "OBJECTID": 370,
   "Continent": "South America",
   "Country": "Suriname",
   "ProvName": "Sipaliwini",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "30-35%",
   "Numerical": 35,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "25-30%",
   "Nummeric_1": 20,
   "DataSource": "2012 Suriname Census Definitive Results. Algemeen Bureau voor de Statistiek - Suriname.",
   "Year": 2012
  },
  {
   "OBJECTID": 371,
   "Continent": "South America",
   "Country": "Suriname",
   "ProvName": "Commewijne",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "World Population and Housing Census Programme, United Nations (2012). https:\/\/unstats.un.org\/unsd\/demographic\/sources\/census\/wphc\/Suriname\/SUR-Census2012-vol1.pdf. https:\/\/en.wikipedia.org\/wiki\/Islam_in_Suriname",
   "Year": 2012
  },
  {
   "OBJECTID": 372,
   "Continent": "South America",
   "Country": "Suriname",
   "ProvName": "Coronie",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "35-40%",
   "Nummeric_1": 40,
   "DataSource": "2012 Suriname Census Definitive Results. Algemeen Bureau voor de Statistiek - Suriname.",
   "Year": 2012
  },
  {
   "OBJECTID": 373,
   "Continent": "Europe",
   "Country": "Moldova",
   "ProvName": "Edinet",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 374,
   "Continent": "Europe",
   "Country": "Sweden",
   "ProvName": "Västmanland",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"The Religious Landscape of Sweden\". www.myndighetensst.se. 2019.",
   "Year": 2016
  },
  {
   "OBJECTID": 375,
   "Continent": "Africa",
   "Country": "Niger",
   "ProvName": "Maradi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 376,
   "Continent": "Europe",
   "Country": "Moldova",
   "ProvName": "Balti",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 377,
   "Continent": "Europe",
   "Country": "Sweden",
   "ProvName": "Halland",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"The Religious Landscape of Sweden\". www.myndighetensst.se. 2019.",
   "Year": 2016
  },
  {
   "OBJECTID": 378,
   "Continent": "South America",
   "Country": "Suriname",
   "ProvName": "Saramacca",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Hinduism",
   "HighRelig": "Hindus",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 379,
   "Continent": "South America",
   "Country": "Suriname",
   "ProvName": "Wanica",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Hinduism",
   "HighRelig": "Hindus",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "World Population and Housing Census Programme, United Nations (2012). https:\/\/unstats.un.org\/unsd\/demographic\/sources\/census\/wphc\/Suriname\/SUR-Census2012-vol1.pdf. https:\/\/en.wikipedia.org\/wiki\/Islam_in_Suriname",
   "Year": 2012
  },
  {
   "OBJECTID": 380,
   "Continent": "Europe",
   "Country": "Norway",
   "ProvName": "Nordland",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Norway. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_170_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 381,
   "Continent": "Europe",
   "Country": "Ireland",
   "ProvName": "Munster",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Ireland. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_112_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 382,
   "Continent": "Europe",
   "Country": "Ireland",
   "ProvName": "Leinster",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Ireland. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_112_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 383,
   "Continent": "Europe",
   "Country": "Ireland",
   "ProvName": "Ulster",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Ireland. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_112_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 384,
   "Continent": "Europe",
   "Country": "Spain",
   "ProvName": "Andalucia",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Spain. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_208_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 385,
   "Continent": "Europe",
   "Country": "Spain",
   "ProvName": "Cantabria",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Spain. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_208_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 386,
   "Continent": "Europe",
   "Country": "Spain",
   "ProvName": "Castilla y Leon",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Spain. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_208_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 387,
   "Continent": "Europe",
   "Country": "Romania",
   "ProvName": "Covasna",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "0.87",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 388,
   "Continent": "Europe",
   "Country": "Spain",
   "ProvName": "Madrid",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Spain. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_208_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 389,
   "Continent": "Asia",
   "Country": "Jordan",
   "ProvName": "Ma'an",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 390,
   "Continent": "Africa",
   "Country": "Togo",
   "ProvName": "Des Plateaux",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "45-50%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Togo. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_221_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 391,
   "Continent": "Africa",
   "Country": "Togo",
   "ProvName": "Maritime",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "45-50%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Togo. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_221_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 392,
   "Continent": "Europe",
   "Country": "Switzerland",
   "ProvName": "Glarus",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "\"Religions\" (official statistics). Neuchâtel, Switzerland: Federal Statistical Office FSO. 2020.",
   "Year": 2018
  },
  {
   "OBJECTID": 393,
   "Continent": "Africa",
   "Country": "Togo",
   "ProvName": "De la Kara",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 394,
   "Continent": "Africa",
   "Country": "Niger",
   "ProvName": "Tahoua",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 395,
   "Continent": "Africa",
   "Country": "Togo",
   "ProvName": "Centrale",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 396,
   "Continent": "Africa",
   "Country": "Togo",
   "ProvName": "Des Savanes",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 397,
   "Continent": "Africa",
   "Country": "Niger",
   "ProvName": "Zinder",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 398,
   "Continent": "Africa",
   "Country": "Niger",
   "ProvName": "Dosso",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 399,
   "Continent": "Africa",
   "Country": "Tunisia",
   "ProvName": "Madaniyin",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "\"Chapter 1: Religious Affiliation\". The World’s Muslims: Unity and Diversity. Pew Research Center's Religion & Public Life Project. August 9, 2012.",
   "Year": 2012
  },
  {
   "OBJECTID": 400,
   "Continent": "Africa",
   "Country": "Tunisia",
   "ProvName": "Qibili",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "\"Chapter 1: Religious Affiliation\". The World’s Muslims: Unity and Diversity. Pew Research Center's Religion & Public Life Project. August 9, 2012.",
   "Year": 2012
  },
  {
   "OBJECTID": 401,
   "Continent": "Africa",
   "Country": "Tunisia",
   "ProvName": "Tatauin",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "\"Chapter 1: Religious Affiliation\". The World’s Muslims: Unity and Diversity. Pew Research Center's Religion & Public Life Project. August 9, 2012.",
   "Year": 2012
  },
  {
   "OBJECTID": 402,
   "Continent": "Europe",
   "Country": "Spain",
   "ProvName": "Cataluña",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Spain. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_208_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 403,
   "Continent": "Africa",
   "Country": "Tunisia",
   "ProvName": "Tawzar",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "\"Chapter 1: Religious Affiliation\". The World’s Muslims: Unity and Diversity. Pew Research Center's Religion & Public Life Project. August 9, 2012.",
   "Year": 2012
  },
  {
   "OBJECTID": 404,
   "Continent": "Africa",
   "Country": "Tunisia",
   "ProvName": "Bajah",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "\"Chapter 1: Religious Affiliation\". The World’s Muslims: Unity and Diversity. Pew Research Center's Religion & Public Life Project. August 9, 2012.",
   "Year": 2012
  },
  {
   "OBJECTID": 405,
   "Continent": "Africa",
   "Country": "Tunisia",
   "ProvName": "Banzart",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "\"Chapter 1: Religious Affiliation\". The World’s Muslims: Unity and Diversity. Pew Research Center's Religion & Public Life Project. August 9, 2012.",
   "Year": 2012
  },
  {
   "OBJECTID": 406,
   "Continent": "Europe",
   "Country": "Sweden",
   "ProvName": "Värmland",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"The Religious Landscape of Sweden\". www.myndighetensst.se. 2019.",
   "Year": 2016
  },
  {
   "OBJECTID": 407,
   "Continent": "Europe",
   "Country": "Moldova",
   "ProvName": "Drochia",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 408,
   "Continent": "Europe",
   "Country": "Sweden",
   "ProvName": "Jämtland",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"The Religious Landscape of Sweden\". www.myndighetensst.se. 2019.",
   "Year": 2016
  },
  {
   "OBJECTID": 409,
   "Continent": "Europe",
   "Country": "Sweden",
   "ProvName": "Norrbotten",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"The Religious Landscape of Sweden\". www.myndighetensst.se. 2019.",
   "Year": 2016
  },
  {
   "OBJECTID": 410,
   "Continent": "Europe",
   "Country": "Sweden",
   "ProvName": "Västernorrland",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"The Religious Landscape of Sweden\". www.myndighetensst.se. 2019.",
   "Year": 2016
  },
  {
   "OBJECTID": 411,
   "Continent": "Africa",
   "Country": "Tunisia",
   "ProvName": "Jundubah",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "\"Chapter 1: Religious Affiliation\". The World’s Muslims: Unity and Diversity. Pew Research Center's Religion & Public Life Project. August 9, 2012.",
   "Year": 2012
  },
  {
   "OBJECTID": 412,
   "Continent": "Africa",
   "Country": "Tunisia",
   "ProvName": "Nabul",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "\"Chapter 1: Religious Affiliation\". The World’s Muslims: Unity and Diversity. Pew Research Center's Religion & Public Life Project. August 9, 2012.",
   "Year": 2012
  },
  {
   "OBJECTID": 413,
   "Continent": "Africa",
   "Country": "Tunisia",
   "ProvName": "al-Qasrayn",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "\"Chapter 1: Religious Affiliation\". The World’s Muslims: Unity and Diversity. Pew Research Center's Religion & Public Life Project. August 9, 2012.",
   "Year": 2012
  },
  {
   "OBJECTID": 414,
   "Continent": "Africa",
   "Country": "Tunisia",
   "ProvName": "Qabis",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "\"Chapter 1: Religious Affiliation\". The World’s Muslims: Unity and Diversity. Pew Research Center's Religion & Public Life Project. August 9, 2012.",
   "Year": 2012
  },
  {
   "OBJECTID": 415,
   "Continent": "Europe",
   "Country": "Romania",
   "ProvName": "Teleorman",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "0.87",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 416,
   "Continent": "Africa",
   "Country": "Tunisia",
   "ProvName": "Qafsah",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "\"Chapter 1: Religious Affiliation\". The World’s Muslims: Unity and Diversity. Pew Research Center's Religion & Public Life Project. August 9, 2012.",
   "Year": 2012
  },
  {
   "OBJECTID": 417,
   "Continent": "Africa",
   "Country": "Tunisia",
   "ProvName": "Sidi Bu Zayd",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "\"Chapter 1: Religious Affiliation\". The World’s Muslims: Unity and Diversity. Pew Research Center's Religion & Public Life Project. August 9, 2012.",
   "Year": 2012
  },
  {
   "OBJECTID": 418,
   "Continent": "North America",
   "Country": "Dominican Republic",
   "ProvName": "San Juan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 419,
   "Continent": "Africa",
   "Country": "Tunisia",
   "ProvName": "Safaqis",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "\"Chapter 1: Religious Affiliation\". The World’s Muslims: Unity and Diversity. Pew Research Center's Religion & Public Life Project. August 9, 2012.",
   "Year": 2012
  },
  {
   "OBJECTID": 420,
   "Continent": "Africa",
   "Country": "Tunisia",
   "ProvName": "Silianah",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "\"Chapter 1: Religious Affiliation\". The World’s Muslims: Unity and Diversity. Pew Research Center's Religion & Public Life Project. August 9, 2012.",
   "Year": 2012
  },
  {
   "OBJECTID": 421,
   "Continent": "Africa",
   "Country": "Tunisia",
   "ProvName": "al-Mahdiyah",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "\"Chapter 1: Religious Affiliation\". The World’s Muslims: Unity and Diversity. Pew Research Center's Religion & Public Life Project. August 9, 2012.",
   "Year": 2012
  },
  {
   "OBJECTID": 422,
   "Continent": "Europe",
   "Country": "Sweden",
   "ProvName": "Västerbotten",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"The Religious Landscape of Sweden\". www.myndighetensst.se. 2019.",
   "Year": 2016
  },
  {
   "OBJECTID": 423,
   "Continent": "Europe",
   "Country": "Sweden",
   "ProvName": "Gotland",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"The Religious Landscape of Sweden\". www.myndighetensst.se. 2019.",
   "Year": 2016
  },
  {
   "OBJECTID": 424,
   "Continent": "Europe",
   "Country": "Sweden",
   "ProvName": "Stockholm",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"The Religious Landscape of Sweden\". www.myndighetensst.se. 2019.",
   "Year": 2016
  },
  {
   "OBJECTID": 425,
   "Continent": "Europe",
   "Country": "Sweden",
   "ProvName": "Uppsala",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"The Religious Landscape of Sweden\". www.myndighetensst.se. 2019.",
   "Year": 2016
  },
  {
   "OBJECTID": 426,
   "Continent": "Europe",
   "Country": "Romania",
   "ProvName": "Calarasi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "0.87",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 427,
   "Continent": "Europe",
   "Country": "Slovenia",
   "ProvName": "Pomurska",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Eurobarometer 90.4 (December 2018): Attitudes of Europeans towards Biodiversity, Awareness and Perceptions of EU customs, and Perceptions of Antisemitism",
   "Year": 2018
  },
  {
   "OBJECTID": 428,
   "Continent": "Europe",
   "Country": "Slovenia",
   "ProvName": "Podravska",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Eurobarometer 90.4 (December 2018): Attitudes of Europeans towards Biodiversity, Awareness and Perceptions of EU customs, and Perceptions of Antisemitism",
   "Year": 2018
  },
  {
   "OBJECTID": 429,
   "Continent": "North America",
   "Country": "Saint Kitts & Nevis",
   "ProvName": "St. Kitts",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Saint Kitts & Nevis. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_189_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 430,
   "Continent": "North America",
   "Country": "Cuba",
   "ProvName": "La Habana",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Cuba. Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_63_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 431,
   "Continent": "North America",
   "Country": "Cuba",
   "ProvName": "Matanzas",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "30-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Cuba. Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_63_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 432,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Phrae",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 433,
   "Continent": "Africa",
   "Country": "Tunisia",
   "ProvName": "al-Munastir",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "\"Chapter 1: Religious Affiliation\". The World’s Muslims: Unity and Diversity. Pew Research Center's Religion & Public Life Project. August 9, 2012.",
   "Year": 2012
  },
  {
   "OBJECTID": 434,
   "Continent": "North America",
   "Country": "Cuba",
   "ProvName": "Villa Clara",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "30-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Cuba. Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_63_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 435,
   "Continent": "Africa",
   "Country": "Tunisia",
   "ProvName": "al-Qayrawan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "\"Chapter 1: Religious Affiliation\". The World’s Muslims: Unity and Diversity. Pew Research Center's Religion & Public Life Project. August 9, 2012.",
   "Year": 2012
  },
  {
   "OBJECTID": 436,
   "Continent": "Africa",
   "Country": "Tunisia",
   "ProvName": "Susah",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "\"Chapter 1: Religious Affiliation\". The World’s Muslims: Unity and Diversity. Pew Research Center's Religion & Public Life Project. August 9, 2012.",
   "Year": 2012
  },
  {
   "OBJECTID": 437,
   "Continent": "Asia",
   "Country": "Syria",
   "ProvName": "al-Ladhiqiyah",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/gulf2000.columbia.edu\/images\/maps\/Syria_Religion_Detailed_lg.png",
   "Year": 2010
  },
  {
   "OBJECTID": 438,
   "Continent": "Asia",
   "Country": "Malaysia",
   "ProvName": "Pahang Darul Makmur",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 439,
   "Continent": "Asia",
   "Country": "Malaysia",
   "ProvName": "Selangor Darul Ehsan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 440,
   "Continent": "Europe",
   "Country": "Romania",
   "ProvName": "Dolj",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "0.87",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 441,
   "Continent": "Europe",
   "Country": "Romania",
   "ProvName": "Gorj",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "0.87",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 442,
   "Continent": "Asia",
   "Country": "Syria",
   "ProvName": "Tartus",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/gulf2000.columbia.edu\/images\/maps\/Syria_Religion_Detailed_lg.png",
   "Year": 2010
  },
  {
   "OBJECTID": 443,
   "Continent": "Europe",
   "Country": "Romania",
   "ProvName": "Mehedinti",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "0.87",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 444,
   "Continent": "Europe",
   "Country": "Romania",
   "ProvName": "Olt",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "0.87",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 445,
   "Continent": "Europe",
   "Country": "Romania",
   "ProvName": "Dâmbovita",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "0.87",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 446,
   "Continent": "Europe",
   "Country": "Romania",
   "ProvName": "Giurgiu",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "0.87",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 447,
   "Continent": "Europe",
   "Country": "Romania",
   "ProvName": "Ialomita",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "0.87",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 448,
   "Continent": "Asia",
   "Country": "Malaysia",
   "ProvName": "Terengganu",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 449,
   "Continent": "Asia",
   "Country": "Syria",
   "ProvName": "Dayr az-Zawr",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/gulf2000.columbia.edu\/images\/maps\/Syria_Religion_Detailed_lg.png",
   "Year": 2010
  },
  {
   "OBJECTID": 450,
   "Continent": "Europe",
   "Country": "Switzerland",
   "ProvName": "Schaffhausen",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "\"Religions\" (official statistics). Neuchâtel, Switzerland: Federal Statistical Office FSO. 2020.",
   "Year": 2018
  },
  {
   "OBJECTID": 451,
   "Continent": "Asia",
   "Country": "Syria",
   "ProvName": "ar-Raqqah",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/gulf2000.columbia.edu\/images\/maps\/Syria_Religion_Detailed_lg.png",
   "Year": 2010
  },
  {
   "OBJECTID": 452,
   "Continent": "Asia",
   "Country": "Syria",
   "ProvName": "Aleppo (Halab)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/gulf2000.columbia.edu\/images\/maps\/Syria_Religion_Detailed_lg.png",
   "Year": 2010
  },
  {
   "OBJECTID": 453,
   "Continent": "Asia",
   "Country": "Syria",
   "ProvName": "Hamah",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/gulf2000.columbia.edu\/images\/maps\/Syria_Religion_Detailed_lg.png",
   "Year": 2010
  },
  {
   "OBJECTID": 454,
   "Continent": "Asia",
   "Country": "Syria",
   "ProvName": "Hims",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/gulf2000.columbia.edu\/images\/maps\/Syria_Religion_Detailed_lg.png",
   "Year": 2010
  },
  {
   "OBJECTID": 455,
   "Continent": "North America",
   "Country": "Saint Kitts & Nevis",
   "ProvName": "Nevis",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Saint Kitts & Nevis. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_189_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 456,
   "Continent": "Asia",
   "Country": "Syria",
   "ProvName": "Idlib",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/gulf2000.columbia.edu\/images\/maps\/Syria_Religion_Detailed_lg.png",
   "Year": 2010
  },
  {
   "OBJECTID": 457,
   "Continent": "Asia",
   "Country": "Syria",
   "ProvName": "al-Hasakah",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/gulf2000.columbia.edu\/images\/maps\/Syria_Religion_Detailed_lg.png",
   "Year": 2010
  },
  {
   "OBJECTID": 458,
   "Continent": "Asia",
   "Country": "Syria",
   "ProvName": "as-Suwayda",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/gulf2000.columbia.edu\/images\/maps\/Syria_Religion_Detailed_lg.png",
   "Year": 2010
  },
  {
   "OBJECTID": 459,
   "Continent": "Asia",
   "Country": "Syria",
   "ProvName": "al-Qunaytirah",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/gulf2000.columbia.edu\/images\/maps\/Syria_Religion_Detailed_lg.png",
   "Year": 2010
  },
  {
   "OBJECTID": 460,
   "Continent": "Asia",
   "Country": "Syria",
   "ProvName": "Dar`a",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/gulf2000.columbia.edu\/images\/maps\/Syria_Religion_Detailed_lg.png",
   "Year": 2010
  },
  {
   "OBJECTID": 461,
   "Continent": "Africa",
   "Country": "South Sudan",
   "ProvName": "Shamâl Bahr-al-Ghazâl (North B~Ghazal)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "30-35%",
   "Numerical": 35,
   "Ethnic2": null,
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "The Pew Forum - Religious Composition by Country. https:\/\/assets.pewresearch.org\/wp-content\/uploads\/sites\/11\/2012\/12\/globalReligion-tables.pdf",
   "Year": 2015
  },
  {
   "OBJECTID": 462,
   "Continent": "Africa",
   "Country": "Sudan",
   "ProvName": "an-Nîl-al-Azraq (Blue Nile)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 463,
   "Continent": "Asia",
   "Country": "Yemen",
   "ProvName": "Sa'dah",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "Integrated Regional Information Networks (IRIN), Yemen: The conflict in Saada Governorate - analysis, 24 July 2008, available at: http:\/\/www.unhcr.org\/refworld\/docid\/488f180d1e.html",
   "Year": 2008
  },
  {
   "OBJECTID": 464,
   "Continent": "Europe",
   "Country": "Romania",
   "ProvName": "Brasov",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "0.87",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 465,
   "Continent": "Africa",
   "Country": "Sudan",
   "ProvName": "al-Bahr-al-Ahmar (Red Sea)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 466,
   "Continent": "North America",
   "Country": "Dominica",
   "ProvName": "St. David",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "Dominica. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_69_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 467,
   "Continent": "Asia",
   "Country": "Yemen",
   "ProvName": "al-Hadaydah",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "Integrated Regional Information Networks (IRIN), Yemen: The conflict in Saada Governorate - analysis, 24 July 2008, available at: http:\/\/www.unhcr.org\/refworld\/docid\/488f180d1e.html",
   "Year": 2008
  },
  {
   "OBJECTID": 468,
   "Continent": "Asia",
   "Country": "Yemen",
   "ProvName": "al-Mahwit",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "Integrated Regional Information Networks (IRIN), Yemen: The conflict in Saada Governorate - analysis, 24 July 2008, available at: http:\/\/www.unhcr.org\/refworld\/docid\/488f180d1e.html",
   "Year": 2008
  },
  {
   "OBJECTID": 469,
   "Continent": "North America",
   "Country": "Dominican Republic",
   "ProvName": "Santo Domingo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 470,
   "Continent": "Europe",
   "Country": "Romania",
   "ProvName": "Harghita",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "0.87",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 471,
   "Continent": "Europe",
   "Country": "Romania",
   "ProvName": "Iasi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "0.87",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 472,
   "Continent": "Europe",
   "Country": "Romania",
   "ProvName": "Neamt",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "0.87",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 473,
   "Continent": "Europe",
   "Country": "Romania",
   "ProvName": "Prahova",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "0.87",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 474,
   "Continent": "Europe",
   "Country": "Slovenia",
   "ProvName": "Notranjsko-kraska",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Eurobarometer 90.4 (December 2018): Attitudes of Europeans towards Biodiversity, Awareness and Perceptions of EU customs, and Perceptions of Antisemitism",
   "Year": 2018
  },
  {
   "OBJECTID": 475,
   "Continent": "Europe",
   "Country": "Romania",
   "ProvName": "Suceava",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "0.87",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 476,
   "Continent": "Asia",
   "Country": "Yemen",
   "ProvName": "Amran",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "Integrated Regional Information Networks (IRIN), Yemen: The conflict in Saada Governorate - analysis, 24 July 2008, available at: http:\/\/www.unhcr.org\/refworld\/docid\/488f180d1e.html",
   "Year": 2008
  },
  {
   "OBJECTID": 477,
   "Continent": "Asia",
   "Country": "Yemen",
   "ProvName": "Ibb",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "Integrated Regional Information Networks (IRIN), Yemen: The conflict in Saada Governorate - analysis, 24 July 2008, available at: http:\/\/www.unhcr.org\/refworld\/docid\/488f180d1e.html",
   "Year": 2008
  },
  {
   "OBJECTID": 478,
   "Continent": "North America",
   "Country": "Dominican Republic",
   "ProvName": "Sánchez Ramírez",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 479,
   "Continent": "Asia",
   "Country": "Yemen",
   "ProvName": "Lahij",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "Integrated Regional Information Networks (IRIN), Yemen: The conflict in Saada Governorate - analysis, 24 July 2008, available at: http:\/\/www.unhcr.org\/refworld\/docid\/488f180d1e.html",
   "Year": 2008
  },
  {
   "OBJECTID": 480,
   "Continent": "Asia",
   "Country": "Yemen",
   "ProvName": "Ta'izz",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "Integrated Regional Information Networks (IRIN), Yemen: The conflict in Saada Governorate - analysis, 24 July 2008, available at: http:\/\/www.unhcr.org\/refworld\/docid\/488f180d1e.html",
   "Year": 2008
  },
  {
   "OBJECTID": 481,
   "Continent": "Europe",
   "Country": "Switzerland",
   "ProvName": "Genève",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "25-30%",
   "Nummeric_1": 35,
   "DataSource": "\"Religions\" (official statistics). Neuchâtel, Switzerland: Federal Statistical Office FSO. 2020.",
   "Year": 2018
  },
  {
   "OBJECTID": 482,
   "Continent": "North America",
   "Country": "Dominican Republic",
   "ProvName": "San Pedro de Macorís",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 483,
   "Continent": "Europe",
   "Country": "Switzerland",
   "ProvName": "Jura",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "\"Religions\" (official statistics). Neuchâtel, Switzerland: Federal Statistical Office FSO. 2020.",
   "Year": 2018
  },
  {
   "OBJECTID": 484,
   "Continent": "Europe",
   "Country": "Switzerland",
   "ProvName": "Neuchâtel",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "\"Religions\" (official statistics). Neuchâtel, Switzerland: Federal Statistical Office FSO. 2020.",
   "Year": 2018
  },
  {
   "OBJECTID": 485,
   "Continent": "Europe",
   "Country": "Switzerland",
   "ProvName": "Aargau",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "\"Religions\" (official statistics). Neuchâtel, Switzerland: Federal Statistical Office FSO. 2020.",
   "Year": 2018
  },
  {
   "OBJECTID": 486,
   "Continent": "Asia",
   "Country": "Yemen",
   "ProvName": "Raymah",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "Integrated Regional Information Networks (IRIN), Yemen: The conflict in Saada Governorate - analysis, 24 July 2008, available at: http:\/\/www.unhcr.org\/refworld\/docid\/488f180d1e.html",
   "Year": 2008
  },
  {
   "OBJECTID": 487,
   "Continent": "Asia",
   "Country": "Japan",
   "ProvName": "Nagasaki",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 488,
   "Continent": "Europe",
   "Country": "Switzerland",
   "ProvName": "Luzern",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "\"Religions\" (official statistics). Neuchâtel, Switzerland: Federal Statistical Office FSO. 2020.",
   "Year": 2018
  },
  {
   "OBJECTID": 489,
   "Continent": "Europe",
   "Country": "Switzerland",
   "ProvName": "Nidwalden",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "\"Religions\" (official statistics). Neuchâtel, Switzerland: Federal Statistical Office FSO. 2020.",
   "Year": 2018
  },
  {
   "OBJECTID": 490,
   "Continent": "Europe",
   "Country": "Romania",
   "ProvName": "Braila",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "0.87",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 491,
   "Continent": "Europe",
   "Country": "Switzerland",
   "ProvName": "Valais",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "\"Religions\" (official statistics). Neuchâtel, Switzerland: Federal Statistical Office FSO. 2020.",
   "Year": 2018
  },
  {
   "OBJECTID": 492,
   "Continent": "Europe",
   "Country": "Romania",
   "ProvName": "Bacau",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "0.87",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 493,
   "Continent": "Europe",
   "Country": "Romania",
   "ProvName": "Buzau",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "0.87",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 494,
   "Continent": "Europe",
   "Country": "Romania",
   "ProvName": "Galati",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "0.87",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 495,
   "Continent": "Europe",
   "Country": "Romania",
   "ProvName": "Vaslui",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "0.87",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 496,
   "Continent": "Europe",
   "Country": "Romania",
   "ProvName": "Vrancea",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "0.87",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 497,
   "Continent": "Europe",
   "Country": "Ukraine",
   "ProvName": "Volyn",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 498,
   "Continent": "Europe",
   "Country": "Ukraine",
   "ProvName": "Cherkasy",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 499,
   "Continent": "Europe",
   "Country": "Ukraine",
   "ProvName": "Kirovohrad",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 500,
   "Continent": "Europe",
   "Country": "Ukraine",
   "ProvName": "Odessa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 501,
   "Continent": "Europe",
   "Country": "Ukraine",
   "ProvName": "Vinnytsya",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 502,
   "Continent": "Europe",
   "Country": "Moldova",
   "ProvName": "Falesti",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 503,
   "Continent": "Europe",
   "Country": "Switzerland",
   "ProvName": "Sankt Gallen",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "\"Religions\" (official statistics). Neuchâtel, Switzerland: Federal Statistical Office FSO. 2020.",
   "Year": 2018
  },
  {
   "OBJECTID": 504,
   "Continent": "Europe",
   "Country": "Switzerland",
   "ProvName": "Ticino",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "\"Religions\" (official statistics). Neuchâtel, Switzerland: Federal Statistical Office FSO. 2020.",
   "Year": 2018
  },
  {
   "OBJECTID": 505,
   "Continent": "Europe",
   "Country": "Switzerland",
   "ProvName": "Graubünden",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "\"Religions\" (official statistics). Neuchâtel, Switzerland: Federal Statistical Office FSO. 2020.",
   "Year": 2018
  },
  {
   "OBJECTID": 506,
   "Continent": "Europe",
   "Country": "Moldova",
   "ProvName": "Glodeni",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 507,
   "Continent": "Europe",
   "Country": "Switzerland",
   "ProvName": "Schwyz",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "\"Religions\" (official statistics). Neuchâtel, Switzerland: Federal Statistical Office FSO. 2020.",
   "Year": 2018
  },
  {
   "OBJECTID": 508,
   "Continent": "Europe",
   "Country": "Switzerland",
   "ProvName": "Thurgau",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "\"Religions\" (official statistics). Neuchâtel, Switzerland: Federal Statistical Office FSO. 2020.",
   "Year": 2018
  },
  {
   "OBJECTID": 509,
   "Continent": "Europe",
   "Country": "Slovenia",
   "ProvName": "Koroska",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Eurobarometer 90.4 (December 2018): Attitudes of Europeans towards Biodiversity, Awareness and Perceptions of EU customs, and Perceptions of Antisemitism",
   "Year": 2018
  },
  {
   "OBJECTID": 510,
   "Continent": "Europe",
   "Country": "Moldova",
   "ProvName": "Sîngerei",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 511,
   "Continent": "Europe",
   "Country": "Switzerland",
   "ProvName": "Uri",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "\"Religions\" (official statistics). Neuchâtel, Switzerland: Federal Statistical Office FSO. 2020.",
   "Year": 2018
  },
  {
   "OBJECTID": 512,
   "Continent": "Europe",
   "Country": "Switzerland",
   "ProvName": "Zürich",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "\"Religions\" (official statistics). Neuchâtel, Switzerland: Federal Statistical Office FSO. 2020.",
   "Year": 2018
  },
  {
   "OBJECTID": 513,
   "Continent": "Europe",
   "Country": "Switzerland",
   "ProvName": "Zug",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "\"Religions\" (official statistics). Neuchâtel, Switzerland: Federal Statistical Office FSO. 2020.",
   "Year": 2018
  },
  {
   "OBJECTID": 514,
   "Continent": "Europe",
   "Country": "Sweden",
   "ProvName": "Gävleborg",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"The Religious Landscape of Sweden\". www.myndighetensst.se. 2019.",
   "Year": 2016
  },
  {
   "OBJECTID": 515,
   "Continent": "Europe",
   "Country": "Moldova",
   "ProvName": "Ungheni",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 516,
   "Continent": "Europe",
   "Country": "Sweden",
   "ProvName": "Jönköping",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"The Religious Landscape of Sweden\". www.myndighetensst.se. 2019.",
   "Year": 2016
  },
  {
   "OBJECTID": 517,
   "Continent": "Europe",
   "Country": "Sweden",
   "ProvName": "Kalmar",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"The Religious Landscape of Sweden\". www.myndighetensst.se. 2019.",
   "Year": 2016
  },
  {
   "OBJECTID": 518,
   "Continent": "Europe",
   "Country": "Slovenia",
   "ProvName": "Gorenjska",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Eurobarometer 90.4 (December 2018): Attitudes of Europeans towards Biodiversity, Awareness and Perceptions of EU customs, and Perceptions of Antisemitism",
   "Year": 2018
  },
  {
   "OBJECTID": 519,
   "Continent": "Europe",
   "Country": "Sweden",
   "ProvName": "Dalarna",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"The Religious Landscape of Sweden\". www.myndighetensst.se. 2019.",
   "Year": 2016
  },
  {
   "OBJECTID": 520,
   "Continent": "Europe",
   "Country": "Sweden",
   "ProvName": "Kronoberg",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"The Religious Landscape of Sweden\". www.myndighetensst.se. 2019.",
   "Year": 2016
  },
  {
   "OBJECTID": 521,
   "Continent": "Europe",
   "Country": "Sweden",
   "ProvName": "Orebro",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"The Religious Landscape of Sweden\". www.myndighetensst.se. 2019.",
   "Year": 2016
  },
  {
   "OBJECTID": 522,
   "Continent": "Europe",
   "Country": "Sweden",
   "ProvName": "Södermanland",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"The Religious Landscape of Sweden\". www.myndighetensst.se. 2019.",
   "Year": 2016
  },
  {
   "OBJECTID": 523,
   "Continent": "Europe",
   "Country": "Sweden",
   "ProvName": "Ostergötland",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"The Religious Landscape of Sweden\". www.myndighetensst.se. 2019.",
   "Year": 2016
  },
  {
   "OBJECTID": 524,
   "Continent": "Europe",
   "Country": "Moldova",
   "ProvName": "Cantemir",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 525,
   "Continent": "Europe",
   "Country": "Slovenia",
   "ProvName": "Goriska",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Eurobarometer 90.4 (December 2018): Attitudes of Europeans towards Biodiversity, Awareness and Perceptions of EU customs, and Perceptions of Antisemitism",
   "Year": 2018
  },
  {
   "OBJECTID": 526,
   "Continent": "Europe",
   "Country": "Sweden",
   "ProvName": "Blekinge",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"The Religious Landscape of Sweden\". www.myndighetensst.se. 2019.",
   "Year": 2016
  },
  {
   "OBJECTID": 527,
   "Continent": "Europe",
   "Country": "Moldova",
   "ProvName": "Calarasi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 528,
   "Continent": "Europe",
   "Country": "Romania",
   "ProvName": "Arad",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "0.87",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 529,
   "Continent": "Europe",
   "Country": "Romania",
   "ProvName": "Botosani",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "0.87",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 530,
   "Continent": "Europe",
   "Country": "Romania",
   "ProvName": "Bihor",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "0.87",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 531,
   "Continent": "Europe",
   "Country": "Romania",
   "ProvName": "Alba",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "0.87",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 532,
   "Continent": "Europe",
   "Country": "Romania",
   "ProvName": "Caras-Severin",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "0.87",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 533,
   "Continent": "Europe",
   "Country": "Romania",
   "ProvName": "Bistrita-Nasaud",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "0.87",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 534,
   "Continent": "Europe",
   "Country": "Moldova",
   "ProvName": "Cimislia",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 535,
   "Continent": "Europe",
   "Country": "Romania",
   "ProvName": "Timis",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "0.87",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 536,
   "Continent": "Europe",
   "Country": "Ukraine",
   "ProvName": "Mykolayiv",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 537,
   "Continent": "Europe",
   "Country": "Ukraine",
   "ProvName": "Chernihiv",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 538,
   "Continent": "Europe",
   "Country": "Ukraine",
   "ProvName": "Rivne",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 539,
   "Continent": "South America",
   "Country": "Brazil",
   "ProvName": "Distrito Federal",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "IBGE – Instituto Brasileiro de Geografia e Estatística (Brazilian Institute for Geography and Statistics). 2010 Census.",
   "Year": 2010
  },
  {
   "OBJECTID": 540,
   "Continent": "South America",
   "Country": "Brazil",
   "ProvName": "Mato Grosso do Sul",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "IBGE – Instituto Brasileiro de Geografia e Estatística (Brazilian Institute for Geography and Statistics). 2010 Census.",
   "Year": 2010
  },
  {
   "OBJECTID": 541,
   "Continent": "South America",
   "Country": "Brazil",
   "ProvName": "Minas Gerais",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "IBGE – Instituto Brasileiro de Geografia e Estatística (Brazilian Institute for Geography and Statistics). 2010 Census.",
   "Year": 2010
  },
  {
   "OBJECTID": 542,
   "Continent": "South America",
   "Country": "Brazil",
   "ProvName": "Mato Grosso",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "IBGE – Instituto Brasileiro de Geografia e Estatística (Brazilian Institute for Geography and Statistics). 2010 Census.",
   "Year": 2010
  },
  {
   "OBJECTID": 543,
   "Continent": "Europe",
   "Country": "Ukraine",
   "ProvName": "Chernivtsi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 544,
   "Continent": "Europe",
   "Country": "Ukraine",
   "ProvName": "Ivano-Frankivsk",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 545,
   "Continent": "Europe",
   "Country": "Ukraine",
   "ProvName": "Khmelnytsky",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 546,
   "Continent": "Europe",
   "Country": "Ukraine",
   "ProvName": "Lviv",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 547,
   "Continent": "Europe",
   "Country": "Ukraine",
   "ProvName": "Ternopil",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 548,
   "Continent": "Europe",
   "Country": "Moldova",
   "ProvName": "Criuleni",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 549,
   "Continent": "Europe",
   "Country": "Ukraine",
   "ProvName": "Zakarpatska",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 550,
   "Continent": "Europe",
   "Country": "Moldova",
   "ProvName": "Floresti",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 551,
   "Continent": "Europe",
   "Country": "Romania",
   "ProvName": "Cluj",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "0.87",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 552,
   "Continent": "Europe",
   "Country": "Romania",
   "ProvName": "Hunedoara",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "0.87",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 553,
   "Continent": "Europe",
   "Country": "Romania",
   "ProvName": "Maramures",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "0.87",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 554,
   "Continent": "Europe",
   "Country": "Romania",
   "ProvName": "Mures",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "0.87",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 555,
   "Continent": "Europe",
   "Country": "Romania",
   "ProvName": "Salaj",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "0.87",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 556,
   "Continent": "Europe",
   "Country": "Romania",
   "ProvName": "Satu Mare",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "0.87",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 557,
   "Continent": "Europe",
   "Country": "Romania",
   "ProvName": "Arges",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "0.87",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 558,
   "Continent": "Europe",
   "Country": "Romania",
   "ProvName": "Sibiu",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "0.87",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 559,
   "Continent": "Europe",
   "Country": "Romania",
   "ProvName": "Vâlcea",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "0.87",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 560,
   "Continent": "South America",
   "Country": "Brazil",
   "ProvName": "Pará",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "IBGE – Instituto Brasileiro de Geografia e Estatística (Brazilian Institute for Geography and Statistics). 2010 Census.",
   "Year": 2010
  },
  {
   "OBJECTID": 561,
   "Continent": "South America",
   "Country": "Brazil",
   "ProvName": "Rondônia",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "IBGE – Instituto Brasileiro de Geografia e Estatística (Brazilian Institute for Geography and Statistics). 2010 Census.",
   "Year": 2010
  },
  {
   "OBJECTID": 562,
   "Continent": "South America",
   "Country": "Brazil",
   "ProvName": "Tocantins",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "IBGE – Instituto Brasileiro de Geografia e Estatística (Brazilian Institute for Geography and Statistics). 2010 Census.",
   "Year": 2010
  },
  {
   "OBJECTID": 563,
   "Continent": "South America",
   "Country": "Paraguay",
   "ProvName": "Alto Paraguay",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.statista.com\/statistics\/1067159\/paraguay-religion-affiliation-share-type\/\/ Religion affiliation in Paraguay as of 2018.",
   "Year": 2018
  },
  {
   "OBJECTID": 564,
   "Continent": "Africa",
   "Country": "Zambia",
   "ProvName": "Luapula",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "15-20%",
   "Nummeric_1": 20,
   "DataSource": "Zambia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_245_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 565,
   "Continent": "Africa",
   "Country": "Zambia",
   "ProvName": "Northern",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "15-20%",
   "Nummeric_1": 20,
   "DataSource": "Zambia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_245_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 566,
   "Continent": "Africa",
   "Country": "Zambia",
   "ProvName": "Central",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "15-20%",
   "Nummeric_1": 20,
   "DataSource": "Zambia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_245_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 567,
   "Continent": "South America",
   "Country": "Paraguay",
   "ProvName": "Boquerón",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.statista.com\/statistics\/1067159\/paraguay-religion-affiliation-share-type\/\/ Religion affiliation in Paraguay as of 2018.",
   "Year": 2018
  },
  {
   "OBJECTID": 568,
   "Continent": "Europe",
   "Country": "Ukraine",
   "ProvName": "Zhytomyr",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 569,
   "Continent": "Europe",
   "Country": "Ukraine",
   "ProvName": "Sumy",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 570,
   "Continent": "South America",
   "Country": "Paraguay",
   "ProvName": "Cordillera",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.statista.com\/statistics\/1067159\/paraguay-religion-affiliation-share-type\/\/ Religion affiliation in Paraguay as of 2018.",
   "Year": 2018
  },
  {
   "OBJECTID": 571,
   "Continent": "Europe",
   "Country": "Iceland",
   "ProvName": "Vestfirdhir",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Populations by religious organizations 1998-2020. Reykjavík, Iceland: Statistics Iceland. http:\/\/px.hagstofa.is\/pxen\/pxweb\/en\/Samfelag\/Samfelag__menning__5_trufelog\/MAN10001.px\/?rxid=4cfc6e75-3bf7-4455-ba53-5cb62900aa65",
   "Year": 2019
  },
  {
   "OBJECTID": 572,
   "Continent": "Europe",
   "Country": "Iceland",
   "ProvName": "Austurland",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Populations by religious organizations 1998-2020. Reykjavík, Iceland: Statistics Iceland. http:\/\/px.hagstofa.is\/pxen\/pxweb\/en\/Samfelag\/Samfelag__menning__5_trufelog\/MAN10001.px\/?rxid=4cfc6e75-3bf7-4455-ba53-5cb62900aa65",
   "Year": 2019
  },
  {
   "OBJECTID": 573,
   "Continent": "Asia",
   "Country": "Uzbekistan",
   "ProvName": "Tashkent",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Non-denominational)",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Sunni)",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "\"Chapter 1: Religious Affiliation\". The World’s Muslims: Unity and Diversity. Pew Research Center's Religion & Public Life Project. August 9, 2012.",
   "Year": 2012
  },
  {
   "OBJECTID": 574,
   "Continent": "Europe",
   "Country": "Ukraine",
   "ProvName": "Dnipropetrovsk",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 575,
   "Continent": "Europe",
   "Country": "Ukraine",
   "ProvName": "Donetsk",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 576,
   "Continent": "Europe",
   "Country": "Ukraine",
   "ProvName": "Kharkiv",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 577,
   "Continent": "Europe",
   "Country": "Ukraine",
   "ProvName": "Luhansk",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 578,
   "Continent": "Europe",
   "Country": "Ukraine",
   "ProvName": "Poltava",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 579,
   "Continent": "Europe",
   "Country": "Ukraine",
   "ProvName": "Zaporizhzhya",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 580,
   "Continent": "North America",
   "Country": "Belize",
   "ProvName": "Orange Walk",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "Belize Population and Housing Census 2010: Country Report (PDF). Belmopan, Belize C.A.: he Statistical Institute of Belize. 2013.",
   "Year": 2010
  },
  {
   "OBJECTID": 581,
   "Continent": "Asia",
   "Country": "Yemen",
   "ProvName": "al-Mahrah",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "Integrated Regional Information Networks (IRIN), Yemen: The conflict in Saada Governorate - analysis, 24 July 2008, available at: http:\/\/www.unhcr.org\/refworld\/docid\/488f180d1e.html",
   "Year": 2008
  },
  {
   "OBJECTID": 582,
   "Continent": "Europe",
   "Country": "Netherlands",
   "ProvName": "Limburg",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "20-25%",
   "Numerical": 25,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Netherlands. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_160_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 583,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Phitsanulok",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 584,
   "Continent": "South America",
   "Country": "Paraguay",
   "ProvName": "Concepción",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.statista.com\/statistics\/1067159\/paraguay-religion-affiliation-share-type\/\/ Religion affiliation in Paraguay as of 2018.",
   "Year": 2018
  },
  {
   "OBJECTID": 585,
   "Continent": "Europe",
   "Country": "Moldova",
   "ProvName": "Nisporeni",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 586,
   "Continent": "Europe",
   "Country": "Iceland",
   "ProvName": "Nordhurland vestra",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Populations by religious organizations 1998-2020. Reykjavík, Iceland: Statistics Iceland. http:\/\/px.hagstofa.is\/pxen\/pxweb\/en\/Samfelag\/Samfelag__menning__5_trufelog\/MAN10001.px\/?rxid=4cfc6e75-3bf7-4455-ba53-5cb62900aa65",
   "Year": 2019
  },
  {
   "OBJECTID": 587,
   "Continent": "Europe",
   "Country": "Netherlands",
   "ProvName": "Gelderland",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "20-25%",
   "Numerical": 25,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Netherlands. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_160_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 588,
   "Continent": "Europe",
   "Country": "Netherlands",
   "ProvName": "Groningen",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "20-25%",
   "Numerical": 25,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Netherlands. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_160_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 589,
   "Continent": "Europe",
   "Country": "Netherlands",
   "ProvName": "Overijssel",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "20-25%",
   "Numerical": 25,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Netherlands. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_160_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 590,
   "Continent": "Europe",
   "Country": "Norway",
   "ProvName": "Troms",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Norway. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_170_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 591,
   "Continent": "Europe",
   "Country": "Norway",
   "ProvName": "Svalbard & Jan Mayen Is",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Norway. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_170_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 592,
   "Continent": "Europe",
   "Country": "Netherlands",
   "ProvName": "Flevoland",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "20-25%",
   "Numerical": 25,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Netherlands. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_160_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 593,
   "Continent": "North America",
   "Country": "Belize",
   "ProvName": "Corozal",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "Belize Population and Housing Census 2010: Country Report (PDF). Belmopan, Belize C.A.: he Statistical Institute of Belize. 2013.",
   "Year": 2010
  },
  {
   "OBJECTID": 594,
   "Continent": "Europe",
   "Country": "Netherlands",
   "ProvName": "Zeeland",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "20-25%",
   "Numerical": 25,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Netherlands. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_160_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 595,
   "Continent": "Europe",
   "Country": "Italy",
   "ProvName": "Piemonte",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Italy. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_115_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 596,
   "Continent": "Europe",
   "Country": "Italy",
   "ProvName": "Valle d'Aosta",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Italy. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_115_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 597,
   "Continent": "Asia",
   "Country": "Malaysia",
   "ProvName": "Kelantan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 598,
   "Continent": "Asia",
   "Country": "Malaysia",
   "ProvName": "Melaka",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"2010 Population and Housing Census of Malaysia\" (PDF). Department of Statistics, Malaysia",
   "Year": 2010
  },
  {
   "OBJECTID": 599,
   "Continent": "North America",
   "Country": "Costa Rica",
   "ProvName": "Cartago",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Costa Rica.Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_60_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 600,
   "Continent": "North America",
   "Country": "Costa Rica",
   "ProvName": "Heredia",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Costa Rica.Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_60_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 601,
   "Continent": "South America",
   "Country": "Colombia",
   "ProvName": "Atlántico",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Religion in Latin America\". Pew Forum. https:\/\/www.pewforum.org\/2014\/11\/13\/religion-in-latin-america\/",
   "Year": 2014
  },
  {
   "OBJECTID": 602,
   "Continent": "South America",
   "Country": "Colombia",
   "ProvName": "Bol?var",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Religion in Latin America\". Pew Forum. https:\/\/www.pewforum.org\/2014\/11\/13\/religion-in-latin-america\/",
   "Year": 2014
  },
  {
   "OBJECTID": 603,
   "Continent": "Africa",
   "Country": "Sao Tome & Principe",
   "ProvName": "São Tomé",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sao Tome and Principe. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_195_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 604,
   "Continent": "North America",
   "Country": "Costa Rica",
   "ProvName": "Limón",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Costa Rica.Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_60_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 605,
   "Continent": "North America",
   "Country": "Costa Rica",
   "ProvName": "Puntarenas",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Costa Rica.Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_60_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 606,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Chai Nat",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 607,
   "Continent": "North America",
   "Country": "Costa Rica",
   "ProvName": "San José",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Costa Rica.Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_60_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 608,
   "Continent": "Europe",
   "Country": "Moldova",
   "ProvName": "Orhei",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 609,
   "Continent": "North America",
   "Country": "Panama",
   "ProvName": "Chiriqu?",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Panama. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_174_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 610,
   "Continent": "North America",
   "Country": "Costa Rica",
   "ProvName": "Alajuela",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Costa Rica.Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_60_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 611,
   "Continent": "South America",
   "Country": "Colombia",
   "ProvName": "Sucre",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Religion in Latin America\". Pew Forum. https:\/\/www.pewforum.org\/2014\/11\/13\/religion-in-latin-america\/",
   "Year": 2014
  },
  {
   "OBJECTID": 612,
   "Continent": "North America",
   "Country": "Costa Rica",
   "ProvName": "Guanacaste",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Costa Rica.Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_60_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 613,
   "Continent": "South America",
   "Country": "Ecuador",
   "ProvName": "Esmeraldas",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 614,
   "Continent": "Europe",
   "Country": "Moldova",
   "ProvName": "Rezina",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 615,
   "Continent": "South America",
   "Country": "Colombia",
   "ProvName": "Cesar",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Religion in Latin America\". Pew Forum. https:\/\/www.pewforum.org\/2014\/11\/13\/religion-in-latin-america\/",
   "Year": 2014
  },
  {
   "OBJECTID": 616,
   "Continent": "South America",
   "Country": "Colombia",
   "ProvName": "Chocó",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Religion in Latin America\". Pew Forum. https:\/\/www.pewforum.org\/2014\/11\/13\/religion-in-latin-america\/",
   "Year": 2014
  },
  {
   "OBJECTID": 617,
   "Continent": "Asia",
   "Country": "Yemen",
   "ProvName": "Ad Dali",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "Integrated Regional Information Networks (IRIN), Yemen: The conflict in Saada Governorate - analysis, 24 July 2008, available at: http:\/\/www.unhcr.org\/refworld\/docid\/488f180d1e.html",
   "Year": 2008
  },
  {
   "OBJECTID": 618,
   "Continent": "South America",
   "Country": "Colombia",
   "ProvName": "Magdalena",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Religion in Latin America\". Pew Forum. https:\/\/www.pewforum.org\/2014\/11\/13\/religion-in-latin-america\/",
   "Year": 2014
  },
  {
   "OBJECTID": 619,
   "Continent": "North America",
   "Country": "Panama",
   "ProvName": "Kuna Yala (San Blas)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Panama. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_174_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 620,
   "Continent": "Asia",
   "Country": "Yemen",
   "ProvName": "al-Jawf",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "Integrated Regional Information Networks (IRIN), Yemen: The conflict in Saada Governorate - analysis, 24 July 2008, available at: http:\/\/www.unhcr.org\/refworld\/docid\/488f180d1e.html",
   "Year": 2008
  },
  {
   "OBJECTID": 621,
   "Continent": "Europe",
   "Country": "Moldova",
   "ProvName": "Soldanesti",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 622,
   "Continent": "South America",
   "Country": "Colombia",
   "ProvName": "Arauca",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Religion in Latin America\". Pew Forum. https:\/\/www.pewforum.org\/2014\/11\/13\/religion-in-latin-america\/",
   "Year": 2014
  },
  {
   "OBJECTID": 623,
   "Continent": "Asia",
   "Country": "Yemen",
   "ProvName": "Shabwah",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "Integrated Regional Information Networks (IRIN), Yemen: The conflict in Saada Governorate - analysis, 24 July 2008, available at: http:\/\/www.unhcr.org\/refworld\/docid\/488f180d1e.html",
   "Year": 2008
  },
  {
   "OBJECTID": 624,
   "Continent": "Africa",
   "Country": "Zimbabwe",
   "ProvName": "Harare",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Inter Censal Demography Survey 2017 Report, Zimbabwe National Statistics Agency (2017)",
   "Year": 2015
  },
  {
   "OBJECTID": 625,
   "Continent": "South America",
   "Country": "Colombia",
   "ProvName": "Norte de Santander",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Religion in Latin America\". Pew Forum. https:\/\/www.pewforum.org\/2014\/11\/13\/religion-in-latin-america\/",
   "Year": 2014
  },
  {
   "OBJECTID": 626,
   "Continent": "Asia",
   "Country": "Yemen",
   "ProvName": "Ma'rib",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "Integrated Regional Information Networks (IRIN), Yemen: The conflict in Saada Governorate - analysis, 24 July 2008, available at: http:\/\/www.unhcr.org\/refworld\/docid\/488f180d1e.html",
   "Year": 2008
  },
  {
   "OBJECTID": 627,
   "Continent": "Africa",
   "Country": "Zimbabwe",
   "ProvName": "Matabeleland North",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Inter Censal Demography Survey 2017 Report, Zimbabwe National Statistics Agency (2017)",
   "Year": 2015
  },
  {
   "OBJECTID": 628,
   "Continent": "South America",
   "Country": "Colombia",
   "ProvName": "Casanare",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Religion in Latin America\". Pew Forum. https:\/\/www.pewforum.org\/2014\/11\/13\/religion-in-latin-america\/",
   "Year": 2014
  },
  {
   "OBJECTID": 629,
   "Continent": "Europe",
   "Country": "Russia",
   "ProvName": "Ivanovo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 630,
   "Continent": "Europe",
   "Country": "Russia",
   "ProvName": "Kostroma",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 631,
   "Continent": "Europe",
   "Country": "Russia",
   "ProvName": "Nizhegorod",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "70-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 632,
   "Continent": "Europe",
   "Country": "Russia",
   "ProvName": "Tver'",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "30-35%",
   "Numerical": 35,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 633,
   "Continent": "Europe",
   "Country": "Russia",
   "ProvName": "Vologda",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "30-35%",
   "Numerical": 35,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 634,
   "Continent": "Europe",
   "Country": "Russia",
   "ProvName": "Yaroslavl'",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "30-35%",
   "Numerical": 35,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 635,
   "Continent": "Europe",
   "Country": "Russia",
   "ProvName": "Kaluga",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 636,
   "Continent": "Europe",
   "Country": "Russia",
   "ProvName": "Kursk",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 637,
   "Continent": "Europe",
   "Country": "Russia",
   "ProvName": "Lipetsk",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "70-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 638,
   "Continent": "Asia",
   "Country": "Yemen",
   "ProvName": "al-Bayda'",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "Integrated Regional Information Networks (IRIN), Yemen: The conflict in Saada Governorate - analysis, 24 July 2008, available at: http:\/\/www.unhcr.org\/refworld\/docid\/488f180d1e.html",
   "Year": 2008
  },
  {
   "OBJECTID": 639,
   "Continent": "Africa",
   "Country": "Zimbabwe",
   "ProvName": "Midlands",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Inter Censal Demography Survey 2017 Report, Zimbabwe National Statistics Agency (2017)",
   "Year": 2015
  },
  {
   "OBJECTID": 640,
   "Continent": "Africa",
   "Country": "Zimbabwe",
   "ProvName": "Mashonaland East",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Inter Censal Demography Survey 2017 Report, Zimbabwe National Statistics Agency (2017)",
   "Year": 2015
  },
  {
   "OBJECTID": 641,
   "Continent": "Asia",
   "Country": "United Arab Emirates",
   "ProvName": "Ra's al-Khaymah",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 642,
   "Continent": "Asia",
   "Country": "United Arab Emirates",
   "ProvName": "Umm al-Qaywayn",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 643,
   "Continent": "Asia",
   "Country": "United Arab Emirates",
   "ProvName": "Dubayy (Dubai)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 644,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Phangnga",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 645,
   "Continent": "Oceania",
   "Country": "Solomon Islands",
   "ProvName": "Rennell and Bellona",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Solomon Islands. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_204_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 646,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Ranong",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 647,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Surat Thani",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 648,
   "Continent": "Asia",
   "Country": "Indonesia",
   "ProvName": "Sumatera Utara",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 649,
   "Continent": "Europe",
   "Country": "Moldova",
   "ProvName": "Straseni",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 650,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Krabi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 651,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Phatthalung",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 652,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Songkhla",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 653,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Satun",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 654,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Trang",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 655,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Nakhon Nayok",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 656,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Yala",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 657,
   "Continent": "Asia",
   "Country": "United Arab Emirates",
   "ProvName": "Al-Fujayrah (Fujairah)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 658,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Chiang Rai",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 659,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Chiang Mai",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 660,
   "Continent": "Asia",
   "Country": "United Arab Emirates",
   "ProvName": "Ash-Shariqah (Sharjah)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 661,
   "Continent": "Asia",
   "Country": "United Arab Emirates",
   "ProvName": "Ajman (Ajman)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 662,
   "Continent": "Asia",
   "Country": "United Arab Emirates",
   "ProvName": "Abu Dhabi (Abu Zaby)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 663,
   "Continent": "Asia",
   "Country": "Turkmenistan",
   "ProvName": "Balkan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 664,
   "Continent": "Asia",
   "Country": "Turkmenistan",
   "ProvName": "Dashhovuse",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 665,
   "Continent": "Europe",
   "Country": "Moldova",
   "ProvName": "Telenesti",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 666,
   "Continent": "Asia",
   "Country": "Uzbekistan",
   "ProvName": "Bukhoro",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Non-denominational)",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Sunni)",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "\"Chapter 1: Religious Affiliation\". The World’s Muslims: Unity and Diversity. Pew Research Center's Religion & Public Life Project. August 9, 2012.",
   "Year": 2012
  },
  {
   "OBJECTID": 667,
   "Continent": "Asia",
   "Country": "Uzbekistan",
   "ProvName": "Khorazm",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Non-denominational)",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Sunni)",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "\"Chapter 1: Religious Affiliation\". The World’s Muslims: Unity and Diversity. Pew Research Center's Religion & Public Life Project. August 9, 2012.",
   "Year": 2012
  },
  {
   "OBJECTID": 668,
   "Continent": "Asia",
   "Country": "Uzbekistan",
   "ProvName": "Qoraqalpoghiston",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Non-denominational)",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Sunni)",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "\"Chapter 1: Religious Affiliation\". The World’s Muslims: Unity and Diversity. Pew Research Center's Religion & Public Life Project. August 9, 2012.",
   "Year": 2012
  },
  {
   "OBJECTID": 669,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Phra Nakhon Si Ayutthaya",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 670,
   "Continent": "Asia",
   "Country": "Uzbekistan",
   "ProvName": "Nawoiy",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Non-denominational)",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Sunni)",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "\"Chapter 1: Religious Affiliation\". The World’s Muslims: Unity and Diversity. Pew Research Center's Religion & Public Life Project. August 9, 2012.",
   "Year": 2012
  },
  {
   "OBJECTID": 671,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Pathum Thani",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 672,
   "Continent": "Asia",
   "Country": "Uzbekistan",
   "ProvName": "Samarqand",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Non-denominational)",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Sunni)",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "\"Chapter 1: Religious Affiliation\". The World’s Muslims: Unity and Diversity. Pew Research Center's Religion & Public Life Project. August 9, 2012.",
   "Year": 2012
  },
  {
   "OBJECTID": 673,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Sing Buri",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 674,
   "Continent": "Asia",
   "Country": "Turkmenistan",
   "ProvName": "Leban",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 675,
   "Continent": "Asia",
   "Country": "Uzbekistan",
   "ProvName": "Qashqadaryo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Non-denominational)",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Sunni)",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "\"Chapter 1: Religious Affiliation\". The World’s Muslims: Unity and Diversity. Pew Research Center's Religion & Public Life Project. August 9, 2012.",
   "Year": 2012
  },
  {
   "OBJECTID": 676,
   "Continent": "Asia",
   "Country": "Turkmenistan",
   "ProvName": "Mary",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 677,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Nakhon Pathom",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 678,
   "Continent": "Asia",
   "Country": "Uzbekistan",
   "ProvName": "Surkhondaryo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Non-denominational)",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Sunni)",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "\"Chapter 1: Religious Affiliation\". The World’s Muslims: Unity and Diversity. Pew Research Center's Religion & Public Life Project. August 9, 2012.",
   "Year": 2012
  },
  {
   "OBJECTID": 679,
   "Continent": "Asia",
   "Country": "Uzbekistan",
   "ProvName": "Andijon",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Non-denominational)",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Sunni)",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "\"Chapter 1: Religious Affiliation\". The World’s Muslims: Unity and Diversity. Pew Research Center's Religion & Public Life Project. August 9, 2012.",
   "Year": 2012
  },
  {
   "OBJECTID": 680,
   "Continent": "Asia",
   "Country": "Uzbekistan",
   "ProvName": "Farghona",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Non-denominational)",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Sunni)",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "\"Chapter 1: Religious Affiliation\". The World’s Muslims: Unity and Diversity. Pew Research Center's Religion & Public Life Project. August 9, 2012.",
   "Year": 2012
  },
  {
   "OBJECTID": 681,
   "Continent": "Asia",
   "Country": "Uzbekistan",
   "ProvName": "Namangan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Non-denominational)",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Sunni)",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "\"Chapter 1: Religious Affiliation\". The World’s Muslims: Unity and Diversity. Pew Research Center's Religion & Public Life Project. August 9, 2012.",
   "Year": 2012
  },
  {
   "OBJECTID": 682,
   "Continent": "Asia",
   "Country": "Tajikistan",
   "ProvName": "Gorno-Badakhshan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 683,
   "Continent": "Asia",
   "Country": "Tajikistan",
   "ProvName": "Khatlon",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 684,
   "Continent": "Asia",
   "Country": "Tajikistan",
   "ProvName": "Sughd",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 685,
   "Continent": "Asia",
   "Country": "Uzbekistan",
   "ProvName": "Jizzakh",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Non-denominational)",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Sunni)",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "\"Chapter 1: Religious Affiliation\". The World’s Muslims: Unity and Diversity. Pew Research Center's Religion & Public Life Project. August 9, 2012.",
   "Year": 2012
  },
  {
   "OBJECTID": 686,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Samut Songkhram",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 687,
   "Continent": "Africa",
   "Country": "Malawi",
   "ProvName": "Blantyre",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "Malawi. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_138_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 688,
   "Continent": "Asia",
   "Country": "Uzbekistan",
   "ProvName": "Sirdaryo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Non-denominational)",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Sunni)",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "\"Chapter 1: Religious Affiliation\". The World’s Muslims: Unity and Diversity. Pew Research Center's Religion & Public Life Project. August 9, 2012.",
   "Year": 2012
  },
  {
   "OBJECTID": 689,
   "Continent": "Asia",
   "Country": "Nepal",
   "ProvName": "Madhya Pashchimanchal (Mid-Western)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Hinduism",
   "HighRelig": "Hindus",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 690,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Mae Hong Son",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 691,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Phichit",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 692,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Phetchabun",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 693,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Chumphon",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 694,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Nakhon Si Thammarat",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 695,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Phuket",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 696,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Sukhothai",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 697,
   "Continent": "North America",
   "Country": "Dominican Republic",
   "ProvName": "Independencia",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 698,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Uttaradit",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 699,
   "Continent": "North America",
   "Country": "Jamaica",
   "ProvName": "Saint Andrew",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Jamaica. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_116_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 700,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Kanchanaburi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 701,
   "Continent": "North America",
   "Country": "Barbados",
   "ProvName": "St. Michael",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Melton, J. Gordon; Baumann, Martin (2010). Religions of the World: A Comprehensive Encyclopedia of Beliefs and Practices (2nd ed.). ABC-CLIO. p. 300. ISBN 1598842048.",
   "Year": 2010
  },
  {
   "OBJECTID": 702,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Kamphaeng Phet",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 703,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Amnat Charoen",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 704,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Suphan Buri",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 705,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Tak",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 706,
   "Continent": "North America",
   "Country": "Nicaragua",
   "ProvName": "Managua",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "35-40%",
   "Nummeric_1": 40,
   "DataSource": "Nicaragua. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_164_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 707,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Uthai Thani",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 708,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Ang Thong",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 709,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Lop Buri",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 710,
   "Continent": "North America",
   "Country": "Dominican Republic",
   "ProvName": "Elías Piña",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 711,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Prachin Buri",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 712,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Loei",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 713,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Sakon Nakhon",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 714,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Udon Thani",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 715,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Nakhon Sawan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 716,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Saraburi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 717,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Bangkok Metropolis",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 718,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Nonthaburi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 719,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Phetchaburi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 720,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Prachuap Khiri Khan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 721,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Ratchaburi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 722,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Samut Prakan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 723,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Samut Sakhon",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 724,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Si Sa Ket",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 725,
   "Continent": "North America",
   "Country": "Dominican Republic",
   "ProvName": "Pedermales",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 726,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Ubon Ratchathani",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 727,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Tekirdag",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 728,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Yasothon",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 729,
   "Continent": "Europe",
   "Country": "Bulgaria",
   "ProvName": "Sofiya-Grad",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Special Eurobarometer 493, European Union: European Commission, September 2019, pages 229-230",
   "Year": 2019
  },
  {
   "OBJECTID": 730,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Chon Buri",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 731,
   "Continent": "North America",
   "Country": "Nicaragua",
   "ProvName": "León",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "35-40%",
   "Nummeric_1": 40,
   "DataSource": "Nicaragua. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_164_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 732,
   "Continent": "South America",
   "Country": "Argentina",
   "ProvName": "La Rioja",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"PEW Research Center: Religion in Latin America 2014\".",
   "Year": 2014
  },
  {
   "OBJECTID": 733,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Chachoengsao",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 734,
   "Continent": "North America",
   "Country": "Dominica",
   "ProvName": "Carriacou",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "Dominica. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_69_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 735,
   "Continent": "Europe",
   "Country": "United Kingdom",
   "ProvName": "West Midlands",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "United Kingdom. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_233_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 736,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Chanthaburi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 737,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Sa Kaeo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 738,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Rayong",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 739,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Trat",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 740,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Buri Ram",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 741,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Chaiyaphum",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 742,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Khon Kaen",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 743,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Kalasin",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 744,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Maha Sarakham",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 745,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Nakhon Ratchasima",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 746,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Roi Et",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 747,
   "Continent": "North America",
   "Country": "Dominican Republic",
   "ProvName": "Azua",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 748,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Surin",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 749,
   "Continent": "North America",
   "Country": "Dominican Republic",
   "ProvName": "La Vega",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 750,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Nong Bua Lam Phu",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 751,
   "Continent": "North America",
   "Country": "Dominican Republic",
   "ProvName": "Monseñor Nouel",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 752,
   "Continent": "Asia",
   "Country": "North Korea",
   "ProvName": "Hwanghae South",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "No Data",
   "HighRelig": "No Data",
   "ReligCatP": null,
   "Numerical": 0,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": null,
   "Year": null
  },
  {
   "OBJECTID": 753,
   "Continent": "Africa",
   "Country": "Liberia",
   "ProvName": "Bomi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 754,
   "Continent": "Africa",
   "Country": "Liberia",
   "ProvName": "Grand Cape Mount",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 755,
   "Continent": "Africa",
   "Country": "Liberia",
   "ProvName": "Bong",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 756,
   "Continent": "Asia",
   "Country": "Indonesia",
   "ProvName": "Riau",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 757,
   "Continent": "Africa",
   "Country": "Liberia",
   "ProvName": "Grand Bassa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "75-80%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Liberia: Demographic and Health Survey, 2013\". Liberia Institute of Statistics and Geo-Information Services, Ministry of Health and Social Welfare, and National AIDS Control Program. p. 34.",
   "Year": 2015
  },
  {
   "OBJECTID": 758,
   "Continent": "Asia",
   "Country": "Cambodia",
   "ProvName": "Otdar Mean Cheay",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 759,
   "Continent": "Africa",
   "Country": "Liberia",
   "ProvName": "Lofa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 760,
   "Continent": "North America",
   "Country": "Dominican Republic",
   "ProvName": "María Trinidad Sánchez",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 761,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Nakhon Phanom",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 762,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Narathiwat",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 763,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Mukdahan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 764,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Pattani",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 765,
   "Continent": "North America",
   "Country": "Dominica",
   "ProvName": "St. John",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "Dominica. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_69_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 766,
   "Continent": "Asia",
   "Country": "Indonesia",
   "ProvName": "Bali",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Hinduism",
   "HighRelig": "Hindus",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 767,
   "Continent": "Asia",
   "Country": "Indonesia",
   "ProvName": "Jawa Timur",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 768,
   "Continent": "Asia",
   "Country": "Indonesia",
   "ProvName": "Sulawesi Utara",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-65%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Sunni)",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "Population by Region and Religion in Indonesia. BPS. 2010. https:\/\/sp2010.bps.go.id\/index.php\/site\/tabel?tid=321&wid=0",
   "Year": 2010
  },
  {
   "OBJECTID": 769,
   "Continent": "Africa",
   "Country": "Zambia",
   "ProvName": "Copperbelt",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "15-20%",
   "Nummeric_1": 20,
   "DataSource": "Zambia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_245_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 770,
   "Continent": "Africa",
   "Country": "Zambia",
   "ProvName": "Eastern",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "15-20%",
   "Nummeric_1": 20,
   "DataSource": "Zambia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_245_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 771,
   "Continent": "Africa",
   "Country": "Zambia",
   "ProvName": "Lusaka",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "15-20%",
   "Nummeric_1": 20,
   "DataSource": "Zambia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_245_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 772,
   "Continent": "Africa",
   "Country": "Zambia",
   "ProvName": "North-Western",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "15-20%",
   "Nummeric_1": 20,
   "DataSource": "Zambia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_245_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 773,
   "Continent": "Africa",
   "Country": "Zambia",
   "ProvName": "Southern",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "15-20%",
   "Nummeric_1": 20,
   "DataSource": "Zambia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_245_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 774,
   "Continent": "Africa",
   "Country": "Zambia",
   "ProvName": "Western",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "15-20%",
   "Nummeric_1": 20,
   "DataSource": "Zambia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_245_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 775,
   "Continent": "Africa",
   "Country": "Morocco",
   "ProvName": "Guelmim-Es-Semara",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 776,
   "Continent": "Africa",
   "Country": "Zimbabwe",
   "ProvName": "Manicaland",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Inter Censal Demography Survey 2017 Report, Zimbabwe National Statistics Agency (2017)",
   "Year": 2015
  },
  {
   "OBJECTID": 777,
   "Continent": "Africa",
   "Country": "Zimbabwe",
   "ProvName": "Matabeleland South",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Inter Censal Demography Survey 2017 Report, Zimbabwe National Statistics Agency (2017)",
   "Year": 2015
  },
  {
   "OBJECTID": 778,
   "Continent": "Africa",
   "Country": "Zimbabwe",
   "ProvName": "Mashonaland Central",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Inter Censal Demography Survey 2017 Report, Zimbabwe National Statistics Agency (2017)",
   "Year": 2015
  },
  {
   "OBJECTID": 779,
   "Continent": "Africa",
   "Country": "Liberia",
   "ProvName": "Montserrado",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "75-80%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Liberia: Demographic and Health Survey, 2013\". Liberia Institute of Statistics and Geo-Information Services, Ministry of Health and Social Welfare, and National AIDS Control Program. p. 34.",
   "Year": 2015
  },
  {
   "OBJECTID": 780,
   "Continent": "Africa",
   "Country": "Zimbabwe",
   "ProvName": "Bulawayo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Inter Censal Demography Survey 2017 Report, Zimbabwe National Statistics Agency (2017)",
   "Year": 2015
  },
  {
   "OBJECTID": 781,
   "Continent": "Africa",
   "Country": "Zimbabwe",
   "ProvName": "Masvingo (Victoria)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Inter Censal Demography Survey 2017 Report, Zimbabwe National Statistics Agency (2017)",
   "Year": 2015
  },
  {
   "OBJECTID": 782,
   "Continent": "Africa",
   "Country": "Zimbabwe",
   "ProvName": "Mashonaland West",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Inter Censal Demography Survey 2017 Report, Zimbabwe National Statistics Agency (2017)",
   "Year": 2015
  },
  {
   "OBJECTID": 783,
   "Continent": "Africa",
   "Country": "Swaziland",
   "ProvName": "Hhohho",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "70-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Global Religious Future Project. Pew Forum. 2010. http:\/\/www.globalreligiousfutures.org\/countries\/swaziland#\/",
   "Year": 2010
  },
  {
   "OBJECTID": 784,
   "Continent": "Asia",
   "Country": "Timor-Leste",
   "ProvName": "Cova Lima",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Timor-Leste: Demographic and Health Survey, 2016\" (PDF). General Directorate of Statistics, Ministry of Planning and Finance & Ministry of Health. p. 35.",
   "Year": 2016
  },
  {
   "OBJECTID": 785,
   "Continent": "Asia",
   "Country": "Timor-Leste",
   "ProvName": "Ermera",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Timor-Leste: Demographic and Health Survey, 2016\" (PDF). General Directorate of Statistics, Ministry of Planning and Finance & Ministry of Health. p. 35.",
   "Year": 2016
  },
  {
   "OBJECTID": 786,
   "Continent": "Africa",
   "Country": "Swaziland",
   "ProvName": "Lubombo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "70-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Global Religious Future Project. Pew Forum. 2010. http:\/\/www.globalreligiousfutures.org\/countries\/swaziland#\/",
   "Year": 2010
  },
  {
   "OBJECTID": 787,
   "Continent": "Africa",
   "Country": "Swaziland",
   "ProvName": "Manzini",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "70-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Global Religious Future Project. Pew Forum. 2010. http:\/\/www.globalreligiousfutures.org\/countries\/swaziland#\/",
   "Year": 2010
  },
  {
   "OBJECTID": 788,
   "Continent": "Asia",
   "Country": "Timor-Leste",
   "ProvName": "Manatuto",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Timor-Leste: Demographic and Health Survey, 2016\" (PDF). General Directorate of Statistics, Ministry of Planning and Finance & Ministry of Health. p. 35.",
   "Year": 2016
  },
  {
   "OBJECTID": 789,
   "Continent": "Asia",
   "Country": "Timor-Leste",
   "ProvName": "Manufahi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Timor-Leste: Demographic and Health Survey, 2016\" (PDF). General Directorate of Statistics, Ministry of Planning and Finance & Ministry of Health. p. 35.",
   "Year": 2016
  },
  {
   "OBJECTID": 790,
   "Continent": "Africa",
   "Country": "Swaziland",
   "ProvName": "Shiselweni",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "70-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Global Religious Future Project. Pew Forum. 2010. http:\/\/www.globalreligiousfutures.org\/countries\/swaziland#\/",
   "Year": 2010
  },
  {
   "OBJECTID": 791,
   "Continent": "Asia",
   "Country": "Indonesia",
   "ProvName": "Maluku Utara",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 792,
   "Continent": "Asia",
   "Country": "Indonesia",
   "ProvName": "Sumatera Barat",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 793,
   "Continent": "Asia",
   "Country": "Indonesia",
   "ProvName": "Yogyakarta",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 794,
   "Continent": "Asia",
   "Country": "Timor-Leste",
   "ProvName": "Dili",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Timor-Leste: Demographic and Health Survey, 2016\" (PDF). General Directorate of Statistics, Ministry of Planning and Finance & Ministry of Health. p. 35.",
   "Year": 2016
  },
  {
   "OBJECTID": 795,
   "Continent": "Asia",
   "Country": "Timor-Leste",
   "ProvName": "Liquiçá",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Timor-Leste: Demographic and Health Survey, 2016\" (PDF). General Directorate of Statistics, Ministry of Planning and Finance & Ministry of Health. p. 35.",
   "Year": 2016
  },
  {
   "OBJECTID": 796,
   "Continent": "Asia",
   "Country": "Timor-Leste",
   "ProvName": "Aileu",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Timor-Leste: Demographic and Health Survey, 2016\" (PDF). General Directorate of Statistics, Ministry of Planning and Finance & Ministry of Health. p. 35.",
   "Year": 2016
  },
  {
   "OBJECTID": 797,
   "Continent": "Asia",
   "Country": "Jordan",
   "ProvName": "Aqaba",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 798,
   "Continent": "Africa",
   "Country": "Liberia",
   "ProvName": "Margibi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 799,
   "Continent": "Asia",
   "Country": "Timor-Leste",
   "ProvName": "Ainaro",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Timor-Leste: Demographic and Health Survey, 2016\" (PDF). General Directorate of Statistics, Ministry of Planning and Finance & Ministry of Health. p. 35.",
   "Year": 2016
  },
  {
   "OBJECTID": 800,
   "Continent": "Asia",
   "Country": "Timor-Leste",
   "ProvName": "Baucau",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Timor-Leste: Demographic and Health Survey, 2016\" (PDF). General Directorate of Statistics, Ministry of Planning and Finance & Ministry of Health. p. 35.",
   "Year": 2016
  },
  {
   "OBJECTID": 801,
   "Continent": "Asia",
   "Country": "Timor-Leste",
   "ProvName": "Bobonaro",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Timor-Leste: Demographic and Health Survey, 2016\" (PDF). General Directorate of Statistics, Ministry of Planning and Finance & Ministry of Health. p. 35.",
   "Year": 2016
  },
  {
   "OBJECTID": 802,
   "Continent": "Africa",
   "Country": "Sierra Leone",
   "ProvName": "Eastern Province",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 803,
   "Continent": "Asia",
   "Country": "Jordan",
   "ProvName": "Mafraq",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 804,
   "Continent": "Africa",
   "Country": "Liberia",
   "ProvName": "Nimba",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 805,
   "Continent": "Asia",
   "Country": "Jordan",
   "ProvName": "Amman",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 806,
   "Continent": "Africa",
   "Country": "Liberia",
   "ProvName": "Rivercress",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "75-80%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Liberia: Demographic and Health Survey, 2013\". Liberia Institute of Statistics and Geo-Information Services, Ministry of Health and Social Welfare, and National AIDS Control Program. p. 34.",
   "Year": 2015
  },
  {
   "OBJECTID": 807,
   "Continent": "Asia",
   "Country": "Timor-Leste",
   "ProvName": "Viqueque",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Timor-Leste: Demographic and Health Survey, 2016\" (PDF). General Directorate of Statistics, Ministry of Planning and Finance & Ministry of Health. p. 35.",
   "Year": 2016
  },
  {
   "OBJECTID": 808,
   "Continent": "Asia",
   "Country": "Timor-Leste",
   "ProvName": "Lautém",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Timor-Leste: Demographic and Health Survey, 2016\" (PDF). General Directorate of Statistics, Ministry of Planning and Finance & Ministry of Health. p. 35.",
   "Year": 2016
  },
  {
   "OBJECTID": 809,
   "Continent": "Asia",
   "Country": "Indonesia",
   "ProvName": "Maluku",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 810,
   "Continent": "Asia",
   "Country": "Indonesia",
   "ProvName": "Nusa Tenggara Barat",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 811,
   "Continent": "Asia",
   "Country": "Indonesia",
   "ProvName": "Sulawesi Tenggara",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 812,
   "Continent": "Asia",
   "Country": "Indonesia",
   "ProvName": "Sulawesi Tengah",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 813,
   "Continent": "Oceania",
   "Country": "Indonesia",
   "ProvName": "Papua",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "65-70%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Population by Region and Religion in Indonesia. BPS. 2010. https:\/\/sp2010.bps.go.id\/index.php\/site\/tabel?tid=321&wid=0",
   "Year": 2010
  },
  {
   "OBJECTID": 814,
   "Continent": "Africa",
   "Country": "New Caledonia",
   "ProvName": "Nord",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "15-20%",
   "Nummeric_1": 20,
   "DataSource": "New Caledonia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_162_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 815,
   "Continent": "Asia",
   "Country": "Saudi Arabia",
   "ProvName": "Tabouk",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 816,
   "Continent": "Asia",
   "Country": "Jordan",
   "ProvName": "Irbid",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 817,
   "Continent": "Asia",
   "Country": "Jordan",
   "ProvName": "Ajlun",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 818,
   "Continent": "Asia",
   "Country": "Jordan",
   "ProvName": "Jarash",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 819,
   "Continent": "Asia",
   "Country": "Jordan",
   "ProvName": "Balqa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 820,
   "Continent": "Asia",
   "Country": "Jordan",
   "ProvName": "Madaba",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 821,
   "Continent": "Africa",
   "Country": "Liberia",
   "ProvName": "Grand Gedeh",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 822,
   "Continent": "North America",
   "Country": "Haiti",
   "ProvName": "Artibonite",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "The Future of World Religions: Population Growth Projections, 2010-2050. Pew Research Center (2010)",
   "Year": 2010
  },
  {
   "OBJECTID": 823,
   "Continent": "North America",
   "Country": "Haiti",
   "ProvName": "Centre",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "The Future of World Religions: Population Growth Projections, 2010-2050. Pew Research Center (2010)",
   "Year": 2010
  },
  {
   "OBJECTID": 824,
   "Continent": "Africa",
   "Country": "Central African Republic",
   "ProvName": "Basse-Kotto",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "30-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "10-20%",
   "Nummeric_1": 20,
   "DataSource": "\"International Religious Freedom Report for 2016\". U.S. Department of State.",
   "Year": 2016
  },
  {
   "OBJECTID": 825,
   "Continent": "North America",
   "Country": "Haiti",
   "ProvName": "Nord-Est",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "The Future of World Religions: Population Growth Projections, 2010-2050. Pew Research Center (2010)",
   "Year": 2010
  },
  {
   "OBJECTID": 826,
   "Continent": "North America",
   "Country": "Dominican Republic",
   "ProvName": "Samaná",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 827,
   "Continent": "Africa",
   "Country": "Central African Republic",
   "ProvName": "Lobaye",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "10-20%",
   "Nummeric_1": 20,
   "DataSource": "\"International Religious Freedom Report for 2016\". U.S. Department of State.",
   "Year": 2016
  },
  {
   "OBJECTID": 828,
   "Continent": "Africa",
   "Country": "Haiti",
   "ProvName": "Nord",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "The Future of World Religions: Population Growth Projections, 2010-2050. Pew Research Center (2010)",
   "Year": 2010
  },
  {
   "OBJECTID": 829,
   "Continent": "North America",
   "Country": "Dominican Republic",
   "ProvName": "San Cristóbal",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 830,
   "Continent": "North America",
   "Country": "Dominican Republic",
   "ProvName": "Santo Domingo city",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 831,
   "Continent": "Africa",
   "Country": "Niger",
   "ProvName": "Diffa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 832,
   "Continent": "North America",
   "Country": "Jamaica",
   "ProvName": "Saint Thomas",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Jamaica. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_116_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 833,
   "Continent": "North America",
   "Country": "Dominican Republic",
   "ProvName": "Santiago Rodríguez",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 834,
   "Continent": "North America",
   "Country": "Dominican Republic",
   "ProvName": "Valverde",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 835,
   "Continent": "Africa",
   "Country": "Haiti",
   "ProvName": "Ouest",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "The Future of World Religions: Population Growth Projections, 2010-2050. Pew Research Center (2010)",
   "Year": 2010
  },
  {
   "OBJECTID": 836,
   "Continent": "North America",
   "Country": "Dominica",
   "ProvName": "St. Andrew",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "Dominica. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_69_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 837,
   "Continent": "North America",
   "Country": "Haiti",
   "ProvName": "Sud-Est",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "The Future of World Religions: Population Growth Projections, 2010-2050. Pew Research Center (2010)",
   "Year": 2010
  },
  {
   "OBJECTID": 838,
   "Continent": "Africa",
   "Country": "Dominican Republic",
   "ProvName": "Santiago",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 839,
   "Continent": "South America",
   "Country": "Colombia",
   "ProvName": "Vichada",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Religion in Latin America\". Pew Forum. https:\/\/www.pewforum.org\/2014\/11\/13\/religion-in-latin-america\/",
   "Year": 2014
  },
  {
   "OBJECTID": 840,
   "Continent": "South America",
   "Country": "Colombia",
   "ProvName": "Meta",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Religion in Latin America\". Pew Forum. https:\/\/www.pewforum.org\/2014\/11\/13\/religion-in-latin-america\/",
   "Year": 2014
  },
  {
   "OBJECTID": 841,
   "Continent": "South America",
   "Country": "Colombia",
   "ProvName": "Vaupes",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Religion in Latin America\". Pew Forum. https:\/\/www.pewforum.org\/2014\/11\/13\/religion-in-latin-america\/",
   "Year": 2014
  },
  {
   "OBJECTID": 842,
   "Continent": "South America",
   "Country": "Peru",
   "ProvName": "Piura",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Peru. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_177_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 843,
   "Continent": "North America",
   "Country": "Barbados",
   "ProvName": "St. Peter",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Melton, J. Gordon; Baumann, Martin (2010). Religions of the World: A Comprehensive Encyclopedia of Beliefs and Practices (2nd ed.). ABC-CLIO. p. 300. ISBN 1598842048.",
   "Year": 2010
  },
  {
   "OBJECTID": 844,
   "Continent": "North America",
   "Country": "Barbados",
   "ProvName": "St. Philip",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Melton, J. Gordon; Baumann, Martin (2010). Religions of the World: A Comprehensive Encyclopedia of Beliefs and Practices (2nd ed.). ABC-CLIO. p. 300. ISBN 1598842048.",
   "Year": 2010
  },
  {
   "OBJECTID": 845,
   "Continent": "North America",
   "Country": "Barbados",
   "ProvName": "St. Thomas",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Melton, J. Gordon; Baumann, Martin (2010). Religions of the World: A Comprehensive Encyclopedia of Beliefs and Practices (2nd ed.). ABC-CLIO. p. 300. ISBN 1598842048.",
   "Year": 2010
  },
  {
   "OBJECTID": 846,
   "Continent": "South America",
   "Country": "French Guiana",
   "ProvName": "French Guiana",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "French Guiana. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_84_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 847,
   "Continent": "Europe",
   "Country": "United Kingdom",
   "ProvName": "South Western Scotland",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "United Kingdom. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_233_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 848,
   "Continent": "Asia",
   "Country": "Russia",
   "ProvName": "Sverdlovsk",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "30-35%",
   "Numerical": 35,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 849,
   "Continent": "Europe",
   "Country": "Russia",
   "ProvName": "Udmurt",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "30-35%",
   "Numerical": 35,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 850,
   "Continent": "Europe",
   "Country": "Russia",
   "ProvName": "Astrakhan'",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Sunni)",
   "SReligCatp": "10-15%",
   "Nummeric_1": 15,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 851,
   "Continent": "Europe",
   "Country": "Russia",
   "ProvName": "Chuvash",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 852,
   "Continent": "Europe",
   "Country": "Russia",
   "ProvName": "Kalmyk",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Tibetan Buddhism)",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Eastern orthodox",
   "SReligCatp": "15-20",
   "Nummeric_1": 20,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 853,
   "Continent": "Europe",
   "Country": "Russia",
   "ProvName": "Orenburg",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Sunni)",
   "SReligCatp": "10-15%",
   "Nummeric_1": 15,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 854,
   "Continent": "Europe",
   "Country": "Russia",
   "ProvName": "Samara",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 855,
   "Continent": "Europe",
   "Country": "Russia",
   "ProvName": "Saratov",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "30-35%",
   "Numerical": 35,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 856,
   "Continent": "South America",
   "Country": "Chile",
   "ProvName": "Magallanes",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "\"Estudio Nacional de Opinión Pública\" (PDF). Centro de Estudios Públicos. October–November 2018",
   "Year": 2018
  },
  {
   "OBJECTID": 857,
   "Continent": "South America",
   "Country": "Chile",
   "ProvName": "Tarapacá",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "\"Estudio Nacional de Opinión Pública\" (PDF). Centro de Estudios Públicos. October–November 2018",
   "Year": 2018
  },
  {
   "OBJECTID": 858,
   "Continent": "South America",
   "Country": "Chile",
   "ProvName": "Arica and Parinacota",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "\"Estudio Nacional de Opinión Pública\" (PDF). Centro de Estudios Públicos. October–November 2018",
   "Year": 2018
  },
  {
   "OBJECTID": 859,
   "Continent": "Africa",
   "Country": "Algeria",
   "ProvName": "Ghardaïa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 860,
   "Continent": "South America",
   "Country": "Chile",
   "ProvName": "Antofagasta",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "\"Estudio Nacional de Opinión Pública\" (PDF). Centro de Estudios Públicos. October–November 2018",
   "Year": 2018
  },
  {
   "OBJECTID": 861,
   "Continent": "South America",
   "Country": "Chile",
   "ProvName": "Atacama",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "\"Estudio Nacional de Opinión Pública\" (PDF). Centro de Estudios Públicos. October–November 2018",
   "Year": 2018
  },
  {
   "OBJECTID": 862,
   "Continent": "South America",
   "Country": "Chile",
   "ProvName": "Coquimbo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "\"Estudio Nacional de Opinión Pública\" (PDF). Centro de Estudios Públicos. October–November 2018",
   "Year": 2018
  },
  {
   "OBJECTID": 863,
   "Continent": "Europe",
   "Country": "Moldova",
   "ProvName": "Stefan Voda",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 864,
   "Continent": "South America",
   "Country": "Chile",
   "ProvName": "Santiago",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "\"Estudio Nacional de Opinión Pública\" (PDF). Centro de Estudios Públicos. October–November 2018",
   "Year": 2018
  },
  {
   "OBJECTID": 865,
   "Continent": "South America",
   "Country": "Chile",
   "ProvName": "Los Ríos",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "\"Estudio Nacional de Opinión Pública\" (PDF). Centro de Estudios Públicos. October–November 2018",
   "Year": 2018
  },
  {
   "OBJECTID": 866,
   "Continent": "South America",
   "Country": "Chile",
   "ProvName": "Valparaíso",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "85-90%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "\"Estudio Nacional de Opinión Pública\" (PDF). Centro de Estudios Públicos. October–November 2018",
   "Year": 2018
  },
  {
   "OBJECTID": 867,
   "Continent": "North America",
   "Country": "Honduras",
   "ProvName": "Santa Bárbara",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "40-45%",
   "Nummeric_1": 45,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region. Pew Research Center,  November 2014.",
   "Year": 2014
  },
  {
   "OBJECTID": 868,
   "Continent": "South America",
   "Country": "Chile",
   "ProvName": "Araucanía",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "\"Estudio Nacional de Opinión Pública\" (PDF). Centro de Estudios Públicos. October–November 2018",
   "Year": 2018
  },
  {
   "OBJECTID": 869,
   "Continent": "North America",
   "Country": "Mexico",
   "ProvName": "Distrito Federal",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mexico. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_149_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 870,
   "Continent": "South America",
   "Country": "Chile",
   "ProvName": "Bío-Bío",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "\"Estudio Nacional de Opinión Pública\" (PDF). Centro de Estudios Públicos. October–November 2018",
   "Year": 2018
  },
  {
   "OBJECTID": 871,
   "Continent": "Europe",
   "Country": "Moldova",
   "ProvName": "Soroca",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 872,
   "Continent": "North America",
   "Country": "Mexico",
   "ProvName": "Guanajuato",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mexico. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_149_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 873,
   "Continent": "North America",
   "Country": "Mexico",
   "ProvName": "Guerrero",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mexico. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_149_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 874,
   "Continent": "North America",
   "Country": "Mexico",
   "ProvName": "Hidalgo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mexico. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_149_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 875,
   "Continent": "North America",
   "Country": "Mexico",
   "ProvName": "México",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mexico. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_149_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 876,
   "Continent": "North America",
   "Country": "Mexico",
   "ProvName": "Morelos",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mexico. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_149_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 877,
   "Continent": "North America",
   "Country": "Mexico",
   "ProvName": "Yucatán",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mexico. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_149_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 878,
   "Continent": "Europe",
   "Country": "Greenland",
   "ProvName": "Qaasuitsup",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/www.pewforum.org\/2011\/12\/19\/table-christian-population-as-percentages-of-total-population-by-country\/",
   "Year": 2010
  },
  {
   "OBJECTID": 879,
   "Continent": "North America",
   "Country": "Mexico",
   "ProvName": "Querétaro",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mexico. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_149_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 880,
   "Continent": "North America",
   "Country": "Mexico",
   "ProvName": "Veracruz",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mexico. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_149_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 881,
   "Continent": "North America",
   "Country": "Mexico",
   "ProvName": "Chiapas",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mexico. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_149_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 882,
   "Continent": "North America",
   "Country": "Mexico",
   "ProvName": "Quintana Roo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mexico. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_149_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 883,
   "Continent": "Oceania",
   "Country": "Vanuatu",
   "ProvName": "Taféa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "70-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Vanuatu. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_237_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 884,
   "Continent": "Oceania",
   "Country": "Vanuatu",
   "ProvName": "Torba",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "70-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Vanuatu. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_237_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 885,
   "Continent": "Oceania",
   "Country": "Vanuatu",
   "ProvName": "Sanma",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "70-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Vanuatu. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_237_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 886,
   "Continent": "North America",
   "Country": "Dominican Republic",
   "ProvName": "El Seíbo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 887,
   "Continent": "Oceania",
   "Country": "Vanuatu",
   "ProvName": "Malampa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "70-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Vanuatu. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_237_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 888,
   "Continent": "Oceania",
   "Country": "Vanuatu",
   "ProvName": "Penama",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "70-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Vanuatu. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_237_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 889,
   "Continent": "South America",
   "Country": "Peru",
   "ProvName": "Tumbes",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Peru. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_177_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 890,
   "Continent": "Oceania",
   "Country": "Vanuatu",
   "ProvName": "Shefa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "70-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Vanuatu. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_237_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 891,
   "Continent": "South America",
   "Country": "Peru",
   "ProvName": "Lambayeque",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Peru. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_177_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 892,
   "Continent": "North America",
   "Country": "Dominican Republic",
   "ProvName": "La Altagracia",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 893,
   "Continent": "South America",
   "Country": "Peru",
   "ProvName": "Apurimac",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Peru. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_177_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 894,
   "Continent": "South America",
   "Country": "Peru",
   "ProvName": "Acre",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Peru. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_177_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 895,
   "Continent": "North America",
   "Country": "Dominican Republic",
   "ProvName": "La Romana",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 896,
   "Continent": "North America",
   "Country": "Barbados",
   "ProvName": "Christ Church",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Melton, J. Gordon; Baumann, Martin (2010). Religions of the World: A Comprehensive Encyclopedia of Beliefs and Practices (2nd ed.). ABC-CLIO. p. 300. ISBN 1598842048.",
   "Year": 2010
  },
  {
   "OBJECTID": 897,
   "Continent": "South America",
   "Country": "Peru",
   "ProvName": "Arequipa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Peru. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_177_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 898,
   "Continent": "South America",
   "Country": "Peru",
   "ProvName": "Cusco",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Peru. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_177_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 899,
   "Continent": "South America",
   "Country": "Peru",
   "ProvName": "Puno",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Peru. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_177_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 900,
   "Continent": "North America",
   "Country": "Barbados",
   "ProvName": "St. Andrew",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Melton, J. Gordon; Baumann, Martin (2010). Religions of the World: A Comprehensive Encyclopedia of Beliefs and Practices (2nd ed.). ABC-CLIO. p. 300. ISBN 1598842048.",
   "Year": 2010
  },
  {
   "OBJECTID": 901,
   "Continent": "North America",
   "Country": "Barbados",
   "ProvName": "Carriacou",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Melton, J. Gordon; Baumann, Martin (2010). Religions of the World: A Comprehensive Encyclopedia of Beliefs and Practices (2nd ed.). ABC-CLIO. p. 300. ISBN 1598842048.",
   "Year": 2010
  },
  {
   "OBJECTID": 902,
   "Continent": "South America",
   "Country": "Peru",
   "ProvName": "Moquegua",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Peru. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_177_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 903,
   "Continent": "South America",
   "Country": "Peru",
   "ProvName": "Tacna",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Peru. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_177_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 904,
   "Continent": "North America",
   "Country": "Barbados",
   "ProvName": "St. James",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Melton, J. Gordon; Baumann, Martin (2010). Religions of the World: A Comprehensive Encyclopedia of Beliefs and Practices (2nd ed.). ABC-CLIO. p. 300. ISBN 1598842048.",
   "Year": 2010
  },
  {
   "OBJECTID": 905,
   "Continent": "North America",
   "Country": "Barbados",
   "ProvName": "St. John",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Melton, J. Gordon; Baumann, Martin (2010). Religions of the World: A Comprehensive Encyclopedia of Beliefs and Practices (2nd ed.). ABC-CLIO. p. 300. ISBN 1598842048.",
   "Year": 2010
  },
  {
   "OBJECTID": 906,
   "Continent": "South America",
   "Country": "Brazil",
   "ProvName": "Acre",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "IBGE – Instituto Brasileiro de Geografia e Estatística (Brazilian Institute for Geography and Statistics). 2010 Census.",
   "Year": 2010
  },
  {
   "OBJECTID": 907,
   "Continent": "North America",
   "Country": "Barbados",
   "ProvName": "St. Joseph",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Melton, J. Gordon; Baumann, Martin (2010). Religions of the World: A Comprehensive Encyclopedia of Beliefs and Practices (2nd ed.). ABC-CLIO. p. 300. ISBN 1598842048.",
   "Year": 2010
  },
  {
   "OBJECTID": 908,
   "Continent": "North America",
   "Country": "Barbados",
   "ProvName": "St. Lucy",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Melton, J. Gordon; Baumann, Martin (2010). Religions of the World: A Comprehensive Encyclopedia of Beliefs and Practices (2nd ed.). ABC-CLIO. p. 300. ISBN 1598842048.",
   "Year": 2010
  },
  {
   "OBJECTID": 909,
   "Continent": "South America",
   "Country": "Peru",
   "ProvName": "Ancash",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Peru. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_177_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 910,
   "Continent": "South America",
   "Country": "Peru",
   "ProvName": "Pasco",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Peru. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_177_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 911,
   "Continent": "South America",
   "Country": "Peru",
   "ProvName": "Cajamarca",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Peru. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_177_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 912,
   "Continent": "South America",
   "Country": "Peru",
   "ProvName": "Huanuco",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Peru. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_177_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 913,
   "Continent": "North America",
   "Country": "Honduras",
   "ProvName": "Copán",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "40-45%",
   "Nummeric_1": 45,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region. Pew Research Center,  November 2014.",
   "Year": 2014
  },
  {
   "OBJECTID": 914,
   "Continent": "South America",
   "Country": "Peru",
   "ProvName": "La Libertad",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Peru. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_177_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 915,
   "Continent": "North America",
   "Country": "Nicaragua",
   "ProvName": "Estelí",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "35-40%",
   "Nummeric_1": 40,
   "DataSource": "Nicaragua. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_164_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 916,
   "Continent": "South America",
   "Country": "Peru",
   "ProvName": "San Martín",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Peru. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_177_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 917,
   "Continent": "South America",
   "Country": "Peru",
   "ProvName": "Ucayali",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Peru. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_177_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 918,
   "Continent": "South America",
   "Country": "Peru",
   "ProvName": "Lima Municipality",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Peru. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_177_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 919,
   "Continent": "South America",
   "Country": "Peru",
   "ProvName": "Amazonas",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Peru. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_177_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 920,
   "Continent": "South America",
   "Country": "Peru",
   "ProvName": "Loreto",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Peru. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_177_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 921,
   "Continent": "South America",
   "Country": "Peru",
   "ProvName": "Ayacucho",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Peru. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_177_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 922,
   "Continent": "South America",
   "Country": "Paraguay",
   "ProvName": "Guairá",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.statista.com\/statistics\/1067159\/paraguay-religion-affiliation-share-type\/\/ Religion affiliation in Paraguay as of 2018.",
   "Year": 2018
  },
  {
   "OBJECTID": 923,
   "Continent": "South America",
   "Country": "Peru",
   "ProvName": "Huancavelica",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Peru. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_177_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 924,
   "Continent": "South America",
   "Country": "Paraguay",
   "ProvName": "Misiones",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.statista.com\/statistics\/1067159\/paraguay-religion-affiliation-share-type\/\/ Religion affiliation in Paraguay as of 2018.",
   "Year": 2018
  },
  {
   "OBJECTID": 925,
   "Continent": "South America",
   "Country": "Peru",
   "ProvName": "Ica",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Peru. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_177_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 926,
   "Continent": "North America",
   "Country": "Canada",
   "ProvName": "Saskatchewan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "30-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "\"Religions in Canada—Census 2011\". Statistics Canada\/Statistique Canada.",
   "Year": 2010
  },
  {
   "OBJECTID": 927,
   "Continent": "North America",
   "Country": "Canada",
   "ProvName": "Alberta",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "30-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "\"Religions in Canada—Census 2011\". Statistics Canada\/Statistique Canada.",
   "Year": 2010
  },
  {
   "OBJECTID": 928,
   "Continent": "North America",
   "Country": "Canada",
   "ProvName": "British Columbia",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "20-30%",
   "Numerical": 30,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Religions in Canada—Census 2011\". Statistics Canada\/Statistique Canada.",
   "Year": 2010
  },
  {
   "OBJECTID": 929,
   "Continent": "North America",
   "Country": "Canada",
   "ProvName": "Nunavut",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "\"Religions in Canada—Census 2011\". Statistics Canada\/Statistique Canada.",
   "Year": 2010
  },
  {
   "OBJECTID": 930,
   "Continent": "North America",
   "Country": "Canada",
   "ProvName": "Northwest Territories",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "30-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "\"Religions in Canada—Census 2011\". Statistics Canada\/Statistique Canada.",
   "Year": 2010
  },
  {
   "OBJECTID": 931,
   "Continent": "North America",
   "Country": "Canada",
   "ProvName": "Yukon Territory",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "10-20%",
   "Numerical": 20,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Religions in Canada—Census 2011\". Statistics Canada\/Statistique Canada.",
   "Year": 2010
  },
  {
   "OBJECTID": 932,
   "Continent": "South America",
   "Country": "Peru",
   "ProvName": "Junin",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Peru. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_177_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 933,
   "Continent": "North America",
   "Country": "Nicaragua",
   "ProvName": "Madriz",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "35-40%",
   "Nummeric_1": 40,
   "DataSource": "Nicaragua. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_164_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 934,
   "Continent": "South America",
   "Country": "Peru",
   "ProvName": "Lima",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Peru. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_177_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 935,
   "Continent": "South America",
   "Country": "Brazil",
   "ProvName": "Amazonas",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "IBGE – Instituto Brasileiro de Geografia e Estatística (Brazilian Institute for Geography and Statistics). 2010 Census.",
   "Year": 2010
  },
  {
   "OBJECTID": 936,
   "Continent": "South America",
   "Country": "Brazil",
   "ProvName": "Maranhão",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "IBGE – Instituto Brasileiro de Geografia e Estatística (Brazilian Institute for Geography and Statistics). 2010 Census.",
   "Year": 2010
  },
  {
   "OBJECTID": 937,
   "Continent": "South America",
   "Country": "Paraguay",
   "ProvName": "Presidente Hayes",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.statista.com\/statistics\/1067159\/paraguay-religion-affiliation-share-type\/\/ Religion affiliation in Paraguay as of 2018.",
   "Year": 2018
  },
  {
   "OBJECTID": 938,
   "Continent": "South America",
   "Country": "Paraguay",
   "ProvName": "San Pedro",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.statista.com\/statistics\/1067159\/paraguay-religion-affiliation-share-type\/\/ Religion affiliation in Paraguay as of 2018.",
   "Year": 2018
  },
  {
   "OBJECTID": 939,
   "Continent": "Europe",
   "Country": "United Kingdom",
   "ProvName": "Merseyside",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "United Kingdom. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_233_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 940,
   "Continent": "South America",
   "Country": "Paraguay",
   "ProvName": "Neembucú",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.statista.com\/statistics\/1067159\/paraguay-religion-affiliation-share-type\/\/ Religion affiliation in Paraguay as of 2018.",
   "Year": 2018
  },
  {
   "OBJECTID": 941,
   "Continent": "South America",
   "Country": "Paraguay",
   "ProvName": "Paraguarí",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.statista.com\/statistics\/1067159\/paraguay-religion-affiliation-share-type\/\/ Religion affiliation in Paraguay as of 2018.",
   "Year": 2018
  },
  {
   "OBJECTID": 942,
   "Continent": "South America",
   "Country": "Brazil",
   "ProvName": "Rio Grande do Sul",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "IBGE – Instituto Brasileiro de Geografia e Estatística (Brazilian Institute for Geography and Statistics). 2010 Census.",
   "Year": 2010
  },
  {
   "OBJECTID": 943,
   "Continent": "South America",
   "Country": "Brazil",
   "ProvName": "Paraná",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "IBGE – Instituto Brasileiro de Geografia e Estatística (Brazilian Institute for Geography and Statistics). 2010 Census.",
   "Year": 2010
  },
  {
   "OBJECTID": 944,
   "Continent": "South America",
   "Country": "Brazil",
   "ProvName": "Santa Catarina",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "IBGE – Instituto Brasileiro de Geografia e Estatística (Brazilian Institute for Geography and Statistics). 2010 Census.",
   "Year": 2010
  },
  {
   "OBJECTID": 945,
   "Continent": "South America",
   "Country": "Paraguay",
   "ProvName": "Amambay",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.statista.com\/statistics\/1067159\/paraguay-religion-affiliation-share-type\/\/ Religion affiliation in Paraguay as of 2018.",
   "Year": 2018
  },
  {
   "OBJECTID": 946,
   "Continent": "South America",
   "Country": "Guyana",
   "ProvName": "Demerara\/Mahaica",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Guyana. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_102_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 947,
   "Continent": "South America",
   "Country": "Paraguay",
   "ProvName": "Alto Paraná",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.statista.com\/statistics\/1067159\/paraguay-religion-affiliation-share-type\/\/ Religion affiliation in Paraguay as of 2018.",
   "Year": 2018
  },
  {
   "OBJECTID": 948,
   "Continent": "Africa",
   "Country": "Algeria",
   "ProvName": "Aïn Temouchent",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 949,
   "Continent": "South America",
   "Country": "Paraguay",
   "ProvName": "Caaguazú",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.statista.com\/statistics\/1067159\/paraguay-religion-affiliation-share-type\/\/ Religion affiliation in Paraguay as of 2018.",
   "Year": 2018
  },
  {
   "OBJECTID": 950,
   "Continent": "South America",
   "Country": "Paraguay",
   "ProvName": "Caazapá",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.statista.com\/statistics\/1067159\/paraguay-religion-affiliation-share-type\/\/ Religion affiliation in Paraguay as of 2018.",
   "Year": 2018
  },
  {
   "OBJECTID": 951,
   "Continent": "South America",
   "Country": "Paraguay",
   "ProvName": "Canindiyú",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.statista.com\/statistics\/1067159\/paraguay-religion-affiliation-share-type\/\/ Religion affiliation in Paraguay as of 2018.",
   "Year": 2018
  },
  {
   "OBJECTID": 952,
   "Continent": "North America",
   "Country": "Honduras",
   "ProvName": "Atlántida",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "40-45%",
   "Nummeric_1": 45,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region. Pew Research Center,  November 2014.",
   "Year": 2014
  },
  {
   "OBJECTID": 953,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Bingöl",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 954,
   "Continent": "South America",
   "Country": "Paraguay",
   "ProvName": "Itapúa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.statista.com\/statistics\/1067159\/paraguay-religion-affiliation-share-type\/\/ Religion affiliation in Paraguay as of 2018.",
   "Year": 2018
  },
  {
   "OBJECTID": 955,
   "Continent": "South America",
   "Country": "Brazil",
   "ProvName": "Ceará",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "IBGE – Instituto Brasileiro de Geografia e Estatística (Brazilian Institute for Geography and Statistics). 2010 Census.",
   "Year": 2010
  },
  {
   "OBJECTID": 956,
   "Continent": "South America",
   "Country": "Brazil",
   "ProvName": "Piauí",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "IBGE – Instituto Brasileiro de Geografia e Estatística (Brazilian Institute for Geography and Statistics). 2010 Census.",
   "Year": 2010
  },
  {
   "OBJECTID": 957,
   "Continent": "North America",
   "Country": "Honduras",
   "ProvName": "Colón",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "40-45%",
   "Nummeric_1": 45,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region. Pew Research Center,  November 2014.",
   "Year": 2014
  },
  {
   "OBJECTID": 958,
   "Continent": "South America",
   "Country": "Brazil",
   "ProvName": "Alagoas",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "IBGE – Instituto Brasileiro de Geografia e Estatística (Brazilian Institute for Geography and Statistics). 2010 Census.",
   "Year": 2010
  },
  {
   "OBJECTID": 959,
   "Continent": "South America",
   "Country": "Brazil",
   "ProvName": "Bahia",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "IBGE – Instituto Brasileiro de Geografia e Estatística (Brazilian Institute for Geography and Statistics). 2010 Census.",
   "Year": 2010
  },
  {
   "OBJECTID": 960,
   "Continent": "South America",
   "Country": "Brazil",
   "ProvName": "Espírito Santo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "IBGE – Instituto Brasileiro de Geografia e Estatística (Brazilian Institute for Geography and Statistics). 2010 Census.",
   "Year": 2010
  },
  {
   "OBJECTID": 961,
   "Continent": "South America",
   "Country": "Brazil",
   "ProvName": "Paraíba",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "IBGE – Instituto Brasileiro de Geografia e Estatística (Brazilian Institute for Geography and Statistics). 2010 Census.",
   "Year": 2010
  },
  {
   "OBJECTID": 962,
   "Continent": "South America",
   "Country": "Brazil",
   "ProvName": "Rio de Janeiro",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "IBGE – Instituto Brasileiro de Geografia e Estatística (Brazilian Institute for Geography and Statistics). 2010 Census.",
   "Year": 2010
  },
  {
   "OBJECTID": 963,
   "Continent": "North America",
   "Country": "Honduras",
   "ProvName": "Islas de la Bahìa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "40-45%",
   "Nummeric_1": 45,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region. Pew Research Center,  November 2014.",
   "Year": 2014
  },
  {
   "OBJECTID": 964,
   "Continent": "Africa",
   "Country": "Burundi",
   "ProvName": "Bururi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Anthony Appiah; Henry Louis Gates (2010). Encyclopedia of Africa. Oxford University Press. p. 221. ISBN 978-0-19-533770-9.",
   "Year": 2010
  },
  {
   "OBJECTID": 965,
   "Continent": "South America",
   "Country": "Brazil",
   "ProvName": "Rio Grande do Norte",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "IBGE – Instituto Brasileiro de Geografia e Estatística (Brazilian Institute for Geography and Statistics). 2010 Census.",
   "Year": 2010
  },
  {
   "OBJECTID": 966,
   "Continent": "South America",
   "Country": "Brazil",
   "ProvName": "Sergipe",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "IBGE – Instituto Brasileiro de Geografia e Estatística (Brazilian Institute for Geography and Statistics). 2010 Census.",
   "Year": 2010
  },
  {
   "OBJECTID": 967,
   "Continent": "North America",
   "Country": "Canada",
   "ProvName": "Manitoba",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "30-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "\"Religions in Canada—Census 2011\". Statistics Canada\/Statistique Canada.",
   "Year": 2010
  },
  {
   "OBJECTID": 968,
   "Continent": "North America",
   "Country": "Nicaragua",
   "ProvName": "Granada",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "35-40%",
   "Nummeric_1": 40,
   "DataSource": "Nicaragua. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_164_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 969,
   "Continent": "North America",
   "Country": "Honduras",
   "ProvName": "Francisco Morazán",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "40-45%",
   "Nummeric_1": 45,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region. Pew Research Center,  November 2014.",
   "Year": 2014
  },
  {
   "OBJECTID": 970,
   "Continent": "North America",
   "Country": "Honduras",
   "ProvName": "Intibucá",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "40-45%",
   "Nummeric_1": 45,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region. Pew Research Center,  November 2014.",
   "Year": 2014
  },
  {
   "OBJECTID": 971,
   "Continent": "North America",
   "Country": "Honduras",
   "ProvName": "Gracias a Dios",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "40-45%",
   "Nummeric_1": 45,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region. Pew Research Center,  November 2014.",
   "Year": 2014
  },
  {
   "OBJECTID": 972,
   "Continent": "North America",
   "Country": "Honduras",
   "ProvName": "Olancho",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "40-45%",
   "Nummeric_1": 45,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region. Pew Research Center,  November 2014.",
   "Year": 2014
  },
  {
   "OBJECTID": 973,
   "Continent": "North America",
   "Country": "Honduras",
   "ProvName": "La Paz",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "40-45%",
   "Nummeric_1": 45,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region. Pew Research Center,  November 2014.",
   "Year": 2014
  },
  {
   "OBJECTID": 974,
   "Continent": "North America",
   "Country": "Honduras",
   "ProvName": "Yoro",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "40-45%",
   "Nummeric_1": 45,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region. Pew Research Center,  November 2014.",
   "Year": 2014
  },
  {
   "OBJECTID": 975,
   "Continent": "North America",
   "Country": "Nicaragua",
   "ProvName": "Atlantico Sur",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "35-40%",
   "Nummeric_1": 40,
   "DataSource": "Nicaragua. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_164_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 976,
   "Continent": "North America",
   "Country": "Honduras",
   "ProvName": "Valle",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "40-45%",
   "Nummeric_1": 45,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region. Pew Research Center,  November 2014.",
   "Year": 2014
  },
  {
   "OBJECTID": 977,
   "Continent": "North America",
   "Country": "Honduras",
   "ProvName": "Comayagua",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "40-45%",
   "Nummeric_1": 45,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region. Pew Research Center,  November 2014.",
   "Year": 2014
  },
  {
   "OBJECTID": 978,
   "Continent": "North America",
   "Country": "Honduras",
   "ProvName": "Cortés",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "40-45%",
   "Nummeric_1": 45,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region. Pew Research Center,  November 2014.",
   "Year": 2014
  },
  {
   "OBJECTID": 979,
   "Continent": "North America",
   "Country": "Honduras",
   "ProvName": "Lempira",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "40-45%",
   "Nummeric_1": 45,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region. Pew Research Center,  November 2014.",
   "Year": 2014
  },
  {
   "OBJECTID": 980,
   "Continent": "North America",
   "Country": "Honduras",
   "ProvName": "Ocotepeque",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "40-45%",
   "Nummeric_1": 45,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region. Pew Research Center,  November 2014.",
   "Year": 2014
  },
  {
   "OBJECTID": 981,
   "Continent": "North America",
   "Country": "Nicaragua",
   "ProvName": "Carazo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "35-40%",
   "Nummeric_1": 40,
   "DataSource": "Nicaragua. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_164_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 982,
   "Continent": "Africa",
   "Country": "Burundi",
   "ProvName": "Makamba",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Anthony Appiah; Henry Louis Gates (2010). Encyclopedia of Africa. Oxford University Press. p. 221. ISBN 978-0-19-533770-9.",
   "Year": 2010
  },
  {
   "OBJECTID": 983,
   "Continent": "North America",
   "Country": "Nicaragua",
   "ProvName": "Jinotega",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "35-40%",
   "Nummeric_1": 40,
   "DataSource": "Nicaragua. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_164_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 984,
   "Continent": "North America",
   "Country": "Nicaragua",
   "ProvName": "Atlantico Norte",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "35-40%",
   "Nummeric_1": 40,
   "DataSource": "Nicaragua. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_164_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 985,
   "Continent": "North America",
   "Country": "Nicaragua",
   "ProvName": "Masaya",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "35-40%",
   "Nummeric_1": 40,
   "DataSource": "Nicaragua. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_164_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 986,
   "Continent": "North America",
   "Country": "Honduras",
   "ProvName": "Choluteca",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "40-45%",
   "Nummeric_1": 45,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region. Pew Research Center,  November 2014.",
   "Year": 2014
  },
  {
   "OBJECTID": 987,
   "Continent": "North America",
   "Country": "Honduras",
   "ProvName": "El Para?so",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "40-45%",
   "Nummeric_1": 45,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region. Pew Research Center,  November 2014.",
   "Year": 2014
  },
  {
   "OBJECTID": 988,
   "Continent": "North America",
   "Country": "Nicaragua",
   "ProvName": "Chinandega",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "35-40%",
   "Nummeric_1": 40,
   "DataSource": "Nicaragua. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_164_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 989,
   "Continent": "North America",
   "Country": "Nicaragua",
   "ProvName": "Matagalpa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "35-40%",
   "Nummeric_1": 40,
   "DataSource": "Nicaragua. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_164_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 990,
   "Continent": "North America",
   "Country": "Nicaragua",
   "ProvName": "Nueva Segovia",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "35-40%",
   "Nummeric_1": 40,
   "DataSource": "Nicaragua. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_164_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 991,
   "Continent": "Africa",
   "Country": "Benin",
   "ProvName": "Plateau",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 992,
   "Continent": "North America",
   "Country": "Nicaragua",
   "ProvName": "Boaco",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "35-40%",
   "Nummeric_1": 40,
   "DataSource": "Nicaragua. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_164_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 993,
   "Continent": "North America",
   "Country": "Nicaragua",
   "ProvName": "Chontales",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "35-40%",
   "Nummeric_1": 40,
   "DataSource": "Nicaragua. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_164_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 994,
   "Continent": "South America",
   "Country": "Brazil",
   "ProvName": "Roraima",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "IBGE – Instituto Brasileiro de Geografia e Estatística (Brazilian Institute for Geography and Statistics). 2010 Census.",
   "Year": 2010
  },
  {
   "OBJECTID": 995,
   "Continent": "South America",
   "Country": "Guyana",
   "ProvName": "East Berbice\/Corentyne",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Guyana. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_102_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 996,
   "Continent": "South America",
   "Country": "Guyana",
   "ProvName": "Essequibo\/West Demera",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Guyana. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_102_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 997,
   "Continent": "South America",
   "Country": "Guyana",
   "ProvName": "Potaro\/Siparuni Mahdia",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Hinduism",
   "HighRelig": "Hindus",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 998,
   "Continent": "South America",
   "Country": "Guyana",
   "ProvName": "Upper Demerara\/Berbice",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Hinduism",
   "HighRelig": "Hindus",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 999,
   "Continent": "South America",
   "Country": "Guyana",
   "ProvName": "Upper Takutu\/Esseququibo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Hinduism",
   "HighRelig": "Hindus",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1000,
   "Continent": "Africa",
   "Country": "Benin",
   "ProvName": "Mono",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1001,
   "Continent": "South America",
   "Country": "Guyana",
   "ProvName": "Barima\/Waini",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Hinduism",
   "HighRelig": "Hindus",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1002,
   "Continent": "South America",
   "Country": "Guyana",
   "ProvName": "Mahaica\/Berbice",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Guyana. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_102_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1003,
   "Continent": "Africa",
   "Country": "Algeria",
   "ProvName": "Tizi Ouzou",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1004,
   "Continent": "South America",
   "Country": "Guyana",
   "ProvName": "Cuyuni\/Mazaruni",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Hinduism",
   "HighRelig": "Hindus",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1005,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Diyarbakir",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1006,
   "Continent": "Africa",
   "Country": "Sudan",
   "ProvName": "Gharb Dârfûr (West Darfur)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1007,
   "Continent": "Europe",
   "Country": "Iceland",
   "ProvName": "Sudurnes",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Populations by religious organizations 1998-2020. Reykjavík, Iceland: Statistics Iceland. http:\/\/px.hagstofa.is\/pxen\/pxweb\/en\/Samfelag\/Samfelag__menning__5_trufelog\/MAN10001.px\/?rxid=4cfc6e75-3bf7-4455-ba53-5cb62900aa65",
   "Year": 2019
  },
  {
   "OBJECTID": 1008,
   "Continent": "Europe",
   "Country": "Iceland",
   "ProvName": "Vesturland",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Populations by religious organizations 1998-2020. Reykjavík, Iceland: Statistics Iceland. http:\/\/px.hagstofa.is\/pxen\/pxweb\/en\/Samfelag\/Samfelag__menning__5_trufelog\/MAN10001.px\/?rxid=4cfc6e75-3bf7-4455-ba53-5cb62900aa65",
   "Year": 2019
  },
  {
   "OBJECTID": 1009,
   "Continent": "Africa",
   "Country": "Cameroon",
   "ProvName": "Ouest",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "20-30%",
   "Numerical": 30,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "July-December, 2010 International Religious Freedom Report : Cameroon. United States Bureau of Democracy, Human Rights and Labor (2010)",
   "Year": 2010
  },
  {
   "OBJECTID": 1010,
   "Continent": "Europe",
   "Country": "Iceland",
   "ProvName": "Capital region",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Populations by religious organizations 1998-2020. Reykjavík, Iceland: Statistics Iceland. http:\/\/px.hagstofa.is\/pxen\/pxweb\/en\/Samfelag\/Samfelag__menning__5_trufelog\/MAN10001.px\/?rxid=4cfc6e75-3bf7-4455-ba53-5cb62900aa65",
   "Year": 2019
  },
  {
   "OBJECTID": 1011,
   "Continent": "Europe",
   "Country": "Ireland",
   "ProvName": "Connacht",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Ireland. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_112_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1012,
   "Continent": "Asia",
   "Country": "Malaysia",
   "ProvName": "Perlis",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1013,
   "Continent": "Africa",
   "Country": "Cameroon",
   "ProvName": "Sud-Ouest",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "20-30%",
   "Numerical": 30,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "July-December, 2010 International Religious Freedom Report : Cameroon. United States Bureau of Democracy, Human Rights and Labor (2010)",
   "Year": 2010
  },
  {
   "OBJECTID": 1014,
   "Continent": "Africa",
   "Country": "Niger",
   "ProvName": "Agadez",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1015,
   "Continent": "Africa",
   "Country": "Central African Republic",
   "ProvName": "Mambéré-Kadéï",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "10-20%",
   "Nummeric_1": 20,
   "DataSource": "\"International Religious Freedom Report for 2016\". U.S. Department of State.",
   "Year": 2016
  },
  {
   "OBJECTID": 1016,
   "Continent": "Africa",
   "Country": "Senegal",
   "ProvName": "Diourbel",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1017,
   "Continent": "Africa",
   "Country": "Central African Republic",
   "ProvName": "Sangha-Mbaéré",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "10-20%",
   "Nummeric_1": 20,
   "DataSource": "\"International Religious Freedom Report for 2016\". U.S. Department of State.",
   "Year": 2016
  },
  {
   "OBJECTID": 1018,
   "Continent": "South America",
   "Country": "Guyana",
   "ProvName": "Pomeroon\/Supenaam",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Hinduism",
   "HighRelig": "Hindus",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1019,
   "Continent": "South America",
   "Country": "Brazil",
   "ProvName": "Amapá",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "IBGE – Instituto Brasileiro de Geografia e Estatística (Brazilian Institute for Geography and Statistics). 2010 Census.",
   "Year": 2010
  },
  {
   "OBJECTID": 1020,
   "Continent": "North America",
   "Country": "Canada",
   "ProvName": "Ontario",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "30-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "\"Religions in Canada—Census 2011\". Statistics Canada\/Statistique Canada.",
   "Year": 2010
  },
  {
   "OBJECTID": 1021,
   "Continent": "North America",
   "Country": "Canada",
   "ProvName": "Quebec",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "\"Religions in Canada—Census 2011\". Statistics Canada\/Statistique Canada.",
   "Year": 2010
  },
  {
   "OBJECTID": 1022,
   "Continent": "North America",
   "Country": "Canada",
   "ProvName": "New Brunswick",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "\"Religions in Canada—Census 2011\". Statistics Canada\/Statistique Canada.",
   "Year": 2010
  },
  {
   "OBJECTID": 1023,
   "Continent": "North America",
   "Country": "Canada",
   "ProvName": "Nova Scotia",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "\"Religions in Canada—Census 2011\". Statistics Canada\/Statistique Canada.",
   "Year": 2010
  },
  {
   "OBJECTID": 1024,
   "Continent": "North America",
   "Country": "Canada",
   "ProvName": "Newfoundland",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "\"Religions in Canada—Census 2011\". Statistics Canada\/Statistique Canada.",
   "Year": 2010
  },
  {
   "OBJECTID": 1025,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Mus",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1026,
   "Continent": "North America",
   "Country": "Canada",
   "ProvName": "Prince Edward Island",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "\"Religions in Canada—Census 2011\". Statistics Canada\/Statistique Canada.",
   "Year": 2010
  },
  {
   "OBJECTID": 1027,
   "Continent": "Europe",
   "Country": "Iceland",
   "ProvName": "Nordhurland eystra",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Populations by religious organizations 1998-2020. Reykjavík, Iceland: Statistics Iceland. http:\/\/px.hagstofa.is\/pxen\/pxweb\/en\/Samfelag\/Samfelag__menning__5_trufelog\/MAN10001.px\/?rxid=4cfc6e75-3bf7-4455-ba53-5cb62900aa65",
   "Year": 2019
  },
  {
   "OBJECTID": 1028,
   "Continent": "Europe",
   "Country": "Iceland",
   "ProvName": "Sudurland",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Populations by religious organizations 1998-2020. Reykjavík, Iceland: Statistics Iceland. http:\/\/px.hagstofa.is\/pxen\/pxweb\/en\/Samfelag\/Samfelag__menning__5_trufelog\/MAN10001.px\/?rxid=4cfc6e75-3bf7-4455-ba53-5cb62900aa65",
   "Year": 2019
  },
  {
   "OBJECTID": 1029,
   "Continent": "Asia",
   "Country": "Taiwan*",
   "ProvName": "P'ing-tung",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1030,
   "Continent": "Europe",
   "Country": "Spain",
   "ProvName": "Murcia",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Spain. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_208_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1031,
   "Continent": "Europe",
   "Country": "Spain",
   "ProvName": "Ceuta",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Sunni)",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "\"Interactivo: Creencias y prácticas religiosas en España\". lavanguardia.com.",
   "Year": 2012
  },
  {
   "OBJECTID": 1032,
   "Continent": "Europe",
   "Country": "Spain",
   "ProvName": "Melilla",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "40-45%",
   "Nummeric_1": 45,
   "DataSource": "Sibai, S. A. (2010). ‘Sometimes I am Spanish and sometimes not’: a study of the identity and integration of Spanish Muslim women. Research in Comparative and International Education, 5(2), 185-204.",
   "Year": 2010
  },
  {
   "OBJECTID": 1033,
   "Continent": "Asia",
   "Country": "Taiwan*",
   "ProvName": "T'ai-nan municipality",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1034,
   "Continent": "Asia",
   "Country": "Taiwan*",
   "ProvName": "Hsin-chu city",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1035,
   "Continent": "Europe",
   "Country": "Portugal",
   "ProvName": "Azores (Acores)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Portugal. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_181_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1036,
   "Continent": "Europe",
   "Country": "Portugal",
   "ProvName": "Madeira",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Portugal. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_181_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1037,
   "Continent": "Asia",
   "Country": "Taiwan*",
   "ProvName": "Hsin-chu",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1038,
   "Continent": "Africa",
   "Country": "Madagascar",
   "ProvName": "Fianarantsoa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "25-30%",
   "Numerical": 30,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "20-25%",
   "Nummeric_1": 25,
   "DataSource": "Madagascar. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_137_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1039,
   "Continent": "Africa",
   "Country": "Madagascar",
   "ProvName": "Mahajanga",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1040,
   "Continent": "Africa",
   "Country": "Madagascar",
   "ProvName": "Toamasina",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1041,
   "Continent": "Africa",
   "Country": "Madagascar",
   "ProvName": "Toliara",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1042,
   "Continent": "Europe",
   "Country": "Spain",
   "ProvName": "Asturias",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Spain. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_208_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1043,
   "Continent": "Europe",
   "Country": "Spain",
   "ProvName": "Galicia",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Spain. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_208_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1044,
   "Continent": "Asia",
   "Country": "Taiwan*",
   "ProvName": "Miao-li",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1045,
   "Continent": "Europe",
   "Country": "Spain",
   "ProvName": "La Rioja",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Spain. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_208_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1046,
   "Continent": "Africa",
   "Country": "Sudan",
   "ProvName": "an-Nîl-al-Abyad (White Nile)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1047,
   "Continent": "Europe",
   "Country": "Spain",
   "ProvName": "País Vasco",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Spain. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_208_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1048,
   "Continent": "Africa",
   "Country": "Cameroon",
   "ProvName": "Sud",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "20-30%",
   "Numerical": 30,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "July-December, 2010 International Religious Freedom Report : Cameroon. United States Bureau of Democracy, Human Rights and Labor (2010)",
   "Year": 2010
  },
  {
   "OBJECTID": 1049,
   "Continent": "Asia",
   "Country": "Taiwan*",
   "ProvName": "T'ai-pei municipality",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "10-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1050,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Bitlis",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1051,
   "Continent": "Africa",
   "Country": "Central African Republic",
   "ProvName": "Nana-Mambéré",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "10-20%",
   "Nummeric_1": 20,
   "DataSource": "\"International Religious Freedom Report for 2016\". U.S. Department of State.",
   "Year": 2016
  },
  {
   "OBJECTID": 1052,
   "Continent": "Europe",
   "Country": "Netherlands",
   "ProvName": "Drenthe",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "20-25%",
   "Numerical": 25,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Netherlands. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_160_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1053,
   "Continent": "Africa",
   "Country": "Central African Republic",
   "ProvName": "Ouham-Pendé",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "10-20%",
   "Nummeric_1": 20,
   "DataSource": "\"International Religious Freedom Report for 2016\". U.S. Department of State.",
   "Year": 2016
  },
  {
   "OBJECTID": 1054,
   "Continent": "Africa",
   "Country": "Central African Republic",
   "ProvName": "Bamingui-Bangoran",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "30-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "10-20%",
   "Nummeric_1": 20,
   "DataSource": "\"International Religious Freedom Report for 2016\". U.S. Department of State.",
   "Year": 2016
  },
  {
   "OBJECTID": 1055,
   "Continent": "Africa",
   "Country": "Central African Republic",
   "ProvName": "Nana-Gribizi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "10-20%",
   "Nummeric_1": 20,
   "DataSource": "\"International Religious Freedom Report for 2016\". U.S. Department of State.",
   "Year": 2016
  },
  {
   "OBJECTID": 1056,
   "Continent": "Europe",
   "Country": "Latvia",
   "ProvName": "Riga city",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Latvia. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_128_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1057,
   "Continent": "Africa",
   "Country": "Somalia",
   "ProvName": "Bakool",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1058,
   "Continent": "Africa",
   "Country": "Somalia",
   "ProvName": "Bay",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1059,
   "Continent": "Africa",
   "Country": "Central African Republic",
   "ProvName": "Kemo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "10-20%",
   "Nummeric_1": 20,
   "DataSource": "\"International Religious Freedom Report for 2016\". U.S. Department of State.",
   "Year": 2016
  },
  {
   "OBJECTID": 1060,
   "Continent": "Africa",
   "Country": "Senegal",
   "ProvName": "Dakar",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1061,
   "Continent": "Africa",
   "Country": "Sierra Leone",
   "ProvName": "Southern Province",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1062,
   "Continent": "Africa",
   "Country": "Sierra Leone",
   "ProvName": "Western Area",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1063,
   "Continent": "Africa",
   "Country": "Sierra Leone",
   "ProvName": "Northern Province",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1064,
   "Continent": "Europe",
   "Country": "Luxembourg",
   "ProvName": "Luxembourg",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Eurobarometer 90.4: Attitudes of Europeans towards Biodiversity, Awareness and Perceptions of EU customs, and Perceptions of Antisemitism. European Commission. 2018",
   "Year": 2018
  },
  {
   "OBJECTID": 1065,
   "Continent": "Europe",
   "Country": "Italy",
   "ProvName": "Lombardia",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Italy. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_115_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1066,
   "Continent": "Europe",
   "Country": "Norway",
   "ProvName": "Møre og Romsdal",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Norway. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_170_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1067,
   "Continent": "Europe",
   "Country": "Norway",
   "ProvName": "Sør-Trøndelag",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Norway. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_170_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1068,
   "Continent": "Europe",
   "Country": "Russia",
   "ProvName": "Leningrad",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "55-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 1069,
   "Continent": "Africa",
   "Country": "Senegal",
   "ProvName": "Fatick",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1070,
   "Continent": "Asia",
   "Country": "Philippines",
   "ProvName": "Muslim Mindanao",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1071,
   "Continent": "Asia",
   "Country": "Philippines",
   "ProvName": "Mimaropa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Philippines. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_178_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1072,
   "Continent": "Asia",
   "Country": "Philippines",
   "ProvName": "Western Visayas",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Philippines. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_178_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1073,
   "Continent": "Africa",
   "Country": "Burundi",
   "ProvName": "Ngozi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Anthony Appiah; Henry Louis Gates (2010). Encyclopedia of Africa. Oxford University Press. p. 221. ISBN 978-0-19-533770-9.",
   "Year": 2010
  },
  {
   "OBJECTID": 1074,
   "Continent": "Africa",
   "Country": "Senegal",
   "ProvName": "Louga",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1075,
   "Continent": "Africa",
   "Country": "Guinea-Bissau",
   "ProvName": "Tombali",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1076,
   "Continent": "Africa",
   "Country": "Senegal",
   "ProvName": "Thiès",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1077,
   "Continent": "Africa",
   "Country": "Guinea-Bissau",
   "ProvName": "Bissau",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1078,
   "Continent": "Africa",
   "Country": "Liberia",
   "ProvName": "Grand Kru",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1079,
   "Continent": "Asia",
   "Country": "Iran",
   "ProvName": "Tehran",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1080,
   "Continent": "Africa",
   "Country": "Guinea-Bissau",
   "ProvName": "Cacheu",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1081,
   "Continent": "Africa",
   "Country": "Guinea-Bissau",
   "ProvName": "Oio",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1082,
   "Continent": "Africa",
   "Country": "Guinea-Bissau",
   "ProvName": "Quinara",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1083,
   "Continent": "Asia",
   "Country": "Iran",
   "ProvName": "Alborz",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1084,
   "Continent": "Africa",
   "Country": "Senegal",
   "ProvName": "Ziguinchor",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1085,
   "Continent": "Oceania",
   "Country": "Solomon Islands",
   "ProvName": "Guadalcanal",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Solomon Islands. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_204_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1086,
   "Continent": "Europe",
   "Country": "Russia",
   "ProvName": "Saint Petersburg City",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 1087,
   "Continent": "Africa",
   "Country": "Guinea-Bissau",
   "ProvName": "Bafatá",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1088,
   "Continent": "North America",
   "Country": "El Salvador",
   "ProvName": "Cabañas",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 1089,
   "Continent": "Europe",
   "Country": "Belarus",
   "ProvName": "Brest",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Generations and Gender Survey, 2020 Belarus Wave 1\". ggpsurvey.ined.fr.",
   "Year": 2017
  },
  {
   "OBJECTID": 1090,
   "Continent": "Africa",
   "Country": "Guinea-Bissau",
   "ProvName": "Gabú",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1091,
   "Continent": "Africa",
   "Country": "Liberia",
   "ProvName": "Maryland",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1092,
   "Continent": "Europe",
   "Country": "Belarus",
   "ProvName": "Homel (Gomel)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Generations and Gender Survey, 2020 Belarus Wave 1\". ggpsurvey.ined.fr.",
   "Year": 2017
  },
  {
   "OBJECTID": 1093,
   "Continent": "Europe",
   "Country": "Belarus",
   "ProvName": "Mahilyou (Mogilyov)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Generations and Gender Survey, 2020 Belarus Wave 1\". ggpsurvey.ined.fr.",
   "Year": 2017
  },
  {
   "OBJECTID": 1094,
   "Continent": "Europe",
   "Country": "Belarus",
   "ProvName": "Vitebsk",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Generations and Gender Survey, 2020 Belarus Wave 1\". ggpsurvey.ined.fr.",
   "Year": 2017
  },
  {
   "OBJECTID": 1095,
   "Continent": "Europe",
   "Country": "Russia",
   "ProvName": "Bryansk",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 1096,
   "Continent": "Europe",
   "Country": "Russia",
   "ProvName": "Smolensk",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "30-35%",
   "Numerical": 35,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 1097,
   "Continent": "Africa",
   "Country": "Liberia",
   "ProvName": "Sinoe",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1098,
   "Continent": "Asia",
   "Country": "Saudi Arabia",
   "ProvName": "Al-Qaseem",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1099,
   "Continent": "Europe",
   "Country": "Belarus",
   "ProvName": "Hrodno (Grodno)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Generations and Gender Survey, 2020 Belarus Wave 1\". ggpsurvey.ined.fr.",
   "Year": 2017
  },
  {
   "OBJECTID": 1100,
   "Continent": "Europe",
   "Country": "Belarus",
   "ProvName": "Minsk (Mensk)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Generations and Gender Survey, 2020 Belarus Wave 1\". ggpsurvey.ined.fr.",
   "Year": 2017
  },
  {
   "OBJECTID": 1101,
   "Continent": "Africa",
   "Country": "Central African Republic",
   "ProvName": "Ouaka",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "10-20%",
   "Nummeric_1": 20,
   "DataSource": "\"International Religious Freedom Report for 2016\". U.S. Department of State.",
   "Year": 2016
  },
  {
   "OBJECTID": 1102,
   "Continent": "Africa",
   "Country": "Central African Republic",
   "ProvName": "Ouham",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "10-20%",
   "Nummeric_1": 20,
   "DataSource": "\"International Religious Freedom Report for 2016\". U.S. Department of State.",
   "Year": 2016
  },
  {
   "OBJECTID": 1103,
   "Continent": "Africa",
   "Country": "Sudan",
   "ProvName": "Janûb Dârfûr (South Darfur)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1104,
   "Continent": "Africa",
   "Country": "South Sudan",
   "ProvName": "al-Buhayrât (Lakes)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "The Pew Forum - Religious Composition by Country. https:\/\/assets.pewresearch.org\/wp-content\/uploads\/sites\/11\/2012\/12\/globalReligion-tables.pdf",
   "Year": 2015
  },
  {
   "OBJECTID": 1105,
   "Continent": "Africa",
   "Country": "Central African Republic",
   "ProvName": "Vakaga",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Fiedler, R. (2014). The Contribution of the Interfaith Platform to the Reconciliation Process in the Central African Republic. Institute for Questions Regarding Islam",
   "Year": 2014
  },
  {
   "OBJECTID": 1106,
   "Continent": "Europe",
   "Country": "Italy",
   "ProvName": "Emilia-Romagna",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Italy. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_115_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1107,
   "Continent": "Europe",
   "Country": "Italy",
   "ProvName": "Liguria",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Italy. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_115_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1108,
   "Continent": "Europe",
   "Country": "Italy",
   "ProvName": "Sardegna",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Italy. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_115_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1109,
   "Continent": "Europe",
   "Country": "Italy",
   "ProvName": "Toscana",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Italy. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_115_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1110,
   "Continent": "Europe",
   "Country": "Spain",
   "ProvName": "Baleares",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Spain. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_208_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1111,
   "Continent": "Africa",
   "Country": "Sudan",
   "ProvName": "al-Jazîrah (Gezira)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1112,
   "Continent": "Europe",
   "Country": "Italy",
   "ProvName": "Basilicata",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Italy. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_115_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1113,
   "Continent": "Europe",
   "Country": "Italy",
   "ProvName": "Calabria",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Italy. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_115_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1114,
   "Continent": "Europe",
   "Country": "Italy",
   "ProvName": "Campania",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Italy. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_115_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1115,
   "Continent": "Europe",
   "Country": "Slovenia",
   "ProvName": "Obalno Krasko",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Eurobarometer 90.4 (December 2018): Attitudes of Europeans towards Biodiversity, Awareness and Perceptions of EU customs, and Perceptions of Antisemitism",
   "Year": 2018
  },
  {
   "OBJECTID": 1116,
   "Continent": "Europe",
   "Country": "Italy",
   "ProvName": "Molise",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Italy. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_115_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1117,
   "Continent": "Asia",
   "Country": "Taiwan*",
   "ProvName": "New T'ai-pei municipality",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "10-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1118,
   "Continent": "Europe",
   "Country": "Italy",
   "ProvName": "Puglia",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Italy. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_115_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1119,
   "Continent": "Europe",
   "Country": "Italy",
   "ProvName": "Sicilia (Sicily)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Italy. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_115_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1120,
   "Continent": "Europe",
   "Country": "Italy",
   "ProvName": "Abruzzi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Italy. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_115_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1121,
   "Continent": "Europe",
   "Country": "Italy",
   "ProvName": "Lazio",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Italy. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_115_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1122,
   "Continent": "Europe",
   "Country": "Italy",
   "ProvName": "Marche",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Italy. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_115_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1123,
   "Continent": "Europe",
   "Country": "Italy",
   "ProvName": "Umbria",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Italy. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_115_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1124,
   "Continent": "Europe",
   "Country": "Kosovo*",
   "ProvName": "Kosovo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 95,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1125,
   "Continent": "Africa",
   "Country": "Sudan",
   "ProvName": "al-Qadârif (Gedarif)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1126,
   "Continent": "Asia",
   "Country": "Saudi Arabia",
   "ProvName": "Al-Madinah Al-Monawarah",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1127,
   "Continent": "Asia",
   "Country": "Saudi Arabia",
   "ProvName": "Ha'il",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1128,
   "Continent": "Asia",
   "Country": "Jordan",
   "ProvName": "Karak",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1129,
   "Continent": "Asia",
   "Country": "Jordan",
   "ProvName": "Zarqa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1130,
   "Continent": "Asia",
   "Country": "Saudi Arabia",
   "ProvName": "Al-Hudud ash Shamaliyah (Northern)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1131,
   "Continent": "Asia",
   "Country": "Saudi Arabia",
   "ProvName": "Al-Jouf",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1132,
   "Continent": "Africa",
   "Country": "South Sudan",
   "ProvName": "Gharb-al-Istiwâ´îyah (West Equatoria)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "The Pew Forum - Religious Composition by Country. https:\/\/assets.pewresearch.org\/wp-content\/uploads\/sites\/11\/2012\/12\/globalReligion-tables.pdf",
   "Year": 2015
  },
  {
   "OBJECTID": 1133,
   "Continent": "Asia",
   "Country": "Taiwan*",
   "ProvName": "T'ao-yuan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1134,
   "Continent": "Africa",
   "Country": "South Sudan",
   "ProvName": "Bahr-al-Jabal (Central Equatoria)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "The Pew Forum - Religious Composition by Country. https:\/\/assets.pewresearch.org\/wp-content\/uploads\/sites\/11\/2012\/12\/globalReligion-tables.pdf",
   "Year": 2015
  },
  {
   "OBJECTID": 1135,
   "Continent": "Africa",
   "Country": "Central African Republic",
   "ProvName": "Haute-Kotto",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "30-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "10-20%",
   "Nummeric_1": 20,
   "DataSource": "\"International Religious Freedom Report for 2016\". U.S. Department of State.",
   "Year": 2016
  },
  {
   "OBJECTID": 1136,
   "Continent": "Africa",
   "Country": "Central African Republic",
   "ProvName": "Haut-Mbomou",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "30-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "10-20%",
   "Nummeric_1": 20,
   "DataSource": "\"International Religious Freedom Report for 2016\". U.S. Department of State.",
   "Year": 2016
  },
  {
   "OBJECTID": 1137,
   "Continent": "Africa",
   "Country": "Central African Republic",
   "ProvName": "Mbomou",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "10-20%",
   "Nummeric_1": 20,
   "DataSource": "\"International Religious Freedom Report for 2016\". U.S. Department of State.",
   "Year": 2016
  },
  {
   "OBJECTID": 1138,
   "Continent": "Africa",
   "Country": "South Sudan",
   "ProvName": "A´âlî-an-Nîl (Upper Nile)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "The Pew Forum - Religious Composition by Country. https:\/\/assets.pewresearch.org\/wp-content\/uploads\/sites\/11\/2012\/12\/globalReligion-tables.pdf",
   "Year": 2015
  },
  {
   "OBJECTID": 1139,
   "Continent": "Africa",
   "Country": "South Sudan",
   "ProvName": "Junqalî (Jungoli)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "30-35%",
   "Numerical": 35,
   "Ethnic2": null,
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "The Pew Forum - Religious Composition by Country. https:\/\/assets.pewresearch.org\/wp-content\/uploads\/sites\/11\/2012\/12\/globalReligion-tables.pdf",
   "Year": 2015
  },
  {
   "OBJECTID": 1140,
   "Continent": "Africa",
   "Country": "South Sudan",
   "ProvName": "al-Wahdah (Unity)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "30-35%",
   "Numerical": 35,
   "Ethnic2": null,
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "The Pew Forum - Religious Composition by Country. https:\/\/assets.pewresearch.org\/wp-content\/uploads\/sites\/11\/2012\/12\/globalReligion-tables.pdf",
   "Year": 2015
  },
  {
   "OBJECTID": 1141,
   "Continent": "Africa",
   "Country": "South Sudan",
   "ProvName": "Warab (Warap)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "30-35%",
   "Numerical": 35,
   "Ethnic2": null,
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "The Pew Forum - Religious Composition by Country. https:\/\/assets.pewresearch.org\/wp-content\/uploads\/sites\/11\/2012\/12\/globalReligion-tables.pdf",
   "Year": 2015
  },
  {
   "OBJECTID": 1142,
   "Continent": "Asia",
   "Country": "Taiwan*",
   "ProvName": "Chang-hua",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1143,
   "Continent": "Africa",
   "Country": "South Sudan",
   "ProvName": "Gharb Bahr-al-Ghazâl (West Bahr-al-Ghazal)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "30-35%",
   "Numerical": 35,
   "Ethnic2": null,
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "The Pew Forum - Religious Composition by Country. https:\/\/assets.pewresearch.org\/wp-content\/uploads\/sites\/11\/2012\/12\/globalReligion-tables.pdf",
   "Year": 2015
  },
  {
   "OBJECTID": 1144,
   "Continent": "Africa",
   "Country": "Sudan",
   "ProvName": "Nahr-an-Nil (River Nile)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1145,
   "Continent": "Europe",
   "Country": "Latvia",
   "ProvName": "Rïga region (Pieriga)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Latvia. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_128_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1146,
   "Continent": "Asia",
   "Country": "Indonesia",
   "ProvName": "Kalimantan Barat",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "55-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "20-25%",
   "Nummeric_1": 25,
   "DataSource": "Population by Region and Religion in Indonesia. BPS. 2010. https:\/\/sp2010.bps.go.id\/index.php\/site\/tabel?tid=321&wid=0",
   "Year": 2010
  },
  {
   "OBJECTID": 1147,
   "Continent": "Africa",
   "Country": "Sudan",
   "ProvName": "ash-Shamâlîyah (Northern)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1148,
   "Continent": "Asia",
   "Country": "Indonesia",
   "ProvName": "Lampung",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1149,
   "Continent": "Africa",
   "Country": "Sudan",
   "ProvName": "al-Khartûm (Khartoum)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1150,
   "Continent": "Africa",
   "Country": "Sudan",
   "ProvName": "Sinnâr (Sennar)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1151,
   "Continent": "Africa",
   "Country": "Sudan",
   "ProvName": "Shamâl Dârfûr (North Darfur)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1152,
   "Continent": "Africa",
   "Country": "Algeria",
   "ProvName": "Tipaza",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1153,
   "Continent": "Africa",
   "Country": "Kenya",
   "ProvName": "Western",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "35-40%",
   "Nummeric_1": 40,
   "DataSource": "Kenya. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_121_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1154,
   "Continent": "Africa",
   "Country": "South Sudan",
   "ProvName": "Sharq-al-Istiwâ'îyah (East Equatoria)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "30-35%",
   "Numerical": 35,
   "Ethnic2": null,
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "The Pew Forum - Religious Composition by Country. https:\/\/assets.pewresearch.org\/wp-content\/uploads\/sites\/11\/2012\/12\/globalReligion-tables.pdf",
   "Year": 2015
  },
  {
   "OBJECTID": 1155,
   "Continent": "Africa",
   "Country": "Burundi",
   "ProvName": "Kirundo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Anthony Appiah; Henry Louis Gates (2010). Encyclopedia of Africa. Oxford University Press. p. 221. ISBN 978-0-19-533770-9.",
   "Year": 2010
  },
  {
   "OBJECTID": 1156,
   "Continent": "Africa",
   "Country": "Kenya",
   "ProvName": "North Eastern",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1157,
   "Continent": "Africa",
   "Country": "Botswana",
   "ProvName": "Kgatleng",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Pew Research Center's Religion & Public Life Project: Botswana. Pew Research Center. 2010.",
   "Year": 2010
  },
  {
   "OBJECTID": 1158,
   "Continent": "Europe",
   "Country": "Netherlands",
   "ProvName": "Friesland",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "20-25%",
   "Numerical": 25,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Netherlands. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_160_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1159,
   "Continent": "Europe",
   "Country": "Luxembourg",
   "ProvName": "Diekirch",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Eurobarometer 90.4: Attitudes of Europeans towards Biodiversity, Awareness and Perceptions of EU customs, and Perceptions of Antisemitism. European Commission. 2018",
   "Year": 2018
  },
  {
   "OBJECTID": 1160,
   "Continent": "Europe",
   "Country": "Luxembourg",
   "ProvName": "Grevenmacher",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Eurobarometer 90.4: Attitudes of Europeans towards Biodiversity, Awareness and Perceptions of EU customs, and Perceptions of Antisemitism. European Commission. 2018",
   "Year": 2018
  },
  {
   "OBJECTID": 1161,
   "Continent": "Asia",
   "Country": "Nepal",
   "ProvName": "Pashchimanchal (Western)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Hinduism",
   "HighRelig": "Hindus",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1162,
   "Continent": "Asia",
   "Country": "Indonesia",
   "ProvName": "Sumatera Selatan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1163,
   "Continent": "Europe",
   "Country": "Bulgaria",
   "ProvName": "Pernik",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Special Eurobarometer 493, European Union: European Commission, September 2019, pages 229-230",
   "Year": 2019
  },
  {
   "OBJECTID": 1164,
   "Continent": "Asia",
   "Country": "Indonesia",
   "ProvName": "Bangka-Belitung",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1165,
   "Continent": "Africa",
   "Country": "Botswana",
   "ProvName": "Kweneng",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Pew Research Center's Religion & Public Life Project: Botswana. Pew Research Center. 2010.",
   "Year": 2010
  },
  {
   "OBJECTID": 1166,
   "Continent": "South America",
   "Country": "Argentina",
   "ProvName": "Santiago del Estero",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"PEW Research Center: Religion in Latin America 2014\".",
   "Year": 2014
  },
  {
   "OBJECTID": 1167,
   "Continent": "Africa",
   "Country": "Botswana",
   "ProvName": "South East",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Pew Research Center's Religion & Public Life Project: Botswana. Pew Research Center. 2010.",
   "Year": 2010
  },
  {
   "OBJECTID": 1168,
   "Continent": "Europe",
   "Country": "Norway",
   "ProvName": "Aust-Agder",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Norway. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_170_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1169,
   "Continent": "Europe",
   "Country": "Norway",
   "ProvName": "Hordaland",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Norway. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_170_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1170,
   "Continent": "Europe",
   "Country": "Norway",
   "ProvName": "Rogaland",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Norway. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_170_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1171,
   "Continent": "Europe",
   "Country": "Norway",
   "ProvName": "Sogn og Fjordane",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Norway. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_170_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1172,
   "Continent": "Europe",
   "Country": "Bulgaria",
   "ProvName": "Gabrovo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Special Eurobarometer 493, European Union: European Commission, September 2019, pages 229-230",
   "Year": 2019
  },
  {
   "OBJECTID": 1173,
   "Continent": "Europe",
   "Country": "Norway",
   "ProvName": "Vest-Agder",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Norway. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_170_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1174,
   "Continent": "Asia",
   "Country": "Taiwan*",
   "ProvName": "Chia-i",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1175,
   "Continent": "Asia",
   "Country": "Taiwan*",
   "ProvName": "Chia-i city",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1176,
   "Continent": "Europe",
   "Country": "Norway",
   "ProvName": "Akershus",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "70-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Norway. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_170_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1177,
   "Continent": "Europe",
   "Country": "Norway",
   "ProvName": "Buskerud",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Norway. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_170_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1178,
   "Continent": "Europe",
   "Country": "Norway",
   "ProvName": "Hedmark",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Norway. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_170_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1179,
   "Continent": "Europe",
   "Country": "Lithuania",
   "ProvName": "Alytus",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Lithuania. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_134_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1180,
   "Continent": "Europe",
   "Country": "Norway",
   "ProvName": "Oppland",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Norway. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_170_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1181,
   "Continent": "Europe",
   "Country": "Norway",
   "ProvName": "Oslo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Norway. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_170_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1182,
   "Continent": "Asia",
   "Country": "Taiwan*",
   "ProvName": "Hua-lien",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1183,
   "Continent": "Europe",
   "Country": "Norway",
   "ProvName": "Telemark",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Norway. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_170_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1184,
   "Continent": "Europe",
   "Country": "Norway",
   "ProvName": "Vestfold",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Norway. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_170_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1185,
   "Continent": "Europe",
   "Country": "Norway",
   "ProvName": "Ostfold",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Norway. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_170_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1186,
   "Continent": "Europe",
   "Country": "Norway",
   "ProvName": "Nord-Trondelag",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Norway. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_170_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1187,
   "Continent": "Asia",
   "Country": "Indonesia",
   "ProvName": "Banten",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1188,
   "Continent": "Europe",
   "Country": "Latvia",
   "ProvName": "Kurzeme",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Latvia. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_128_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1189,
   "Continent": "Europe",
   "Country": "Lithuania",
   "ProvName": "Marijampole",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Lithuania. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_134_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1190,
   "Continent": "Europe",
   "Country": "Lithuania",
   "ProvName": "Klaipeda",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Lithuania. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_134_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1191,
   "Continent": "Asia",
   "Country": "Saudi Arabia",
   "ProvName": "Najran",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1192,
   "Continent": "Africa",
   "Country": "Botswana",
   "ProvName": "Southern",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Pew Research Center's Religion & Public Life Project: Botswana. Pew Research Center. 2010.",
   "Year": 2010
  },
  {
   "OBJECTID": 1193,
   "Continent": "Europe",
   "Country": "Lithuania",
   "ProvName": "Telsiai",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Lithuania. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_134_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1194,
   "Continent": "Europe",
   "Country": "Slovenia",
   "ProvName": "Spodnjeposavska",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Eurobarometer 90.4 (December 2018): Attitudes of Europeans towards Biodiversity, Awareness and Perceptions of EU customs, and Perceptions of Antisemitism",
   "Year": 2018
  },
  {
   "OBJECTID": 1195,
   "Continent": "Europe",
   "Country": "Slovenia",
   "ProvName": "Zasavska",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Eurobarometer 90.4 (December 2018): Attitudes of Europeans towards Biodiversity, Awareness and Perceptions of EU customs, and Perceptions of Antisemitism",
   "Year": 2018
  },
  {
   "OBJECTID": 1196,
   "Continent": "Europe",
   "Country": "Italy",
   "ProvName": "Friuli-Venezia Giulia",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Italy. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_115_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1197,
   "Continent": "Europe",
   "Country": "Italy",
   "ProvName": "Trentino-Alto Adige",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Italy. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_115_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1198,
   "Continent": "Europe",
   "Country": "Italy",
   "ProvName": "Veneto",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Italy. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_115_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1199,
   "Continent": "Asia",
   "Country": "Taiwan*",
   "ProvName": "T'ai-chung municipality",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "10-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1200,
   "Continent": "Europe",
   "Country": "Slovakia",
   "ProvName": "Bratislava",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Slovakia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_202_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1201,
   "Continent": "Asia",
   "Country": "Taiwan*",
   "ProvName": "Yun-lin",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1202,
   "Continent": "Oceania",
   "Country": "Papua New Guinea",
   "ProvName": "Simba (Chimbu)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Papua New Guinea. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_175_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1203,
   "Continent": "Europe",
   "Country": "Slovakia",
   "ProvName": "Bansk Bystrica",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Slovakia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_202_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1204,
   "Continent": "Oceania",
   "Country": "Australia",
   "ProvName": "Northern Territory",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "30-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "2016 Census of Population and General Community (Sheet G14) Australian Bureau of Statistics",
   "Year": 2016
  },
  {
   "OBJECTID": 1205,
   "Continent": "Europe",
   "Country": "Latvia",
   "ProvName": "Latgale",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Latvia. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_128_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1206,
   "Continent": "Asia",
   "Country": "Taiwan*",
   "ProvName": "T'ai-tung",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1207,
   "Continent": "Europe",
   "Country": "Lithuania",
   "ProvName": "Kaunas",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Lithuania. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_134_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1208,
   "Continent": "Europe",
   "Country": "Lithuania",
   "ProvName": "Panevezys",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Lithuania. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_134_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1209,
   "Continent": "Asia",
   "Country": "Brunei",
   "ProvName": "Belait",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Brunei. The World Factbook. Central Intelligence Agency. May 2011",
   "Year": 2008
  },
  {
   "OBJECTID": 1210,
   "Continent": "Asia",
   "Country": "Brunei",
   "ProvName": "Brunei and Muara",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Brunei. The World Factbook. Central Intelligence Agency. May 2011",
   "Year": 2008
  },
  {
   "OBJECTID": 1211,
   "Continent": "Europe",
   "Country": "Lithuania",
   "ProvName": "Siauliai",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Lithuania. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_134_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1212,
   "Continent": "Asia",
   "Country": "Indonesia",
   "ProvName": "Jakarta Raya",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1213,
   "Continent": "Asia",
   "Country": "Brunei",
   "ProvName": "Temburong",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Brunei. The World Factbook. Central Intelligence Agency. May 2011",
   "Year": 2008
  },
  {
   "OBJECTID": 1214,
   "Continent": "Asia",
   "Country": "Brunei",
   "ProvName": "Tutong",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Brunei. The World Factbook. Central Intelligence Agency. May 2011",
   "Year": 2008
  },
  {
   "OBJECTID": 1215,
   "Continent": "Europe",
   "Country": "Lithuania",
   "ProvName": "Taurage",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Lithuania. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_134_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1216,
   "Continent": "Asia",
   "Country": "Kyrgyzstan",
   "ProvName": "Talas",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1217,
   "Continent": "Europe",
   "Country": "Lithuania",
   "ProvName": "Utena",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Lithuania. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_134_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1218,
   "Continent": "Europe",
   "Country": "Lithuania",
   "ProvName": "Vilnius",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Lithuania. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_134_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1219,
   "Continent": "Africa",
   "Country": "Lesotho",
   "ProvName": "Qacha's Nek",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "40-45%",
   "Nummeric_1": 45,
   "DataSource": "Lesotho.  The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_130_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1220,
   "Continent": "Asia",
   "Country": "Indonesia",
   "ProvName": "Kalimantan Timur",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1221,
   "Continent": "Europe",
   "Country": "Latvia",
   "ProvName": "Vidzeme",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Latvia. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_128_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1222,
   "Continent": "Asia",
   "Country": "Malaysia",
   "ProvName": "Sarawak",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1223,
   "Continent": "Africa",
   "Country": "South Africa",
   "ProvName": "Northern Cape",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "South Africa - Community Survey 2016. https:\/\/www.datafirst.uct.ac.za\/dataportal\/index.php\/catalog\/611",
   "Year": 2016
  },
  {
   "OBJECTID": 1224,
   "Continent": "Africa",
   "Country": "South Africa",
   "ProvName": "Western Cape",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "South Africa - Community Survey 2016. https:\/\/www.datafirst.uct.ac.za\/dataportal\/index.php\/catalog\/611",
   "Year": 2016
  },
  {
   "OBJECTID": 1225,
   "Continent": "Europe",
   "Country": "Latvia",
   "ProvName": "Zemgale",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Latvia. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_128_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1226,
   "Continent": "Africa",
   "Country": "Kenya",
   "ProvName": "Coast",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "Kenya. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_121_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1227,
   "Continent": "Asia",
   "Country": "Saudi Arabia",
   "ProvName": "Al-Riyadh",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1228,
   "Continent": "Asia",
   "Country": "Saudi Arabia",
   "ProvName": "ash-Sharqiyah (Eastern)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1229,
   "Continent": "Europe",
   "Country": "Romania",
   "ProvName": "Ilfov",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "0.87",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 1230,
   "Continent": "Asia",
   "Country": "Pakistan",
   "ProvName": "Balochistan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1231,
   "Continent": "Asia",
   "Country": "Pakistan",
   "ProvName": "Azad Kashmir",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1232,
   "Continent": "Asia",
   "Country": "Pakistan",
   "ProvName": "Islamabad",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1233,
   "Continent": "Asia",
   "Country": "Pakistan",
   "ProvName": "Northern Areas",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1234,
   "Continent": "Asia",
   "Country": "Pakistan",
   "ProvName": "Federally Administered Tribal Areas",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1235,
   "Continent": "Asia",
   "Country": "Pakistan",
   "ProvName": "Punjab",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1236,
   "Continent": "Asia",
   "Country": "Pakistan",
   "ProvName": "Sindh",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1237,
   "Continent": "Asia",
   "Country": "Kyrgyzstan",
   "ProvName": "Bishkek (Frunze)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1238,
   "Continent": "Asia",
   "Country": "Kyrgyzstan",
   "ProvName": "Chüy (Chu)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1239,
   "Continent": "Asia",
   "Country": "Kyrgyzstan",
   "ProvName": "Ysyk-Köl",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1240,
   "Continent": "Asia",
   "Country": "Kyrgyzstan",
   "ProvName": "Naryn",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1241,
   "Continent": "Asia",
   "Country": "Kyrgyzstan",
   "ProvName": "Batken",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1242,
   "Continent": "Asia",
   "Country": "Kyrgyzstan",
   "ProvName": "Jalal-Abad",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1243,
   "Continent": "Asia",
   "Country": "Kyrgyzstan",
   "ProvName": "Osh",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1244,
   "Continent": "Asia",
   "Country": "Pakistan",
   "ProvName": "Khyber Pakhtunkhwa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1245,
   "Continent": "Asia",
   "Country": "Nepal",
   "ProvName": "Sudur Pashchimanchal (Far-Western)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Hinduism",
   "HighRelig": "Hindus",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1246,
   "Continent": "Oceania",
   "Country": "Papua New Guinea",
   "ProvName": "Eastern Highlands",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Papua New Guinea. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_175_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1247,
   "Continent": "Asia",
   "Country": "Nepal",
   "ProvName": "Madhyamanchal (Central)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Hinduism",
   "HighRelig": "Hindus",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1248,
   "Continent": "Asia",
   "Country": "Nepal",
   "ProvName": "Purwanchal (Eastern)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Hinduism",
   "HighRelig": "Hindus",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1249,
   "Continent": "Asia",
   "Country": "Indonesia",
   "ProvName": "Aceh",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1250,
   "Continent": "Asia",
   "Country": "Malaysia",
   "ProvName": "Perak",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1251,
   "Continent": "Oceania",
   "Country": "Papua New Guinea",
   "ProvName": "Western Highlands",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Papua New Guinea. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_175_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1252,
   "Continent": "Africa",
   "Country": "Lesotho",
   "ProvName": "Thaba-Tseka",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "40-45%",
   "Nummeric_1": 45,
   "DataSource": "Lesotho.  The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_130_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1253,
   "Continent": "Africa",
   "Country": "South Africa",
   "ProvName": "KwaZulu-Natal",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "South Africa - Community Survey 2016. https:\/\/www.datafirst.uct.ac.za\/dataportal\/index.php\/catalog\/611",
   "Year": 2016
  },
  {
   "OBJECTID": 1254,
   "Continent": "Africa",
   "Country": "Madagascar",
   "ProvName": "Antananarivo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "25-30%",
   "Numerical": 30,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "20-25%",
   "Nummeric_1": 25,
   "DataSource": "Madagascar. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_137_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1255,
   "Continent": "Africa",
   "Country": "Madagascar",
   "ProvName": "Antsiranana",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1256,
   "Continent": "Asia",
   "Country": "Malaysia",
   "ProvName": "Kedah",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1257,
   "Continent": "Asia",
   "Country": "Japan",
   "ProvName": "Hiroshima",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1258,
   "Continent": "Asia",
   "Country": "Malaysia",
   "ProvName": "Pulau Pinang",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1259,
   "Continent": "Europe",
   "Country": "Hungary",
   "ProvName": "Komárom-Esztergom",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Hungary. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_106_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1260,
   "Continent": "Asia",
   "Country": "Malaysia",
   "ProvName": "Johor",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1261,
   "Continent": "Asia",
   "Country": "Taiwan*",
   "ProvName": "Kao-hsiung municipality",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "10-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1262,
   "Continent": "Asia",
   "Country": "Indonesia",
   "ProvName": "Jawa Barat",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1263,
   "Continent": "Africa",
   "Country": "Malawi",
   "ProvName": "Karonga",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "Malawi. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_138_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1264,
   "Continent": "Asia",
   "Country": "Indonesia",
   "ProvName": "Jawa Tengah",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1265,
   "Continent": "Asia",
   "Country": "Cambodia",
   "ProvName": "Kampot",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1266,
   "Continent": "Asia",
   "Country": "Indonesia",
   "ProvName": "Bengkulu",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1267,
   "Continent": "Asia",
   "Country": "Taiwan*",
   "ProvName": "I-lan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1268,
   "Continent": "Asia",
   "Country": "Taiwan*",
   "ProvName": "Chi-lung city",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1269,
   "Continent": "South America",
   "Country": "Argentina",
   "ProvName": "Rió Negro",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"PEW Research Center: Religion in Latin America 2014\".",
   "Year": 2014
  },
  {
   "OBJECTID": 1270,
   "Continent": "South America",
   "Country": "Argentina",
   "ProvName": "San Luis",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"PEW Research Center: Religion in Latin America 2014\".",
   "Year": 2014
  },
  {
   "OBJECTID": 1271,
   "Continent": "Africa",
   "Country": "Lesotho",
   "ProvName": "Berea",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "40-45%",
   "Nummeric_1": 45,
   "DataSource": "Lesotho.  The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_130_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1272,
   "Continent": "South America",
   "Country": "Argentina",
   "ProvName": "Córdoba",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"PEW Research Center: Religion in Latin America 2014\".",
   "Year": 2014
  },
  {
   "OBJECTID": 1273,
   "Continent": "South America",
   "Country": "Argentina",
   "ProvName": "Catamarca",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"PEW Research Center: Religion in Latin America 2014\".",
   "Year": 2014
  },
  {
   "OBJECTID": 1274,
   "Continent": "Asia",
   "Country": "Taiwan*",
   "ProvName": "Nan-t'ou",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1275,
   "Continent": "Asia",
   "Country": "Cambodia",
   "ProvName": "Kaeb",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1276,
   "Continent": "Africa",
   "Country": "Mozambique",
   "ProvName": "Tete",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-25%",
   "Nummeric_1": 25,
   "DataSource": "Mozambique. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_156_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1277,
   "Continent": "Africa",
   "Country": "Botswana",
   "ProvName": "Ghanzi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Pew Research Center's Religion & Public Life Project: Botswana. Pew Research Center. 2010.",
   "Year": 2010
  },
  {
   "OBJECTID": 1278,
   "Continent": "Africa",
   "Country": "Mozambique",
   "ProvName": "Manica",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1279,
   "Continent": "Africa",
   "Country": "Kenya",
   "ProvName": "Central",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "35-40%",
   "Nummeric_1": 40,
   "DataSource": "Kenya. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_121_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1280,
   "Continent": "Africa",
   "Country": "Kenya",
   "ProvName": "Nairobi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "35-40%",
   "Nummeric_1": 40,
   "DataSource": "Kenya. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_121_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1281,
   "Continent": "Africa",
   "Country": "Kenya",
   "ProvName": "Nyanza",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "35-40%",
   "Nummeric_1": 40,
   "DataSource": "Kenya. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_121_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1282,
   "Continent": "Africa",
   "Country": "Mozambique",
   "ProvName": "Cabo Delgado",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1283,
   "Continent": "Africa",
   "Country": "Mozambique",
   "ProvName": "Niassa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-25%",
   "Nummeric_1": 25,
   "DataSource": "Mozambique. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_156_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1284,
   "Continent": "Africa",
   "Country": "Mozambique",
   "ProvName": "Nampula",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-25%",
   "Nummeric_1": 25,
   "DataSource": "Mozambique. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_156_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1285,
   "Continent": "Africa",
   "Country": "South Africa",
   "ProvName": "North West",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "South Africa - Community Survey 2016. https:\/\/www.datafirst.uct.ac.za\/dataportal\/index.php\/catalog\/611",
   "Year": 2016
  },
  {
   "OBJECTID": 1286,
   "Continent": "Africa",
   "Country": "Lesotho",
   "ProvName": "Quthing",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "40-45%",
   "Nummeric_1": 45,
   "DataSource": "Lesotho.  The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_130_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1287,
   "Continent": "Africa",
   "Country": "Lesotho",
   "ProvName": "Maseru",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "40-45%",
   "Nummeric_1": 45,
   "DataSource": "Lesotho.  The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_130_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1288,
   "Continent": "Africa",
   "Country": "Lesotho",
   "ProvName": "Mohale's Hoek",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "35-40%",
   "Nummeric_1": 40,
   "DataSource": "Lesotho.  The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_130_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1289,
   "Continent": "Africa",
   "Country": "South Africa",
   "ProvName": "Free State",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "South Africa - Community Survey 2016. https:\/\/www.datafirst.uct.ac.za\/dataportal\/index.php\/catalog\/611",
   "Year": 2016
  },
  {
   "OBJECTID": 1290,
   "Continent": "Africa",
   "Country": "Mozambique",
   "ProvName": "Gaza",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "Mozambique. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_156_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1291,
   "Continent": "Africa",
   "Country": "South Africa",
   "ProvName": "Gauteng",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "South Africa - Community Survey 2016. https:\/\/www.datafirst.uct.ac.za\/dataportal\/index.php\/catalog\/611",
   "Year": 2016
  },
  {
   "OBJECTID": 1292,
   "Continent": "Africa",
   "Country": "South Africa",
   "ProvName": "Mpumalanga",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "South Africa - Community Survey 2016. https:\/\/www.datafirst.uct.ac.za\/dataportal\/index.php\/catalog\/611",
   "Year": 2016
  },
  {
   "OBJECTID": 1293,
   "Continent": "Africa",
   "Country": "South Africa",
   "ProvName": "Limpopo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "South Africa - Community Survey 2016. https:\/\/www.datafirst.uct.ac.za\/dataportal\/index.php\/catalog\/611",
   "Year": 2016
  },
  {
   "OBJECTID": 1294,
   "Continent": "Africa",
   "Country": "Lesotho",
   "ProvName": "Butha-Buthe",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "40-45%",
   "Nummeric_1": 45,
   "DataSource": "Lesotho.  The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_130_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1295,
   "Continent": "Africa",
   "Country": "Lesotho",
   "ProvName": "Leribe",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "40-45%",
   "Nummeric_1": 45,
   "DataSource": "Lesotho.  The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_130_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1296,
   "Continent": "Africa",
   "Country": "Lesotho",
   "ProvName": "Mokhotlong",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "40-45%",
   "Nummeric_1": 45,
   "DataSource": "Lesotho.  The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_130_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1297,
   "Continent": "North America",
   "Country": "Bahamas",
   "ProvName": "Eleuthera",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Religions in Bahamas - PEW-GRF\". http:\/\/www.globalreligiousfutures.org\/countries\/bahamas#\/?affiliations_religion_id=11&affiliations_year=2010&restrictions_year=2015",
   "Year": 2010
  },
  {
   "OBJECTID": 1298,
   "Continent": "Asia",
   "Country": "Indonesia",
   "ProvName": "Kalimantan Selatan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1299,
   "Continent": "Asia",
   "Country": "Indonesia",
   "ProvName": "Nusa Tenggara Timur",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "35-40%",
   "Nummeric_1": 40,
   "DataSource": "Nusa Tenggara Timur Province in Figures 2018. https:\/\/ntt.bps.go.id\/publication\/2018\/08\/16\/d94e38a4fda352a452976ffb\/provinsi-nusa-tenggara-timur-dalam-angka-2018.html",
   "Year": 2018
  },
  {
   "OBJECTID": 1300,
   "Continent": "Asia",
   "Country": "Indonesia",
   "ProvName": "Sulawesi Selatan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1301,
   "Continent": "North America",
   "Country": "Bahamas",
   "ProvName": "Cat Island",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Religions in Bahamas - PEW-GRF\". http:\/\/www.globalreligiousfutures.org\/countries\/bahamas#\/?affiliations_religion_id=11&affiliations_year=2010&restrictions_year=2015",
   "Year": 2010
  },
  {
   "OBJECTID": 1302,
   "Continent": "Asia",
   "Country": "Indonesia",
   "ProvName": "Sulawesi Barat",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1303,
   "Continent": "Oceania",
   "Country": "Papua New Guinea",
   "ProvName": "Enga",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Papua New Guinea. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_175_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1304,
   "Continent": "South America",
   "Country": "Colombia",
   "ProvName": "Bogotá",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Religion in Latin America\". Pew Forum. https:\/\/www.pewforum.org\/2014\/11\/13\/religion-in-latin-america\/",
   "Year": 2014
  },
  {
   "OBJECTID": 1305,
   "Continent": "Oceania",
   "Country": "Papua New Guinea",
   "ProvName": "East Sepik",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Papua New Guinea. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_175_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1306,
   "Continent": "Oceania",
   "Country": "Papua New Guinea",
   "ProvName": "Sandaun (West Sepik)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Papua New Guinea. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_175_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1307,
   "Continent": "South America",
   "Country": "Colombia",
   "ProvName": "Quindío",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Religion in Latin America\". Pew Forum. https:\/\/www.pewforum.org\/2014\/11\/13\/religion-in-latin-america\/",
   "Year": 2014
  },
  {
   "OBJECTID": 1308,
   "Continent": "Oceania",
   "Country": "Papua New Guinea",
   "ProvName": "Madang",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Papua New Guinea. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_175_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1309,
   "Continent": "North America",
   "Country": "El Salvador",
   "ProvName": "Cuscatlán",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 1310,
   "Continent": "Oceania",
   "Country": "Papua New Guinea",
   "ProvName": "Gulf",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Papua New Guinea. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_175_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1311,
   "Continent": "Oceania",
   "Country": "Solomon Islands",
   "ProvName": "Central Islands",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Solomon Islands. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_204_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1312,
   "Continent": "Oceania",
   "Country": "Papua New Guinea",
   "ProvName": "Bougainville",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Papua New Guinea. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_175_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1313,
   "Continent": "Oceania",
   "Country": "Papua New Guinea",
   "ProvName": "Southern Highlands",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Papua New Guinea. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_175_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1314,
   "Continent": "Africa",
   "Country": "Burkina Faso",
   "ProvName": "Namentenga",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "10-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1315,
   "Continent": "South America",
   "Country": "Argentina",
   "ProvName": "Jujuy",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"PEW Research Center: Religion in Latin America 2014\".",
   "Year": 2014
  },
  {
   "OBJECTID": 1316,
   "Continent": "Oceania",
   "Country": "Papua New Guinea",
   "ProvName": "Western",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Papua New Guinea. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_175_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1317,
   "Continent": "Oceania",
   "Country": "Papua New Guinea",
   "ProvName": "Central",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Papua New Guinea. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_175_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1318,
   "Continent": "Oceania",
   "Country": "Papua New Guinea",
   "ProvName": "East New Britain",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Papua New Guinea. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_175_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1319,
   "Continent": "Africa",
   "Country": "Haiti",
   "ProvName": "Nord-Ouest",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "The Future of World Religions: Population Growth Projections, 2010-2050. Pew Research Center (2010)",
   "Year": 2010
  },
  {
   "OBJECTID": 1320,
   "Continent": "Oceania",
   "Country": "Papua New Guinea",
   "ProvName": "Manus",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Papua New Guinea. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_175_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1321,
   "Continent": "Oceania",
   "Country": "Papua New Guinea",
   "ProvName": "Milne Bay",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Papua New Guinea. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_175_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1322,
   "Continent": "Oceania",
   "Country": "Papua New Guinea",
   "ProvName": "Oro (Northern)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Papua New Guinea. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_175_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1323,
   "Continent": "Oceania",
   "Country": "Papua New Guinea",
   "ProvName": "West New Britain",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Papua New Guinea. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_175_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1324,
   "Continent": "Oceania",
   "Country": "Papua New Guinea",
   "ProvName": "Morobe",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Papua New Guinea. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_175_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1325,
   "Continent": "Oceania",
   "Country": "Papua New Guinea",
   "ProvName": "National Capital District",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Papua New Guinea. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_175_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1326,
   "Continent": "Oceania",
   "Country": "Papua New Guinea",
   "ProvName": "New Ireland",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Papua New Guinea. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_175_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1327,
   "Continent": "Oceania",
   "Country": "New Caledonia",
   "ProvName": "Loyaute",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "15-20%",
   "Nummeric_1": 20,
   "DataSource": "New Caledonia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_162_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1328,
   "Continent": "Oceania",
   "Country": "Solomon Islands",
   "ProvName": "Malaita",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Solomon Islands. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_204_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1329,
   "Continent": "Oceania",
   "Country": "New Caledonia",
   "ProvName": "Sud",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "15-20%",
   "Nummeric_1": 20,
   "DataSource": "New Caledonia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_162_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1330,
   "Continent": "Oceania",
   "Country": "Solomon Islands",
   "ProvName": "Isabel",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Solomon Islands. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_204_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1331,
   "Continent": "Europe",
   "Country": "France",
   "ProvName": "Rhône-Alpes",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "France. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_83_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1332,
   "Continent": "South America",
   "Country": "Ecuador",
   "ProvName": "Chimborazo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 1333,
   "Continent": "South America",
   "Country": "Ecuador",
   "ProvName": "Azuay",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 1334,
   "Continent": "South America",
   "Country": "Ecuador",
   "ProvName": "Cañar",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 1335,
   "Continent": "Africa",
   "Country": "Egypt",
   "ProvName": "Al-Uqsur (Luxor)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1336,
   "Continent": "Africa",
   "Country": "Burkina Faso",
   "ProvName": "Koulpélogo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1337,
   "Continent": "Europe",
   "Country": "Spain",
   "ProvName": "Canarias (Canary Islands)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Spain. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_208_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1338,
   "Continent": "South America",
   "Country": "Ecuador",
   "ProvName": "Cotopaxi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 1339,
   "Continent": "South America",
   "Country": "Ecuador",
   "ProvName": "Los Ríos",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 1340,
   "Continent": "South America",
   "Country": "Ecuador",
   "ProvName": "Manabí",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 1341,
   "Continent": "South America",
   "Country": "Colombia",
   "ProvName": "Amazonas",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Religion in Latin America\". Pew Forum. https:\/\/www.pewforum.org\/2014\/11\/13\/religion-in-latin-america\/",
   "Year": 2014
  },
  {
   "OBJECTID": 1342,
   "Continent": "South America",
   "Country": "Ecuador",
   "ProvName": "Morona-Santiago",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 1343,
   "Continent": "South America",
   "Country": "Ecuador",
   "ProvName": "Orellana",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 1344,
   "Continent": "South America",
   "Country": "Argentina",
   "ProvName": "La Pampa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"PEW Research Center: Religion in Latin America 2014\".",
   "Year": 2014
  },
  {
   "OBJECTID": 1345,
   "Continent": "Africa",
   "Country": "Gambia",
   "ProvName": "Banjul",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1346,
   "Continent": "South America",
   "Country": "Ecuador",
   "ProvName": "Pastaza",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 1347,
   "Continent": "South America",
   "Country": "Ecuador",
   "ProvName": "Napo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 1348,
   "Continent": "South America",
   "Country": "Ecuador",
   "ProvName": "Tungurahua",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 1349,
   "Continent": "North America",
   "Country": "Martinique",
   "ProvName": "Martinique",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Martinique. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_145_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1350,
   "Continent": "South America",
   "Country": "Bolivia",
   "ProvName": "Cochabamba",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Religion affiliation in Bolivia as of 2018. Based on Latinobarómetro. Survey period: June 15 to August 2, 2018",
   "Year": 2018
  },
  {
   "OBJECTID": 1351,
   "Continent": "South America",
   "Country": "Bolivia",
   "ProvName": "Chuquisaca",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Religion affiliation in Bolivia as of 2018. Based on Latinobarómetro. Survey period: June 15 to August 2, 2018",
   "Year": 2018
  },
  {
   "OBJECTID": 1352,
   "Continent": "South America",
   "Country": "Bolivia",
   "ProvName": "Beni",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Religion affiliation in Bolivia as of 2018. Based on Latinobarómetro. Survey period: June 15 to August 2, 2018",
   "Year": 2018
  },
  {
   "OBJECTID": 1353,
   "Continent": "South America",
   "Country": "Brazil",
   "ProvName": "Goi獺s",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "IBGE – Instituto Brasileiro de Geografia e Estatística (Brazilian Institute for Geography and Statistics). 2010 Census.",
   "Year": 2010
  },
  {
   "OBJECTID": 1354,
   "Continent": "South America",
   "Country": "Argentina",
   "ProvName": "Tucumán",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"PEW Research Center: Religion in Latin America 2014\".",
   "Year": 2014
  },
  {
   "OBJECTID": 1355,
   "Continent": "South America",
   "Country": "Colombia",
   "ProvName": "Córdoba",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Religion in Latin America\". Pew Forum. https:\/\/www.pewforum.org\/2014\/11\/13\/religion-in-latin-america\/",
   "Year": 2014
  },
  {
   "OBJECTID": 1356,
   "Continent": "South America",
   "Country": "Argentina",
   "ProvName": "Chaco",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"PEW Research Center: Religion in Latin America 2014\".",
   "Year": 2014
  },
  {
   "OBJECTID": 1357,
   "Continent": "South America",
   "Country": "Argentina",
   "ProvName": "Formosa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"PEW Research Center: Religion in Latin America 2014\".",
   "Year": 2014
  },
  {
   "OBJECTID": 1358,
   "Continent": "South America",
   "Country": "Argentina",
   "ProvName": "Corrientes",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"PEW Research Center: Religion in Latin America 2014\".",
   "Year": 2014
  },
  {
   "OBJECTID": 1359,
   "Continent": "Europe",
   "Country": "Bulgaria",
   "ProvName": "Lovech",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Special Eurobarometer 493, European Union: European Commission, September 2019, pages 229-230",
   "Year": 2019
  },
  {
   "OBJECTID": 1360,
   "Continent": "South America",
   "Country": "Argentina",
   "ProvName": "Entre Ríos",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"PEW Research Center: Religion in Latin America 2014\".",
   "Year": 2014
  },
  {
   "OBJECTID": 1361,
   "Continent": "North America",
   "Country": "Panama",
   "ProvName": "Coclé",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Panama. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_174_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1362,
   "Continent": "South America",
   "Country": "Argentina",
   "ProvName": "Santa Fe",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"PEW Research Center: Religion in Latin America 2014\".",
   "Year": 2014
  },
  {
   "OBJECTID": 1363,
   "Continent": "South America",
   "Country": "Brazil",
   "ProvName": "São Paulo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "IBGE – Instituto Brasileiro de Geografia e Estatística (Brazilian Institute for Geography and Statistics). 2010 Census.",
   "Year": 2010
  },
  {
   "OBJECTID": 1364,
   "Continent": "South America",
   "Country": "Argentina",
   "ProvName": "Misiones",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"PEW Research Center: Religion in Latin America 2014\".",
   "Year": 2014
  },
  {
   "OBJECTID": 1365,
   "Continent": "South America",
   "Country": "Brazil",
   "ProvName": "Pernambuco",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "IBGE – Instituto Brasileiro de Geografia e Estatística (Brazilian Institute for Geography and Statistics). 2010 Census.",
   "Year": 2010
  },
  {
   "OBJECTID": 1366,
   "Continent": "South America",
   "Country": "Colombia",
   "ProvName": "Antioquia",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Religion in Latin America\". Pew Forum. https:\/\/www.pewforum.org\/2014\/11\/13\/religion-in-latin-america\/",
   "Year": 2014
  },
  {
   "OBJECTID": 1367,
   "Continent": "North America",
   "Country": "Panama",
   "ProvName": "Los Santos",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Panama. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_174_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1368,
   "Continent": "South America",
   "Country": "Colombia",
   "ProvName": "Boyacá",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Religion in Latin America\". Pew Forum. https:\/\/www.pewforum.org\/2014\/11\/13\/religion-in-latin-america\/",
   "Year": 2014
  },
  {
   "OBJECTID": 1369,
   "Continent": "South America",
   "Country": "Colombia",
   "ProvName": "Santander",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Religion in Latin America\". Pew Forum. https:\/\/www.pewforum.org\/2014\/11\/13\/religion-in-latin-america\/",
   "Year": 2014
  },
  {
   "OBJECTID": 1370,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Karaman",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1371,
   "Continent": "South America",
   "Country": "Colombia",
   "ProvName": "La Guajira",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Religion in Latin America\". Pew Forum. https:\/\/www.pewforum.org\/2014\/11\/13\/religion-in-latin-america\/",
   "Year": 2014
  },
  {
   "OBJECTID": 1372,
   "Continent": "North America",
   "Country": "Haiti",
   "ProvName": "Sud",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "The Future of World Religions: Population Growth Projections, 2010-2050. Pew Research Center (2010)",
   "Year": 2010
  },
  {
   "OBJECTID": 1373,
   "Continent": "North America",
   "Country": "Cuba",
   "ProvName": "Cienfuegos",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "30-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Cuba. Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_63_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1374,
   "Continent": "North America",
   "Country": "Cuba",
   "ProvName": "Isla de la Juventud",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "30-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Cuba. Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_63_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1375,
   "Continent": "North America",
   "Country": "Jamaica",
   "ProvName": "Manchester",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Jamaica. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_116_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1376,
   "Continent": "North America",
   "Country": "Cuba",
   "ProvName": "Pinar del Río",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "30-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Cuba. Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_63_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1377,
   "Continent": "North America",
   "Country": "Jamaica",
   "ProvName": "Westmoreland",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Jamaica. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_116_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1378,
   "Continent": "North America",
   "Country": "Jamaica",
   "ProvName": "Kingston",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Jamaica. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_116_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1379,
   "Continent": "North America",
   "Country": "Cuba",
   "ProvName": "Sancti Spíritus",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "30-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Cuba. Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_63_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1380,
   "Continent": "Asia",
   "Country": "Japan",
   "ProvName": "Okayama",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1381,
   "Continent": "North America",
   "Country": "Belize",
   "ProvName": "Belize",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "30-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Belize Population and Housing Census 2010: Country Report. Belmopan, Belize C.A.: he Statistical Institute of Belize. 2013.",
   "Year": 2010
  },
  {
   "OBJECTID": 1382,
   "Continent": "North America",
   "Country": "Belize",
   "ProvName": "Cayo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "Belize Population and Housing Census 2010: Country Report (PDF). Belmopan, Belize C.A.: he Statistical Institute of Belize. 2013.",
   "Year": 2010
  },
  {
   "OBJECTID": 1383,
   "Continent": "South America",
   "Country": "Colombia",
   "ProvName": "San Andrés y Providencia",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Religion in Latin America\". Pew Forum. https:\/\/www.pewforum.org\/2014\/11\/13\/religion-in-latin-america\/",
   "Year": 2014
  },
  {
   "OBJECTID": 1384,
   "Continent": "North America",
   "Country": "Panama",
   "ProvName": "Colón",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Panama. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_174_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1385,
   "Continent": "North America",
   "Country": "Panama",
   "ProvName": "Herrera",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Panama. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_174_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1386,
   "Continent": "North America",
   "Country": "El Salvador",
   "ProvName": "Ahuachapán",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 1387,
   "Continent": "North America",
   "Country": "Panama",
   "ProvName": "Veraguas",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Panama. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_174_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1388,
   "Continent": "North America",
   "Country": "El Salvador",
   "ProvName": "La Libertad",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 1389,
   "Continent": "North America",
   "Country": "El Salvador",
   "ProvName": "La Paz",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 1390,
   "Continent": "North America",
   "Country": "El Salvador",
   "ProvName": "Sonsonate",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 1391,
   "Continent": "North America",
   "Country": "El Salvador",
   "ProvName": "San Salvador",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 1392,
   "Continent": "North America",
   "Country": "El Salvador",
   "ProvName": "La Unión",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 1393,
   "Continent": "North America",
   "Country": "El Salvador",
   "ProvName": "Morazán",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 1394,
   "Continent": "North America",
   "Country": "El Salvador",
   "ProvName": "San Miguel",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 1395,
   "Continent": "North America",
   "Country": "El Salvador",
   "ProvName": "San Vicente",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 1396,
   "Continent": "North America",
   "Country": "El Salvador",
   "ProvName": "Usulután",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 1397,
   "Continent": "North America",
   "Country": "Belize",
   "ProvName": "Stann Creek",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "Belize Population and Housing Census 2010: Country Report (PDF). Belmopan, Belize C.A.: he Statistical Institute of Belize. 2013.",
   "Year": 2010
  },
  {
   "OBJECTID": 1398,
   "Continent": "North America",
   "Country": "Jamaica",
   "ProvName": "Portland",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Jamaica. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_116_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1399,
   "Continent": "North America",
   "Country": "Belize",
   "ProvName": "Toledo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "Belize Population and Housing Census 2010: Country Report (PDF). Belmopan, Belize C.A.: he Statistical Institute of Belize. 2013.",
   "Year": 2010
  },
  {
   "OBJECTID": 1400,
   "Continent": "North America",
   "Country": "El Salvador",
   "ProvName": "Chalatenango",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 1401,
   "Continent": "North America",
   "Country": "Jamaica",
   "ProvName": "Saint Ann",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Jamaica. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_116_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1402,
   "Continent": "North America",
   "Country": "El Salvador",
   "ProvName": "Santa Ana",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 1403,
   "Continent": "North America",
   "Country": "Haiti",
   "ProvName": "Grande Anse",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "The Future of World Religions: Population Growth Projections, 2010-2050. Pew Research Center (2010)",
   "Year": 2010
  },
  {
   "OBJECTID": 1404,
   "Continent": "North America",
   "Country": "Jamaica",
   "ProvName": "Saint Elizabeth",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Jamaica. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_116_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1405,
   "Continent": "North America",
   "Country": "Jamaica",
   "ProvName": "Saint Catherine",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Jamaica. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_116_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1406,
   "Continent": "Asia",
   "Country": "Japan",
   "ProvName": "Shimane",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1407,
   "Continent": "North America",
   "Country": "Haiti",
   "ProvName": "Nippes",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "The Future of World Religions: Population Growth Projections, 2010-2050. Pew Research Center (2010)",
   "Year": 2010
  },
  {
   "OBJECTID": 1408,
   "Continent": "North America",
   "Country": "Cuba",
   "ProvName": "Ciego de Avila",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "30-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Cuba. Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_63_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1409,
   "Continent": "North America",
   "Country": "Cuba",
   "ProvName": "Camagüey",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "30-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Cuba. Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_63_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1410,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Usak",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1411,
   "Continent": "North America",
   "Country": "Cuba",
   "ProvName": "Guantánamo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "30-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Cuba. Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_63_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1412,
   "Continent": "South America",
   "Country": "Ecuador",
   "ProvName": "Carchi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 1413,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Nigde",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1414,
   "Continent": "North America",
   "Country": "Cuba",
   "ProvName": "Granma",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "30-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Cuba. Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_63_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1415,
   "Continent": "North America",
   "Country": "Cuba",
   "ProvName": "Holgu?n",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Cuba. Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_63_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1416,
   "Continent": "South America",
   "Country": "Ecuador",
   "ProvName": "Imbabura",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 1417,
   "Continent": "North America",
   "Country": "Cuba",
   "ProvName": "Las Tunas",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "30-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Cuba. Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_63_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1418,
   "Continent": "Africa",
   "Country": "Morocco",
   "ProvName": "Tanger-Tétouan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1419,
   "Continent": "North America",
   "Country": "Cuba",
   "ProvName": "Santiago de Cuba",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Cuba. Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_63_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1420,
   "Continent": "North America",
   "Country": "Jamaica",
   "ProvName": "Clarendon",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Jamaica. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_116_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1421,
   "Continent": "North America",
   "Country": "Jamaica",
   "ProvName": "Hanover",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Jamaica. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_116_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1422,
   "Continent": "South America",
   "Country": "Colombia",
   "ProvName": "Huila",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Religion in Latin America\". Pew Forum. https:\/\/www.pewforum.org\/2014\/11\/13\/religion-in-latin-america\/",
   "Year": 2014
  },
  {
   "OBJECTID": 1423,
   "Continent": "Asia",
   "Country": "Japan",
   "ProvName": "Tottori",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1424,
   "Continent": "North America",
   "Country": "Jamaica",
   "ProvName": "Saint Mary",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Jamaica. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_116_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1425,
   "Continent": "South America",
   "Country": "Colombia",
   "ProvName": "Nariño",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Religion in Latin America\". Pew Forum. https:\/\/www.pewforum.org\/2014\/11\/13\/religion-in-latin-america\/",
   "Year": 2014
  },
  {
   "OBJECTID": 1426,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Aksaray",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1427,
   "Continent": "South America",
   "Country": "Colombia",
   "ProvName": "Putumayo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Religion in Latin America\". Pew Forum. https:\/\/www.pewforum.org\/2014\/11\/13\/religion-in-latin-america\/",
   "Year": 2014
  },
  {
   "OBJECTID": 1428,
   "Continent": "South America",
   "Country": "Colombia",
   "ProvName": "Valle de Cauca",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Religion in Latin America\". Pew Forum. https:\/\/www.pewforum.org\/2014\/11\/13\/religion-in-latin-america\/",
   "Year": 2014
  },
  {
   "OBJECTID": 1429,
   "Continent": "North America",
   "Country": "Jamaica",
   "ProvName": "Saint James",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Jamaica. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_116_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1430,
   "Continent": "North America",
   "Country": "Jamaica",
   "ProvName": "Trelawny",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Jamaica. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_116_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1431,
   "Continent": "South America",
   "Country": "Ecuador",
   "ProvName": "Sucumbíos",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 1432,
   "Continent": "South America",
   "Country": "Colombia",
   "ProvName": "Guaviare",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Religion in Latin America\". Pew Forum. https:\/\/www.pewforum.org\/2014\/11\/13\/religion-in-latin-america\/",
   "Year": 2014
  },
  {
   "OBJECTID": 1433,
   "Continent": "South America",
   "Country": "Colombia",
   "ProvName": "Guainia",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Religion in Latin America\". Pew Forum. https:\/\/www.pewforum.org\/2014\/11\/13\/religion-in-latin-america\/",
   "Year": 2014
  },
  {
   "OBJECTID": 1434,
   "Continent": "North America",
   "Country": "Dominica",
   "ProvName": "St. Luke",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "Dominica. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_69_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1435,
   "Continent": "South America",
   "Country": "Colombia",
   "ProvName": "Caldas",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Religion in Latin America\". Pew Forum. https:\/\/www.pewforum.org\/2014\/11\/13\/religion-in-latin-america\/",
   "Year": 2014
  },
  {
   "OBJECTID": 1436,
   "Continent": "South America",
   "Country": "Colombia",
   "ProvName": "Risaralda",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Religion in Latin America\". Pew Forum. https:\/\/www.pewforum.org\/2014\/11\/13\/religion-in-latin-america\/",
   "Year": 2014
  },
  {
   "OBJECTID": 1437,
   "Continent": "South America",
   "Country": "Colombia",
   "ProvName": "Cundinamarca",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Religion in Latin America\". Pew Forum. https:\/\/www.pewforum.org\/2014\/11\/13\/religion-in-latin-america\/",
   "Year": 2014
  },
  {
   "OBJECTID": 1438,
   "Continent": "South America",
   "Country": "Colombia",
   "ProvName": "Tolima",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Religion in Latin America\". Pew Forum. https:\/\/www.pewforum.org\/2014\/11\/13\/religion-in-latin-america\/",
   "Year": 2014
  },
  {
   "OBJECTID": 1439,
   "Continent": "North America",
   "Country": "Dominica",
   "ProvName": "St. Patrick",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "Dominica. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_69_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1440,
   "Continent": "North America",
   "Country": "Dominica",
   "ProvName": "St. Paul",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "Dominica. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_69_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1441,
   "Continent": "North America",
   "Country": "Dominica",
   "ProvName": "St. Peter",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "Dominica. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_69_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1442,
   "Continent": "South America",
   "Country": "Colombia",
   "ProvName": "Caquetá",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Religion in Latin America\". Pew Forum. https:\/\/www.pewforum.org\/2014\/11\/13\/religion-in-latin-america\/",
   "Year": 2014
  },
  {
   "OBJECTID": 1443,
   "Continent": "South America",
   "Country": "Colombia",
   "ProvName": "Cauca",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Religion in Latin America\". Pew Forum. https:\/\/www.pewforum.org\/2014\/11\/13\/religion-in-latin-america\/",
   "Year": 2014
  },
  {
   "OBJECTID": 1444,
   "Continent": "North America",
   "Country": "Dominica",
   "ProvName": "St. Mark",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "Dominica. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_69_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1445,
   "Continent": "Europe",
   "Country": "Faeroe Islands",
   "ProvName": "Faeroe Islands",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"CS 10.1.2 Population by religious faith, educational attainment, occupation, country of birth, year of arrival in the country and place of usual residence\". Statistics Faroe Islands",
   "Year": 2011
  },
  {
   "OBJECTID": 1446,
   "Continent": "Africa",
   "Country": "Morocco",
   "ProvName": "Fès-Boulemane",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1447,
   "Continent": "Africa",
   "Country": "Morocco",
   "ProvName": "Taza-Al-Hoceïma-Taounate",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1448,
   "Continent": "Africa",
   "Country": "Morocco",
   "ProvName": "Gharb-Chrarda-Béni Hssen",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1449,
   "Continent": "Africa",
   "Country": "Morocco",
   "ProvName": "Chaouia-Ouardigha",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1450,
   "Continent": "Africa",
   "Country": "Morocco",
   "ProvName": "Grand Casablanca",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1451,
   "Continent": "Africa",
   "Country": "Morocco",
   "ProvName": "Rabat-Salé-Zemmour-Zaer",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1452,
   "Continent": "Africa",
   "Country": "Morocco",
   "ProvName": "Doukala-Abda",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1453,
   "Continent": "Africa",
   "Country": "Morocco",
   "ProvName": "Meknès-Tafilalet",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1454,
   "Continent": "Africa",
   "Country": "Equatorial Guinea",
   "ProvName": "Bioko Norte",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Equatorial Guinea. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_75_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1455,
   "Continent": "Africa",
   "Country": "Morocco",
   "ProvName": "Tadla-Azilal",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1456,
   "Continent": "Africa",
   "Country": "Morocco",
   "ProvName": "Oriental",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1457,
   "Continent": "Africa",
   "Country": "Liberia",
   "ProvName": "River Gee",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1458,
   "Continent": "Africa",
   "Country": "Morocco",
   "ProvName": "Souss-Massa-Daraâ",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1459,
   "Continent": "Africa",
   "Country": "Morocco",
   "ProvName": "Marrakech-Tensift-Al Haouz",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1460,
   "Continent": "Africa",
   "Country": "Liberia",
   "ProvName": "Gbarpolu",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1461,
   "Continent": "Africa",
   "Country": "Congo DR",
   "ProvName": "Equateur",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Congo, Democratic Republic of the. Association of Religion Data Archives. (2015)  http:\/\/www.thearda.com\/internationalData\/countries\/Country_57_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1462,
   "Continent": "Africa",
   "Country": "Chad",
   "ProvName": "Lac",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "30-40%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "10-20%",
   "Nummeric_1": 20,
   "DataSource": "\"The World's Muslims: Unity and Diversity\" (PDF). Pew Forum on Religious & Public life. 9 August 2012. pp. 128–129.",
   "Year": 2012
  },
  {
   "OBJECTID": 1463,
   "Continent": "Africa",
   "Country": "Equatorial Guinea",
   "ProvName": "Annobón",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Equatorial Guinea. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_75_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1464,
   "Continent": "Africa",
   "Country": "Cameroon",
   "ProvName": "Extrême-Nord",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "20-30%",
   "Numerical": 30,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "July-December, 2010 International Religious Freedom Report : Cameroon. United States Bureau of Democracy, Human Rights and Labor (2010)",
   "Year": 2010
  },
  {
   "OBJECTID": 1465,
   "Continent": "Africa",
   "Country": "Equatorial Guinea",
   "ProvName": "Wele-Nzas",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Equatorial Guinea. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_75_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1466,
   "Continent": "Africa",
   "Country": "Equatorial Guinea",
   "ProvName": "Centro-Sur",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Equatorial Guinea. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_75_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1467,
   "Continent": "Africa",
   "Country": "Equatorial Guinea",
   "ProvName": "Kie-Ntem",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Equatorial Guinea. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_75_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1468,
   "Continent": "Africa",
   "Country": "Equatorial Guinea",
   "ProvName": "Litoral",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Equatorial Guinea. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_75_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1469,
   "Continent": "Africa",
   "Country": "Chad",
   "ProvName": "Batha",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-50%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "10-20%",
   "Nummeric_1": 20,
   "DataSource": "\"The World's Muslims: Unity and Diversity\" (PDF). Pew Forum on Religious & Public life. 9 August 2012. pp. 128–129.",
   "Year": 2012
  },
  {
   "OBJECTID": 1470,
   "Continent": "Africa",
   "Country": "Cameroon",
   "ProvName": "Nord-Ouest",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "20-30%",
   "Numerical": 30,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "July-December, 2010 International Religious Freedom Report : Cameroon. United States Bureau of Democracy, Human Rights and Labor (2010)",
   "Year": 2010
  },
  {
   "OBJECTID": 1471,
   "Continent": "Africa",
   "Country": "Chad",
   "ProvName": "Wadi Fira",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-50%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "10-20%",
   "Nummeric_1": 20,
   "DataSource": "\"The World's Muslims: Unity and Diversity\" (PDF). Pew Forum on Religious & Public life. 9 August 2012. pp. 128–129.",
   "Year": 2012
  },
  {
   "OBJECTID": 1472,
   "Continent": "Asia",
   "Country": "Japan",
   "ProvName": "Saga",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1473,
   "Continent": "Africa",
   "Country": "Chad",
   "ProvName": "Guéra",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "30-40%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "10-20%",
   "Nummeric_1": 20,
   "DataSource": "\"The World's Muslims: Unity and Diversity\" (PDF). Pew Forum on Religious & Public life. 9 August 2012. pp. 128–129.",
   "Year": 2012
  },
  {
   "OBJECTID": 1474,
   "Continent": "Africa",
   "Country": "Cameroon",
   "ProvName": "Littoral",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "20-30%",
   "Numerical": 30,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "July-December, 2010 International Religious Freedom Report : Cameroon. United States Bureau of Democracy, Human Rights and Labor (2010)",
   "Year": 2010
  },
  {
   "OBJECTID": 1475,
   "Continent": "Asia",
   "Country": "Japan",
   "ProvName": "Yamaguchi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1476,
   "Continent": "Europe",
   "Country": "Bulgaria",
   "ProvName": "Pleven",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Special Eurobarometer 493, European Union: European Commission, September 2019, pages 229-230",
   "Year": 2019
  },
  {
   "OBJECTID": 1477,
   "Continent": "Asia",
   "Country": "Japan",
   "ProvName": "Fukuoka",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1478,
   "Continent": "Africa",
   "Country": "Equatorial Guinea",
   "ProvName": "Bioko Sur",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Equatorial Guinea. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_75_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1479,
   "Continent": "Africa",
   "Country": "Cameroon",
   "ProvName": "Centre",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "30-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "July-December, 2010 International Religious Freedom Report : Cameroon. United States Bureau of Democracy, Human Rights and Labor (2010)",
   "Year": 2010
  },
  {
   "OBJECTID": 1480,
   "Continent": "Africa",
   "Country": "Cameroon",
   "ProvName": "Est",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "20-30%",
   "Numerical": 30,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "July-December, 2010 International Religious Freedom Report : Cameroon. United States Bureau of Democracy, Human Rights and Labor (2010)",
   "Year": 2010
  },
  {
   "OBJECTID": 1481,
   "Continent": "Europe",
   "Country": "Albania",
   "ProvName": "Durrës",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1482,
   "Continent": "Africa",
   "Country": "Cameroon",
   "ProvName": "Adamoua",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "20-30%",
   "Numerical": 30,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "July-December, 2010 International Religious Freedom Report : Cameroon. United States Bureau of Democracy, Human Rights and Labor (2010)",
   "Year": 2010
  },
  {
   "OBJECTID": 1483,
   "Continent": "Asia",
   "Country": "Philippines",
   "ProvName": "National Capital Region",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Philippines. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_178_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1484,
   "Continent": "Africa",
   "Country": "Cameroon",
   "ProvName": "Nord",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "20-30%",
   "Numerical": 30,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "July-December, 2010 International Religious Freedom Report : Cameroon. United States Bureau of Democracy, Human Rights and Labor (2010)",
   "Year": 2010
  },
  {
   "OBJECTID": 1485,
   "Continent": "Africa",
   "Country": "Egypt",
   "ProvName": "al-Minufiyah (Monufia)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1486,
   "Continent": "Africa",
   "Country": "Chad",
   "ProvName": "Logone Occidental",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "30-40%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "10-20%",
   "Nummeric_1": 20,
   "DataSource": "\"The World's Muslims: Unity and Diversity\" (PDF). Pew Forum on Religious & Public life. 9 August 2012. pp. 128–129.",
   "Year": 2012
  },
  {
   "OBJECTID": 1487,
   "Continent": "Africa",
   "Country": "Chad",
   "ProvName": "Logone Oriental",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "30-40%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "10-20%",
   "Nummeric_1": 20,
   "DataSource": "\"The World's Muslims: Unity and Diversity\" (PDF). Pew Forum on Religious & Public life. 9 August 2012. pp. 128–129.",
   "Year": 2012
  },
  {
   "OBJECTID": 1488,
   "Continent": "Africa",
   "Country": "Egypt",
   "ProvName": "al-Qahirah (Cairo)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1489,
   "Continent": "Africa",
   "Country": "Chad",
   "ProvName": "Tandjilé",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "30-40%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "10-20%",
   "Nummeric_1": 20,
   "DataSource": "\"The World's Muslims: Unity and Diversity\" (PDF). Pew Forum on Religious & Public life. 9 August 2012. pp. 128–129.",
   "Year": 2012
  },
  {
   "OBJECTID": 1490,
   "Continent": "Europe",
   "Country": "Albania",
   "ProvName": "Kukës",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1491,
   "Continent": "Africa",
   "Country": "Chad",
   "ProvName": "Salamat",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "30-40%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "10-20%",
   "Nummeric_1": 20,
   "DataSource": "\"The World's Muslims: Unity and Diversity\" (PDF). Pew Forum on Religious & Public life. 9 August 2012. pp. 128–129.",
   "Year": 2012
  },
  {
   "OBJECTID": 1492,
   "Continent": "Europe",
   "Country": "Croatia",
   "ProvName": "Dubrovnik-Neretva",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Population by Religion, by Towns\/Municipalities, 2011 Census\". Census of Population, Households and Dwellings 2011. Zagreb: Croatian Bureau of Statistics.",
   "Year": 2011
  },
  {
   "OBJECTID": 1493,
   "Continent": "Europe",
   "Country": "Montenegro",
   "ProvName": "Plav",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 1494,
   "Continent": "Africa",
   "Country": "Egypt",
   "ProvName": "al-Qalyubiyah (Qalyubia)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1495,
   "Continent": "Europe",
   "Country": "Croatia",
   "ProvName": "Sibenik-Knin",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Population by Religion, by Towns\/Municipalities, 2011 Census\". Census of Population, Households and Dwellings 2011. Zagreb: Croatian Bureau of Statistics.",
   "Year": 2011
  },
  {
   "OBJECTID": 1496,
   "Continent": "Europe",
   "Country": "Montenegro",
   "ProvName": "Berane",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 1497,
   "Continent": "Europe",
   "Country": "Montenegro",
   "ProvName": "Bijelo Polje",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 1498,
   "Continent": "Europe",
   "Country": "Croatia",
   "ProvName": "Split-Dalmatia",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Population by Religion, by Towns\/Municipalities, 2011 Census\". Census of Population, Households and Dwellings 2011. Zagreb: Croatian Bureau of Statistics.",
   "Year": 2011
  },
  {
   "OBJECTID": 1499,
   "Continent": "Europe",
   "Country": "Croatia",
   "ProvName": "Zadar",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Population by Religion, by Towns\/Municipalities, 2011 Census\". Census of Population, Households and Dwellings 2011. Zagreb: Croatian Bureau of Statistics.",
   "Year": 2011
  },
  {
   "OBJECTID": 1500,
   "Continent": "Europe",
   "Country": "Montenegro",
   "ProvName": "Kolasin",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 1501,
   "Continent": "Europe",
   "Country": "Montenegro",
   "ProvName": "Mojkovac",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 1502,
   "Continent": "Europe",
   "Country": "Albania",
   "ProvName": "Fier",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1503,
   "Continent": "Europe",
   "Country": "Montenegro",
   "ProvName": "Bar",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 1504,
   "Continent": "Europe",
   "Country": "Montenegro",
   "ProvName": "Ulcinj",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 1505,
   "Continent": "Europe",
   "Country": "Albania",
   "ProvName": "Shkodër",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1506,
   "Continent": "Europe",
   "Country": "Montenegro",
   "ProvName": "Budva",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 1507,
   "Continent": "Europe",
   "Country": "Montenegro",
   "ProvName": "Danilovgrad",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 1508,
   "Continent": "Europe",
   "Country": "Montenegro",
   "ProvName": "Cetinje",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 1509,
   "Continent": "Europe",
   "Country": "Montenegro",
   "ProvName": "Rozaje",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 1510,
   "Continent": "Europe",
   "Country": "Albania",
   "ProvName": "Vlorë",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1511,
   "Continent": "Europe",
   "Country": "Montenegro",
   "ProvName": "Herceg Novi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 1512,
   "Continent": "Europe",
   "Country": "Montenegro",
   "ProvName": "Kotor",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 1513,
   "Continent": "Europe",
   "Country": "Montenegro",
   "ProvName": "Andrijevica",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 1514,
   "Continent": "Asia",
   "Country": "Japan",
   "ProvName": "Kumamoto",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1515,
   "Continent": "Europe",
   "Country": "Montenegro",
   "ProvName": "Niksic'",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 1516,
   "Continent": "Asia",
   "Country": "Japan",
   "ProvName": "Miyazaki",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1517,
   "Continent": "Europe",
   "Country": "Montenegro",
   "ProvName": "Pluzine",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 1518,
   "Continent": "Europe",
   "Country": "Montenegro",
   "ProvName": "Pljevlja",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 1519,
   "Continent": "Europe",
   "Country": "Montenegro",
   "ProvName": "Podgorica",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 1520,
   "Continent": "Asia",
   "Country": "Japan",
   "ProvName": "Ehime",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1521,
   "Continent": "Asia",
   "Country": "Japan",
   "ProvName": "Kagawa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1522,
   "Continent": "Asia",
   "Country": "Japan",
   "ProvName": "Kochi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1523,
   "Continent": "Asia",
   "Country": "Japan",
   "ProvName": "Oita",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1524,
   "Continent": "Europe",
   "Country": "Albania",
   "ProvName": "Korçë",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1525,
   "Continent": "Europe",
   "Country": "Albania",
   "ProvName": "Berat",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1526,
   "Continent": "Europe",
   "Country": "Hungary",
   "ProvName": "Nógrád",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Hungary. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_106_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1527,
   "Continent": "Europe",
   "Country": "Albania",
   "ProvName": "Elbasan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1528,
   "Continent": "Europe",
   "Country": "Albania",
   "ProvName": "Gjirokastër",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1529,
   "Continent": "Europe",
   "Country": "Bulgaria",
   "ProvName": "Montana",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Special Eurobarometer 493, European Union: European Commission, September 2019, pages 229-230",
   "Year": 2019
  },
  {
   "OBJECTID": 1530,
   "Continent": "Europe",
   "Country": "Albania",
   "ProvName": "Dibër",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1531,
   "Continent": "Europe",
   "Country": "Albania",
   "ProvName": "Lezhë",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1532,
   "Continent": "Europe",
   "Country": "Albania",
   "ProvName": "Tiranë",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1533,
   "Continent": "Africa",
   "Country": "Egypt",
   "ProvName": "al-Gharbiyah (Gharbia)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1534,
   "Continent": "Africa",
   "Country": "Egypt",
   "ProvName": "al-Ismailiyah (ismailia)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1535,
   "Continent": "Africa",
   "Country": "Egypt",
   "ProvName": "ash-Sharqiyah (Sharqia)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1536,
   "Continent": "Africa",
   "Country": "Egypt",
   "ProvName": "as-Suways (Suez)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1537,
   "Continent": "Asia",
   "Country": "Japan",
   "ProvName": "Tokushima",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1538,
   "Continent": "Africa",
   "Country": "Egypt",
   "ProvName": "ad-Daqahliyah (Dakahlia)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1539,
   "Continent": "Africa",
   "Country": "Egypt",
   "ProvName": "Bani Suyayf (Beni Suef)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1540,
   "Continent": "Europe",
   "Country": "Isle of Man",
   "ProvName": "Isle of Man",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Isle of Man. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_143_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1541,
   "Continent": "Asia",
   "Country": "Indonesia",
   "ProvName": "Gorontalo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1542,
   "Continent": "Asia",
   "Country": "Japan",
   "ProvName": "Aichi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1543,
   "Continent": "Africa",
   "Country": "Egypt",
   "ProvName": "Bur Said (Port Said)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1544,
   "Continent": "Africa",
   "Country": "Egypt",
   "ProvName": "Dumyat (Damietta)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1545,
   "Continent": "Africa",
   "Country": "Egypt",
   "ProvName": "Matruh (Matruh)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1546,
   "Continent": "Europe",
   "Country": "Bulgaria",
   "ProvName": "Vratsa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Special Eurobarometer 493, European Union: European Commission, September 2019, pages 229-230",
   "Year": 2019
  },
  {
   "OBJECTID": 1547,
   "Continent": "Africa",
   "Country": "Egypt",
   "ProvName": "al-Buhayrah (Beheira)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1548,
   "Continent": "Africa",
   "Country": "Egypt",
   "ProvName": "al-Fayyum (Faiyum)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1549,
   "Continent": "Africa",
   "Country": "Egypt",
   "ProvName": "al-Iskandariyah (Alexandria)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1550,
   "Continent": "Africa",
   "Country": "Egypt",
   "ProvName": "al-Jizah (Giza)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1551,
   "Continent": "Africa",
   "Country": "Egypt",
   "ProvName": "al-Minya (Minya)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1552,
   "Continent": "Africa",
   "Country": "Egypt",
   "ProvName": "Kafr ash-Shaykh (Kafr el-Sheikh)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1553,
   "Continent": "Africa",
   "Country": "Egypt",
   "ProvName": "al-Wadi al-Jadid (New Valley)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1554,
   "Continent": "Africa",
   "Country": "Egypt",
   "ProvName": "Aswan (Aswan)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1555,
   "Continent": "Africa",
   "Country": "Egypt",
   "ProvName": "Asyut (Asyut)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1556,
   "Continent": "Asia",
   "Country": "Japan",
   "ProvName": "Gifu",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1557,
   "Continent": "Asia",
   "Country": "Japan",
   "ProvName": "Ishikawa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1558,
   "Continent": "Asia",
   "Country": "Japan",
   "ProvName": "Mie",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1559,
   "Continent": "Europe",
   "Country": "Germany",
   "ProvName": "Bremen",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "5-10%",
   "Nummeric_1": 10,
   "DataSource": "The GESIS – Leibniz Institute for the Social Sciences (2016) \"Konfession, Bundesland – weighted (Kumulierter Datensatz)\" https:\/\/search.gesis.org\/research_data\/ZA6888",
   "Year": 2016
  },
  {
   "OBJECTID": 1560,
   "Continent": "Europe",
   "Country": "Germany",
   "ProvName": "Niedersachsen",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "15-20%",
   "Nummeric_1": 20,
   "DataSource": "The GESIS – Leibniz Institute for the Social Sciences (2016) \"Konfession, Bundesland – weighted (Kumulierter Datensatz)\" https:\/\/search.gesis.org\/research_data\/ZA6888",
   "Year": 2016
  },
  {
   "OBJECTID": 1561,
   "Continent": "Europe",
   "Country": "Germany",
   "ProvName": "Thüringen",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "25-30%",
   "Numerical": 30,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "5-10%",
   "Nummeric_1": 10,
   "DataSource": "The GESIS – Leibniz Institute for the Social Sciences (2016) \"Konfession, Bundesland – weighted (Kumulierter Datensatz)\" https:\/\/search.gesis.org\/research_data\/ZA6888",
   "Year": 2016
  },
  {
   "OBJECTID": 1562,
   "Continent": "Asia",
   "Country": "Japan",
   "ProvName": "Nagano",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1563,
   "Continent": "Africa",
   "Country": "Egypt",
   "ProvName": "Sawhaj (Sohag)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1564,
   "Continent": "Africa",
   "Country": "Saint Helena",
   "ProvName": "Saint Helena",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Saint Helena. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_188_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1565,
   "Continent": "Asia",
   "Country": "Armenia",
   "ProvName": "Aragatsotn",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Oriental orthodox",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.armstat.am\/file\/article\/sv_03_13a_520.pdf",
   "Year": 2011
  },
  {
   "OBJECTID": 1566,
   "Continent": "Asia",
   "Country": "Armenia",
   "ProvName": "Armavir",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Oriental orthodox",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.armstat.am\/file\/article\/sv_03_13a_520.pdf",
   "Year": 2011
  },
  {
   "OBJECTID": 1567,
   "Continent": "Europe",
   "Country": "Croatia",
   "ProvName": "Krapina-Zagorje",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Population by Religion, by Towns\/Municipalities, 2011 Census\". Census of Population, Households and Dwellings 2011. Zagreb: Croatian Bureau of Statistics.",
   "Year": 2011
  },
  {
   "OBJECTID": 1568,
   "Continent": "Asia",
   "Country": "Armenia",
   "ProvName": "Shirak",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Oriental orthodox",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.armstat.am\/file\/article\/sv_03_13a_520.pdf",
   "Year": 2011
  },
  {
   "OBJECTID": 1569,
   "Continent": "Africa",
   "Country": "Egypt",
   "ProvName": "al-Bahr al-Ahmar (Red Sea)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1570,
   "Continent": "Africa",
   "Country": "Egypt",
   "ProvName": "Shamal Sina' (South Sinai)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1571,
   "Continent": "Africa",
   "Country": "Congo DR",
   "ProvName": "Haut-Congo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Congo, Democratic Republic of the. Association of Religion Data Archives. (2015)  http:\/\/www.thearda.com\/internationalData\/countries\/Country_57_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1572,
   "Continent": "South America",
   "Country": "Argentina",
   "ProvName": "Buenas Aires city",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"PEW Research Center: Religion in Latin America 2014\".",
   "Year": 2014
  },
  {
   "OBJECTID": 1573,
   "Continent": "Africa",
   "Country": "Egypt",
   "ProvName": "Janub Sina' (North Sinai)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1574,
   "Continent": "Africa",
   "Country": "Eritrea",
   "ProvName": "Debub",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Oriental orthodox",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Religious Composition by Country, 2010-2050\". Pew Research Center.",
   "Year": 2010
  },
  {
   "OBJECTID": 1575,
   "Continent": "Europe",
   "Country": "Belarus",
   "ProvName": "Minsk City",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Generations and Gender Survey, 2020 Belarus Wave 1\". ggpsurvey.ined.fr.",
   "Year": 2017
  },
  {
   "OBJECTID": 1576,
   "Continent": "Africa",
   "Country": "Eritrea",
   "ProvName": "Gash Barka",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Oriental orthodox",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Religious Composition by Country, 2010-2050\". Pew Research Center.",
   "Year": 2010
  },
  {
   "OBJECTID": 1577,
   "Continent": "Africa",
   "Country": "Eritrea",
   "ProvName": "Maekel",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Oriental orthodox",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Religious Composition by Country, 2010-2050\". Pew Research Center.",
   "Year": 2010
  },
  {
   "OBJECTID": 1578,
   "Continent": "Africa",
   "Country": "Eritrea",
   "ProvName": "Semenawi Keyh Bahri",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1579,
   "Continent": "Africa",
   "Country": "Eritrea",
   "ProvName": "Ameba",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Oriental orthodox",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Religious Composition by Country, 2010-2050\". Pew Research Center.",
   "Year": 2010
  },
  {
   "OBJECTID": 1580,
   "Continent": "Africa",
   "Country": "Eritrea",
   "ProvName": "Debubawi Keyh Bahri",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1581,
   "Continent": "Africa",
   "Country": "Djibouti",
   "ProvName": "Ali Sabih (Ali-Sabieh)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1582,
   "Continent": "Africa",
   "Country": "Djibouti",
   "ProvName": "Djibouti",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1583,
   "Continent": "Africa",
   "Country": "Djibouti",
   "ProvName": "Tadjoura (Tadjourah)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1584,
   "Continent": "Europe",
   "Country": "Germany",
   "ProvName": "Nordrhein-Westfalen",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "The GESIS – Leibniz Institute for the Social Sciences (2016) \"Konfession, Bundesland – weighted (Kumulierter Datensatz)\" https:\/\/search.gesis.org\/research_data\/ZA6888",
   "Year": 2016
  },
  {
   "OBJECTID": 1585,
   "Continent": "Europe",
   "Country": "Germany",
   "ProvName": "Baden-Württemberg",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "The GESIS – Leibniz Institute for the Social Sciences (2016) \"Konfession, Bundesland – weighted (Kumulierter Datensatz)\" https:\/\/search.gesis.org\/research_data\/ZA6888",
   "Year": 2016
  },
  {
   "OBJECTID": 1586,
   "Continent": "Europe",
   "Country": "Germany",
   "ProvName": "Hessen",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "20-25%",
   "Nummeric_1": 25,
   "DataSource": "The GESIS – Leibniz Institute for the Social Sciences (2016) \"Konfession, Bundesland – weighted (Kumulierter Datensatz)\" https:\/\/search.gesis.org\/research_data\/ZA6888",
   "Year": 2016
  },
  {
   "OBJECTID": 1587,
   "Continent": "North America",
   "Country": "Aruba",
   "ProvName": "Aruba",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Central America and Caribbean ::ARUBA\". CIA The World Factbook.",
   "Year": 2019
  },
  {
   "OBJECTID": 1588,
   "Continent": "Asia",
   "Country": "Japan",
   "ProvName": "Shizuoka",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1589,
   "Continent": "Africa",
   "Country": "Djibouti",
   "ProvName": "Arta",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1590,
   "Continent": "Africa",
   "Country": "Djibouti",
   "ProvName": "Dikhil",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1591,
   "Continent": "Africa",
   "Country": "Djibouti",
   "ProvName": "Obock",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1592,
   "Continent": "Europe",
   "Country": "Germany",
   "ProvName": "Hamburg",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "30-35%",
   "Numerical": 35,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "5-10%",
   "Nummeric_1": 10,
   "DataSource": "The GESIS – Leibniz Institute for the Social Sciences (2016) \"Konfession, Bundesland – weighted (Kumulierter Datensatz)\" https:\/\/search.gesis.org\/research_data\/ZA6888",
   "Year": 2016
  },
  {
   "OBJECTID": 1593,
   "Continent": "Europe",
   "Country": "Germany",
   "ProvName": "Schleswig Holstein",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "The GESIS – Leibniz Institute for the Social Sciences (2016) \"Konfession, Bundesland – weighted (Kumulierter Datensatz)\" https:\/\/search.gesis.org\/research_data\/ZA6888",
   "Year": 2016
  },
  {
   "OBJECTID": 1594,
   "Continent": "Europe",
   "Country": "Germany",
   "ProvName": "Rheinland-Pfalz",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "The GESIS – Leibniz Institute for the Social Sciences (2016) \"Konfession, Bundesland – weighted (Kumulierter Datensatz)\" https:\/\/search.gesis.org\/research_data\/ZA6888",
   "Year": 2016
  },
  {
   "OBJECTID": 1595,
   "Continent": "Europe",
   "Country": "Germany",
   "ProvName": "Saarland",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-25%",
   "Nummeric_1": 25,
   "DataSource": "The GESIS – Leibniz Institute for the Social Sciences (2016) \"Konfession, Bundesland – weighted (Kumulierter Datensatz)\" https:\/\/search.gesis.org\/research_data\/ZA6888",
   "Year": 2016
  },
  {
   "OBJECTID": 1596,
   "Continent": "Asia",
   "Country": "Palestine",
   "ProvName": "Gaza Strip",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1597,
   "Continent": "Europe",
   "Country": "Croatia",
   "ProvName": "Karlovac",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Population by Religion, by Towns\/Municipalities, 2011 Census\". Census of Population, Households and Dwellings 2011. Zagreb: Croatian Bureau of Statistics.",
   "Year": 2011
  },
  {
   "OBJECTID": 1598,
   "Continent": "Europe",
   "Country": "Croatia",
   "ProvName": "Zagreb city",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Population by Religion, by Towns\/Municipalities, 2011 Census\". Census of Population, Households and Dwellings 2011. Zagreb: Croatian Bureau of Statistics.",
   "Year": 2011
  },
  {
   "OBJECTID": 1599,
   "Continent": "Europe",
   "Country": "Germany",
   "ProvName": "Bayern",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "55-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-25%",
   "Nummeric_1": 25,
   "DataSource": "The GESIS – Leibniz Institute for the Social Sciences (2016) \"Konfession, Bundesland – weighted (Kumulierter Datensatz)\" https:\/\/search.gesis.org\/research_data\/ZA6888",
   "Year": 2016
  },
  {
   "OBJECTID": 1600,
   "Continent": "Europe",
   "Country": "Croatia",
   "ProvName": "Lika-Senj",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Population by Religion, by Towns\/Municipalities, 2011 Census\". Census of Population, Households and Dwellings 2011. Zagreb: Croatian Bureau of Statistics.",
   "Year": 2011
  },
  {
   "OBJECTID": 1601,
   "Continent": "Europe",
   "Country": "Germany",
   "ProvName": "Berlin",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "30-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "The GESIS – Leibniz Institute for the Social Sciences (2016) \"Konfession, Bundesland – weighted (Kumulierter Datensatz)\" https:\/\/search.gesis.org\/research_data\/ZA6888",
   "Year": 2016
  },
  {
   "OBJECTID": 1602,
   "Continent": "Europe",
   "Country": "Croatia",
   "ProvName": "Primorje-Gorski Kotar",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Population by Religion, by Towns\/Municipalities, 2011 Census\". Census of Population, Households and Dwellings 2011. Zagreb: Croatian Bureau of Statistics.",
   "Year": 2011
  },
  {
   "OBJECTID": 1603,
   "Continent": "Europe",
   "Country": "Germany",
   "ProvName": "Sachsen-Anhalt",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "15-20%",
   "Numerical": 20,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "5-10%",
   "Nummeric_1": 10,
   "DataSource": "The GESIS – Leibniz Institute for the Social Sciences (2016) \"Konfession, Bundesland – weighted (Kumulierter Datensatz)\" https:\/\/search.gesis.org\/research_data\/ZA6888",
   "Year": 2016
  },
  {
   "OBJECTID": 1604,
   "Continent": "Europe",
   "Country": "Germany",
   "ProvName": "Sachsen",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "25-30%",
   "Numerical": 30,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "The GESIS – Leibniz Institute for the Social Sciences (2016) \"Konfession, Bundesland – weighted (Kumulierter Datensatz)\" https:\/\/search.gesis.org\/research_data\/ZA6888",
   "Year": 2016
  },
  {
   "OBJECTID": 1605,
   "Continent": "Europe",
   "Country": "Croatia",
   "ProvName": "Sisak-Moslavina",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Population by Religion, by Towns\/Municipalities, 2011 Census\". Census of Population, Households and Dwellings 2011. Zagreb: Croatian Bureau of Statistics.",
   "Year": 2011
  },
  {
   "OBJECTID": 1606,
   "Continent": "North America",
   "Country": "Saint Pierre & Miquelon",
   "ProvName": "Saint Pierre & Miquelon",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Saint Pierre & Miquelon. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_191_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1607,
   "Continent": "Europe",
   "Country": "Croatia",
   "ProvName": "Zagreb",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Population by Religion, by Towns\/Municipalities, 2011 Census\". Census of Population, Households and Dwellings 2011. Zagreb: Croatian Bureau of Statistics.",
   "Year": 2011
  },
  {
   "OBJECTID": 1608,
   "Continent": "Africa",
   "Country": "Burkina Faso",
   "ProvName": "Ganzourgou",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mapping the Global Muslim Population. Estimate Range of Shia by Country. Pew Forum, 2010. Johnson, T. M., & Grim, B. J. (Eds.).",
   "Year": 2008
  },
  {
   "OBJECTID": 1609,
   "Continent": "Europe",
   "Country": "Croatia",
   "ProvName": "Istria",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Population by Religion, by Towns\/Municipalities, 2011 Census\". Census of Population, Households and Dwellings 2011. Zagreb: Croatian Bureau of Statistics.",
   "Year": 2011
  },
  {
   "OBJECTID": 1610,
   "Continent": "Europe",
   "Country": "Moldova",
   "ProvName": "Ocnita",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 1611,
   "Continent": "Asia",
   "Country": "Japan",
   "ProvName": "Toyama",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1612,
   "Continent": "Asia",
   "Country": "Japan",
   "ProvName": "Hokkaido (Territory)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1613,
   "Continent": "Asia",
   "Country": "Japan",
   "ProvName": "Fukui",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1614,
   "Continent": "Europe",
   "Country": "Croatia",
   "ProvName": "Brod-Posavina",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Population by Religion, by Towns\/Municipalities, 2011 Census\". Census of Population, Households and Dwellings 2011. Zagreb: Croatian Bureau of Statistics.",
   "Year": 2011
  },
  {
   "OBJECTID": 1615,
   "Continent": "Asia",
   "Country": "Japan",
   "ProvName": "Hyogo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1616,
   "Continent": "Europe",
   "Country": "Czech Republic",
   "ProvName": "Praha",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "10-20%",
   "Numerical": 20,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"2011 Census: Population by religious belief and by regions\". https:\/\/web.archive.org\/web\/20131104224923\/http:\/\/www.czso.cz\/sldb2011\/eng\/redakce.nsf\/i\/tab_7_2_population_by_religious_belief_and_by_regions\/$File\/PVCR072_ENG.pdf",
   "Year": 2011
  },
  {
   "OBJECTID": 1617,
   "Continent": "Europe",
   "Country": "Czech Republic",
   "ProvName": "Stredoceský",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "<= 10%",
   "Numerical": 10,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"2011 Census: Population by religious belief and by regions\". https:\/\/web.archive.org\/web\/20131104224923\/http:\/\/www.czso.cz\/sldb2011\/eng\/redakce.nsf\/i\/tab_7_2_population_by_religious_belief_and_by_regions\/$File\/PVCR072_ENG.pdf",
   "Year": 2011
  },
  {
   "OBJECTID": 1618,
   "Continent": "Africa",
   "Country": "Burkina Faso",
   "ProvName": "Kouritenga",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "10-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mapping the Global Muslim Population. Estimate Range of Shia by Country. Pew Forum, 2010. Johnson, T. M., & Grim, B. J. (Eds.).",
   "Year": 2008
  },
  {
   "OBJECTID": 1619,
   "Continent": "Europe",
   "Country": "Croatia",
   "ProvName": "Osijek-Baranja",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Population by Religion, by Towns\/Municipalities, 2011 Census\". Census of Population, Households and Dwellings 2011. Zagreb: Croatian Bureau of Statistics.",
   "Year": 2011
  },
  {
   "OBJECTID": 1620,
   "Continent": "Asia",
   "Country": "Cambodia",
   "ProvName": "Preah Sihanouk",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1621,
   "Continent": "Europe",
   "Country": "Croatia",
   "ProvName": "Pozega-Slavonija",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Population by Religion, by Towns\/Municipalities, 2011 Census\". Census of Population, Households and Dwellings 2011. Zagreb: Croatian Bureau of Statistics.",
   "Year": 2011
  },
  {
   "OBJECTID": 1622,
   "Continent": "Europe",
   "Country": "Croatia",
   "ProvName": "Varazdin",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Population by Religion, by Towns\/Municipalities, 2011 Census\". Census of Population, Households and Dwellings 2011. Zagreb: Croatian Bureau of Statistics.",
   "Year": 2011
  },
  {
   "OBJECTID": 1623,
   "Continent": "Europe",
   "Country": "Croatia",
   "ProvName": "Vukovar-Srijem",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Population by Religion, by Towns\/Municipalities, 2011 Census\". Census of Population, Households and Dwellings 2011. Zagreb: Croatian Bureau of Statistics.",
   "Year": 2011
  },
  {
   "OBJECTID": 1624,
   "Continent": "Europe",
   "Country": "Croatia",
   "ProvName": "Virovitica-Podravina",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Population by Religion, by Towns\/Municipalities, 2011 Census\". Census of Population, Households and Dwellings 2011. Zagreb: Croatian Bureau of Statistics.",
   "Year": 2011
  },
  {
   "OBJECTID": 1625,
   "Continent": "Europe",
   "Country": "Channel Islands",
   "ProvName": "Jersey",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Channel Islands. Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_46_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1626,
   "Continent": "Europe",
   "Country": "Croatia",
   "ProvName": "Bjelovar-Bilogora",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Population by Religion, by Towns\/Municipalities, 2011 Census\". Census of Population, Households and Dwellings 2011. Zagreb: Croatian Bureau of Statistics.",
   "Year": 2011
  },
  {
   "OBJECTID": 1627,
   "Continent": "Europe",
   "Country": "Czech Republic",
   "ProvName": "Jihomoravský",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "20-30%",
   "Numerical": 30,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"2011 Census: Population by religious belief and by regions\". https:\/\/web.archive.org\/web\/20131104224923\/http:\/\/www.czso.cz\/sldb2011\/eng\/redakce.nsf\/i\/tab_7_2_population_by_religious_belief_and_by_regions\/$File\/PVCR072_ENG.pdf",
   "Year": 2011
  },
  {
   "OBJECTID": 1628,
   "Continent": "Europe",
   "Country": "Croatia",
   "ProvName": "Koprivnica-Krizevci",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Population by Religion, by Towns\/Municipalities, 2011 Census\". Census of Population, Households and Dwellings 2011. Zagreb: Croatian Bureau of Statistics.",
   "Year": 2011
  },
  {
   "OBJECTID": 1629,
   "Continent": "Europe",
   "Country": "Croatia",
   "ProvName": "Medimurje",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Population by Religion, by Towns\/Municipalities, 2011 Census\". Census of Population, Households and Dwellings 2011. Zagreb: Croatian Bureau of Statistics.",
   "Year": 2011
  },
  {
   "OBJECTID": 1630,
   "Continent": "Europe",
   "Country": "Moldova",
   "ProvName": "Briceni",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 1631,
   "Continent": "Asia",
   "Country": "Japan",
   "ProvName": "Kyoto",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1632,
   "Continent": "Asia",
   "Country": "Japan",
   "ProvName": "Nara",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1633,
   "Continent": "Africa",
   "Country": "Gabon",
   "ProvName": "Ogooué-Maritime",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Gabon. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_86_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1634,
   "Continent": "Europe",
   "Country": "Channel Islands",
   "ProvName": "Guernsey",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Channel Islands. Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_46_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1635,
   "Continent": "Africa",
   "Country": "Botswana",
   "ProvName": "Kgalagadi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Pew Research Center's Religion & Public Life Project: Botswana. Pew Research Center. 2010.",
   "Year": 2010
  },
  {
   "OBJECTID": 1636,
   "Continent": "Asia",
   "Country": "Armenia",
   "ProvName": "Kotayk",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Oriental orthodox",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.armstat.am\/file\/article\/sv_03_13a_520.pdf",
   "Year": 2011
  },
  {
   "OBJECTID": 1637,
   "Continent": "Oceania",
   "Country": "Australia",
   "ProvName": "Western Australia",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "30-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "2016 Census of Population and General Community (Sheet G14) Australian Bureau of Statistics",
   "Year": 2016
  },
  {
   "OBJECTID": 1638,
   "Continent": "Africa",
   "Country": "Congo",
   "ProvName": "Bouenza",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "\"Congo, Republic of the\". Association of Religion Data Archives. 2015 http:\/\/www.thearda.com\/internationalData\/countries\/Country_57_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1639,
   "Continent": "Africa",
   "Country": "Burkina Faso",
   "ProvName": "Nahouri",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mapping the Global Muslim Population. Estimate Range of Shia by Country. Pew Forum, 2010. Johnson, T. M., & Grim, B. J. (Eds.).",
   "Year": 2008
  },
  {
   "OBJECTID": 1640,
   "Continent": "Africa",
   "Country": "Gabon",
   "ProvName": "Haut-Ogooué",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Gabon. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_86_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1641,
   "Continent": "Europe",
   "Country": "Moldova",
   "ProvName": "Rîscani",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 1642,
   "Continent": "South America",
   "Country": "Bolivia",
   "ProvName": "Pando",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Religion affiliation in Bolivia as of 2018. Based on Latinobarómetro. Survey period: June 15 to August 2, 2018",
   "Year": 2018
  },
  {
   "OBJECTID": 1643,
   "Continent": "South America",
   "Country": "Bolivia",
   "ProvName": "Potosí",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Religion affiliation in Bolivia as of 2018. Based on Latinobarómetro. Survey period: June 15 to August 2, 2018",
   "Year": 2018
  },
  {
   "OBJECTID": 1644,
   "Continent": "North America",
   "Country": "United States Virgin Is",
   "ProvName": "United States Virgin Islands",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Religions in U S Virgin Islands - PEW-GRF\". www.globalreligiousfutures.org. Archived from the original on January 7, 2018.",
   "Year": 2010
  },
  {
   "OBJECTID": 1645,
   "Continent": "Europe",
   "Country": "Moldova",
   "ProvName": "Transnistria",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 1646,
   "Continent": "Europe",
   "Country": "Moldova",
   "ProvName": "Hîncesti",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 1647,
   "Continent": "South America",
   "Country": "Bolivia",
   "ProvName": "Santa Cruz",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Religion affiliation in Bolivia as of 2018. Based on Latinobarómetro. Survey period: June 15 to August 2, 2018",
   "Year": 2018
  },
  {
   "OBJECTID": 1648,
   "Continent": "South America",
   "Country": "Bolivia",
   "ProvName": "Tarija",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Religion affiliation in Bolivia as of 2018. Based on Latinobarómetro. Survey period: June 15 to August 2, 2018",
   "Year": 2018
  },
  {
   "OBJECTID": 1649,
   "Continent": "Asia",
   "Country": "Oman",
   "ProvName": "al-Dakhiliyah",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Ibadi)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1650,
   "Continent": "Asia",
   "Country": "Afghanistan",
   "ProvName": "Panjshir",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1651,
   "Continent": "Africa",
   "Country": "Gabon",
   "ProvName": "Ogooué-Lolo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Gabon. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_86_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1652,
   "Continent": "Africa",
   "Country": "Uganda",
   "ProvName": "Central",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "35-40%",
   "Nummeric_1": 40,
   "DataSource": "Uganda. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_230_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1653,
   "Continent": "Europe",
   "Country": "Moldova",
   "ProvName": "Leova",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 1654,
   "Continent": "Asia",
   "Country": "Sri Lanka",
   "ProvName": "Sabaragamuwa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1655,
   "Continent": "Asia",
   "Country": "Sri Lanka",
   "ProvName": "Southern",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1656,
   "Continent": "Asia",
   "Country": "Afghanistan",
   "ProvName": "Laghman",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1657,
   "Continent": "Asia",
   "Country": "Sri Lanka",
   "ProvName": "Uva",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1658,
   "Continent": "Africa",
   "Country": "Sri Lanka",
   "ProvName": "Western",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1659,
   "Continent": "Europe",
   "Country": "Estonia",
   "ProvName": "Järva (Paide)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "10-20%",
   "Numerical": 20,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Estonia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_77_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1660,
   "Continent": "Asia",
   "Country": "Myanmar",
   "ProvName": "Kayah",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "45-50%",
   "Nummeric_1": 50,
   "DataSource": "The 2014 Myanmar Population and Housing Census Census Report Volume 2-C. Department of Population Ministry of Labour, Immigration and Population MYANMAR. pp. 12–15.",
   "Year": 2014
  },
  {
   "OBJECTID": 1661,
   "Continent": "Asia",
   "Country": "India",
   "ProvName": "Andaman\/Nicobar Islands",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Hinduism",
   "HighRelig": "Hindus",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1662,
   "Continent": "Europe",
   "Country": "Moldova",
   "ProvName": "Causeni",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 1663,
   "Continent": "Europe",
   "Country": "Estonia",
   "ProvName": "Hiiu",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "10-20%",
   "Numerical": 20,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Estonia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_77_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1664,
   "Continent": "Europe",
   "Country": "Estonia",
   "ProvName": "Harju",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "10-20%",
   "Numerical": 20,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Estonia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_77_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1665,
   "Continent": "Europe",
   "Country": "Estonia",
   "ProvName": "Ida-Viru",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "10-20%",
   "Numerical": 20,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Estonia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_77_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1666,
   "Continent": "Europe",
   "Country": "Estonia",
   "ProvName": "Jõgeva",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "10-20%",
   "Numerical": 20,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Estonia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_77_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1667,
   "Continent": "Europe",
   "Country": "Estonia",
   "ProvName": "Lääne-Viru (Rakvere)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "10-20%",
   "Numerical": 20,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Estonia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_77_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1668,
   "Continent": "Europe",
   "Country": "Estonia",
   "ProvName": "Tartu",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "10-20%",
   "Numerical": 20,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Estonia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_77_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1669,
   "Continent": "Europe",
   "Country": "Estonia",
   "ProvName": "Lääne (Haapsalu)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "10-20%",
   "Numerical": 20,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Estonia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_77_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1670,
   "Continent": "Asia",
   "Country": "Kuwait",
   "ProvName": "Al-Asimah (Al-Kuwayt)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "Burwell, Francis G. (2008) \"The Evolution of U. S.-Turkish Relations in a Transatlantic Context\". Strategic Studies Institute.",
   "Year": 2008
  },
  {
   "OBJECTID": 1671,
   "Continent": "Asia",
   "Country": "Kuwait",
   "ProvName": "al-Farwaniyah",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "Burwell, Francis G. (2008) \"The Evolution of U. S.-Turkish Relations in a Transatlantic Context\". Strategic Studies Institute.",
   "Year": 2008
  },
  {
   "OBJECTID": 1672,
   "Continent": "Asia",
   "Country": "Cambodia",
   "ProvName": "Pailin",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1673,
   "Continent": "Asia",
   "Country": "Japan",
   "ProvName": "Shiga",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1674,
   "Continent": "Asia",
   "Country": "Cambodia",
   "ProvName": "Rotanak Kiri",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1675,
   "Continent": "Asia",
   "Country": "Kuwait",
   "ProvName": "al-Ahmadi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "Burwell, Francis G. (2008) \"The Evolution of U. S.-Turkish Relations in a Transatlantic Context\". Strategic Studies Institute.",
   "Year": 2008
  },
  {
   "OBJECTID": 1676,
   "Continent": "Asia",
   "Country": "Kuwait",
   "ProvName": "Mubarak Al-Kabir",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "Burwell, Francis G. (2008) \"The Evolution of U. S.-Turkish Relations in a Transatlantic Context\". Strategic Studies Institute.",
   "Year": 2008
  },
  {
   "OBJECTID": 1677,
   "Continent": "Africa",
   "Country": "Burkina Faso",
   "ProvName": "Zoundwéogo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mapping the Global Muslim Population. Estimate Range of Shia by Country. Pew Forum, 2010. Johnson, T. M., & Grim, B. J. (Eds.).",
   "Year": 2008
  },
  {
   "OBJECTID": 1678,
   "Continent": "Asia",
   "Country": "Kuwait",
   "ProvName": "al-Jahra'",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "Burwell, Francis G. (2008) \"The Evolution of U. S.-Turkish Relations in a Transatlantic Context\". Strategic Studies Institute.",
   "Year": 2008
  },
  {
   "OBJECTID": 1679,
   "Continent": "Asia",
   "Country": "Azerbaijan",
   "ProvName": "Ganja-Gazakh",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1680,
   "Continent": "Africa",
   "Country": "Ethiopia",
   "ProvName": "Hariai",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1681,
   "Continent": "Asia",
   "Country": "Armenia",
   "ProvName": "Tavush",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Oriental orthodox",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.armstat.am\/file\/article\/sv_03_13a_520.pdf",
   "Year": 2011
  },
  {
   "OBJECTID": 1682,
   "Continent": "Asia",
   "Country": "Armenia",
   "ProvName": "Ararat",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Oriental orthodox",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.armstat.am\/file\/article\/sv_03_13a_520.pdf",
   "Year": 2011
  },
  {
   "OBJECTID": 1683,
   "Continent": "Asia",
   "Country": "Armenia",
   "ProvName": "Gegharkunik",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Oriental orthodox",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.armstat.am\/file\/article\/sv_03_13a_520.pdf",
   "Year": 2011
  },
  {
   "OBJECTID": 1684,
   "Continent": "Asia",
   "Country": "Armenia",
   "ProvName": "Lori",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Oriental orthodox",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.armstat.am\/file\/article\/sv_03_13a_520.pdf",
   "Year": 2011
  },
  {
   "OBJECTID": 1685,
   "Continent": "Asia",
   "Country": "Armenia",
   "ProvName": "Yerevan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Oriental orthodox",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.armstat.am\/file\/article\/sv_03_13a_520.pdf",
   "Year": 2011
  },
  {
   "OBJECTID": 1686,
   "Continent": "Asia",
   "Country": "Azerbaijan",
   "ProvName": "Yukhari Karabakh",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1687,
   "Continent": "Asia",
   "Country": "Azerbaijan",
   "ProvName": "Kalbajar-Lachin",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1688,
   "Continent": "Asia",
   "Country": "Azerbaijan",
   "ProvName": "Aran",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1689,
   "Continent": "Asia",
   "Country": "Azerbaijan",
   "ProvName": "Baku",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1690,
   "Continent": "Asia",
   "Country": "Azerbaijan",
   "ProvName": "Absheron",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1691,
   "Continent": "Asia",
   "Country": "Azerbaijan",
   "ProvName": "Dakhlik Shirvan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1692,
   "Continent": "Asia",
   "Country": "Azerbaijan",
   "ProvName": "Lankaran",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1693,
   "Continent": "Asia",
   "Country": "Indonesia",
   "ProvName": "Kepulauan Riau",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1694,
   "Continent": "Asia",
   "Country": "Bangladesh",
   "ProvName": "Barisal",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1695,
   "Continent": "Africa",
   "Country": "Burundi",
   "ProvName": "Muyinga",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Anthony Appiah; Henry Louis Gates (2010). Encyclopedia of Africa. Oxford University Press. p. 221. ISBN 978-0-19-533770-9.",
   "Year": 2010
  },
  {
   "OBJECTID": 1696,
   "Continent": "Asia",
   "Country": "Azerbaijan",
   "ProvName": "Guba-Khachmaz",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1697,
   "Continent": "Asia",
   "Country": "Azerbaijan",
   "ProvName": "Shaki-Zagatala",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1698,
   "Continent": "Asia",
   "Country": "Armenia",
   "ProvName": "Syunik",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Oriental orthodox",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.armstat.am\/file\/article\/sv_03_13a_520.pdf",
   "Year": 2011
  },
  {
   "OBJECTID": 1699,
   "Continent": "Asia",
   "Country": "Armenia",
   "ProvName": "Vayots-Dzor",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Oriental orthodox",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.armstat.am\/file\/article\/sv_03_13a_520.pdf",
   "Year": 2011
  },
  {
   "OBJECTID": 1700,
   "Continent": "Oceania",
   "Country": "Wallis & Futuna Islands",
   "ProvName": "Wallis & Futuna Islands",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"The World Factbook — Central Intelligence Agency\". www.cia.gov.",
   "Year": 2019
  },
  {
   "OBJECTID": 1701,
   "Continent": "Asia",
   "Country": "Afghanistan",
   "ProvName": "Badghis",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1702,
   "Continent": "Asia",
   "Country": "Afghanistan",
   "ProvName": "Herat",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1703,
   "Continent": "Asia",
   "Country": "Afghanistan",
   "ProvName": "Khost",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1704,
   "Continent": "Europe",
   "Country": "Bulgaria",
   "ProvName": "Shumen",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Special Eurobarometer 493, European Union: European Commission, September 2019, pages 229-230",
   "Year": 2019
  },
  {
   "OBJECTID": 1705,
   "Continent": "Asia",
   "Country": "Afghanistan",
   "ProvName": "Bamian",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1706,
   "Continent": "Europe",
   "Country": "Bulgaria",
   "ProvName": "Dobrich",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Special Eurobarometer 493, European Union: European Commission, September 2019, pages 229-230",
   "Year": 2019
  },
  {
   "OBJECTID": 1707,
   "Continent": "Asia",
   "Country": "Afghanistan",
   "ProvName": "Balkh",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1708,
   "Continent": "Africa",
   "Country": "Malawi",
   "ProvName": "Dedza",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "55-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Malawi. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_138_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1709,
   "Continent": "Asia",
   "Country": "Afghanistan",
   "ProvName": "Faryab",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1710,
   "Continent": "Europe",
   "Country": "Andorra",
   "ProvName": "La Massana",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"PEW Research Center: Christian Population as Percentages of Total Population by Country 2010\".",
   "Year": 2010
  },
  {
   "OBJECTID": 1711,
   "Continent": "Europe",
   "Country": "Andorra",
   "ProvName": "Andorra la Vella",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"PEW Research Center: Christian Population as Percentages of Total Population by Country 2010\".",
   "Year": 2010
  },
  {
   "OBJECTID": 1712,
   "Continent": "Asia",
   "Country": "Afghanistan",
   "ProvName": "Jowzjan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1713,
   "Continent": "Asia",
   "Country": "Afghanistan",
   "ProvName": "Ghowr",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1714,
   "Continent": "Asia",
   "Country": "Cambodia",
   "ProvName": "Svay Rieng",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1715,
   "Continent": "Europe",
   "Country": "Andorra",
   "ProvName": "Sant Juli? de Lòria",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"PEW Research Center: Christian Population as Percentages of Total Population by Country 2010\".",
   "Year": 2010
  },
  {
   "OBJECTID": 1716,
   "Continent": "Asia",
   "Country": "Afghanistan",
   "ProvName": "Sar-e-Pol",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1717,
   "Continent": "Asia",
   "Country": "Afghanistan",
   "ProvName": "Farah",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1718,
   "Continent": "Asia",
   "Country": "Afghanistan",
   "ProvName": "Helmand",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1719,
   "Continent": "Europe",
   "Country": "Andorra",
   "ProvName": "Les Escaldes-Engordany",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"PEW Research Center: Christian Population as Percentages of Total Population by Country 2010\".",
   "Year": 2010
  },
  {
   "OBJECTID": 1720,
   "Continent": "Europe",
   "Country": "Bosnia-Herzegovina",
   "ProvName": "Serb Republic",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Section 4. Population by ethnicity and religion\". Census of Population, Households, and Dwellings. Institute of Statistics (Report). Republika Srpska. 2013.",
   "Year": 2013
  },
  {
   "OBJECTID": 1721,
   "Continent": "Asia",
   "Country": "Afghanistan",
   "ProvName": "Nimruz",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1722,
   "Continent": "Asia",
   "Country": "Afghanistan",
   "ProvName": "Konduz",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1723,
   "Continent": "Asia",
   "Country": "Afghanistan",
   "ProvName": "Oruzgan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1724,
   "Continent": "Europe",
   "Country": "Andorra",
   "ProvName": "Encamp",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"PEW Research Center: Christian Population as Percentages of Total Population by Country 2010\".",
   "Year": 2010
  },
  {
   "OBJECTID": 1725,
   "Continent": "Asia",
   "Country": "Afghanistan",
   "ProvName": "Daikondi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1726,
   "Continent": "North America",
   "Country": "Antigua & Barbuda",
   "ProvName": "Antigua",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.indexmundi.com\/antigua_and_barbuda\/religions.html",
   "Year": 2019
  },
  {
   "OBJECTID": 1727,
   "Continent": "South America",
   "Country": "Argentina",
   "ProvName": "Buenos Aires",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"PEW Research Center: Religion in Latin America 2014\".",
   "Year": 2014
  },
  {
   "OBJECTID": 1728,
   "Continent": "Asia",
   "Country": "Afghanistan",
   "ProvName": "Kandahar",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1729,
   "Continent": "Asia",
   "Country": "Afghanistan",
   "ProvName": "Zabol",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1730,
   "Continent": "Asia",
   "Country": "Afghanistan",
   "ProvName": "Ghazni",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1731,
   "Continent": "North America",
   "Country": "Anguilla",
   "ProvName": "Anguilla",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "90-100%",
   "Numerical": 95,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1732,
   "Continent": "Asia",
   "Country": "Afghanistan",
   "ProvName": "Paktika",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1733,
   "Continent": "Asia",
   "Country": "Afghanistan",
   "ProvName": "Badakhshan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1734,
   "Continent": "Asia",
   "Country": "Afghanistan",
   "ProvName": "Nangarhar",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1735,
   "Continent": "Asia",
   "Country": "Afghanistan",
   "ProvName": "Nurestan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1736,
   "Continent": "Asia",
   "Country": "Afghanistan",
   "ProvName": "Konar",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1737,
   "Continent": "Oceania",
   "Country": "American Samoa",
   "ProvName": "American Samoa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2015\/04\/02\/religious-projection-table\/2020\/percent\/all\/",
   "Year": 2010
  },
  {
   "OBJECTID": 1738,
   "Continent": "Asia",
   "Country": "Afghanistan",
   "ProvName": "Takhar",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1739,
   "Continent": "Asia",
   "Country": "Afghanistan",
   "ProvName": "Kapisa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1740,
   "Continent": "North America",
   "Country": "Antigua & Barbuda",
   "ProvName": "Barbuda",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.indexmundi.com\/antigua_and_barbuda\/religions.html",
   "Year": 2019
  },
  {
   "OBJECTID": 1741,
   "Continent": "Asia",
   "Country": "Afghanistan",
   "ProvName": "Baghlan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1742,
   "Continent": "Asia",
   "Country": "Afghanistan",
   "ProvName": "Kabul",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1743,
   "Continent": "Asia",
   "Country": "Afghanistan",
   "ProvName": "Lowgar",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1744,
   "Continent": "Asia",
   "Country": "Afghanistan",
   "ProvName": "Parvan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1745,
   "Continent": "Asia",
   "Country": "Cambodia",
   "ProvName": "Takaev",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1746,
   "Continent": "Asia",
   "Country": "Afghanistan",
   "ProvName": "Samangan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1747,
   "Continent": "Asia",
   "Country": "Cambodia",
   "ProvName": "Bat Dambang",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1748,
   "Continent": "Asia",
   "Country": "Afghanistan",
   "ProvName": "Vardak",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1749,
   "Continent": "Asia",
   "Country": "Cambodia",
   "ProvName": "Banteay Mean Chey",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1750,
   "Continent": "Asia",
   "Country": "Cambodia",
   "ProvName": "Kaoh Kong",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1751,
   "Continent": "Asia",
   "Country": "Cambodia",
   "ProvName": "Pousat",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1752,
   "Continent": "Asia",
   "Country": "Cambodia",
   "ProvName": "Siem Reab",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1753,
   "Continent": "Asia",
   "Country": "Bangladesh",
   "ProvName": "Dhaka",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1754,
   "Continent": "Asia",
   "Country": "Japan",
   "ProvName": "Osaka",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1755,
   "Continent": "Asia",
   "Country": "Japan",
   "ProvName": "Wakayama",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1756,
   "Continent": "Asia",
   "Country": "Japan",
   "ProvName": "Chiba",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1757,
   "Continent": "Asia",
   "Country": "Japan",
   "ProvName": "Ibaraki",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1758,
   "Continent": "Asia",
   "Country": "Japan",
   "ProvName": "Kanagawa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1759,
   "Continent": "Asia",
   "Country": "Japan",
   "ProvName": "Saitama",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1760,
   "Continent": "Asia",
   "Country": "Japan",
   "ProvName": "Tochigi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1761,
   "Continent": "Africa",
   "Country": "Rwanda",
   "ProvName": "Kigali city",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "40-45%",
   "Nummeric_1": 45,
   "DataSource": "Rwanda. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_187_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1762,
   "Continent": "Asia",
   "Country": "Japan",
   "ProvName": "Tokyo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1763,
   "Continent": "Asia",
   "Country": "Japan",
   "ProvName": "Yamanashi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1764,
   "Continent": "Asia",
   "Country": "Japan",
   "ProvName": "Akita",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1765,
   "Continent": "Asia",
   "Country": "Japan",
   "ProvName": "Fukushima",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1766,
   "Continent": "Asia",
   "Country": "Japan",
   "ProvName": "Aomori",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1767,
   "Continent": "Asia",
   "Country": "Japan",
   "ProvName": "Yamagata",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1768,
   "Continent": "Africa",
   "Country": "Congo DR",
   "ProvName": "Bandundu",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Congo, Democratic Republic of the. Association of Religion Data Archives. (2015)  http:\/\/www.thearda.com\/internationalData\/countries\/Country_57_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1769,
   "Continent": "Africa",
   "Country": "Congo DR",
   "ProvName": "Kasai Occidental",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Congo, Democratic Republic of the. Association of Religion Data Archives. (2015)  http:\/\/www.thearda.com\/internationalData\/countries\/Country_57_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1770,
   "Continent": "Asia",
   "Country": "Japan",
   "ProvName": "Iwate",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1771,
   "Continent": "Africa",
   "Country": "Malawi",
   "ProvName": "Mchinji",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "Malawi. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_138_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1772,
   "Continent": "Asia",
   "Country": "Japan",
   "ProvName": "Miyagi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1773,
   "Continent": "Africa",
   "Country": "Malawi",
   "ProvName": "Chitipa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "65-70%",
   "Numerical": 71,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "Malawi. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_138_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1774,
   "Continent": "Asia",
   "Country": "Japan",
   "ProvName": "Niigata",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1775,
   "Continent": "Asia",
   "Country": "Bhutan",
   "ProvName": "Bumthang",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Tibetan Buddhism)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1776,
   "Continent": "Africa",
   "Country": "Angola",
   "ProvName": "Lunda Norte",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Angola\". Association of Religion Data Archives. 2015.",
   "Year": 2015
  },
  {
   "OBJECTID": 1777,
   "Continent": "Africa",
   "Country": "Angola",
   "ProvName": "Lunda Sul",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Angola\". Association of Religion Data Archives. 2015.",
   "Year": 2015
  },
  {
   "OBJECTID": 1778,
   "Continent": "Africa",
   "Country": "Angola",
   "ProvName": "Malanje",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Angola\". Association of Religion Data Archives. 2015.",
   "Year": 2015
  },
  {
   "OBJECTID": 1779,
   "Continent": "Africa",
   "Country": "Somalia",
   "ProvName": "Jubbada Hoose",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1780,
   "Continent": "Africa",
   "Country": "Angola",
   "ProvName": "Bengo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Angola\". Association of Religion Data Archives. 2015.",
   "Year": 2015
  },
  {
   "OBJECTID": 1781,
   "Continent": "North America",
   "Country": "Dominican Republic",
   "ProvName": "Peravia",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 1782,
   "Continent": "Africa",
   "Country": "Malawi",
   "ProvName": "Ntcheu",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "Malawi. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_138_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1783,
   "Continent": "Africa",
   "Country": "Angola",
   "ProvName": "Kuanza Norte",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Angola\". Association of Religion Data Archives. 2015.",
   "Year": 2015
  },
  {
   "OBJECTID": 1784,
   "Continent": "Africa",
   "Country": "Congo DR",
   "ProvName": "Kinshasa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Congo, Democratic Republic of the. Association of Religion Data Archives. (2015)  http:\/\/www.thearda.com\/internationalData\/countries\/Country_57_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1785,
   "Continent": "Africa",
   "Country": "Angola",
   "ProvName": "Kuanza Sul",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Angola\". Association of Religion Data Archives. 2015.",
   "Year": 2015
  },
  {
   "OBJECTID": 1786,
   "Continent": "Asia",
   "Country": "Bangladesh",
   "ProvName": "Chittagong Hill Tracts",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1787,
   "Continent": "Asia",
   "Country": "India",
   "ProvName": "Assam",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Hinduism",
   "HighRelig": "Hindus",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1788,
   "Continent": "Asia",
   "Country": "India",
   "ProvName": "Manipur",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Hinduism",
   "HighRelig": "Hindus",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "40-45%",
   "Nummeric_1": 45,
   "DataSource": "\"Population by religion community - 2011\". Census of India, 2011. The Registrar General & Census Commissioner, India",
   "Year": 2011
  },
  {
   "OBJECTID": 1789,
   "Continent": "Africa",
   "Country": "Angola",
   "ProvName": "Cabinda",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Angola\". Association of Religion Data Archives. 2015.",
   "Year": 2015
  },
  {
   "OBJECTID": 1790,
   "Continent": "Africa",
   "Country": "Angola",
   "ProvName": "Bié",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Angola\". Association of Religion Data Archives. 2015.",
   "Year": 2015
  },
  {
   "OBJECTID": 1791,
   "Continent": "Asia",
   "Country": "India",
   "ProvName": "Nagaland",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Nagaland Population 2011 Census. http:\/\/www.census2011.co.in\/census\/state\/nagaland.html",
   "Year": 2011
  },
  {
   "OBJECTID": 1792,
   "Continent": "Africa",
   "Country": "Malawi",
   "ProvName": "Ntchisi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "Malawi. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_138_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1793,
   "Continent": "Africa",
   "Country": "Angola",
   "ProvName": "Luanda",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Angola\". Association of Religion Data Archives. 2015.",
   "Year": 2015
  },
  {
   "OBJECTID": 1794,
   "Continent": "Africa",
   "Country": "Malawi",
   "ProvName": "Salima",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "20-25%",
   "Nummeric_1": 25,
   "DataSource": "Malawi. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_138_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1795,
   "Continent": "Africa",
   "Country": "Malawi",
   "ProvName": "Balaka",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "20-25%",
   "Nummeric_1": 25,
   "DataSource": "Malawi. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_138_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1796,
   "Continent": "Africa",
   "Country": "Angola",
   "ProvName": "Uíge",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Angola\". Association of Religion Data Archives. 2015.",
   "Year": 2015
  },
  {
   "OBJECTID": 1797,
   "Continent": "Africa",
   "Country": "Angola",
   "ProvName": "Zaire",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Angola\". Association of Religion Data Archives. 2015.",
   "Year": 2015
  },
  {
   "OBJECTID": 1798,
   "Continent": "Africa",
   "Country": "Angola",
   "ProvName": "Huambo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Angola\". Association of Religion Data Archives. 2015.",
   "Year": 2015
  },
  {
   "OBJECTID": 1799,
   "Continent": "Africa",
   "Country": "Congo DR",
   "ProvName": "Bas-Congo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Congo, Democratic Republic of the. Association of Religion Data Archives. (2015)  http:\/\/www.thearda.com\/internationalData\/countries\/Country_57_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1800,
   "Continent": "Africa",
   "Country": "Gambia",
   "ProvName": "North Bank",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1801,
   "Continent": "Africa",
   "Country": "Angola",
   "ProvName": "Benguela",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Angola\". Association of Religion Data Archives. 2015.",
   "Year": 2015
  },
  {
   "OBJECTID": 1802,
   "Continent": "Africa",
   "Country": "Angola",
   "ProvName": "Kuando Kubango",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Angola\". Association of Religion Data Archives. 2015.",
   "Year": 2015
  },
  {
   "OBJECTID": 1803,
   "Continent": "Africa",
   "Country": "Angola",
   "ProvName": "Cunene",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Angola\". Association of Religion Data Archives. 2015.",
   "Year": 2015
  },
  {
   "OBJECTID": 1804,
   "Continent": "Africa",
   "Country": "Angola",
   "ProvName": "Huíla",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Angola\". Association of Religion Data Archives. 2015.",
   "Year": 2015
  },
  {
   "OBJECTID": 1805,
   "Continent": "Africa",
   "Country": "Angola",
   "ProvName": "Moxico",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Angola\". Association of Religion Data Archives. 2015.",
   "Year": 2015
  },
  {
   "OBJECTID": 1806,
   "Continent": "Africa",
   "Country": "Malawi",
   "ProvName": "Rumphi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "Malawi. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_138_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1807,
   "Continent": "Africa",
   "Country": "Angola",
   "ProvName": "Namibe",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Angola\". Association of Religion Data Archives. 2015.",
   "Year": 2015
  },
  {
   "OBJECTID": 1808,
   "Continent": "Asia",
   "Country": "Oman",
   "ProvName": "al-Buraymi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Ibadi)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1809,
   "Continent": "Africa",
   "Country": "Congo DR",
   "ProvName": "Sud-Kivu",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Congo, Democratic Republic of the. Association of Religion Data Archives. (2015)  http:\/\/www.thearda.com\/internationalData\/countries\/Country_57_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1810,
   "Continent": "Africa",
   "Country": "Congo DR",
   "ProvName": "Maniema",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Congo, Democratic Republic of the. Association of Religion Data Archives. (2015)  http:\/\/www.thearda.com\/internationalData\/countries\/Country_57_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1811,
   "Continent": "Africa",
   "Country": "Congo DR",
   "ProvName": "Kasai Oriental",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Congo, Democratic Republic of the. Association of Religion Data Archives. (2015)  http:\/\/www.thearda.com\/internationalData\/countries\/Country_57_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1812,
   "Continent": "Africa",
   "Country": "Congo DR",
   "ProvName": "Katanga",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Congo, Democratic Republic of the. Association of Religion Data Archives. (2015)  http:\/\/www.thearda.com\/internationalData\/countries\/Country_57_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1813,
   "Continent": "Africa",
   "Country": "Congo DR",
   "ProvName": "Nord-Kivu",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Congo, Democratic Republic of the. Association of Religion Data Archives. (2015)  http:\/\/www.thearda.com\/internationalData\/countries\/Country_57_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1814,
   "Continent": "Africa",
   "Country": "Malawi",
   "ProvName": "Kasungu",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "Malawi. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_138_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1815,
   "Continent": "Africa",
   "Country": "Malawi",
   "ProvName": "Machinga",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1816,
   "Continent": "Africa",
   "Country": "Mozambique",
   "ProvName": "Sofala",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1817,
   "Continent": "Africa",
   "Country": "Mozambique",
   "ProvName": "Zambézia",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-25%",
   "Nummeric_1": 25,
   "DataSource": "Mozambique. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_156_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1818,
   "Continent": "Africa",
   "Country": "Malawi",
   "ProvName": "Chikwawa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "55-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Malawi. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_138_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1819,
   "Continent": "Africa",
   "Country": "Malawi",
   "ProvName": "Mzimba",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "Malawi. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_138_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1820,
   "Continent": "Africa",
   "Country": "Malawi",
   "ProvName": "Nkhotakota",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "20-25%",
   "Nummeric_1": 25,
   "DataSource": "Malawi. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_138_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1821,
   "Continent": "Africa",
   "Country": "Malawi",
   "ProvName": "Dowa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "Malawi. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_138_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1822,
   "Continent": "Africa",
   "Country": "Malawi",
   "ProvName": "Lilongwe",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "Malawi. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_138_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1823,
   "Continent": "Africa",
   "Country": "Malawi",
   "ProvName": "Mangochi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1824,
   "Continent": "North America",
   "Country": "Dominican Republic",
   "ProvName": "San Jose de Ocoa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 1825,
   "Continent": "Asia",
   "Country": "Iran",
   "ProvName": "Esfahan (Isfahan)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1826,
   "Continent": "Africa",
   "Country": "Malawi",
   "ProvName": "Chiradzulu",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "55-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Malawi. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_138_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1827,
   "Continent": "Africa",
   "Country": "Malawi",
   "ProvName": "Thyolo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "15-20%",
   "Nummeric_1": 20,
   "DataSource": "Malawi. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_138_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1828,
   "Continent": "Africa",
   "Country": "Malawi",
   "ProvName": "Nsanje",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "20-25%",
   "Nummeric_1": 25,
   "DataSource": "Malawi. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_138_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1829,
   "Continent": "Africa",
   "Country": "Malawi",
   "ProvName": "Zomba",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "55-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Malawi. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_138_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1830,
   "Continent": "Africa",
   "Country": "Malawi",
   "ProvName": "Mulanje",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "15-20%",
   "Nummeric_1": 20,
   "DataSource": "Malawi. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_138_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1831,
   "Continent": "Africa",
   "Country": "Malawi",
   "ProvName": "Phalombe",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "Malawi. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_138_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1832,
   "Continent": "Africa",
   "Country": "Mozambique",
   "ProvName": "Inhambane",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "Mozambique. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_156_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1833,
   "Continent": "Africa",
   "Country": "South Africa",
   "ProvName": "Eastern Cape",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "South Africa - Community Survey 2016. https:\/\/www.datafirst.uct.ac.za\/dataportal\/index.php\/catalog\/611",
   "Year": 2016
  },
  {
   "OBJECTID": 1834,
   "Continent": "North America",
   "Country": "Guatemala",
   "ProvName": "Huehuetenango",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "Guatemala. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_98_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1835,
   "Continent": "Asia",
   "Country": "Indonesia",
   "ProvName": "Jambi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1836,
   "Continent": "Asia",
   "Country": "Indonesia",
   "ProvName": "Kalimantan Tengah",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1837,
   "Continent": "Oceania",
   "Country": "Australia",
   "ProvName": "New South Wales",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "30-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "2016 Census of Population and General Community (Sheet G14) Australian Bureau of Statistics",
   "Year": 2016
  },
  {
   "OBJECTID": 1838,
   "Continent": "Oceania",
   "Country": "Indonesia",
   "ProvName": "Papua Barat",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Sunni)",
   "SReligCatp": "35-40%",
   "Nummeric_1": 40,
   "DataSource": "Population by Region and Religion in Indonesia. BPS. 2010. https:\/\/sp2010.bps.go.id\/index.php\/site\/tabel?tid=321&wid=0",
   "Year": 2010
  },
  {
   "OBJECTID": 1839,
   "Continent": "North America",
   "Country": "Guatemala",
   "ProvName": "Retalhuleu",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "Guatemala. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_98_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1840,
   "Continent": "Oceania",
   "Country": "Solomon Islands",
   "ProvName": "Temotu",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Solomon Islands. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_204_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1841,
   "Continent": "South America",
   "Country": "Bolivia",
   "ProvName": "La Paz",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Religion affiliation in Bolivia as of 2018. Based on Latinobarómetro. Survey period: June 15 to August 2, 2018",
   "Year": 2018
  },
  {
   "OBJECTID": 1842,
   "Continent": "South America",
   "Country": "Bolivia",
   "ProvName": "Oruro",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Religion affiliation in Bolivia as of 2018. Based on Latinobarómetro. Survey period: June 15 to August 2, 2018",
   "Year": 2018
  },
  {
   "OBJECTID": 1843,
   "Continent": "North America",
   "Country": "Guatemala",
   "ProvName": "Baja Verapaz",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "Guatemala. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_98_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1844,
   "Continent": "North America",
   "Country": "Guatemala",
   "ProvName": "Petén",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "Guatemala. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_98_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1845,
   "Continent": "North America",
   "Country": "Guatemala",
   "ProvName": "Quetzaltenango",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "Guatemala. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_98_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1846,
   "Continent": "North America",
   "Country": "Guatemala",
   "ProvName": "San Marcos",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "Guatemala. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_98_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1847,
   "Continent": "North America",
   "Country": "Guatemala",
   "ProvName": "Escuintla",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "Guatemala. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_98_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1848,
   "Continent": "Africa",
   "Country": "Benin",
   "ProvName": "Collines",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "20-30%",
   "Numerical": 30,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "https:\/\/www.cia.gov\/library\/publications\/the-world-factbook\/geos\/bn.html",
   "Year": 2013
  },
  {
   "OBJECTID": 1849,
   "Continent": "North America",
   "Country": "Guatemala",
   "ProvName": "Alta Verapaz",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "Guatemala. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_98_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1850,
   "Continent": "North America",
   "Country": "Guatemala",
   "ProvName": "Chimaltenango",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "Guatemala. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_98_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1851,
   "Continent": "North America",
   "Country": "Guatemala",
   "ProvName": "Guatemala",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "Guatemala. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_98_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1852,
   "Continent": "North America",
   "Country": "Guatemala",
   "ProvName": "Suchitepéquez",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "Guatemala. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_98_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1853,
   "Continent": "North America",
   "Country": "Guatemala",
   "ProvName": "Sacatepéquez",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "Guatemala. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_98_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1854,
   "Continent": "Europe",
   "Country": "United Kingdom",
   "ProvName": "Eastern Scotland",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "United Kingdom. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_233_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1855,
   "Continent": "Africa",
   "Country": "Benin",
   "ProvName": "Atlantique",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "30-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "https:\/\/www.cia.gov\/library\/publications\/the-world-factbook\/geos\/bn.html",
   "Year": 2013
  },
  {
   "OBJECTID": 1856,
   "Continent": "Europe",
   "Country": "United Kingdom",
   "ProvName": "Northumberland and Tyne and Wear",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "United Kingdom. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_233_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1857,
   "Continent": "Europe",
   "Country": "United Kingdom",
   "ProvName": "Tees Valley and Durham",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "United Kingdom. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_233_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1858,
   "Continent": "Africa",
   "Country": "Benin",
   "ProvName": "Littoral",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "30-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "https:\/\/www.cia.gov\/library\/publications\/the-world-factbook\/geos\/bn.html",
   "Year": 2013
  },
  {
   "OBJECTID": 1859,
   "Continent": "Europe",
   "Country": "United Kingdom",
   "ProvName": "Hampshire and Isle of Wight",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "United Kingdom. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_233_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1860,
   "Continent": "Asia",
   "Country": "Iran",
   "ProvName": "Fars",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1861,
   "Continent": "North America",
   "Country": "Guatemala",
   "ProvName": "El Progreso",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "Guatemala. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_98_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1862,
   "Continent": "North America",
   "Country": "Guatemala",
   "ProvName": "Sololá",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "Guatemala. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_98_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1863,
   "Continent": "North America",
   "Country": "Guatemala",
   "ProvName": "Totonicapán",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "Guatemala. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_98_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1864,
   "Continent": "North America",
   "Country": "Guatemala",
   "ProvName": "Santa Rosa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "Guatemala. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_98_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1865,
   "Continent": "North America",
   "Country": "Panama",
   "ProvName": "Bocas del Toro",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Panama. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_174_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1866,
   "Continent": "North America",
   "Country": "Guatemala",
   "ProvName": "Izabal",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "Guatemala. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_98_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1867,
   "Continent": "North America",
   "Country": "Guatemala",
   "ProvName": "Chiquimula",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "Guatemala. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_98_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1868,
   "Continent": "North America",
   "Country": "Guatemala",
   "ProvName": "Jalapa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "Guatemala. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_98_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1869,
   "Continent": "North America",
   "Country": "Guatemala",
   "ProvName": "Jutiapa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "Guatemala. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_98_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1870,
   "Continent": "North America",
   "Country": "Guatemala",
   "ProvName": "Zacapa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "Guatemala. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_98_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1871,
   "Continent": "Asia",
   "Country": "Myanmar",
   "ProvName": "Kachin",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "The 2014 Myanmar Population and Housing Census Census Report Volume 2-C. Department of Population Ministry of Labour, Immigration and Population MYANMAR. pp. 12–15.",
   "Year": 2014
  },
  {
   "OBJECTID": 1872,
   "Continent": "North America",
   "Country": "Dominican Republic",
   "ProvName": "Puerto Plata",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 1873,
   "Continent": "North America",
   "Country": "Dominican Republic",
   "ProvName": "Dajabón",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 1874,
   "Continent": "Asia",
   "Country": "India",
   "ProvName": "Arunachal Pradesh",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "30-35%",
   "Numerical": 35,
   "Ethnic2": null,
   "SecRelig0": "Hinduism",
   "SecRelig": "Hindus",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Population by religious community - 2011 Office of the Registrar General & Census Commissioner. https:\/\/web.archive.org\/web\/20150825155850\/http:\/\/www.censusindia.gov.in\/2011census\/C-01\/DDW00C-01%20MDDS.XLS",
   "Year": 2011
  },
  {
   "OBJECTID": 1875,
   "Continent": "North America",
   "Country": "Dominican Republic",
   "ProvName": "Espaillat",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 1876,
   "Continent": "North America",
   "Country": "Dominican Republic",
   "ProvName": "Hermanas Mirabal",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 1877,
   "Continent": "North America",
   "Country": "Dominican Republic",
   "ProvName": "Baoruco",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 1878,
   "Continent": "North America",
   "Country": "Dominican Republic",
   "ProvName": "Barahona",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 1879,
   "Continent": "Asia",
   "Country": "India",
   "ProvName": "Mizoram",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Population by religion community – 2011\". Census of India, 2011. The Registrar General & Census Commissioner, India. ",
   "Year": 2011
  },
  {
   "OBJECTID": 1880,
   "Continent": "North America",
   "Country": "Dominican Republic",
   "ProvName": "Monte Cristi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 1881,
   "Continent": "Asia",
   "Country": "India",
   "ProvName": "Tripura",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Hinduism",
   "HighRelig": "Hindus",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1882,
   "Continent": "Asia",
   "Country": "Myanmar",
   "ProvName": "Sagaing",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-95%",
   "Numerical": 95,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "The 2014 Myanmar Population and Housing Census Census Report Volume 2-C. Department of Population Ministry of Labour, Immigration and Population MYANMAR. pp. 12–15.",
   "Year": 2014
  },
  {
   "OBJECTID": 1883,
   "Continent": "Asia",
   "Country": "Cyprus",
   "ProvName": "Limassol",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 1884,
   "Continent": "Asia",
   "Country": "North Korea",
   "ProvName": "Hwanghae North",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "No Data",
   "HighRelig": "No Data",
   "ReligCatP": null,
   "Numerical": 0,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": null,
   "Year": null
  },
  {
   "OBJECTID": 1885,
   "Continent": "Asia",
   "Country": "North Korea",
   "ProvName": "Pyongyang City",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "No Data",
   "HighRelig": "No Data",
   "ReligCatP": null,
   "Numerical": 0,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": null,
   "Year": null
  },
  {
   "OBJECTID": 1886,
   "Continent": "Asia",
   "Country": "North Korea",
   "ProvName": "Phyongan South (P'yongan)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "No Data",
   "HighRelig": "No Data",
   "ReligCatP": null,
   "Numerical": 0,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": null,
   "Year": null
  },
  {
   "OBJECTID": 1887,
   "Continent": "Europe",
   "Country": "United Kingdom",
   "ProvName": "North Eastern Scotland",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "United Kingdom. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_233_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1888,
   "Continent": "Europe",
   "Country": "United Kingdom",
   "ProvName": "Highlands and Islands",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "United Kingdom. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_233_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1889,
   "Continent": "Asia",
   "Country": "North Korea",
   "ProvName": "Kangwon",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "No Data",
   "HighRelig": "No Data",
   "ReligCatP": null,
   "Numerical": 0,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": null,
   "Year": null
  },
  {
   "OBJECTID": 1890,
   "Continent": "North America",
   "Country": "Dominican Republic",
   "ProvName": "Duarte",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 1891,
   "Continent": "North America",
   "Country": "Dominican Republic",
   "ProvName": "Hato Mayor",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 1892,
   "Continent": "North America",
   "Country": "Dominican Republic",
   "ProvName": "Monte Plata",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 1893,
   "Continent": "Europe",
   "Country": "United Kingdom",
   "ProvName": "Berkshire, Buckinghamshire and Oxfordshire",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "United Kingdom. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_233_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1894,
   "Continent": "Europe",
   "Country": "United Kingdom",
   "ProvName": "Gloucestershire, Wiltshire and Bristol\/Bat",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "United Kingdom. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_233_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1895,
   "Continent": "Europe",
   "Country": "United Kingdom",
   "ProvName": "Bedfordshire and Hertfordshire",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "United Kingdom. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_233_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1896,
   "Continent": "Europe",
   "Country": "United Kingdom",
   "ProvName": "Dorset and Somerset",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "United Kingdom. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_233_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1897,
   "Continent": "Africa",
   "Country": "Benin",
   "ProvName": "Couffo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1898,
   "Continent": "Europe",
   "Country": "United Kingdom",
   "ProvName": "Devon",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "United Kingdom. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_233_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1899,
   "Continent": "Europe",
   "Country": "United Kingdom",
   "ProvName": "Leicestershire, Rutland and Northamptonshi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "United Kingdom. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_233_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1900,
   "Continent": "Africa",
   "Country": "Benin",
   "ProvName": "Ouémé",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "30-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "https:\/\/www.cia.gov\/library\/publications\/the-world-factbook\/geos\/bn.html",
   "Year": 2013
  },
  {
   "OBJECTID": 1901,
   "Continent": "Europe",
   "Country": "United Kingdom",
   "ProvName": "East Yorkshire and Northern Lincolnshire",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "United Kingdom. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_233_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1902,
   "Continent": "Europe",
   "Country": "United Kingdom",
   "ProvName": "Derbyshire and Nottinghamshire",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "United Kingdom. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_233_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1903,
   "Continent": "North America",
   "Country": "Panama",
   "ProvName": "Kuna de Madungandi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Panama. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_174_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1904,
   "Continent": "North America",
   "Country": "Panama",
   "ProvName": "Panamá",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "15-20%",
   "Nummeric_1": 20,
   "DataSource": "Panama. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_174_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1905,
   "Continent": "Europe",
   "Country": "United Kingdom",
   "ProvName": "Outer London",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "30-35%",
   "Numerical": 35,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "United Kingdom. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_233_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1906,
   "Continent": "Africa",
   "Country": "Algeria",
   "ProvName": "Laghouat",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1907,
   "Continent": "Europe",
   "Country": "United Kingdom",
   "ProvName": "Inner London",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "30-35%",
   "Numerical": 35,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "United Kingdom. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_233_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1908,
   "Continent": "Europe",
   "Country": "United Kingdom",
   "ProvName": "Lincolnshire",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "United Kingdom. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_233_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1909,
   "Continent": "Europe",
   "Country": "United Kingdom",
   "ProvName": "Northern Ireland",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "30-35%",
   "Numerical": 35,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "United Kingdom. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_233_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1910,
   "Continent": "Europe",
   "Country": "United Kingdom",
   "ProvName": "West Wales and The Valleys",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "United Kingdom. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_233_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1911,
   "Continent": "North America",
   "Country": "Panama",
   "ProvName": "Darién",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Panama. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_174_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1912,
   "Continent": "Europe",
   "Country": "United Kingdom",
   "ProvName": "Cheshire",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "United Kingdom. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_233_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1913,
   "Continent": "Europe",
   "Country": "United Kingdom",
   "ProvName": "Cornwall and Isles of Scilly",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "United Kingdom. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_233_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1914,
   "Continent": "Europe",
   "Country": "United Kingdom",
   "ProvName": "East Wales",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "United Kingdom. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_233_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1915,
   "Continent": "North America",
   "Country": "Panama",
   "ProvName": "Kuna de Wargandi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Panama. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_174_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1916,
   "Continent": "Europe",
   "Country": "United Kingdom",
   "ProvName": "North Yorkshire",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "United Kingdom. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_233_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1917,
   "Continent": "Africa",
   "Country": "Algeria",
   "ProvName": "Oran",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1918,
   "Continent": "Europe",
   "Country": "United Kingdom",
   "ProvName": "Shropshire and Staffordshire",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "United Kingdom. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_233_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1919,
   "Continent": "Europe",
   "Country": "United Kingdom",
   "ProvName": "Lancashire",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "United Kingdom. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_233_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1920,
   "Continent": "Europe",
   "Country": "United Kingdom",
   "ProvName": "Cumbria",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "United Kingdom. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_233_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1921,
   "Continent": "Africa",
   "Country": "Algeria",
   "ProvName": "Adrar",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1922,
   "Continent": "Africa",
   "Country": "Algeria",
   "ProvName": "Sidi bel-Abbès",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1923,
   "Continent": "Africa",
   "Country": "Algeria",
   "ProvName": "Tlemcen",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1924,
   "Continent": "Africa",
   "Country": "Algeria",
   "ProvName": "Béchar",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1925,
   "Continent": "Africa",
   "Country": "Algeria",
   "ProvName": "Naâma",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1926,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Igdir",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1927,
   "Continent": "Asia",
   "Country": "North Korea",
   "ProvName": "Jagang (Chagang)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "No Data",
   "HighRelig": "No Data",
   "ReligCatP": null,
   "Numerical": 0,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": null,
   "Year": null
  },
  {
   "OBJECTID": 1928,
   "Continent": "Africa",
   "Country": "Gambia",
   "ProvName": "Central River",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1929,
   "Continent": "Africa",
   "Country": "Gambia",
   "ProvName": "Upper River",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1930,
   "Continent": "Africa",
   "Country": "Ghana",
   "ProvName": "Northern",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1931,
   "Continent": "Africa",
   "Country": "Algeria",
   "ProvName": "Skikda",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1932,
   "Continent": "Asia",
   "Country": "Russia",
   "ProvName": "Tomsk",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "30-35%",
   "Numerical": 35,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 1933,
   "Continent": "Africa",
   "Country": "Algeria",
   "ProvName": "Tindouf",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1934,
   "Continent": "Africa",
   "Country": "Ghana",
   "ProvName": "Upper East",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1935,
   "Continent": "Africa",
   "Country": "Algeria",
   "ProvName": "Annaba",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1936,
   "Continent": "Africa",
   "Country": "Ghana",
   "ProvName": "Upper West",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "10-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1937,
   "Continent": "Africa",
   "Country": "Ghana",
   "ProvName": "Ashanti",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "10-20%",
   "Nummeric_1": 20,
   "DataSource": "Ghana. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_91_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1938,
   "Continent": "Africa",
   "Country": "Ghana",
   "ProvName": "Brong-Ahafo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "10-20%",
   "Nummeric_1": 20,
   "DataSource": "Ghana. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_91_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1939,
   "Continent": "Africa",
   "Country": "Algeria",
   "ProvName": "Ouargla",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1940,
   "Continent": "Africa",
   "Country": "Algeria",
   "ProvName": "et-Tarf",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1941,
   "Continent": "Africa",
   "Country": "Ghana",
   "ProvName": "Central",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "10-20%",
   "Nummeric_1": 20,
   "DataSource": "Ghana. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_91_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1942,
   "Continent": "Africa",
   "Country": "Tanzania",
   "ProvName": "Kilimanjaro",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "35-40%",
   "Nummeric_1": 40,
   "DataSource": "Tanzania. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_219_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1943,
   "Continent": "Africa",
   "Country": "Ghana",
   "ProvName": "Eastern",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "10-20%",
   "Nummeric_1": 20,
   "DataSource": "Ghana. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_91_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1944,
   "Continent": "Africa",
   "Country": "Algeria",
   "ProvName": "Jijel",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1945,
   "Continent": "Africa",
   "Country": "Ghana",
   "ProvName": "Western",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "10-20%",
   "Nummeric_1": 20,
   "DataSource": "Ghana. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_91_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1946,
   "Continent": "Africa",
   "Country": "Gabon",
   "ProvName": "Estuaire",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Gabon. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_86_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1947,
   "Continent": "Europe",
   "Country": "Bulgaria",
   "ProvName": "Varna",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Special Eurobarometer 493, European Union: European Commission, September 2019, pages 229-230",
   "Year": 2019
  },
  {
   "OBJECTID": 1948,
   "Continent": "Asia",
   "Country": "Russia",
   "ProvName": "Primor'ye",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "25-30%",
   "Numerical": 30,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 1949,
   "Continent": "Africa",
   "Country": "Benin",
   "ProvName": "Borgou",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1950,
   "Continent": "Africa",
   "Country": "Benin",
   "ProvName": "Alibori",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1951,
   "Continent": "Asia",
   "Country": "Russia",
   "ProvName": "Chukot",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "50-55%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Russian Federal State Statistics Service (2011). http:\/\/www.gks.ru\/free_doc\/new_site\/perepis2010\/croc\/perepis_itogi1612.htm",
   "Year": 2012
  },
  {
   "OBJECTID": 1952,
   "Continent": "Asia",
   "Country": "Russia",
   "ProvName": "Yevrey",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "20-25%",
   "Numerical": 25,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 1953,
   "Continent": "Asia",
   "Country": "Russia",
   "ProvName": "Khabarovsk",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "25-30%",
   "Numerical": 30,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 1954,
   "Continent": "Asia",
   "Country": "Russia",
   "ProvName": "Magadan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "30-35%",
   "Numerical": 35,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 1955,
   "Continent": "Asia",
   "Country": "Russia",
   "ProvName": "Sakhalin",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "20-25%",
   "Numerical": 25,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 1956,
   "Continent": "Africa",
   "Country": "Ghana",
   "ProvName": "Greater Accra",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "10-20%",
   "Nummeric_1": 20,
   "DataSource": "Ghana. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_91_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1957,
   "Continent": "Africa",
   "Country": "Burkina Faso",
   "ProvName": "Ioba",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mapping the Global Muslim Population. Estimate Range of Shia by Country. Pew Forum, 2010. Johnson, T. M., & Grim, B. J. (Eds.).",
   "Year": 2008
  },
  {
   "OBJECTID": 1958,
   "Continent": "Africa",
   "Country": "Ghana",
   "ProvName": "Volta",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "10-20%",
   "Nummeric_1": 20,
   "DataSource": "Ghana. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_91_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1959,
   "Continent": "Europe",
   "Country": "Netherlands",
   "ProvName": "Utrecht",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "20-25%",
   "Numerical": 25,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Netherlands. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_160_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1960,
   "Continent": "Europe",
   "Country": "Netherlands",
   "ProvName": "Zuid-Holland",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "15-20%",
   "Numerical": 20,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Netherlands. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_160_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1961,
   "Continent": "Africa",
   "Country": "Benin",
   "ProvName": "Zou",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "20-30%",
   "Numerical": 30,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "https:\/\/www.cia.gov\/library\/publications\/the-world-factbook\/geos\/bn.html",
   "Year": 2013
  },
  {
   "OBJECTID": 1962,
   "Continent": "Africa",
   "Country": "Benin",
   "ProvName": "Atacora",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1963,
   "Continent": "Africa",
   "Country": "Benin",
   "ProvName": "Donga",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1964,
   "Continent": "Africa",
   "Country": "Burkina Faso",
   "ProvName": "Kompienga",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mapping the Global Muslim Population. Estimate Range of Shia by Country. Pew Forum, 2010. Johnson, T. M., & Grim, B. J. (Eds.).",
   "Year": 2008
  },
  {
   "OBJECTID": 1965,
   "Continent": "Africa",
   "Country": "Burkina Faso",
   "ProvName": "Gourma",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mapping the Global Muslim Population. Estimate Range of Shia by Country. Pew Forum, 2010. Johnson, T. M., & Grim, B. J. (Eds.).",
   "Year": 2008
  },
  {
   "OBJECTID": 1966,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Kars",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1967,
   "Continent": "Africa",
   "Country": "Congo",
   "ProvName": "Cuvette-Ouest",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "\"Congo, Republic of the\". Association of Religion Data Archives. 2015 http:\/\/www.thearda.com\/internationalData\/countries\/Country_57_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1968,
   "Continent": "Africa",
   "Country": "Algeria",
   "ProvName": "el-Bayadh",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1969,
   "Continent": "Africa",
   "Country": "Gabon",
   "ProvName": "Ogooué-Ivindo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Gabon. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_86_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1970,
   "Continent": "Africa",
   "Country": "Algeria",
   "ProvName": "el-Oued",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1971,
   "Continent": "Africa",
   "Country": "Algeria",
   "ProvName": "Alger",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1972,
   "Continent": "Africa",
   "Country": "Gabon",
   "ProvName": "Woleu-Ntem",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Gabon. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_86_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1973,
   "Continent": "Africa",
   "Country": "Algeria",
   "ProvName": "Boumerdes",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1974,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Ardahan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1975,
   "Continent": "Africa",
   "Country": "Algeria",
   "ProvName": "Illizi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1976,
   "Continent": "Africa",
   "Country": "Algeria",
   "ProvName": "Tamanrasset",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1977,
   "Continent": "Asia",
   "Country": "Turkmenistan",
   "ProvName": "Ashgabat (Ashkhabad)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1978,
   "Continent": "Europe",
   "Country": "Ukraine",
   "ProvName": "Kherson",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 1979,
   "Continent": "Africa",
   "Country": "Algeria",
   "ProvName": "Aïn Defla",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1980,
   "Continent": "Africa",
   "Country": "Algeria",
   "ProvName": "ech-Chleff",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1981,
   "Continent": "Africa",
   "Country": "Algeria",
   "ProvName": "Relizane",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1982,
   "Continent": "Africa",
   "Country": "Algeria",
   "ProvName": "Mascara",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1983,
   "Continent": "Africa",
   "Country": "Algeria",
   "ProvName": "Mostaganem",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1984,
   "Continent": "Africa",
   "Country": "Algeria",
   "ProvName": "Tissemsilt",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1985,
   "Continent": "Africa",
   "Country": "Algeria",
   "ProvName": "Saïda",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1986,
   "Continent": "Africa",
   "Country": "Algeria",
   "ProvName": "Tiaret",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1987,
   "Continent": "Africa",
   "Country": "Algeria",
   "ProvName": "Bordj Bou Arreridj",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1988,
   "Continent": "Africa",
   "Country": "Algeria",
   "ProvName": "Bejaïa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1989,
   "Continent": "Europe",
   "Country": "Bulgaria",
   "ProvName": "Pazardzhik",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Special Eurobarometer 493, European Union: European Commission, September 2019, pages 229-230",
   "Year": 2019
  },
  {
   "OBJECTID": 1990,
   "Continent": "Africa",
   "Country": "Algeria",
   "ProvName": "Blida",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1991,
   "Continent": "Africa",
   "Country": "Algeria",
   "ProvName": "Bouira",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1992,
   "Continent": "Africa",
   "Country": "Algeria",
   "ProvName": "Guelma",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1993,
   "Continent": "Africa",
   "Country": "Algeria",
   "ProvName": "Biskra",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1994,
   "Continent": "Africa",
   "Country": "Algeria",
   "ProvName": "Khenchela",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1995,
   "Continent": "Africa",
   "Country": "Algeria",
   "ProvName": "Djelfa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1996,
   "Continent": "Africa",
   "Country": "Algeria",
   "ProvName": "Médéa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1997,
   "Continent": "Africa",
   "Country": "Algeria",
   "ProvName": "M' Sila",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1998,
   "Continent": "Africa",
   "Country": "Algeria",
   "ProvName": "Mila",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 1999,
   "Continent": "Africa",
   "Country": "Algeria",
   "ProvName": "Sétif",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2000,
   "Continent": "Africa",
   "Country": "Algeria",
   "ProvName": "Oum el-Bouaghi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2001,
   "Continent": "Africa",
   "Country": "Algeria",
   "ProvName": "Batna",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2002,
   "Continent": "Africa",
   "Country": "Somalia",
   "ProvName": "Gedo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2003,
   "Continent": "Africa",
   "Country": "Algeria",
   "ProvName": "Constantine",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2004,
   "Continent": "Africa",
   "Country": "Algeria",
   "ProvName": "Souk Ahras",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2005,
   "Continent": "Africa",
   "Country": "Algeria",
   "ProvName": "Tébessa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2006,
   "Continent": "Europe",
   "Country": "Bosnia-Herzegovina",
   "ProvName": "Federation of Bosnia and Herzegovina",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Non-denominational)",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Sunni)",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "\"Chapter 1: Religious Affiliation\". The World’s Muslims: Unity and Diversity. Pew Research Center's Religion & Public Life Project. August 9, 2012.",
   "Year": 2012
  },
  {
   "OBJECTID": 2007,
   "Continent": "Europe",
   "Country": "Bulgaria",
   "ProvName": "Sliven",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Special Eurobarometer 493, European Union: European Commission, September 2019, pages 229-230",
   "Year": 2019
  },
  {
   "OBJECTID": 2008,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Aydin",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2009,
   "Continent": "Europe",
   "Country": "Bulgaria",
   "ProvName": "Haskovo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Special Eurobarometer 493, European Union: European Commission, September 2019, pages 229-230",
   "Year": 2019
  },
  {
   "OBJECTID": 2010,
   "Continent": "Europe",
   "Country": "Bulgaria",
   "ProvName": "Stara Zagora",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Special Eurobarometer 493, European Union: European Commission, September 2019, pages 229-230",
   "Year": 2019
  },
  {
   "OBJECTID": 2011,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Izmir",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2012,
   "Continent": "Europe",
   "Country": "Bulgaria",
   "ProvName": "Plovdiv",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Special Eurobarometer 493, European Union: European Commission, September 2019, pages 229-230",
   "Year": 2019
  },
  {
   "OBJECTID": 2013,
   "Continent": "Europe",
   "Country": "Bulgaria",
   "ProvName": "Smoljan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Special Eurobarometer 493, European Union: European Commission, September 2019, pages 229-230",
   "Year": 2019
  },
  {
   "OBJECTID": 2014,
   "Continent": "Europe",
   "Country": "Bulgaria",
   "ProvName": "Kurdzhali",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2015,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Balikesir",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2016,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Kirklareli",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2017,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Canakkale",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2018,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Edirne",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2019,
   "Continent": "Europe",
   "Country": "Bulgaria",
   "ProvName": "Sofiya",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Special Eurobarometer 493, European Union: European Commission, September 2019, pages 229-230",
   "Year": 2019
  },
  {
   "OBJECTID": 2020,
   "Continent": "Europe",
   "Country": "Austria",
   "ProvName": "Kärnten",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Austrian Catholic Church data 2017. https:\/\/www.katholisch.at\/aktuelles\/2018\/01\/09\/statistik-2017-wieder-leichter-rueckgang-bei-kirchenaustritten",
   "Year": 2017
  },
  {
   "OBJECTID": 2021,
   "Continent": "Europe",
   "Country": "Bulgaria",
   "ProvName": "Veliko Tarnovo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Special Eurobarometer 493, European Union: European Commission, September 2019, pages 229-230",
   "Year": 2019
  },
  {
   "OBJECTID": 2022,
   "Continent": "Europe",
   "Country": "Austria",
   "ProvName": "Oberösterreich",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Austrian Catholic Church data 2017. https:\/\/www.katholisch.at\/aktuelles\/2018\/01\/09\/statistik-2017-wieder-leichter-rueckgang-bei-kirchenaustritten",
   "Year": 2017
  },
  {
   "OBJECTID": 2023,
   "Continent": "Europe",
   "Country": "Austria",
   "ProvName": "Salzburg",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Austrian Catholic Church data 2017. https:\/\/www.katholisch.at\/aktuelles\/2018\/01\/09\/statistik-2017-wieder-leichter-rueckgang-bei-kirchenaustritten",
   "Year": 2017
  },
  {
   "OBJECTID": 2024,
   "Continent": "Europe",
   "Country": "Bulgaria",
   "ProvName": "Kjustendil",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Special Eurobarometer 493, European Union: European Commission, September 2019, pages 229-230",
   "Year": 2019
  },
  {
   "OBJECTID": 2025,
   "Continent": "Europe",
   "Country": "Austria",
   "ProvName": "Tirol",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Austrian Catholic Church data 2017. https:\/\/www.katholisch.at\/aktuelles\/2018\/01\/09\/statistik-2017-wieder-leichter-rueckgang-bei-kirchenaustritten",
   "Year": 2017
  },
  {
   "OBJECTID": 2026,
   "Continent": "Europe",
   "Country": "Bulgaria",
   "ProvName": "Vidin",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Special Eurobarometer 493, European Union: European Commission, September 2019, pages 229-230",
   "Year": 2019
  },
  {
   "OBJECTID": 2027,
   "Continent": "Europe",
   "Country": "Austria",
   "ProvName": "Niederösterreich",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Austrian Catholic Church data 2017. https:\/\/www.katholisch.at\/aktuelles\/2018\/01\/09\/statistik-2017-wieder-leichter-rueckgang-bei-kirchenaustritten",
   "Year": 2017
  },
  {
   "OBJECTID": 2028,
   "Continent": "Asia",
   "Country": "Philippines",
   "ProvName": "Central Mindanao (Soccsksargen)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Philippines. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_178_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2029,
   "Continent": "Asia",
   "Country": "Philippines",
   "ProvName": "Eastern Visayas",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Philippines. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_178_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2030,
   "Continent": "Europe",
   "Country": "Bulgaria",
   "ProvName": "Turgovishte",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Special Eurobarometer 493, European Union: European Commission, September 2019, pages 229-230",
   "Year": 2019
  },
  {
   "OBJECTID": 2031,
   "Continent": "Asia",
   "Country": "Philippines",
   "ProvName": "Caraga",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Philippines. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_178_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2032,
   "Continent": "Europe",
   "Country": "Bulgaria",
   "ProvName": "Burgas",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Special Eurobarometer 493, European Union: European Commission, September 2019, pages 229-230",
   "Year": 2019
  },
  {
   "OBJECTID": 2033,
   "Continent": "Europe",
   "Country": "Bulgaria",
   "ProvName": "Jambol",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Special Eurobarometer 493, European Union: European Commission, September 2019, pages 229-230",
   "Year": 2019
  },
  {
   "OBJECTID": 2034,
   "Continent": "Europe",
   "Country": "Bulgaria",
   "ProvName": "Razgrad",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2035,
   "Continent": "Asia",
   "Country": "Philippines",
   "ProvName": "Southern Mindanao (Davao)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Philippines. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_178_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2036,
   "Continent": "Asia",
   "Country": "Russia",
   "ProvName": "Krasnoyarsk",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "30-35%",
   "Numerical": 35,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 2037,
   "Continent": "Asia",
   "Country": "Russia",
   "ProvName": "Irkutsk",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "25-30%",
   "Numerical": 30,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 2038,
   "Continent": "Asia",
   "Country": "Russia",
   "ProvName": "Tuva",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Tibetan Buddhism)",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "5-10%",
   "Nummeric_1": 10,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 2039,
   "Continent": "Asia",
   "Country": "Russia",
   "ProvName": "Buryat",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "25-30%",
   "Numerical": 30,
   "Ethnic2": null,
   "SecRelig0": "Buddhism",
   "SecRelig": "Buddhists(Tibetan Buddhism)",
   "SReligCatp": "20-25%",
   "Nummeric_1": 25,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 2040,
   "Continent": "Asia",
   "Country": "Russia",
   "ProvName": "Zabaykal'ye",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "20-25%",
   "Numerical": 25,
   "Ethnic2": null,
   "SecRelig0": "Buddhism",
   "SecRelig": "Buddhists(Tibetan Buddhism)",
   "SReligCatp": "5-10%",
   "Nummeric_1": 10,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 2041,
   "Continent": "Asia",
   "Country": "Russia",
   "ProvName": "Amur",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "25-30%",
   "Numerical": 30,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 2042,
   "Continent": "Oceania",
   "Country": "Fiji",
   "ProvName": "Central",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "<= 10%",
   "Nummeric_1": 10,
   "DataSource": "Fiji. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_81_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2043,
   "Continent": "Africa",
   "Country": "Fiji",
   "ProvName": "Eastern",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Hinduism",
   "HighRelig": "Hindus",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2044,
   "Continent": "Europe",
   "Country": "Bulgaria",
   "ProvName": "Silistra",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Special Eurobarometer 493, European Union: European Commission, September 2019, pages 229-230",
   "Year": 2019
  },
  {
   "OBJECTID": 2045,
   "Continent": "Oceania",
   "Country": "Micronesia",
   "ProvName": "Chuuk (Truk)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "55-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "Micronesia. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationaldata\/regions\/profiles\/Region_9_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2046,
   "Continent": "Europe",
   "Country": "Bulgaria",
   "ProvName": "Ruse",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Special Eurobarometer 493, European Union: European Commission, September 2019, pages 229-230",
   "Year": 2019
  },
  {
   "OBJECTID": 2047,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Bilecik",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2048,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Sakarya",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2049,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Eskisehir",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2050,
   "Continent": "Africa",
   "Country": "Fiji",
   "ProvName": "Northern",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "<= 10%",
   "Nummeric_1": 10,
   "DataSource": "Fiji. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_81_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2051,
   "Continent": "Oceania",
   "Country": "Micronesia",
   "ProvName": "Pohnpei",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "55-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "Micronesia. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationaldata\/regions\/profiles\/Region_9_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2052,
   "Continent": "Africa",
   "Country": "Fiji",
   "ProvName": "Western",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "<= 10%",
   "Nummeric_1": 10,
   "DataSource": "Fiji. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_81_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2053,
   "Continent": "Oceania",
   "Country": "Micronesia",
   "ProvName": "Yap",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "55-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "Micronesia. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationaldata\/regions\/profiles\/Region_9_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2054,
   "Continent": "Europe",
   "Country": "San Marino",
   "ProvName": "Domagnano",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2055,
   "Continent": "Africa",
   "Country": "Gabon",
   "ProvName": "Moyen-Ogooué",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Gabon. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_86_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2056,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Kastamonu",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2057,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Manisa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2058,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Antalya",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2059,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Afyon",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2060,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Burdur",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2061,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Mugla",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2062,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Denizli",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2063,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Isparta",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2064,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Kütahya",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2065,
   "Continent": "Europe",
   "Country": "Russia",
   "ProvName": "Adygey",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Sunni)",
   "SReligCatp": "10-15%",
   "Nummeric_1": 15,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 2066,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Adiyaman",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2067,
   "Continent": "North America",
   "Country": "Saint Lucia",
   "ProvName": "Gros Islet",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Saint Lucia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_190_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2068,
   "Continent": "Africa",
   "Country": "Gabon",
   "ProvName": "Ngounié",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Gabon. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_86_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2069,
   "Continent": "Africa",
   "Country": "Gabon",
   "ProvName": "Nyanga",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Gabon. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_86_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2070,
   "Continent": "Europe",
   "Country": "Russia",
   "ProvName": "Karachay-Cherkess",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Eastern orthodox",
   "SReligCatp": "10-15%",
   "Nummeric_1": 15,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 2071,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Giresun",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2072,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Elazig",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2073,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "K.Maras",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2074,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Malatya",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2075,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Ordu",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2076,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Mersin (was: Içel)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2077,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Kirsehir",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2078,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Kayseri",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2079,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Nevsehir",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2080,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Hatay",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2081,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Amasya",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2082,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Corum",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2083,
   "Continent": "Asia",
   "Country": "South Korea",
   "ProvName": "Jeju",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Buddhism",
   "SecRelig": "Buddhists(Mahayana)",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "South Korea. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_124_1.asp. https:\/\/en.wikipedia.org\/wiki\/Jeju_Province",
   "Year": 2015
  },
  {
   "OBJECTID": 2084,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Sinop",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2085,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Sivas",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2086,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Samsun",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2087,
   "Continent": "Europe",
   "Country": "Russia",
   "ProvName": "Pskov",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 2088,
   "Continent": "Africa",
   "Country": "Rwanda",
   "ProvName": "Southern",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "Rwanda. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_187_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2089,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Tokat",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2090,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Artvin",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2091,
   "Continent": "North America",
   "Country": "Saint Lucia",
   "ProvName": "Castries",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Saint Lucia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_190_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2092,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Erzurum",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2093,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Erzincan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2094,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Rize",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2095,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Trabzon",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2096,
   "Continent": "North America",
   "Country": "Saint Lucia",
   "ProvName": "Anse-la-Raye",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Saint Lucia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_190_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2097,
   "Continent": "Europe",
   "Country": "Russia",
   "ProvName": "Ingush",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "95-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 2098,
   "Continent": "Europe",
   "Country": "Russia",
   "ProvName": "Kabardin-Balkar",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "70-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Eastern orthodox",
   "SReligCatp": "10-15%",
   "Nummeric_1": 15,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 2099,
   "Continent": "North America",
   "Country": "Saint Lucia",
   "ProvName": "Canaries",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Saint Lucia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_190_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2100,
   "Continent": "Europe",
   "Country": "Russia",
   "ProvName": "North Ossetia",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 2101,
   "Continent": "Europe",
   "Country": "Russia",
   "ProvName": "Stavropol'",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "70-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Ukrainian National Census (2001). https:\/\/en.wikipedia.org\/wiki\/Ukrainian_Census_(2001)",
   "Year": 2012
  },
  {
   "OBJECTID": 2102,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Agri",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2103,
   "Continent": "Europe",
   "Country": "Austria",
   "ProvName": "Wien (Vienna)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Austrian Catholic Church data 2017. https:\/\/www.katholisch.at\/aktuelles\/2018\/01\/09\/statistik-2017-wieder-leichter-rueckgang-bei-kirchenaustritten",
   "Year": 2017
  },
  {
   "OBJECTID": 2104,
   "Continent": "Europe",
   "Country": "Russia",
   "ProvName": "Murmansk",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 2105,
   "Continent": "Europe",
   "Country": "Russia",
   "ProvName": "Novgorod",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 2106,
   "Continent": "Asia",
   "Country": "Philippines",
   "ProvName": "Central Visayas",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Philippines. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_178_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2107,
   "Continent": "Europe",
   "Country": "Estonia",
   "ProvName": "Rapla",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "10-20%",
   "Numerical": 20,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Estonia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_77_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2108,
   "Continent": "Asia",
   "Country": "Philippines",
   "ProvName": "Western Mindanao (Zamboanga)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Philippines. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_178_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2109,
   "Continent": "Oceania",
   "Country": "Samoa",
   "ProvName": "Savaii",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Samoa. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_193_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2110,
   "Continent": "Europe",
   "Country": "Estonia",
   "ProvName": "Pärnu",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "10-20%",
   "Numerical": 20,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Estonia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_77_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2111,
   "Continent": "Europe",
   "Country": "Estonia",
   "ProvName": "Põlva",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "10-20%",
   "Numerical": 20,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Estonia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_77_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2112,
   "Continent": "Europe",
   "Country": "Russia",
   "ProvName": "Moskva",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "55-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 2113,
   "Continent": "Europe",
   "Country": "Russia",
   "ProvName": "Orel",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 2114,
   "Continent": "Europe",
   "Country": "Russia",
   "ProvName": "Rostov",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 2115,
   "Continent": "Europe",
   "Country": "Russia",
   "ProvName": "Tula",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 2116,
   "Continent": "Europe",
   "Country": "Russia",
   "ProvName": "Volgograd",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "55-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 2117,
   "Continent": "Europe",
   "Country": "Russia",
   "ProvName": "Belgorod",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 2118,
   "Continent": "Europe",
   "Country": "Russia",
   "ProvName": "Krasnodar",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 2119,
   "Continent": "Europe",
   "Country": "Russia",
   "ProvName": "Mordovia",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "70-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 2120,
   "Continent": "Europe",
   "Country": "Estonia",
   "ProvName": "Valga",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "10-20%",
   "Numerical": 20,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Estonia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_77_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2121,
   "Continent": "Europe",
   "Country": "Estonia",
   "ProvName": "Viljandi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "10-20%",
   "Numerical": 20,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Estonia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_77_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2122,
   "Continent": "Europe",
   "Country": "Russia",
   "ProvName": "Penza",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "5-10%",
   "Nummeric_1": 10,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 2123,
   "Continent": "Europe",
   "Country": "Russia",
   "ProvName": "Ryazan'",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 2124,
   "Continent": "Europe",
   "Country": "Russia",
   "ProvName": "Tambov",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 2125,
   "Continent": "Europe",
   "Country": "Russia",
   "ProvName": "Vladimir",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 2126,
   "Continent": "Europe",
   "Country": "Russia",
   "ProvName": "Voronezh",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 2127,
   "Continent": "Europe",
   "Country": "Russia",
   "ProvName": "Bashkortostan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "55-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Eastern orthodox",
   "SReligCatp": "15-20%",
   "Nummeric_1": 20,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 2128,
   "Continent": "Asia",
   "Country": "Russia",
   "ProvName": "Chelyabinsk",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "30-35%",
   "Numerical": 35,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 2129,
   "Continent": "Asia",
   "Country": "Russia",
   "ProvName": "Kurgan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "30-35%",
   "Numerical": 35,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 2130,
   "Continent": "Europe",
   "Country": "Russia",
   "ProvName": "Nenets",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "15-20%",
   "Nummeric_1": 20,
   "DataSource": "Russian Federal State Statistics Service (2011). http:\/\/www.gks.ru\/free_doc\/new_site\/perepis2010\/croc\/perepis_itogi1612.htm",
   "Year": 2012
  },
  {
   "OBJECTID": 2131,
   "Continent": "Asia",
   "Country": "Russia",
   "ProvName": "Yamal-Nenets",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Sunni)",
   "SReligCatp": "15-20%",
   "Nummeric_1": 20,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 2132,
   "Continent": "Europe",
   "Country": "Russia",
   "ProvName": "Komi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "30-35%",
   "Numerical": 35,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 2133,
   "Continent": "Europe",
   "Country": "Russia",
   "ProvName": "Kirov",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 2134,
   "Continent": "Europe",
   "Country": "Russia",
   "ProvName": "Mariy-El",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 2135,
   "Continent": "Europe",
   "Country": "Russia",
   "ProvName": "Tatarstan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "30-35%",
   "Numerical": 35,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Eastern orthodox",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 2136,
   "Continent": "Europe",
   "Country": "Russia",
   "ProvName": "Ul'yanovsk",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Sunni)",
   "SReligCatp": "5-10%",
   "Nummeric_1": 10,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 2137,
   "Continent": "Asia",
   "Country": "Russia",
   "ProvName": "Khanty-Mansiy",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Sunni)",
   "SReligCatp": "10-15%",
   "Nummeric_1": 15,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 2138,
   "Continent": "Asia",
   "Country": "Russia",
   "ProvName": "Omsk",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 2139,
   "Continent": "Asia",
   "Country": "Russia",
   "ProvName": "Tyumen'",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "30-35%",
   "Numerical": 35,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 2140,
   "Continent": "Asia",
   "Country": "Russia",
   "ProvName": "Altay",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "25-30%",
   "Numerical": 30,
   "Ethnic2": null,
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "10-15%",
   "Nummeric_1": 15,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 2141,
   "Continent": "Asia",
   "Country": "Russia",
   "ProvName": "Gorno-Altay",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 2142,
   "Continent": "Asia",
   "Country": "Russia",
   "ProvName": "Kemerovo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "30-35%",
   "Numerical": 35,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 2143,
   "Continent": "Asia",
   "Country": "Russia",
   "ProvName": "Khakass",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "30-35%",
   "Numerical": 35,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 2144,
   "Continent": "Asia",
   "Country": "Russia",
   "ProvName": "Novosibirsk",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "25-30%",
   "Numerical": 30,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 2145,
   "Continent": "Europe",
   "Country": "Estonia",
   "ProvName": "Võru",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "10-20%",
   "Numerical": 20,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Estonia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_77_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2146,
   "Continent": "Europe",
   "Country": "Estonia",
   "ProvName": "Saare (Kingissepa)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "10-20%",
   "Numerical": 20,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Estonia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_77_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2147,
   "Continent": "Europe",
   "Country": "Russia",
   "ProvName": "Karelia",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "25-30%",
   "Numerical": 30,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 2148,
   "Continent": "Europe",
   "Country": "Russia",
   "ProvName": "Arkhangel'sk",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "30-35%",
   "Numerical": 35,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 2149,
   "Continent": "Africa",
   "Country": "Rwanda",
   "ProvName": "Western",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "Rwanda. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_187_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2150,
   "Continent": "Asia",
   "Country": "Oman",
   "ProvName": "Al-Wusta",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Ibadi)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2151,
   "Continent": "Asia",
   "Country": "Azerbaijan",
   "ProvName": "Nakhchivan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2152,
   "Continent": "Asia",
   "Country": "Oman",
   "ProvName": "ash-Sharqiyah",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Ibadi)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2153,
   "Continent": "Africa",
   "Country": "Somalia",
   "ProvName": "Banaadir",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2154,
   "Continent": "Africa",
   "Country": "Somalia",
   "ProvName": "Galguduud",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2155,
   "Continent": "Africa",
   "Country": "Somalia",
   "ProvName": "Hiiraan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2156,
   "Continent": "Africa",
   "Country": "Somalia",
   "ProvName": "Shabeellaha Dhexe",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2157,
   "Continent": "Asia",
   "Country": "Oman",
   "ProvName": "al-Batinah",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Ibadi)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2158,
   "Continent": "Asia",
   "Country": "Oman",
   "ProvName": "Zufar (Dhofar)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Ibadi)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2159,
   "Continent": "Africa",
   "Country": "Somalia",
   "ProvName": "Mudug",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2160,
   "Continent": "Africa",
   "Country": "Somalia",
   "ProvName": "Nugaal",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2161,
   "Continent": "Asia",
   "Country": "India",
   "ProvName": "Delhi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Hinduism",
   "HighRelig": "Hindus",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2162,
   "Continent": "Asia",
   "Country": "India",
   "ProvName": "Himachal Pradesh",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Hinduism",
   "HighRelig": "Hindus",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2163,
   "Continent": "Asia",
   "Country": "India",
   "ProvName": "Haryana",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Hinduism",
   "HighRelig": "Hindus",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2164,
   "Continent": "Asia",
   "Country": "India*",
   "ProvName": "Jammu and Kashmir",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": "Hinduism",
   "SecRelig": "Hinduism",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "\"Population by religion community – 2011\". Census of India, 2011. The Registrar General & Census Commissioner, India.",
   "Year": 2011
  },
  {
   "OBJECTID": 2165,
   "Continent": "Asia",
   "Country": "Bangladesh",
   "ProvName": "Khulna",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2166,
   "Continent": "North America",
   "Country": "Saint Lucia",
   "ProvName": "Soufrière",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Saint Lucia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_190_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2167,
   "Continent": "Europe",
   "Country": "Russia",
   "ProvName": "Chechnya",
   "NAME_1": null,
   "Ethnic1": "Chechen",
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-95%",
   "Numerical": 95,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 2168,
   "Continent": "Europe",
   "Country": "Russia",
   "ProvName": "Dagestan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "95-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 2169,
   "Continent": "North America",
   "Country": "Saint Lucia",
   "ProvName": "Choiseul",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Saint Lucia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_190_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2170,
   "Continent": "North America",
   "Country": "Saint Lucia",
   "ProvName": "Laborie",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Saint Lucia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_190_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2171,
   "Continent": "North America",
   "Country": "Saint Lucia",
   "ProvName": "Vieux Fort",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Saint Lucia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_190_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2172,
   "Continent": "Asia",
   "Country": "Oman",
   "ProvName": "Musandam",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Ibadi)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2173,
   "Continent": "Asia",
   "Country": "Bhutan",
   "ProvName": "Chhukha",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Tibetan Buddhism)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2174,
   "Continent": "Asia",
   "Country": "Bhutan",
   "ProvName": "Dagana",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Tibetan Buddhism)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2175,
   "Continent": "Asia",
   "Country": "Philippines",
   "ProvName": "Northern Mindanao",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Philippines. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_178_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2176,
   "Continent": "Asia",
   "Country": "Oman",
   "ProvName": "Masqat",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Ibadi)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2177,
   "Continent": "Asia",
   "Country": "India",
   "ProvName": "Chandigarh",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Hinduism",
   "HighRelig": "Hindus",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2178,
   "Continent": "Asia",
   "Country": "Bhutan",
   "ProvName": "Ha",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Tibetan Buddhism)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2179,
   "Continent": "Asia",
   "Country": "Philippines",
   "ProvName": "Bicol",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Philippines. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_178_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2180,
   "Continent": "Asia",
   "Country": "Bhutan",
   "ProvName": "Paro",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Tibetan Buddhism)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2181,
   "Continent": "Asia",
   "Country": "Bhutan",
   "ProvName": "Gasa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Tibetan Buddhism)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2182,
   "Continent": "North America",
   "Country": "Saint Lucia",
   "ProvName": "Micoud",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Saint Lucia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_190_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2183,
   "Continent": "North America",
   "Country": "Saint Lucia",
   "ProvName": "Dennery",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Saint Lucia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_190_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2184,
   "Continent": "North America",
   "Country": "Saint Vincent",
   "ProvName": "Saint David",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Saint Vincent. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_192_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2185,
   "Continent": "Asia",
   "Country": "Bhutan",
   "ProvName": "Samchi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Tibetan Buddhism)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2186,
   "Continent": "Asia",
   "Country": "Bhutan",
   "ProvName": "Thimphu",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Tibetan Buddhism)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2187,
   "Continent": "Asia",
   "Country": "Bhutan",
   "ProvName": "Punakha",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Tibetan Buddhism)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2188,
   "Continent": "Asia",
   "Country": "India",
   "ProvName": "Andhra Pradesh",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Hinduism",
   "HighRelig": "Hindus",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2189,
   "Continent": "Asia",
   "Country": "India",
   "ProvName": "Kerala",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Hinduism",
   "HighRelig": "Hindus",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Sunni)",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Population by religious community - 2011 Office of the Registrar General & Census Commissioner. https:\/\/web.archive.org\/web\/20150825155850\/http:\/\/www.censusindia.gov.in\/2011census\/C-01\/DDW00C-01%20MDDS.XLS",
   "Year": 2011
  },
  {
   "OBJECTID": 2190,
   "Continent": "North America",
   "Country": "Saint Vincent",
   "ProvName": "Charlotte",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Saint Vincent. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_192_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2191,
   "Continent": "North America",
   "Country": "Saint Vincent",
   "ProvName": "Saint Patrick",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Saint Vincent. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_192_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2192,
   "Continent": "North America",
   "Country": "Saint Vincent",
   "ProvName": "Saint Andrew",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Saint Vincent. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_192_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2193,
   "Continent": "North America",
   "Country": "Saint Vincent",
   "ProvName": "Saint George",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Saint Vincent. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_192_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2194,
   "Continent": "Asia",
   "Country": "India",
   "ProvName": "Lakshadweep",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2195,
   "Continent": "Asia",
   "Country": "India",
   "ProvName": "Orissa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Hinduism",
   "HighRelig": "Hindus",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2196,
   "Continent": "Asia",
   "Country": "India",
   "ProvName": "Dadra and Nagar Haveli",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Hinduism",
   "HighRelig": "Hindus",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2197,
   "Continent": "Asia",
   "Country": "India",
   "ProvName": "Karnataka",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Hinduism",
   "HighRelig": "Hindus",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2198,
   "Continent": "Asia",
   "Country": "India",
   "ProvName": "Maharashtra",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Hinduism",
   "HighRelig": "Hindus",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2199,
   "Continent": "Asia",
   "Country": "Sri Lanka",
   "ProvName": "Central",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2200,
   "Continent": "Africa",
   "Country": "Sri Lanka",
   "ProvName": "Eastern",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": "Hinduism",
   "SecRelig": "Hindus",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "\"A3 : Population by religion according to districts, 2012\". Department of Census & Statistics, Sri Lanka. http:\/\/www.statistics.gov.lk\/PopHouSat\/CPH2011\/index.php?fileName=pop43&gp=Activities&tpl=3",
   "Year": 2012
  },
  {
   "OBJECTID": 2201,
   "Continent": "North America",
   "Country": "Saint Vincent",
   "ProvName": "Grenadines",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Saint Vincent. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_192_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2202,
   "Continent": "Asia",
   "Country": "Sri Lanka",
   "ProvName": "North Central",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2203,
   "Continent": "Asia",
   "Country": "Sri Lanka",
   "ProvName": "North Western",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2204,
   "Continent": "Europe",
   "Country": "San Marino",
   "ProvName": "Serravalle\/Dogano",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2205,
   "Continent": "Europe",
   "Country": "San Marino",
   "ProvName": "Fiorentino",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2206,
   "Continent": "Europe",
   "Country": "San Marino",
   "ProvName": "Chiesanuova",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2207,
   "Continent": "Africa",
   "Country": "Sri Lanka",
   "ProvName": "Northern",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Hinduism",
   "HighRelig": "Hindus",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2208,
   "Continent": "Asia",
   "Country": "Bhutan",
   "ProvName": "Chirang",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Tibetan Buddhism)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2209,
   "Continent": "Europe",
   "Country": "San Marino",
   "ProvName": "Acquaviva",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2210,
   "Continent": "Europe",
   "Country": "San Marino",
   "ProvName": "Citt?",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2211,
   "Continent": "Europe",
   "Country": "San Marino",
   "ProvName": "Borgo Maggiore",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2212,
   "Continent": "Asia",
   "Country": "Bhutan",
   "ProvName": "Gaylegphug",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Tibetan Buddhism)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2213,
   "Continent": "Asia",
   "Country": "Bhutan",
   "ProvName": "Lhuntshi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Tibetan Buddhism)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2214,
   "Continent": "Asia",
   "Country": "Bhutan",
   "ProvName": "Tashi Yangtse",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Tibetan Buddhism)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2215,
   "Continent": "Asia",
   "Country": "Bhutan",
   "ProvName": "Shemgang",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Tibetan Buddhism)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2216,
   "Continent": "Asia",
   "Country": "Bhutan",
   "ProvName": "Tongsa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Tibetan Buddhism)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2217,
   "Continent": "Asia",
   "Country": "Bhutan",
   "ProvName": "Mongar",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Tibetan Buddhism)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2218,
   "Continent": "Asia",
   "Country": "Bhutan",
   "ProvName": "Pema Gatsel",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Tibetan Buddhism)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2219,
   "Continent": "Asia",
   "Country": "Bhutan",
   "ProvName": "Wangdi Phodrang",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Tibetan Buddhism)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2220,
   "Continent": "Asia",
   "Country": "Bhutan",
   "ProvName": "Samdrup Jongkhar",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Tibetan Buddhism)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2221,
   "Continent": "Asia",
   "Country": "Bangladesh",
   "ProvName": "Sylhet",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2222,
   "Continent": "Asia",
   "Country": "Bhutan",
   "ProvName": "Tashigang",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Tibetan Buddhism)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2223,
   "Continent": "Asia",
   "Country": "India",
   "ProvName": "Meghalaya",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Population by religion community – 2011\". Census of India, 2011. The Registrar General & Census Commissioner, India. ",
   "Year": 2011
  },
  {
   "OBJECTID": 2224,
   "Continent": "Asia",
   "Country": "South Korea",
   "ProvName": "Gyeongsangbuk-do",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Buddhism",
   "SecRelig": "Buddhists(Mahayana)",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "South Korea. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_124_1.asp. https:\/\/en.wikipedia.org\/wiki\/North_Gyeongsang_Province",
   "Year": 2015
  },
  {
   "OBJECTID": 2225,
   "Continent": "Asia",
   "Country": "Philippines",
   "ProvName": "Cagayan Valley",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Philippines. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_178_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2226,
   "Continent": "Asia",
   "Country": "South Korea",
   "ProvName": "Chungcheongbuk-do",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": "Buddhism",
   "SecRelig": "Buddhists(Mahayana)",
   "SReligCatp": "20-25%",
   "Nummeric_1": 25,
   "DataSource": "South Korea. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_124_1.asp. https:\/\/en.wikipedia.org\/wiki\/North_Chungcheong_Province",
   "Year": 2015
  },
  {
   "OBJECTID": 2227,
   "Continent": "Asia",
   "Country": "Philippines",
   "ProvName": "Cordillera",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Philippines. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_178_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2228,
   "Continent": "Asia",
   "Country": "South Korea",
   "ProvName": "Incheon",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-25%",
   "Nummeric_1": 25,
   "DataSource": "South Korea. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_124_1.asp. https:\/\/en.wikipedia.org\/wiki\/Incheon",
   "Year": 2015
  },
  {
   "OBJECTID": 2229,
   "Continent": "Asia",
   "Country": "South Korea",
   "ProvName": "Gangwon-do",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Buddhism",
   "SecRelig": "Buddhists(Mahayana)",
   "SReligCatp": "20-25%",
   "Nummeric_1": 25,
   "DataSource": "South Korea. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_124_1.asp.",
   "Year": 2015
  },
  {
   "OBJECTID": 2230,
   "Continent": "Asia",
   "Country": "South Korea",
   "ProvName": "Seoul",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Buddhism",
   "SecRelig": "Buddhists(Mahayana)",
   "SReligCatp": "20-25%",
   "Nummeric_1": 25,
   "DataSource": "South Korea. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_124_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2231,
   "Continent": "Asia",
   "Country": "South Korea",
   "ProvName": "Gyeonggi-do",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-25%",
   "Nummeric_1": 25,
   "DataSource": "South Korea. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_124_1.asp. https:\/\/en.wikipedia.org\/wiki\/Gyeonggi_Province",
   "Year": 2015
  },
  {
   "OBJECTID": 2232,
   "Continent": "Asia",
   "Country": "South Korea",
   "ProvName": "Jeollabuk-do",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "South Korea. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_124_1.asp. https:\/\/en.wikipedia.org\/wiki\/North_Jeolla_Province",
   "Year": 2015
  },
  {
   "OBJECTID": 2233,
   "Continent": "Asia",
   "Country": "South Korea",
   "ProvName": "Jeollanam-do",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-25%",
   "Nummeric_1": 25,
   "DataSource": "South Korea. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_124_1.asp. https:\/\/en.wikipedia.org\/wiki\/South_Jeolla_Province",
   "Year": 2015
  },
  {
   "OBJECTID": 2234,
   "Continent": "Asia",
   "Country": "South Korea",
   "ProvName": "Gyeongsangnam-do",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Buddhism",
   "SecRelig": "Buddhists(Mahayana)",
   "SReligCatp": "35-40%",
   "Nummeric_1": 40,
   "DataSource": "South Korea. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_124_1.asp. https:\/\/en.wikipedia.org\/wiki\/South_Gyeongsang_Province",
   "Year": 2015
  },
  {
   "OBJECTID": 2235,
   "Continent": "Asia",
   "Country": "South Korea",
   "ProvName": "Chungcheongnam-do",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": "Buddhism",
   "SecRelig": "Buddhists(Mahayana)",
   "SReligCatp": "20-25%",
   "Nummeric_1": 25,
   "DataSource": "South Korea. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_124_1.asp. https:\/\/en.wikipedia.org\/wiki\/South_Chungcheong_Province",
   "Year": 2015
  },
  {
   "OBJECTID": 2236,
   "Continent": "Asia",
   "Country": "South Korea",
   "ProvName": "Daejeon",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Buddhism",
   "SecRelig": "Buddhists(Mahayana)",
   "SReligCatp": "20-25%",
   "Nummeric_1": 25,
   "DataSource": "South Korea. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_124_1.asp. https:\/\/en.wikipedia.org\/wiki\/Daejeon",
   "Year": 2015
  },
  {
   "OBJECTID": 2237,
   "Continent": "Africa",
   "Country": "Burundi",
   "ProvName": "Cankuzo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Anthony Appiah; Henry Louis Gates (2010). Encyclopedia of Africa. Oxford University Press. p. 221. ISBN 978-0-19-533770-9.",
   "Year": 2010
  },
  {
   "OBJECTID": 2238,
   "Continent": "Africa",
   "Country": "Burundi",
   "ProvName": "Karuzi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Anthony Appiah; Henry Louis Gates (2010). Encyclopedia of Africa. Oxford University Press. p. 221. ISBN 978-0-19-533770-9.",
   "Year": 2010
  },
  {
   "OBJECTID": 2239,
   "Continent": "Asia",
   "Country": "South Korea",
   "ProvName": "Daegu",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Buddhism",
   "SecRelig": "Buddhists(Mahayana)",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "South Korea. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_124_1.asp. https:\/\/en.wikipedia.org\/wiki\/Daegu",
   "Year": 2015
  },
  {
   "OBJECTID": 2240,
   "Continent": "Asia",
   "Country": "South Korea",
   "ProvName": "Gwangju",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-25%",
   "Nummeric_1": 25,
   "DataSource": "South Korea. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_124_1.asp. https:\/\/en.wikipedia.org\/wiki\/Gwangju",
   "Year": 2015
  },
  {
   "OBJECTID": 2241,
   "Continent": "Asia",
   "Country": "South Korea",
   "ProvName": "Busan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Mahayana)",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": "East Asian Religiosity",
   "SecRelig": "East Asian Religiosity",
   "SReligCatp": "35-40%",
   "Nummeric_1": 40,
   "DataSource": "World Urbanization Prospects - United Nations population estimates and projections of major Urban Agglomerations. 2018. https:\/\/population.un.org\/wup\/",
   "Year": 2018
  },
  {
   "OBJECTID": 2242,
   "Continent": "Asia",
   "Country": "South Korea",
   "ProvName": "Ulsan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Buddhism",
   "SecRelig": "Buddhists(Mahayana)",
   "SReligCatp": "20-25%",
   "Nummeric_1": 25,
   "DataSource": "South Korea. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_124_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2243,
   "Continent": "Asia",
   "Country": "Philippines",
   "ProvName": "Ilocos",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Philippines. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_178_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2244,
   "Continent": "Africa",
   "Country": "Burundi",
   "ProvName": "Rutana",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Anthony Appiah; Henry Louis Gates (2010). Encyclopedia of Africa. Oxford University Press. p. 221. ISBN 978-0-19-533770-9.",
   "Year": 2010
  },
  {
   "OBJECTID": 2245,
   "Continent": "Asia",
   "Country": "Philippines",
   "ProvName": "Central Luzon",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Philippines. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_178_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2246,
   "Continent": "Asia",
   "Country": "Philippines",
   "ProvName": "Calabarzon",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Philippines. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_178_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2247,
   "Continent": "Africa",
   "Country": "Burundi",
   "ProvName": "Ruyigi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Anthony Appiah; Henry Louis Gates (2010). Encyclopedia of Africa. Oxford University Press. p. 221. ISBN 978-0-19-533770-9.",
   "Year": 2010
  },
  {
   "OBJECTID": 2248,
   "Continent": "Europe",
   "Country": "Netherlands",
   "ProvName": "Noord-Holland",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "15-20%",
   "Numerical": 20,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Netherlands. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_160_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2249,
   "Continent": "Europe",
   "Country": "Germany",
   "ProvName": "Brandenburg",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "25-30%",
   "Numerical": 30,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "The GESIS – Leibniz Institute for the Social Sciences (2016) \"Konfession, Bundesland – weighted (Kumulierter Datensatz)\" https:\/\/search.gesis.org\/research_data\/ZA6888",
   "Year": 2016
  },
  {
   "OBJECTID": 2250,
   "Continent": "Europe",
   "Country": "Germany",
   "ProvName": "Mecklenburg-Vorpommern",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "25-30%",
   "Numerical": 30,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "The GESIS – Leibniz Institute for the Social Sciences (2016) \"Konfession, Bundesland – weighted (Kumulierter Datensatz)\" https:\/\/search.gesis.org\/research_data\/ZA6888",
   "Year": 2016
  },
  {
   "OBJECTID": 2251,
   "Continent": "Africa",
   "Country": "Burundi",
   "ProvName": "Cibitoke",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Anthony Appiah; Henry Louis Gates (2010). Encyclopedia of Africa. Oxford University Press. p. 221. ISBN 978-0-19-533770-9.",
   "Year": 2010
  },
  {
   "OBJECTID": 2252,
   "Continent": "Africa",
   "Country": "Burundi",
   "ProvName": "Gitega",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Anthony Appiah; Henry Louis Gates (2010). Encyclopedia of Africa. Oxford University Press. p. 221. ISBN 978-0-19-533770-9.",
   "Year": 2010
  },
  {
   "OBJECTID": 2253,
   "Continent": "Africa",
   "Country": "Burundi",
   "ProvName": "Kayanza",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Anthony Appiah; Henry Louis Gates (2010). Encyclopedia of Africa. Oxford University Press. p. 221. ISBN 978-0-19-533770-9.",
   "Year": 2010
  },
  {
   "OBJECTID": 2254,
   "Continent": "Oceania",
   "Country": "Australia",
   "ProvName": "Australian Capital Territory",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "30-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "2016 Census of Population and General Community (Sheet G14) Australian Bureau of Statistics",
   "Year": 2016
  },
  {
   "OBJECTID": 2255,
   "Continent": "Oceania",
   "Country": "Australia",
   "ProvName": "South Australia",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "30-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "2016 Census of Population and General Community (Sheet G14) Australian Bureau of Statistics",
   "Year": 2016
  },
  {
   "OBJECTID": 2256,
   "Continent": "Oceania",
   "Country": "Australia",
   "ProvName": "Victoria",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "30-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "2016 Census of Population and General Community (Sheet G14) Australian Bureau of Statistics",
   "Year": 2016
  },
  {
   "OBJECTID": 2257,
   "Continent": "Oceania",
   "Country": "Australia",
   "ProvName": "Queensland",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "30-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "2016 Census of Population and General Community (Sheet G14) Australian Bureau of Statistics",
   "Year": 2016
  },
  {
   "OBJECTID": 2258,
   "Continent": "Oceania",
   "Country": "Fiji",
   "ProvName": "Rotuma",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Hinduism",
   "HighRelig": "Hindus",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2259,
   "Continent": "Oceania",
   "Country": "Australia",
   "ProvName": "Tasmania",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "30-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "2016 Census of Population and General Community (Sheet G14) Australian Bureau of Statistics",
   "Year": 2016
  },
  {
   "OBJECTID": 2260,
   "Continent": "Europe",
   "Country": "France",
   "ProvName": "Basse-Normandie",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "France. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_83_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2261,
   "Continent": "Europe",
   "Country": "France",
   "ProvName": "Bretagne (Brittany)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "France. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_83_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2262,
   "Continent": "Europe",
   "Country": "France",
   "ProvName": "Poitou-Charentes",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "France. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_83_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2263,
   "Continent": "Europe",
   "Country": "France",
   "ProvName": "Pays de la Loire",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "France. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_83_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2264,
   "Continent": "Europe",
   "Country": "France",
   "ProvName": "Acquitaine",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "France. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_83_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2265,
   "Continent": "Europe",
   "Country": "United Kingdom",
   "ProvName": "Kent",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "United Kingdom. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_233_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2266,
   "Continent": "Africa",
   "Country": "Seychelles",
   "ProvName": "Outer (Coralline) islands",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Seychelles. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_199_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2267,
   "Continent": "Europe",
   "Country": "France",
   "ProvName": "Corse (Corsica)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "France. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_83_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2268,
   "Continent": "Europe",
   "Country": "France",
   "ProvName": "Provence-Alpes-Cote-d'Azur",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "France. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_83_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2269,
   "Continent": "Europe",
   "Country": "France",
   "ProvName": "Languedoc-Roussillon",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "France. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_83_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2270,
   "Continent": "Europe",
   "Country": "France",
   "ProvName": "Midi-Pyrenees",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "France. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_83_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2271,
   "Continent": "Europe",
   "Country": "France",
   "ProvName": "Auvergne",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "France. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_83_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2272,
   "Continent": "Europe",
   "Country": "France",
   "ProvName": "Bourgogne (Burgundy)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "France. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_83_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2273,
   "Continent": "Europe",
   "Country": "France",
   "ProvName": "Centre",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "France. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_83_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2274,
   "Continent": "Africa",
   "Country": "Seychelles",
   "ProvName": "Mahé and satellites",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Seychelles. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_199_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2275,
   "Continent": "Europe",
   "Country": "France",
   "ProvName": "Haute-Normandie",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "France. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_83_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2276,
   "Continent": "Europe",
   "Country": "United Kingdom",
   "ProvName": "Surrey, East and West Sussex",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "United Kingdom. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_233_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2277,
   "Continent": "Africa",
   "Country": "Seychelles",
   "ProvName": "Silhouette",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Seychelles. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_199_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2278,
   "Continent": "Africa",
   "Country": "Seychelles",
   "ProvName": "La Digue and satellites",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Seychelles. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_199_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2279,
   "Continent": "Europe",
   "Country": "France",
   "ProvName": "Ile-de-France",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "30-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "France. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_83_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2280,
   "Continent": "Africa",
   "Country": "Mali",
   "ProvName": "Tombouctou",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2281,
   "Continent": "Europe",
   "Country": "France",
   "ProvName": "Limousin",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "France. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_83_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2282,
   "Continent": "Europe",
   "Country": "France",
   "ProvName": "Champagne-Ardenne",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "France. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_83_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2283,
   "Continent": "North America",
   "Country": "Mexico",
   "ProvName": "Nuevo León",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mexico. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_149_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2284,
   "Continent": "North America",
   "Country": "Mexico",
   "ProvName": "San Luis Potosí",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mexico. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_149_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2285,
   "Continent": "Europe",
   "Country": "France",
   "ProvName": "Nord-Pas-de-Calais",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "France. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_83_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2286,
   "Continent": "Europe",
   "Country": "France",
   "ProvName": "Picardie",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "France. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_83_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2287,
   "Continent": "North America",
   "Country": "Mexico",
   "ProvName": "Tamaulipas",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mexico. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_149_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2288,
   "Continent": "Africa",
   "Country": "Seychelles",
   "ProvName": "Praslin and satellites",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Seychelles. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_199_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2289,
   "Continent": "Oceania",
   "Country": "Tonga",
   "ProvName": "`Eua",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "10-15%",
   "Nummeric_1": 15,
   "DataSource": "Tonga. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_223_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2290,
   "Continent": "Europe",
   "Country": "France",
   "ProvName": "Franche-Comte",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "France. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_83_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2291,
   "Continent": "Oceania",
   "Country": "Tonga",
   "ProvName": "Tongatapu",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "10-15%",
   "Nummeric_1": 15,
   "DataSource": "Tonga. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_223_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2292,
   "Continent": "Europe",
   "Country": "France",
   "ProvName": "Alsace",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "France. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_83_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2293,
   "Continent": "Europe",
   "Country": "France",
   "ProvName": "Lorraine",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "France. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_83_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2294,
   "Continent": "North America",
   "Country": "Bahamas",
   "ProvName": "San Salvador",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Religions in Bahamas - PEW-GRF\". http:\/\/www.globalreligiousfutures.org\/countries\/bahamas#\/?affiliations_religion_id=11&affiliations_year=2010&restrictions_year=2015",
   "Year": 2010
  },
  {
   "OBJECTID": 2295,
   "Continent": "Africa",
   "Country": "Mali",
   "ProvName": "Kidal",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2296,
   "Continent": "Africa",
   "Country": "Mali",
   "ProvName": "Gao",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2297,
   "Continent": "South America",
   "Country": "Chile",
   "ProvName": "Ais矇n del General",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "\"Estudio Nacional de Opinión Pública\" (PDF). Centro de Estudios Públicos. October–November 2018",
   "Year": 2018
  },
  {
   "OBJECTID": 2298,
   "Continent": "North America",
   "Country": "Mexico",
   "ProvName": "Aguascalientes",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mexico. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_149_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2299,
   "Continent": "South America",
   "Country": "Chile",
   "ProvName": "Libertado General",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "\"Estudio Nacional de Opinión Pública\" (PDF). Centro de Estudios Públicos. October–November 2018",
   "Year": 2018
  },
  {
   "OBJECTID": 2300,
   "Continent": "South America",
   "Country": "Chile",
   "ProvName": "Los Lagos",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "\"Estudio Nacional de Opinión Pública\" (PDF). Centro de Estudios Públicos. October–November 2018",
   "Year": 2018
  },
  {
   "OBJECTID": 2301,
   "Continent": "South America",
   "Country": "Chile",
   "ProvName": "Maule",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "\"Estudio Nacional de Opinión Pública\" (PDF). Centro de Estudios Públicos. October–November 2018",
   "Year": 2018
  },
  {
   "OBJECTID": 2302,
   "Continent": "North America",
   "Country": "Mexico",
   "ProvName": "Baja California Norte",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mexico. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_149_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2303,
   "Continent": "North America",
   "Country": "Mexico",
   "ProvName": "Baja California Sur",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mexico. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_149_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2304,
   "Continent": "North America",
   "Country": "Mexico",
   "ProvName": "Coahuila",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mexico. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_149_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2305,
   "Continent": "North America",
   "Country": "Mexico",
   "ProvName": "Chihuahua",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mexico. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_149_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2306,
   "Continent": "North America",
   "Country": "Mexico",
   "ProvName": "Durango",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mexico. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_149_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2307,
   "Continent": "North America",
   "Country": "Mexico",
   "ProvName": "Sinaloa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mexico. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_149_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2308,
   "Continent": "North America",
   "Country": "Mexico",
   "ProvName": "Sonora",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mexico. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_149_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2309,
   "Continent": "North America",
   "Country": "Mexico",
   "ProvName": "Zacatecas",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mexico. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_149_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2310,
   "Continent": "North America",
   "Country": "Mexico",
   "ProvName": "Colima",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mexico. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_149_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2311,
   "Continent": "North America",
   "Country": "Mexico",
   "ProvName": "Jalisco",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mexico. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_149_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2312,
   "Continent": "North America",
   "Country": "Mexico",
   "ProvName": "Michoacán",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mexico. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_149_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2313,
   "Continent": "Asia",
   "Country": "Oman",
   "ProvName": "az-Zahirah",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Ibadi)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2314,
   "Continent": "Europe",
   "Country": "United Kingdom",
   "ProvName": "Greater Manchester",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "30-35%",
   "Numerical": 35,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "United Kingdom. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_233_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2315,
   "Continent": "Europe",
   "Country": "United Kingdom",
   "ProvName": "South Yorkshire",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "United Kingdom. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_233_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2316,
   "Continent": "North America",
   "Country": "Mexico",
   "ProvName": "Nayarit",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mexico. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_149_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2317,
   "Continent": "Africa",
   "Country": "Mauritania",
   "ProvName": "Tiris Zemmour",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2318,
   "Continent": "North America",
   "Country": "Mexico",
   "ProvName": "Campeche",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mexico. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_149_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2319,
   "Continent": "North America",
   "Country": "Mexico",
   "ProvName": "Oaxaca",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mexico. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_149_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2320,
   "Continent": "North America",
   "Country": "Mexico",
   "ProvName": "Puebla",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mexico. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_149_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2321,
   "Continent": "North America",
   "Country": "Mexico",
   "ProvName": "Tabasco",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mexico. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_149_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2322,
   "Continent": "North America",
   "Country": "Mexico",
   "ProvName": "Tlaxcala",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mexico. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_149_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2323,
   "Continent": "Europe",
   "Country": "Greenland",
   "ProvName": "Sermersooq",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/www.pewforum.org\/2011\/12\/19\/table-christian-population-as-percentages-of-total-population-by-country\/",
   "Year": 2010
  },
  {
   "OBJECTID": 2324,
   "Continent": "Europe",
   "Country": "Greenland",
   "ProvName": "Kujalleq",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/www.pewforum.org\/2011\/12\/19\/table-christian-population-as-percentages-of-total-population-by-country\/",
   "Year": 2010
  },
  {
   "OBJECTID": 2325,
   "Continent": "Europe",
   "Country": "Greenland",
   "ProvName": "Qeqqata",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/www.pewforum.org\/2011\/12\/19\/table-christian-population-as-percentages-of-total-population-by-country\/",
   "Year": 2010
  },
  {
   "OBJECTID": 2326,
   "Continent": "Europe",
   "Country": "Greenland",
   "ProvName": "Northeast Greenland National Park",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/www.pewforum.org\/2011\/12\/19\/table-christian-population-as-percentages-of-total-population-by-country\/",
   "Year": 2010
  },
  {
   "OBJECTID": 2327,
   "Continent": "Africa",
   "Country": "Mauritania",
   "ProvName": "Brakna",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2328,
   "Continent": "Europe",
   "Country": "United Kingdom",
   "ProvName": "Herefordshire, Worcestershire and Warwicks",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "United Kingdom. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_233_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2329,
   "Continent": "Europe",
   "Country": "United Kingdom",
   "ProvName": "West Yorkshire",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "United Kingdom. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_233_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2330,
   "Continent": "North America",
   "Country": "Bahamas",
   "ProvName": "Berry Islands",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Religions in Bahamas - PEW-GRF\". http:\/\/www.globalreligiousfutures.org\/countries\/bahamas#\/?affiliations_religion_id=11&affiliations_year=2010&restrictions_year=2015",
   "Year": 2010
  },
  {
   "OBJECTID": 2331,
   "Continent": "Africa",
   "Country": "Mauritania",
   "ProvName": "Dakhlet Nouadhibou",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2332,
   "Continent": "Africa",
   "Country": "Mauritania",
   "ProvName": "Inchiri",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2333,
   "Continent": "Africa",
   "Country": "Mauritania",
   "ProvName": "Nouakchott",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2334,
   "Continent": "Africa",
   "Country": "Mauritania",
   "ProvName": "Trarza",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2335,
   "Continent": "Africa",
   "Country": "Mauritania",
   "ProvName": "Assaba (el-Açâba)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2336,
   "Continent": "Asia",
   "Country": "Iran",
   "ProvName": "Kohkiluyeh Buyer Ahmadi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2337,
   "Continent": "Oceania",
   "Country": "Tonga",
   "ProvName": "Ha'apai",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "10-15%",
   "Nummeric_1": 15,
   "DataSource": "Tonga. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_223_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2338,
   "Continent": "Oceania",
   "Country": "Tonga",
   "ProvName": "Niuas",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "10-15%",
   "Nummeric_1": 15,
   "DataSource": "Tonga. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_223_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2339,
   "Continent": "Europe",
   "Country": "Macedonia",
   "ProvName": "Southeastern",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Strategies of symbolic nation-building in West Balkan states: intents and results (2011) - Department of Literature, Area Studies and European Languages\". www.hf.uio.no",
   "Year": 2011
  },
  {
   "OBJECTID": 2340,
   "Continent": "Europe",
   "Country": "Greece",
   "ProvName": "Macedonia and Thrace",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 2341,
   "Continent": "Europe",
   "Country": "Bulgaria",
   "ProvName": "Blagoevgrad",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Special Eurobarometer 493, European Union: European Commission, September 2019, pages 229-230",
   "Year": 2019
  },
  {
   "OBJECTID": 2342,
   "Continent": "Africa",
   "Country": "Macedonia",
   "ProvName": "Eastern",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Strategies of symbolic nation-building in West Balkan states: intents and results (2011) - Department of Literature, Area Studies and European Languages\". www.hf.uio.no",
   "Year": 2011
  },
  {
   "OBJECTID": 2343,
   "Continent": "Europe",
   "Country": "Finland",
   "ProvName": "Lapland",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Finland. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_82_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2344,
   "Continent": "Europe",
   "Country": "Finland",
   "ProvName": "Western and Inland Finland",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Finland. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_82_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2345,
   "Continent": "North America",
   "Country": "Bahamas",
   "ProvName": "Crooked and Long Cay",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Religions in Bahamas - PEW-GRF\". http:\/\/www.globalreligiousfutures.org\/countries\/bahamas#\/?affiliations_religion_id=11&affiliations_year=2010&restrictions_year=2015",
   "Year": 2010
  },
  {
   "OBJECTID": 2346,
   "Continent": "Europe",
   "Country": "Finland",
   "ProvName": "Eastern Finland",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Finland. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_82_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2347,
   "Continent": "Europe",
   "Country": "Finland",
   "ProvName": "Northern Finland",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Finland. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_82_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2348,
   "Continent": "Europe",
   "Country": "Finland",
   "ProvName": "Southern Finland",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Finland. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_82_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2349,
   "Continent": "Asia",
   "Country": "Kazakhstan",
   "ProvName": "Soltüstik Qazaqstan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2350,
   "Continent": "Oceania",
   "Country": "Tonga",
   "ProvName": "Vava'u",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "10-15%",
   "Nummeric_1": 15,
   "DataSource": "Tonga. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_223_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2351,
   "Continent": "Asia",
   "Country": "Kazakhstan",
   "ProvName": "Pavlodar",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2352,
   "Continent": "Asia",
   "Country": "Kazakhstan",
   "ProvName": "Shyghys Qazaqstan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2353,
   "Continent": "North America",
   "Country": "Bahamas",
   "ProvName": "Inagua, Great and Little",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Religions in Bahamas - PEW-GRF\". http:\/\/www.globalreligiousfutures.org\/countries\/bahamas#\/?affiliations_religion_id=11&affiliations_year=2010&restrictions_year=2015",
   "Year": 2010
  },
  {
   "OBJECTID": 2354,
   "Continent": "North America",
   "Country": "Bahamas",
   "ProvName": "Spanish Wells",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Religions in Bahamas - PEW-GRF\". http:\/\/www.globalreligiousfutures.org\/countries\/bahamas#\/?affiliations_religion_id=11&affiliations_year=2010&restrictions_year=2015",
   "Year": 2010
  },
  {
   "OBJECTID": 2355,
   "Continent": "North America",
   "Country": "Bahamas",
   "ProvName": "Harbour Island",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Religions in Bahamas - PEW-GRF\". http:\/\/www.globalreligiousfutures.org\/countries\/bahamas#\/?affiliations_religion_id=11&affiliations_year=2010&restrictions_year=2015",
   "Year": 2010
  },
  {
   "OBJECTID": 2356,
   "Continent": "Asia",
   "Country": "Mongolia",
   "ProvName": "Bayan-?lgiy",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2357,
   "Continent": "Asia",
   "Country": "Iran",
   "ProvName": "Bushehr",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2358,
   "Continent": "North America",
   "Country": "Bahamas",
   "ProvName": "Grand Bahama",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Religions in Bahamas - PEW-GRF\". http:\/\/www.globalreligiousfutures.org\/countries\/bahamas#\/?affiliations_religion_id=11&affiliations_year=2010&restrictions_year=2015",
   "Year": 2010
  },
  {
   "OBJECTID": 2359,
   "Continent": "North America",
   "Country": "Bahamas",
   "ProvName": "Acklins",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Religions in Bahamas - PEW-GRF\". http:\/\/www.globalreligiousfutures.org\/countries\/bahamas#\/?affiliations_religion_id=11&affiliations_year=2010&restrictions_year=2015",
   "Year": 2010
  },
  {
   "OBJECTID": 2360,
   "Continent": "North America",
   "Country": "Bahamas",
   "ProvName": "Andros",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Religions in Bahamas - PEW-GRF\". http:\/\/www.globalreligiousfutures.org\/countries\/bahamas#\/?affiliations_religion_id=11&affiliations_year=2010&restrictions_year=2015",
   "Year": 2010
  },
  {
   "OBJECTID": 2361,
   "Continent": "North America",
   "Country": "Bahamas",
   "ProvName": "Mayaguana",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Religions in Bahamas - PEW-GRF\". http:\/\/www.globalreligiousfutures.org\/countries\/bahamas#\/?affiliations_religion_id=11&affiliations_year=2010&restrictions_year=2015",
   "Year": 2010
  },
  {
   "OBJECTID": 2362,
   "Continent": "Asia",
   "Country": "North Korea",
   "ProvName": "Hamgyong South",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "No Data",
   "HighRelig": "No Data",
   "ReligCatP": null,
   "Numerical": 0,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": null,
   "Year": null
  },
  {
   "OBJECTID": 2363,
   "Continent": "North America",
   "Country": "Bahamas",
   "ProvName": "Long Island",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Religions in Bahamas - PEW-GRF\". http:\/\/www.globalreligiousfutures.org\/countries\/bahamas#\/?affiliations_religion_id=11&affiliations_year=2010&restrictions_year=2015",
   "Year": 2010
  },
  {
   "OBJECTID": 2364,
   "Continent": "North America",
   "Country": "Bahamas",
   "ProvName": "Exuma",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Religions in Bahamas - PEW-GRF\". http:\/\/www.globalreligiousfutures.org\/countries\/bahamas#\/?affiliations_religion_id=11&affiliations_year=2010&restrictions_year=2015",
   "Year": 2010
  },
  {
   "OBJECTID": 2365,
   "Continent": "North America",
   "Country": "Bahamas",
   "ProvName": "New Providence",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Religions in Bahamas - PEW-GRF\". http:\/\/www.globalreligiousfutures.org\/countries\/bahamas#\/?affiliations_religion_id=11&affiliations_year=2010&restrictions_year=2015",
   "Year": 2010
  },
  {
   "OBJECTID": 2366,
   "Continent": "North America",
   "Country": "Bahamas",
   "ProvName": "Rum Cay",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Religions in Bahamas - PEW-GRF\". http:\/\/www.globalreligiousfutures.org\/countries\/bahamas#\/?affiliations_religion_id=11&affiliations_year=2010&restrictions_year=2015",
   "Year": 2010
  },
  {
   "OBJECTID": 2367,
   "Continent": "Africa",
   "Country": "Mauritania",
   "ProvName": "Guidmaka",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2368,
   "Continent": "Asia",
   "Country": "North Korea",
   "ProvName": "Phyongan North (P'yongan)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "No Data",
   "HighRelig": "No Data",
   "ReligCatP": null,
   "Numerical": 0,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": null,
   "Year": null
  },
  {
   "OBJECTID": 2369,
   "Continent": "Africa",
   "Country": "Mauritania",
   "ProvName": "Tagant",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2370,
   "Continent": "Asia",
   "Country": "North Korea",
   "ProvName": "Ryanggang (Yanggang)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "No Data",
   "HighRelig": "No Data",
   "ReligCatP": null,
   "Numerical": 0,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": null,
   "Year": null
  },
  {
   "OBJECTID": 2371,
   "Continent": "Africa",
   "Country": "Burkina Faso",
   "ProvName": "Banwa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mapping the Global Muslim Population. Estimate Range of Shia by Country. Pew Forum, 2010. Johnson, T. M., & Grim, B. J. (Eds.).",
   "Year": 2008
  },
  {
   "OBJECTID": 2372,
   "Continent": "Africa",
   "Country": "Burkina Faso",
   "ProvName": "Nayala",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mapping the Global Muslim Population. Estimate Range of Shia by Country. Pew Forum, 2010. Johnson, T. M., & Grim, B. J. (Eds.).",
   "Year": 2008
  },
  {
   "OBJECTID": 2373,
   "Continent": "North America",
   "Country": "Bahamas",
   "ProvName": "Biminis Islands",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Religions in Bahamas - PEW-GRF\". http:\/\/www.globalreligiousfutures.org\/countries\/bahamas#\/?affiliations_religion_id=11&affiliations_year=2010&restrictions_year=2015",
   "Year": 2010
  },
  {
   "OBJECTID": 2374,
   "Continent": "North America",
   "Country": "Bahamas",
   "ProvName": "Ragged Island",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Religions in Bahamas - PEW-GRF\". http:\/\/www.globalreligiousfutures.org\/countries\/bahamas#\/?affiliations_religion_id=11&affiliations_year=2010&restrictions_year=2015",
   "Year": 2010
  },
  {
   "OBJECTID": 2375,
   "Continent": "Africa",
   "Country": "Bahrain",
   "ProvName": "Northern",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Sunni)",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "Unofficial sources, the Library of Congress Country Studies, and The New York Times, estimate approximately 45% Sunni and 55% Shia",
   "Year": 2008
  },
  {
   "OBJECTID": 2376,
   "Continent": "Asia",
   "Country": "Bahrain",
   "ProvName": "Muharraq",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Sunni)",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "Unofficial sources, the Library of Congress Country Studies, and The New York Times, estimate approximately 45% Sunni and 55% Shia",
   "Year": 2008
  },
  {
   "OBJECTID": 2377,
   "Continent": "Asia",
   "Country": "Bahrain",
   "ProvName": "Capital",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Sunni)",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "Unofficial sources, the Library of Congress Country Studies, and The New York Times, estimate approximately 45% Sunni and 55% Shia",
   "Year": 2008
  },
  {
   "OBJECTID": 2378,
   "Continent": "Asia",
   "Country": "Bahrain",
   "ProvName": "Central",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Sunni)",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "Unofficial sources, the Library of Congress Country Studies, and The New York Times, estimate approximately 45% Sunni and 55% Shia",
   "Year": 2008
  },
  {
   "OBJECTID": 2379,
   "Continent": "Africa",
   "Country": "Mauritania",
   "ProvName": "Gorgol",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2380,
   "Continent": "Africa",
   "Country": "Mali",
   "ProvName": "Kayes",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2381,
   "Continent": "Africa",
   "Country": "Mali",
   "ProvName": "Sikasso",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2382,
   "Continent": "Africa",
   "Country": "Mauritania",
   "ProvName": "Adrar",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2383,
   "Continent": "Africa",
   "Country": "Mauritania",
   "ProvName": "Hodh ech-Chargui",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2384,
   "Continent": "Africa",
   "Country": "Mauritania",
   "ProvName": "Hodh el-Gharbi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2385,
   "Continent": "Africa",
   "Country": "Burkina Faso",
   "ProvName": "Houet",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mapping the Global Muslim Population. Estimate Range of Shia by Country. Pew Forum, 2010. Johnson, T. M., & Grim, B. J. (Eds.).",
   "Year": 2008
  },
  {
   "OBJECTID": 2386,
   "Continent": "Africa",
   "Country": "Burkina Faso",
   "ProvName": "Kénédougou",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mapping the Global Muslim Population. Estimate Range of Shia by Country. Pew Forum, 2010. Johnson, T. M., & Grim, B. J. (Eds.).",
   "Year": 2008
  },
  {
   "OBJECTID": 2387,
   "Continent": "Africa",
   "Country": "Burkina Faso",
   "ProvName": "Kossi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mapping the Global Muslim Population. Estimate Range of Shia by Country. Pew Forum, 2010. Johnson, T. M., & Grim, B. J. (Eds.).",
   "Year": 2008
  },
  {
   "OBJECTID": 2388,
   "Continent": "Africa",
   "Country": "Burkina Faso",
   "ProvName": "Balé",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mapping the Global Muslim Population. Estimate Range of Shia by Country. Pew Forum, 2010. Johnson, T. M., & Grim, B. J. (Eds.).",
   "Year": 2008
  },
  {
   "OBJECTID": 2389,
   "Continent": "Africa",
   "Country": "Burkina Faso",
   "ProvName": "Sourou",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mapping the Global Muslim Population. Estimate Range of Shia by Country. Pew Forum, 2010. Johnson, T. M., & Grim, B. J. (Eds.).",
   "Year": 2008
  },
  {
   "OBJECTID": 2390,
   "Continent": "Africa",
   "Country": "Burkina Faso",
   "ProvName": "Mouhoun",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mapping the Global Muslim Population. Estimate Range of Shia by Country. Pew Forum, 2010. Johnson, T. M., & Grim, B. J. (Eds.).",
   "Year": 2008
  },
  {
   "OBJECTID": 2391,
   "Continent": "Africa",
   "Country": "Burkina Faso",
   "ProvName": "Oudalan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mapping the Global Muslim Population. Estimate Range of Shia by Country. Pew Forum, 2010. Johnson, T. M., & Grim, B. J. (Eds.).",
   "Year": 2008
  },
  {
   "OBJECTID": 2392,
   "Continent": "Africa",
   "Country": "Burkina Faso",
   "ProvName": "Bam",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "10-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mapping the Global Muslim Population. Estimate Range of Shia by Country. Pew Forum, 2010. Johnson, T. M., & Grim, B. J. (Eds.).",
   "Year": 2008
  },
  {
   "OBJECTID": 2393,
   "Continent": "Africa",
   "Country": "Nigeria",
   "ProvName": "Imo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "15-20%",
   "Nummeric_1": 20,
   "DataSource": "Nigeria. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_166_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2394,
   "Continent": "Africa",
   "Country": "Burkina Faso",
   "ProvName": "Soum",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mapping the Global Muslim Population. Estimate Range of Shia by Country. Pew Forum, 2010. Johnson, T. M., & Grim, B. J. (Eds.).",
   "Year": 2008
  },
  {
   "OBJECTID": 2395,
   "Continent": "Africa",
   "Country": "Mali",
   "ProvName": "Mopti",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2396,
   "Continent": "Africa",
   "Country": "Mali",
   "ProvName": "Ségou",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2397,
   "Continent": "Africa",
   "Country": "Nigeria",
   "ProvName": "Rivers",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "10-15%",
   "Nummeric_1": 15,
   "DataSource": "Nigeria. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_166_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2398,
   "Continent": "Africa",
   "Country": "Burkina Faso",
   "ProvName": "Boulkiemdé",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mapping the Global Muslim Population. Estimate Range of Shia by Country. Pew Forum, 2010. Johnson, T. M., & Grim, B. J. (Eds.).",
   "Year": 2008
  },
  {
   "OBJECTID": 2399,
   "Continent": "Africa",
   "Country": "Nigeria",
   "ProvName": "Bayelsa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "15-20%",
   "Nummeric_1": 20,
   "DataSource": "Nigeria. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_166_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2400,
   "Continent": "Africa",
   "Country": "Nigeria",
   "ProvName": "Benue",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "15-20%",
   "Nummeric_1": 20,
   "DataSource": "Nigeria. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_166_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2401,
   "Continent": "Africa",
   "Country": "Nigeria",
   "ProvName": "Cross River",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "15-20%",
   "Nummeric_1": 20,
   "DataSource": "Nigeria. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_166_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2402,
   "Continent": "Africa",
   "Country": "Burkina Faso",
   "ProvName": "Kourwéogo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "10-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mapping the Global Muslim Population. Estimate Range of Shia by Country. Pew Forum, 2010. Johnson, T. M., & Grim, B. J. (Eds.).",
   "Year": 2008
  },
  {
   "OBJECTID": 2403,
   "Continent": "Africa",
   "Country": "Burkina Faso",
   "ProvName": "Bazèga",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mapping the Global Muslim Population. Estimate Range of Shia by Country. Pew Forum, 2010. Johnson, T. M., & Grim, B. J. (Eds.).",
   "Year": 2008
  },
  {
   "OBJECTID": 2404,
   "Continent": "Africa",
   "Country": "Nigeria",
   "ProvName": "Taraba",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2405,
   "Continent": "Africa",
   "Country": "Burkina Faso",
   "ProvName": "Kadiogo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2406,
   "Continent": "Africa",
   "Country": "Burkina Faso",
   "ProvName": "Oubritenga",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "10-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2407,
   "Continent": "Africa",
   "Country": "Nigeria",
   "ProvName": "Kwara",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2408,
   "Continent": "Africa",
   "Country": "Nigeria",
   "ProvName": "Lagos",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "15-20%",
   "Nummeric_1": 20,
   "DataSource": "Nigeria. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_166_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2409,
   "Continent": "Africa",
   "Country": "Nigeria",
   "ProvName": "Niger",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2410,
   "Continent": "Africa",
   "Country": "Burkina Faso",
   "ProvName": "Zondoma",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mapping the Global Muslim Population. Estimate Range of Shia by Country. Pew Forum, 2010. Johnson, T. M., & Grim, B. J. (Eds.).",
   "Year": 2008
  },
  {
   "OBJECTID": 2411,
   "Continent": "Africa",
   "Country": "Nigeria",
   "ProvName": "Ogun",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "10-15%",
   "Nummeric_1": 15,
   "DataSource": "Nigeria. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_166_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2412,
   "Continent": "Africa",
   "Country": "Nigeria",
   "ProvName": "Ondo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "10-15%",
   "Nummeric_1": 15,
   "DataSource": "Nigeria. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_166_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2413,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Kirikkale",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2414,
   "Continent": "Africa",
   "Country": "Burkina Faso",
   "ProvName": "Sanguié",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mapping the Global Muslim Population. Estimate Range of Shia by Country. Pew Forum, 2010. Johnson, T. M., & Grim, B. J. (Eds.).",
   "Year": 2008
  },
  {
   "OBJECTID": 2415,
   "Continent": "Africa",
   "Country": "Burkina Faso",
   "ProvName": "Passoré",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "10-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2416,
   "Continent": "Africa",
   "Country": "Burkina Faso",
   "ProvName": "Sissili",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mapping the Global Muslim Population. Estimate Range of Shia by Country. Pew Forum, 2010. Johnson, T. M., & Grim, B. J. (Eds.).",
   "Year": 2008
  },
  {
   "OBJECTID": 2417,
   "Continent": "Africa",
   "Country": "Burkina Faso",
   "ProvName": "Ziro",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mapping the Global Muslim Population. Estimate Range of Shia by Country. Pew Forum, 2010. Johnson, T. M., & Grim, B. J. (Eds.).",
   "Year": 2008
  },
  {
   "OBJECTID": 2418,
   "Continent": "Africa",
   "Country": "Burkina Faso",
   "ProvName": "Loroum",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mapping the Global Muslim Population. Estimate Range of Shia by Country. Pew Forum, 2010. Johnson, T. M., & Grim, B. J. (Eds.).",
   "Year": 2008
  },
  {
   "OBJECTID": 2419,
   "Continent": "Africa",
   "Country": "Burkina Faso",
   "ProvName": "Yatenga",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mapping the Global Muslim Population. Estimate Range of Shia by Country. Pew Forum, 2010. Johnson, T. M., & Grim, B. J. (Eds.).",
   "Year": 2008
  },
  {
   "OBJECTID": 2420,
   "Continent": "Africa",
   "Country": "Burkina Faso",
   "ProvName": "Sanmatenga",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mapping the Global Muslim Population. Estimate Range of Shia by Country. Pew Forum, 2010. Johnson, T. M., & Grim, B. J. (Eds.).",
   "Year": 2008
  },
  {
   "OBJECTID": 2421,
   "Continent": "Africa",
   "Country": "Burkina Faso",
   "ProvName": "Boulgou",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "10-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mapping the Global Muslim Population. Estimate Range of Shia by Country. Pew Forum, 2010. Johnson, T. M., & Grim, B. J. (Eds.).",
   "Year": 2008
  },
  {
   "OBJECTID": 2422,
   "Continent": "Africa",
   "Country": "Burkina Faso",
   "ProvName": "Bougouriba",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mapping the Global Muslim Population. Estimate Range of Shia by Country. Pew Forum, 2010. Johnson, T. M., & Grim, B. J. (Eds.).",
   "Year": 2008
  },
  {
   "OBJECTID": 2423,
   "Continent": "Europe",
   "Country": "Finland",
   "ProvName": "Aland (Ahvenanmaa)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Finland. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_82_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2424,
   "Continent": "Africa",
   "Country": "Burkina Faso",
   "ProvName": "Tuy",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mapping the Global Muslim Population. Estimate Range of Shia by Country. Pew Forum, 2010. Johnson, T. M., & Grim, B. J. (Eds.).",
   "Year": 2008
  },
  {
   "OBJECTID": 2425,
   "Continent": "Africa",
   "Country": "Burkina Faso",
   "ProvName": "Léraba",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mapping the Global Muslim Population. Estimate Range of Shia by Country. Pew Forum, 2010. Johnson, T. M., & Grim, B. J. (Eds.).",
   "Year": 2008
  },
  {
   "OBJECTID": 2426,
   "Continent": "Africa",
   "Country": "Nigeria",
   "ProvName": "Akwa Ibom",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "15-20%",
   "Nummeric_1": 20,
   "DataSource": "Nigeria. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_166_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2427,
   "Continent": "Europe",
   "Country": "Moldova",
   "ProvName": "Dubasari",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 2428,
   "Continent": "Africa",
   "Country": "Burkina Faso",
   "ProvName": "Comoé",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mapping the Global Muslim Population. Estimate Range of Shia by Country. Pew Forum, 2010. Johnson, T. M., & Grim, B. J. (Eds.).",
   "Year": 2008
  },
  {
   "OBJECTID": 2429,
   "Continent": "Africa",
   "Country": "Nigeria",
   "ProvName": "Ekiti",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "10-15%",
   "Nummeric_1": 15,
   "DataSource": "Nigeria. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_166_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2430,
   "Continent": "Europe",
   "Country": "Moldova",
   "ProvName": "Ialoveni",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 2431,
   "Continent": "Africa",
   "Country": "Congo",
   "ProvName": "Likouala",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "\"Congo, Republic of the\". Association of Religion Data Archives. 2015 http:\/\/www.thearda.com\/internationalData\/countries\/Country_57_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2432,
   "Continent": "Africa",
   "Country": "Nigeria",
   "ProvName": "Borno",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2433,
   "Continent": "Africa",
   "Country": "Nigeria",
   "ProvName": "Abia",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "65-70%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "15-20%",
   "Nummeric_1": 20,
   "DataSource": "Nigeria. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_166_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2434,
   "Continent": "Europe",
   "Country": "Moldova",
   "ProvName": "Chisinau city",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 2435,
   "Continent": "Europe",
   "Country": "Moldova",
   "ProvName": "Bender",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 2436,
   "Continent": "Europe",
   "Country": "Hungary",
   "ProvName": "Vas",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Hungary. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_106_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2437,
   "Continent": "Europe",
   "Country": "Poland",
   "ProvName": "Warminsko-Marzurskie",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Poland. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_180_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2438,
   "Continent": "Africa",
   "Country": "Nigeria",
   "ProvName": "Osun",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "10-15%",
   "Nummeric_1": 15,
   "DataSource": "Nigeria. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_166_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2439,
   "Continent": "Europe",
   "Country": "Poland",
   "ProvName": "Pomorskie",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Poland. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_180_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2440,
   "Continent": "Africa",
   "Country": "Nigeria",
   "ProvName": "Oyo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "10-15%",
   "Nummeric_1": 15,
   "DataSource": "Nigeria. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_166_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2441,
   "Continent": "Europe",
   "Country": "Poland",
   "ProvName": "Dolnoslaskie",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Poland. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_180_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2442,
   "Continent": "Africa",
   "Country": "Nigeria",
   "ProvName": "Anambra",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "15-20%",
   "Nummeric_1": 20,
   "DataSource": "Nigeria. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_166_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2443,
   "Continent": "Europe",
   "Country": "Poland",
   "ProvName": "Zachodniopomorskie",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Poland. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_180_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2444,
   "Continent": "Europe",
   "Country": "Poland",
   "ProvName": "Lubuskie",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Poland. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_180_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2445,
   "Continent": "Africa",
   "Country": "Nigeria",
   "ProvName": "Bauchi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2446,
   "Continent": "Africa",
   "Country": "Nigeria",
   "ProvName": "Gombe",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2447,
   "Continent": "Africa",
   "Country": "Nigeria",
   "ProvName": "Edo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "15-20%",
   "Nummeric_1": 20,
   "DataSource": "Nigeria. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_166_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2448,
   "Continent": "Africa",
   "Country": "Nigeria",
   "ProvName": "Delta",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "15-20%",
   "Nummeric_1": 20,
   "DataSource": "Nigeria. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_166_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2449,
   "Continent": "Africa",
   "Country": "Nigeria",
   "ProvName": "Enugu",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "15-20%",
   "Nummeric_1": 20,
   "DataSource": "Nigeria. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_166_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2450,
   "Continent": "Europe",
   "Country": "Poland",
   "ProvName": "Wielkopolskie",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Poland. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_180_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2451,
   "Continent": "Europe",
   "Country": "Poland",
   "ProvName": "Kujawsko-pomorskie",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Poland. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_180_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2452,
   "Continent": "Africa",
   "Country": "Nigeria",
   "ProvName": "Plateau",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "10-15%",
   "Nummeric_1": 15,
   "DataSource": "Nigeria. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_166_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2453,
   "Continent": "Europe",
   "Country": "Poland",
   "ProvName": "Slaskie",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Poland. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_180_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2454,
   "Continent": "Europe",
   "Country": "Poland",
   "ProvName": "Lodzkie",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Poland. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_180_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2455,
   "Continent": "Africa",
   "Country": "Nigeria",
   "ProvName": "Ebonyi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "15-20%",
   "Nummeric_1": 20,
   "DataSource": "Nigeria. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_166_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2456,
   "Continent": "Africa",
   "Country": "Nigeria",
   "ProvName": "Kaduna",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2457,
   "Continent": "Africa",
   "Country": "Nigeria",
   "ProvName": "Kogi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "10-15%",
   "Nummeric_1": 15,
   "DataSource": "Nigeria. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_166_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2458,
   "Continent": "Africa",
   "Country": "Nigeria",
   "ProvName": "Nassarawa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "10-15%",
   "Nummeric_1": 15,
   "DataSource": "Nigeria. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_166_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2459,
   "Continent": "Africa",
   "Country": "Nigeria",
   "ProvName": "Jigawa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2460,
   "Continent": "Africa",
   "Country": "Burkina Faso",
   "ProvName": "Komondjari",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mapping the Global Muslim Population. Estimate Range of Shia by Country. Pew Forum, 2010. Johnson, T. M., & Grim, B. J. (Eds.).",
   "Year": 2008
  },
  {
   "OBJECTID": 2461,
   "Continent": "Asia",
   "Country": "India",
   "ProvName": "Chhattisgarh",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Hinduism",
   "HighRelig": "Hindus",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2462,
   "Continent": "Africa",
   "Country": "Nigeria",
   "ProvName": "Kano",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2463,
   "Continent": "Africa",
   "Country": "Nigeria",
   "ProvName": "Katsina",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2464,
   "Continent": "Africa",
   "Country": "Nigeria",
   "ProvName": "Sokoto",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2465,
   "Continent": "Africa",
   "Country": "Nigeria",
   "ProvName": "Zamfara",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2466,
   "Continent": "Africa",
   "Country": "Nigeria",
   "ProvName": "Yobe",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2467,
   "Continent": "Africa",
   "Country": "Burkina Faso",
   "ProvName": "Gnagna",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mapping the Global Muslim Population. Estimate Range of Shia by Country. Pew Forum, 2010. Johnson, T. M., & Grim, B. J. (Eds.).",
   "Year": 2008
  },
  {
   "OBJECTID": 2468,
   "Continent": "Africa",
   "Country": "Burkina Faso",
   "ProvName": "Sèno",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mapping the Global Muslim Population. Estimate Range of Shia by Country. Pew Forum, 2010. Johnson, T. M., & Grim, B. J. (Eds.).",
   "Year": 2008
  },
  {
   "OBJECTID": 2469,
   "Continent": "Africa",
   "Country": "Burkina Faso",
   "ProvName": "Yagha",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mapping the Global Muslim Population. Estimate Range of Shia by Country. Pew Forum, 2010. Johnson, T. M., & Grim, B. J. (Eds.).",
   "Year": 2008
  },
  {
   "OBJECTID": 2470,
   "Continent": "Africa",
   "Country": "Burkina Faso",
   "ProvName": "Tapoa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mapping the Global Muslim Population. Estimate Range of Shia by Country. Pew Forum, 2010. Johnson, T. M., & Grim, B. J. (Eds.).",
   "Year": 2008
  },
  {
   "OBJECTID": 2471,
   "Continent": "Europe",
   "Country": "Moldova",
   "ProvName": "Anenii Noi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 2472,
   "Continent": "Africa",
   "Country": "Nigeria",
   "ProvName": "Kebbi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2473,
   "Continent": "Africa",
   "Country": "Congo",
   "ProvName": "Sangha",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "\"Congo, Republic of the\". Association of Religion Data Archives. 2015 http:\/\/www.thearda.com\/internationalData\/countries\/Country_57_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2474,
   "Continent": "Africa",
   "Country": "Nigeria",
   "ProvName": "Adamawa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2475,
   "Continent": "Africa",
   "Country": "Libya",
   "ProvName": "Nâlût",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2476,
   "Continent": "Africa",
   "Country": "Botswana",
   "ProvName": "Ngamiland",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Pew Research Center's Religion & Public Life Project: Botswana. Pew Research Center. 2010.",
   "Year": 2010
  },
  {
   "OBJECTID": 2477,
   "Continent": "Africa",
   "Country": "Botswana",
   "ProvName": "Chobe",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Pew Research Center's Religion & Public Life Project: Botswana. Pew Research Center. 2010.",
   "Year": 2010
  },
  {
   "OBJECTID": 2478,
   "Continent": "Europe",
   "Country": "Moldova",
   "ProvName": "Taraclia",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 2479,
   "Continent": "Europe",
   "Country": "Greece",
   "ProvName": "Peloponnese, Western Greece and the Ionian",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 2480,
   "Continent": "Europe",
   "Country": "Greece",
   "ProvName": "Attica",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 2481,
   "Continent": "Europe",
   "Country": "Greece",
   "ProvName": "Thessaly and Continental Greece",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 2482,
   "Continent": "Europe",
   "Country": "Greece",
   "ProvName": "Epirus and Western Macedonia",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 2483,
   "Continent": "Europe",
   "Country": "Macedonia",
   "ProvName": "Southwestern",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Strategies of symbolic nation-building in West Balkan states: intents and results (2011) - Department of Literature, Area Studies and European Languages\". www.hf.uio.no",
   "Year": 2011
  },
  {
   "OBJECTID": 2484,
   "Continent": "Europe",
   "Country": "Macedonia",
   "ProvName": "Polog",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2485,
   "Continent": "Europe",
   "Country": "Macedonia",
   "ProvName": "Pelagonia",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Strategies of symbolic nation-building in West Balkan states: intents and results (2011) - Department of Literature, Area Studies and European Languages\". www.hf.uio.no",
   "Year": 2011
  },
  {
   "OBJECTID": 2486,
   "Continent": "Africa",
   "Country": "Libya",
   "ProvName": "al-Jufrah",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2487,
   "Continent": "Africa",
   "Country": "Libya",
   "ProvName": "al-Kufrah",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2488,
   "Continent": "Europe",
   "Country": "Macedonia",
   "ProvName": "Skopje",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Strategies of symbolic nation-building in West Balkan states: intents and results (2011) - Department of Literature, Area Studies and European Languages\". www.hf.uio.no",
   "Year": 2011
  },
  {
   "OBJECTID": 2489,
   "Continent": "Europe",
   "Country": "Macedonia",
   "ProvName": "Northeast",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Strategies of symbolic nation-building in West Balkan states: intents and results (2011) - Department of Literature, Area Studies and European Languages\". www.hf.uio.no",
   "Year": 2011
  },
  {
   "OBJECTID": 2490,
   "Continent": "Europe",
   "Country": "Macedonia",
   "ProvName": "Vardar",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Strategies of symbolic nation-building in West Balkan states: intents and results (2011) - Department of Literature, Area Studies and European Languages\". www.hf.uio.no",
   "Year": 2011
  },
  {
   "OBJECTID": 2491,
   "Continent": "Africa",
   "Country": "Libya",
   "ProvName": "Wâdî ash-Shâtî",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2492,
   "Continent": "Africa",
   "Country": "Libya",
   "ProvName": "Bangâzî",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2493,
   "Continent": "Asia",
   "Country": "India",
   "ProvName": "Madhya Pradesh",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Hinduism",
   "HighRelig": "Hindus",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2494,
   "Continent": "Asia",
   "Country": "India",
   "ProvName": "Pondicherry",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Hinduism",
   "HighRelig": "Hindus",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2495,
   "Continent": "Asia",
   "Country": "India",
   "ProvName": "Tamil Nadu",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Hinduism",
   "HighRelig": "Hindus",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2496,
   "Continent": "Africa",
   "Country": "Libya",
   "ProvName": "Murzuq (Marzuq)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2497,
   "Continent": "Africa",
   "Country": "Libya",
   "ProvName": "Misrâtah",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2498,
   "Continent": "Africa",
   "Country": "Libya",
   "ProvName": "Sabhâ",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2499,
   "Continent": "Africa",
   "Country": "Libya",
   "ProvName": "âl-Jifarah",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2500,
   "Continent": "Africa",
   "Country": "Libya",
   "ProvName": "an-Nuqât al-Hums",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2501,
   "Continent": "Africa",
   "Country": "Libya",
   "ProvName": "az-Zâwiyah",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2502,
   "Continent": "Africa",
   "Country": "Malawi",
   "ProvName": "Mwanza",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "15-20%",
   "Nummeric_1": 20,
   "DataSource": "Malawi. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_138_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2503,
   "Continent": "Africa",
   "Country": "Malawi",
   "ProvName": "Neno",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "15-20%",
   "Nummeric_1": 20,
   "DataSource": "Malawi. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_138_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2504,
   "Continent": "Asia",
   "Country": "India",
   "ProvName": "Gujarat",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Hinduism",
   "HighRelig": "Hindus",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2505,
   "Continent": "Asia",
   "Country": "India",
   "ProvName": "Goa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Hinduism",
   "HighRelig": "Hindus",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2506,
   "Continent": "Asia",
   "Country": "Myanmar",
   "ProvName": "Karen",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "The 2014 Myanmar Population and Housing Census Census Report Volume 2-C. Department of Population Ministry of Labour, Immigration and Population MYANMAR. pp. 12–15.",
   "Year": 2014
  },
  {
   "OBJECTID": 2507,
   "Continent": "Asia",
   "Country": "Myanmar",
   "ProvName": "Mandalay",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-95%",
   "Numerical": 95,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "The 2014 Myanmar Population and Housing Census Census Report Volume 2-C. Department of Population Ministry of Labour, Immigration and Population MYANMAR. pp. 12–15.",
   "Year": 2014
  },
  {
   "OBJECTID": 2508,
   "Continent": "Asia",
   "Country": "Myanmar",
   "ProvName": "Yangôn",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-95%",
   "Numerical": 95,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "The 2014 Myanmar Population and Housing Census Census Report Volume 2-C. Department of Population Ministry of Labour, Immigration and Population MYANMAR. pp. 12–15.",
   "Year": 2014
  },
  {
   "OBJECTID": 2509,
   "Continent": "Asia",
   "Country": "Myanmar",
   "ProvName": "Pegu (Bago)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-95%",
   "Numerical": 95,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "The 2014 Myanmar Population and Housing Census Census Report Volume 2-C. Department of Population Ministry of Labour, Immigration and Population MYANMAR. pp. 12–15.",
   "Year": 2014
  },
  {
   "OBJECTID": 2510,
   "Continent": "Africa",
   "Country": "Libya",
   "ProvName": "al-Jabal al-Gharbi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2511,
   "Continent": "Africa",
   "Country": "Libya",
   "ProvName": "Tarâbulus (Tripoli)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2512,
   "Continent": "Africa",
   "Country": "Libya",
   "ProvName": "al-Marqab",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2513,
   "Continent": "Africa",
   "Country": "Libya",
   "ProvName": "al-Marj",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2514,
   "Continent": "Africa",
   "Country": "Libya",
   "ProvName": "al-Jabal al-Ahdar",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2515,
   "Continent": "Africa",
   "Country": "Libya",
   "ProvName": "al-Wâhât",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2516,
   "Continent": "Asia",
   "Country": "Georgia",
   "ProvName": "Abkhazia",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 2517,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Sanliurfa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2518,
   "Continent": "Asia",
   "Country": "Myanmar",
   "ProvName": "Mon",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-95%",
   "Numerical": 95,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "The 2014 Myanmar Population and Housing Census Census Report Volume 2-C. Department of Population Ministry of Labour, Immigration and Population MYANMAR. pp. 12–15.",
   "Year": 2014
  },
  {
   "OBJECTID": 2519,
   "Continent": "Africa",
   "Country": "Libya",
   "ProvName": "al-Butnân",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2520,
   "Continent": "Africa",
   "Country": "Libya",
   "ProvName": "Surt",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2521,
   "Continent": "Africa",
   "Country": "Libya",
   "ProvName": "Darnah",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2522,
   "Continent": "Europe",
   "Country": "Greece",
   "ProvName": "Aegean Islands",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 2523,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Sirnak",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2524,
   "Continent": "Europe",
   "Country": "Greece",
   "ProvName": "Crete",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 2525,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Ankara",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2526,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Cankiri",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2527,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Konya",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2528,
   "Continent": "Asia",
   "Country": "Lebanon",
   "ProvName": "al-Biqa' (Beqaa)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "30-40%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "\"Middle East :: LEBANON\". CIA The World Factbook.",
   "Year": 2012
  },
  {
   "OBJECTID": 2529,
   "Continent": "Asia",
   "Country": "Lebanon",
   "ProvName": "ash-Shamal (North Lebanon)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/reliefweb.int\/report\/lebanon\/lebanon-north-and-akkar-governorates-profile-august-2016",
   "Year": 2016
  },
  {
   "OBJECTID": 2530,
   "Continent": "Asia",
   "Country": "Lebanon",
   "ProvName": "Bayrut (Beirut)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "30-40%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "\"Middle East :: LEBANON\". CIA The World Factbook.",
   "Year": 2012
  },
  {
   "OBJECTID": 2531,
   "Continent": "Asia",
   "Country": "Lebanon",
   "ProvName": "Jabal Lubnan (Mount Lebanon)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "30-40%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "\"Middle East :: LEBANON\". CIA The World Factbook.",
   "Year": 2012
  },
  {
   "OBJECTID": 2532,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Yozgat",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2533,
   "Continent": "Asia",
   "Country": "Georgia",
   "ProvName": "Ajaria",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 2534,
   "Continent": "Asia",
   "Country": "Georgia",
   "ProvName": "Guria",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 2535,
   "Continent": "Asia",
   "Country": "Georgia",
   "ProvName": "Samegrelo-Zemo Svanteni",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 2536,
   "Continent": "Europe",
   "Country": "Poland",
   "ProvName": "Mazowieckie",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Poland. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_180_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2537,
   "Continent": "Europe",
   "Country": "Poland",
   "ProvName": "Swietokrzyskie",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Poland. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_180_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2538,
   "Continent": "Europe",
   "Country": "Poland",
   "ProvName": "Podlaskie",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Poland. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_180_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2539,
   "Continent": "Europe",
   "Country": "Poland",
   "ProvName": "Lubelskie",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Poland. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_180_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2540,
   "Continent": "Europe",
   "Country": "Hungary",
   "ProvName": "Baranya",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Hungary. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_106_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2541,
   "Continent": "Europe",
   "Country": "Poland",
   "ProvName": "Podkarpackie",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Poland. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_180_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2542,
   "Continent": "Europe",
   "Country": "Hungary",
   "ProvName": "Györ-Moson-Sopron",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Hungary. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_106_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2543,
   "Continent": "Africa",
   "Country": "Botswana",
   "ProvName": "Central",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Pew Research Center's Religion & Public Life Project: Botswana. Pew Research Center. 2010.",
   "Year": 2010
  },
  {
   "OBJECTID": 2544,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Batman",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2545,
   "Continent": "Europe",
   "Country": "Hungary",
   "ProvName": "Somogy",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Hungary. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_106_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2546,
   "Continent": "Asia",
   "Country": "Georgia",
   "ProvName": "Imereti",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 2547,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Gümüshane",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2548,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Bayburt",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2549,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Siirt",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2550,
   "Continent": "Asia",
   "Country": "Georgia",
   "ProvName": "Kakheti",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 2551,
   "Continent": "Asia",
   "Country": "Georgia",
   "ProvName": "Mtskheta-Mtianeti",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 2552,
   "Continent": "Asia",
   "Country": "Georgia",
   "ProvName": "Racha-Lochkhumi-Kvemo Svaneti",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 2553,
   "Continent": "Asia",
   "Country": "Georgia",
   "ProvName": "T'bilisi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 2554,
   "Continent": "Asia",
   "Country": "Georgia",
   "ProvName": "Kvemo Kartli",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 2555,
   "Continent": "Asia",
   "Country": "Georgia",
   "ProvName": "Samtskhe-Javakheti",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 2556,
   "Continent": "Asia",
   "Country": "Georgia",
   "ProvName": "Shida Kartli",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 2557,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Mardin",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2558,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Tunceli",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2559,
   "Continent": "Asia",
   "Country": "Iraq",
   "ProvName": "Dahuk",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Sunni)",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "\"Middle East :: IRAQ\". CIA The World Factbook",
   "Year": 2008
  },
  {
   "OBJECTID": 2560,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Hakkari",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2561,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Van",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2562,
   "Continent": "Asia",
   "Country": "Kazakhstan",
   "ProvName": "Qyzylorda",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2563,
   "Continent": "Asia",
   "Country": "Kazakhstan",
   "ProvName": "Atyrau",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2564,
   "Continent": "Asia",
   "Country": "Iraq",
   "ProvName": "at-Ta'mim",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Sunni)",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "\"Middle East :: IRAQ\". CIA The World Factbook",
   "Year": 2008
  },
  {
   "OBJECTID": 2565,
   "Continent": "Asia",
   "Country": "Iraq",
   "ProvName": "Arbil",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Sunni)",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "\"Middle East :: IRAQ\". CIA The World Factbook",
   "Year": 2008
  },
  {
   "OBJECTID": 2566,
   "Continent": "Asia",
   "Country": "Iraq",
   "ProvName": "Ninawa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Sunni)",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "\"Middle East :: IRAQ\". CIA The World Factbook",
   "Year": 2008
  },
  {
   "OBJECTID": 2567,
   "Continent": "Asia",
   "Country": "Iraq",
   "ProvName": "Salah ad-Din",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Sunni)",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "\"Middle East :: IRAQ\". CIA The World Factbook",
   "Year": 2008
  },
  {
   "OBJECTID": 2568,
   "Continent": "Asia",
   "Country": "Israel",
   "ProvName": "Tel Aviv",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2569,
   "Continent": "Asia",
   "Country": "Israel",
   "ProvName": "Jerusalem (Yerushalayim)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2570,
   "Continent": "Asia",
   "Country": "Israel",
   "ProvName": "Southern (Ha Darom)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2571,
   "Continent": "Asia",
   "Country": "Israel",
   "ProvName": "Haifa (Hefa)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2572,
   "Continent": "Asia",
   "Country": "Israel",
   "ProvName": "Central (Ha Merkaz)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2573,
   "Continent": "Europe",
   "Country": "Finland",
   "ProvName": "Southestern Finland",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Finland. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_82_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2574,
   "Continent": "Asia",
   "Country": "Lebanon",
   "ProvName": "An-Nabatiyah",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-50%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "\"Middle East :: LEBANON\". CIA The World Factbook.",
   "Year": 2012
  },
  {
   "OBJECTID": 2575,
   "Continent": "Asia",
   "Country": "Kazakhstan",
   "ProvName": "Aqtöbe (Aktyubinsk)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2576,
   "Continent": "Asia",
   "Country": "Kazakhstan",
   "ProvName": "Qostanay",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2577,
   "Continent": "Asia",
   "Country": "Iraq",
   "ProvName": "Baghdad",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Sunni)",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "\"Middle East :: IRAQ\". CIA The World Factbook",
   "Year": 2008
  },
  {
   "OBJECTID": 2578,
   "Continent": "Asia",
   "Country": "Lebanon",
   "ProvName": "al-Janub (South Lebanon)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-50%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "\"Middle East :: LEBANON\". CIA The World Factbook.",
   "Year": 2012
  },
  {
   "OBJECTID": 2579,
   "Continent": "Asia",
   "Country": "Iraq",
   "ProvName": "an-Najaf",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Sunni)",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "\"Middle East :: IRAQ\". CIA The World Factbook",
   "Year": 2008
  },
  {
   "OBJECTID": 2580,
   "Continent": "Asia",
   "Country": "Iraq",
   "ProvName": "Karbala",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Sunni)",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "\"Middle East :: IRAQ\". CIA The World Factbook",
   "Year": 2008
  },
  {
   "OBJECTID": 2581,
   "Continent": "Africa",
   "Country": "Uganda",
   "ProvName": "Eastern",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "35-40%",
   "Nummeric_1": 40,
   "DataSource": "Uganda. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_230_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2582,
   "Continent": "Africa",
   "Country": "Uganda",
   "ProvName": "Northern",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "40-45%",
   "Nummeric_1": 45,
   "DataSource": "Uganda. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_230_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2583,
   "Continent": "Africa",
   "Country": "Ethiopia",
   "ProvName": "Gambella",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Oriental orthodox",
   "ReligCatP": "25-30%",
   "Numerical": 30,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Ethiopia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_77_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2584,
   "Continent": "Africa",
   "Country": "Ethiopia",
   "ProvName": "Oromiya",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2585,
   "Continent": "Africa",
   "Country": "Uganda",
   "ProvName": "Western",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "45-50%",
   "Nummeric_1": 50,
   "DataSource": "Uganda. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_230_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2586,
   "Continent": "Africa",
   "Country": "Ethiopia",
   "ProvName": "Amhara",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Oriental orthodox",
   "ReligCatP": "30-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Ethiopia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_77_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2587,
   "Continent": "Africa",
   "Country": "Ethiopia",
   "ProvName": "Dire-Dawa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2588,
   "Continent": "Europe",
   "Country": "Russia",
   "ProvName": "Perm'",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 2589,
   "Continent": "Africa",
   "Country": "Ethiopia",
   "ProvName": "Tigray",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Oriental orthodox",
   "ReligCatP": "30-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Ethiopia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_77_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2590,
   "Continent": "Africa",
   "Country": "Ethiopia",
   "ProvName": "Afar",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2591,
   "Continent": "Africa",
   "Country": "Ethiopia",
   "ProvName": "Southern Nations",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Oriental orthodox",
   "ReligCatP": "25-30%",
   "Numerical": 30,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Ethiopia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_77_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2592,
   "Continent": "Europe",
   "Country": "Hungary",
   "ProvName": "Veszprém",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Hungary. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_106_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2593,
   "Continent": "Africa",
   "Country": "Ethiopia",
   "ProvName": "Benishangul Gumuz",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2594,
   "Continent": "Africa",
   "Country": "Ethiopia",
   "ProvName": "Addis Ababa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Oriental orthodox",
   "ReligCatP": "30-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Ethiopia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_77_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2595,
   "Continent": "Africa",
   "Country": "Ethiopia",
   "ProvName": "Somali",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2596,
   "Continent": "Asia",
   "Country": "Kazakhstan",
   "ProvName": "Batys Qazaqstan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2597,
   "Continent": "Europe",
   "Country": "Hungary",
   "ProvName": "Zala",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Hungary. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_106_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2598,
   "Continent": "Europe",
   "Country": "Hungary",
   "ProvName": "Budapest",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Hungary. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_106_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2599,
   "Continent": "Europe",
   "Country": "Hungary",
   "ProvName": "Bács-Kiskun",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Hungary. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_106_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2600,
   "Continent": "Europe",
   "Country": "Hungary",
   "ProvName": "Fejér",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Hungary. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_106_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2601,
   "Continent": "Europe",
   "Country": "Hungary",
   "ProvName": "Pest",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Hungary. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_106_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2602,
   "Continent": "Asia",
   "Country": "Kazakhstan",
   "ProvName": "Qaraghandy",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2603,
   "Continent": "Asia",
   "Country": "Iran",
   "ProvName": "Golestan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2604,
   "Continent": "Europe",
   "Country": "Hungary",
   "ProvName": "Tolna",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Hungary. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_106_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2605,
   "Continent": "Europe",
   "Country": "Poland",
   "ProvName": "Opolskie",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Poland. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_180_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2606,
   "Continent": "Europe",
   "Country": "Hungary",
   "ProvName": "Borsod-Abaúj-Zemplén",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Hungary. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_106_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2607,
   "Continent": "Europe",
   "Country": "Hungary",
   "ProvName": "Szabolcs-Szatmár-Bereg",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Hungary. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_106_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2608,
   "Continent": "Europe",
   "Country": "Poland",
   "ProvName": "Malopolskie",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Poland. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_180_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2609,
   "Continent": "Europe",
   "Country": "Hungary",
   "ProvName": "Békés",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Hungary. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_106_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2610,
   "Continent": "Europe",
   "Country": "Hungary",
   "ProvName": "Csongrád",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Hungary. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_106_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2611,
   "Continent": "Europe",
   "Country": "Hungary",
   "ProvName": "Hajdú-Bihar",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Hungary. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_106_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2612,
   "Continent": "Europe",
   "Country": "Hungary",
   "ProvName": "Heves",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Hungary. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_106_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2613,
   "Continent": "Europe",
   "Country": "Hungary",
   "ProvName": "Jász-Nagykun-Szolnok",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Hungary. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_106_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2614,
   "Continent": "Asia",
   "Country": "Iran",
   "ProvName": "Mazandaran",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2615,
   "Continent": "Asia",
   "Country": "Iran",
   "ProvName": "Semnan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2616,
   "Continent": "Asia",
   "Country": "Iran",
   "ProvName": "Yazd",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2617,
   "Continent": "Asia",
   "Country": "Iran",
   "ProvName": "Chahar Mahall Bakhtiari",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2618,
   "Continent": "Asia",
   "Country": "Iraq",
   "ProvName": "al-Basrah",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Sunni)",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "\"Middle East :: IRAQ\". CIA The World Factbook",
   "Year": 2008
  },
  {
   "OBJECTID": 2619,
   "Continent": "Asia",
   "Country": "Iran",
   "ProvName": "Khuzestan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2620,
   "Continent": "Asia",
   "Country": "Iran",
   "ProvName": "Lorestan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2621,
   "Continent": "Asia",
   "Country": "Iran",
   "ProvName": "Ilam",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2622,
   "Continent": "Asia",
   "Country": "Iran",
   "ProvName": "Zanjan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2623,
   "Continent": "Asia",
   "Country": "Iran",
   "ProvName": "Qazvin",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2624,
   "Continent": "Asia",
   "Country": "Kazakhstan",
   "ProvName": "Mangghystau",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2625,
   "Continent": "Asia",
   "Country": "Iran",
   "ProvName": "Azarbaijan-e Gharbi (West)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2626,
   "Continent": "Asia",
   "Country": "Iran",
   "ProvName": "Azarbaijan-e Sharqi (East)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2627,
   "Continent": "Asia",
   "Country": "Iran",
   "ProvName": "Kermanshahan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2628,
   "Continent": "Asia",
   "Country": "Iran",
   "ProvName": "Gilan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2629,
   "Continent": "Asia",
   "Country": "Iran",
   "ProvName": "Kordestan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2630,
   "Continent": "Asia",
   "Country": "Iraq",
   "ProvName": "as-Sulaymaniyah",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Sunni)",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "\"Middle East :: IRAQ\". CIA The World Factbook",
   "Year": 2008
  },
  {
   "OBJECTID": 2631,
   "Continent": "Asia",
   "Country": "Iraq",
   "ProvName": "Diyala",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Sunni)",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "\"Middle East :: IRAQ\". CIA The World Factbook",
   "Year": 2008
  },
  {
   "OBJECTID": 2632,
   "Continent": "Asia",
   "Country": "Iran",
   "ProvName": "South Khorasan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2633,
   "Continent": "North America",
   "Country": "United States",
   "ProvName": "Massachusetts",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "30-35%",
   "Numerical": 35,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Adults in Massachusetts\". Pew Research Center.https:\/\/www.pewforum.org\/religious-landscape-study\/state\/Massachusetts\/",
   "Year": 2014
  },
  {
   "OBJECTID": 2634,
   "Continent": "North America",
   "Country": "United States",
   "ProvName": "Minnesota",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Adults in Minnesota\". Pew Research Center.https:\/\/www.pewforum.org\/religious-landscape-study\/state\/Minnesota\/",
   "Year": 2014
  },
  {
   "OBJECTID": 2635,
   "Continent": "North America",
   "Country": "United States",
   "ProvName": "Montana",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Adults in Montana\". Pew Research Center.https:\/\/www.pewforum.org\/religious-landscape-study\/state\/Montana\/",
   "Year": 2014
  },
  {
   "OBJECTID": 2636,
   "Continent": "North America",
   "Country": "United States",
   "ProvName": "North Dakota",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Adults in North Dakota\". Pew Research Center.https:\/\/www.pewforum.org\/religious-landscape-study\/state\/North Dakota\/",
   "Year": 2014
  },
  {
   "OBJECTID": 2637,
   "Continent": "Oceania",
   "Country": "United States",
   "ProvName": "Hawaii",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Adults in Hawaii\". Pew Research Center.https:\/\/www.pewforum.org\/religious-landscape-study\/state\/Hawaii\/",
   "Year": 2014
  },
  {
   "OBJECTID": 2638,
   "Continent": "North America",
   "Country": "United States",
   "ProvName": "Idaho",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Adults in Idaho\". Pew Research Center.https:\/\/www.pewforum.org\/religious-landscape-study\/state\/Idaho\/",
   "Year": 2014
  },
  {
   "OBJECTID": 2639,
   "Continent": "North America",
   "Country": "United States",
   "ProvName": "Washington",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-45%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Adults in Washington\". Pew Research Center.https:\/\/www.pewforum.org\/religious-landscape-study\/state\/Washington\/",
   "Year": 2014
  },
  {
   "OBJECTID": 2640,
   "Continent": "North America",
   "Country": "United States",
   "ProvName": "Colorado",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Adults in Colorado\". Pew Research Center. https:\/\/www.pewforum.org\/religious-landscape-study\/state\/colorado\/",
   "Year": 2014
  },
  {
   "OBJECTID": 2641,
   "Continent": "Africa",
   "Country": "Senegal",
   "ProvName": "Kaolack",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2642,
   "Continent": "North America",
   "Country": "United States",
   "ProvName": "Arizona",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Adults in Arizona\". Pew Research Center. https:\/\/www.pewforum.org\/religious-landscape-study\/state\/arizona\/",
   "Year": 2014
  },
  {
   "OBJECTID": 2643,
   "Continent": "North America",
   "Country": "United States",
   "ProvName": "California",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "30-35%",
   "Numerical": 35,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "\"Adults in California\". Pew Research Center.https:\/\/www.pewforum.org\/religious-landscape-study\/state\/california\/",
   "Year": 2014
  },
  {
   "OBJECTID": 2644,
   "Continent": "Asia",
   "Country": "Iraq",
   "ProvName": "al-Muthanna",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Sunni)",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "\"Middle East :: IRAQ\". CIA The World Factbook",
   "Year": 2008
  },
  {
   "OBJECTID": 2645,
   "Continent": "Asia",
   "Country": "Iraq",
   "ProvName": "al-Qadisiyah",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Sunni)",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "\"Middle East :: IRAQ\". CIA The World Factbook",
   "Year": 2008
  },
  {
   "OBJECTID": 2646,
   "Continent": "Asia",
   "Country": "Iraq",
   "ProvName": "Dhi Qar",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Sunni)",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "\"Middle East :: IRAQ\". CIA The World Factbook",
   "Year": 2008
  },
  {
   "OBJECTID": 2647,
   "Continent": "Africa",
   "Country": "Tunisia",
   "ProvName": "Manubah",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "\"Chapter 1: Religious Affiliation\". The World’s Muslims: Unity and Diversity. Pew Research Center's Religion & Public Life Project. August 9, 2012.",
   "Year": 2012
  },
  {
   "OBJECTID": 2648,
   "Continent": "Asia",
   "Country": "Iraq",
   "ProvName": "Maysan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Sunni)",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "\"Middle East :: IRAQ\". CIA The World Factbook",
   "Year": 2008
  },
  {
   "OBJECTID": 2649,
   "Continent": "Asia",
   "Country": "Iraq",
   "ProvName": "Wasit",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Sunni)",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "\"Middle East :: IRAQ\". CIA The World Factbook",
   "Year": 2008
  },
  {
   "OBJECTID": 2650,
   "Continent": "Asia",
   "Country": "Iran",
   "ProvName": "Hormozgan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2651,
   "Continent": "Asia",
   "Country": "Iran",
   "ProvName": "Ardabil",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2652,
   "Continent": "Asia",
   "Country": "Iran",
   "ProvName": "Markazi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2653,
   "Continent": "Asia",
   "Country": "Iran",
   "ProvName": "Qom",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2654,
   "Continent": "Asia",
   "Country": "Iran",
   "ProvName": "Hamadan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2655,
   "Continent": "Asia",
   "Country": "Iran",
   "ProvName": "North Khorasan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2656,
   "Continent": "Asia",
   "Country": "Myanmar",
   "ProvName": "Rakhine (Arakan)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Sunni)",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "The 2014 Myanmar Population and Housing Census Census Report Volume 2-C. Department of Population Ministry of Labour, Immigration and Population MYANMAR. pp. 12–15.",
   "Year": 2014
  },
  {
   "OBJECTID": 2657,
   "Continent": "Asia",
   "Country": "Iran",
   "ProvName": "Razavi Khorasan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2658,
   "Continent": "Asia",
   "Country": "Iran",
   "ProvName": "Sistan-va Baluchestan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2659,
   "Continent": "Asia",
   "Country": "Iran",
   "ProvName": "Kerman",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2660,
   "Continent": "Asia",
   "Country": "India",
   "ProvName": "Punjab",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2661,
   "Continent": "Asia",
   "Country": "India",
   "ProvName": "Rajasthan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Hinduism",
   "HighRelig": "Hindus",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2662,
   "Continent": "Asia",
   "Country": "Kazakhstan",
   "ProvName": "Zhambyl",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2663,
   "Continent": "Asia",
   "Country": "India",
   "ProvName": "Uttar Pradesh",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Hinduism",
   "HighRelig": "Hindus",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2664,
   "Continent": "Asia",
   "Country": "India",
   "ProvName": "Uttarakhand",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Hinduism",
   "HighRelig": "Hindus",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2665,
   "Continent": "Asia",
   "Country": "Kazakhstan",
   "ProvName": "Ongtüstik Qazaqstan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2666,
   "Continent": "Asia",
   "Country": "Bangladesh",
   "ProvName": "Rajshahi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2667,
   "Continent": "Asia",
   "Country": "India",
   "ProvName": "Jharkhand",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Hinduism",
   "HighRelig": "Hindus",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2668,
   "Continent": "Asia",
   "Country": "India",
   "ProvName": "West Bengal",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Hinduism",
   "HighRelig": "Hindus",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2669,
   "Continent": "Asia",
   "Country": "India",
   "ProvName": "Bihar",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Hinduism",
   "HighRelig": "Hindus",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2670,
   "Continent": "Asia",
   "Country": "India",
   "ProvName": "Sikkim",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Hinduism",
   "HighRelig": "Hindus",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2671,
   "Continent": "Asia",
   "Country": "Myanmar",
   "ProvName": "Chin",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "The 2014 Myanmar Population and Housing Census Census Report Volume 2-C. Department of Population Ministry of Labour, Immigration and Population MYANMAR. pp. 12–15.",
   "Year": 2014
  },
  {
   "OBJECTID": 2672,
   "Continent": "Asia",
   "Country": "Myanmar",
   "ProvName": "Irrawaddy (Ayeyarwady)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-95%",
   "Numerical": 95,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "The 2014 Myanmar Population and Housing Census Census Report Volume 2-C. Department of Population Ministry of Labour, Immigration and Population MYANMAR. pp. 12–15.",
   "Year": 2014
  },
  {
   "OBJECTID": 2673,
   "Continent": "Asia",
   "Country": "Myanmar",
   "ProvName": "Magwe (Magway)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "The 2014 Myanmar Population and Housing Census Census Report Volume 2-C. Department of Population Ministry of Labour, Immigration and Population MYANMAR. pp. 12–15.",
   "Year": 2014
  },
  {
   "OBJECTID": 2674,
   "Continent": "Asia",
   "Country": "Myanmar",
   "ProvName": "Shan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "The 2014 Myanmar Population and Housing Census Census Report Volume 2-C. Department of Population Ministry of Labour, Immigration and Population MYANMAR. pp. 12–15.",
   "Year": 2014
  },
  {
   "OBJECTID": 2675,
   "Continent": "Asia",
   "Country": "Myanmar",
   "ProvName": "Tenasserim (Tanintharyi)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "The 2014 Myanmar Population and Housing Census Census Report Volume 2-C. Department of Population Ministry of Labour, Immigration and Population MYANMAR. pp. 12–15.",
   "Year": 2014
  },
  {
   "OBJECTID": 2676,
   "Continent": "Africa",
   "Country": "Senegal",
   "ProvName": "Kaffrine",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2677,
   "Continent": "Africa",
   "Country": "Tanzania",
   "ProvName": "Mbeya",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "35-40%",
   "Nummeric_1": 40,
   "DataSource": "Tanzania. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_219_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2678,
   "Continent": "Oceania",
   "Country": "Solomon Islands",
   "ProvName": "Honiara",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Solomon Islands. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_204_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2679,
   "Continent": "Africa",
   "Country": "Tanzania",
   "ProvName": "Rukwa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2680,
   "Continent": "Africa",
   "Country": "Tanzania",
   "ProvName": "Zanzibar South and Central",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2681,
   "Continent": "Africa",
   "Country": "Somalia",
   "ProvName": "Awdal",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2682,
   "Continent": "Africa",
   "Country": "Namibia",
   "ProvName": "Karas",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "15-20%",
   "Nummeric_1": 20,
   "DataSource": "Namibia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_157_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2683,
   "Continent": "North America",
   "Country": "Nicaragua",
   "ProvName": "Rio San Juan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "35-40%",
   "Nummeric_1": 40,
   "DataSource": "Nicaragua. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_164_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2684,
   "Continent": "North America",
   "Country": "Cuba",
   "ProvName": "Mayabeque",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "30-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Cuba. Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_63_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2685,
   "Continent": "Africa",
   "Country": "Namibia",
   "ProvName": "Hardap",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "20-25%",
   "Nummeric_1": 25,
   "DataSource": "Namibia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_157_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2686,
   "Continent": "Africa",
   "Country": "Namibia",
   "ProvName": "Omusati",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "15-20%",
   "Nummeric_1": 20,
   "DataSource": "Namibia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_157_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2687,
   "Continent": "Africa",
   "Country": "Namibia",
   "ProvName": "Khomas",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "15-20%",
   "Nummeric_1": 20,
   "DataSource": "Namibia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_157_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2688,
   "Continent": "Africa",
   "Country": "Congo",
   "ProvName": "Cuvette",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "\"Congo, Republic of the\". Association of Religion Data Archives. 2015 http:\/\/www.thearda.com\/internationalData\/countries\/Country_57_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2689,
   "Continent": "Africa",
   "Country": "Congo",
   "ProvName": "Lékoumou",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "\"Congo, Republic of the\". Association of Religion Data Archives. 2015 http:\/\/www.thearda.com\/internationalData\/countries\/Country_57_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2690,
   "Continent": "Africa",
   "Country": "Congo",
   "ProvName": "Niari",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "\"Congo, Republic of the\". Association of Religion Data Archives. 2015 http:\/\/www.thearda.com\/internationalData\/countries\/Country_57_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2691,
   "Continent": "Africa",
   "Country": "Congo",
   "ProvName": "Plateaux",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "\"Congo, Republic of the\". Association of Religion Data Archives. 2015 http:\/\/www.thearda.com\/internationalData\/countries\/Country_57_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2692,
   "Continent": "Africa",
   "Country": "Namibia",
   "ProvName": "Kunene",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "15-20%",
   "Nummeric_1": 20,
   "DataSource": "Namibia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_157_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2693,
   "Continent": "North America",
   "Country": "Nicaragua",
   "ProvName": "Rivas",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "35-40%",
   "Nummeric_1": 40,
   "DataSource": "Nicaragua. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_164_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2694,
   "Continent": "Africa",
   "Country": "Namibia",
   "ProvName": "Erongo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-65%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "15-20%",
   "Nummeric_1": 20,
   "DataSource": "Namibia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_157_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2695,
   "Continent": "Africa",
   "Country": "Namibia",
   "ProvName": "Oshana",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "15-20%",
   "Nummeric_1": 20,
   "DataSource": "Namibia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_157_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2696,
   "Continent": "Africa",
   "Country": "Namibia",
   "ProvName": "Ohangwena",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "15-20%",
   "Nummeric_1": 20,
   "DataSource": "Namibia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_157_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2697,
   "Continent": "Africa",
   "Country": "Namibia",
   "ProvName": "Otjozondjupa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "20-25%",
   "Nummeric_1": 25,
   "DataSource": "Namibia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_157_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2698,
   "Continent": "Africa",
   "Country": "Niger",
   "ProvName": "Tillabéri",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2699,
   "Continent": "Oceania",
   "Country": "New Zealand",
   "ProvName": "Marlborough",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "25-30%",
   "Numerical": 30,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "New Zealand. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_163_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2700,
   "Continent": "Africa",
   "Country": "Namibia",
   "ProvName": "Omaheke",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "15-20%",
   "Nummeric_1": 20,
   "DataSource": "Namibia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_157_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2701,
   "Continent": "Africa",
   "Country": "Namibia",
   "ProvName": "Okavango",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "15-20%",
   "Nummeric_1": 20,
   "DataSource": "Namibia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_157_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2702,
   "Continent": "Africa",
   "Country": "Tanzania",
   "ProvName": "Pemba North",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2703,
   "Continent": "Africa",
   "Country": "Namibia",
   "ProvName": "Oshikoto",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "15-20%",
   "Nummeric_1": 20,
   "DataSource": "Namibia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_157_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2704,
   "Continent": "Africa",
   "Country": "Namibia",
   "ProvName": "Liambezi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "20-25%",
   "Nummeric_1": 25,
   "DataSource": "Namibia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_157_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2705,
   "Continent": "Africa",
   "Country": "Tanzania",
   "ProvName": "Mwanza",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "35-40%",
   "Nummeric_1": 40,
   "DataSource": "Tanzania. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_219_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2706,
   "Continent": "Africa",
   "Country": "Tanzania",
   "ProvName": "Pemba South",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2707,
   "Continent": "Africa",
   "Country": "Tanzania",
   "ProvName": "Mara",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "30-35%",
   "Numerical": 35,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Tanzania. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_219_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2708,
   "Continent": "Africa",
   "Country": "Tanzania",
   "ProvName": "Shinyanga",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2709,
   "Continent": "Africa",
   "Country": "Tanzania",
   "ProvName": "Dodoma",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "35-40%",
   "Nummeric_1": 40,
   "DataSource": "Tanzania. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_219_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2710,
   "Continent": "Africa",
   "Country": "Tanzania",
   "ProvName": "Tabora",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "30-35%",
   "Numerical": 35,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Tanzania. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_219_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2711,
   "Continent": "Africa",
   "Country": "Tanzania",
   "ProvName": "Singida",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2712,
   "Continent": "Africa",
   "Country": "Tanzania",
   "ProvName": "Kagera",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "30-35%",
   "Numerical": 35,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Tanzania. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_219_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2713,
   "Continent": "Africa",
   "Country": "Tanzania",
   "ProvName": "Arusha",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "35-40%",
   "Nummeric_1": 40,
   "DataSource": "Tanzania. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_219_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2714,
   "Continent": "Africa",
   "Country": "Tanzania",
   "ProvName": "Kigoma",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "35-40%",
   "Nummeric_1": 40,
   "DataSource": "Tanzania. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_219_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2715,
   "Continent": "Africa",
   "Country": "Burundi",
   "ProvName": "Mwaro",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Anthony Appiah; Henry Louis Gates (2010). Encyclopedia of Africa. Oxford University Press. p. 221. ISBN 978-0-19-533770-9.",
   "Year": 2010
  },
  {
   "OBJECTID": 2716,
   "Continent": "Africa",
   "Country": "Tanzania",
   "ProvName": "Dar es Salaam",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "30-35%",
   "Numerical": 35,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Tanzania. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_219_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2717,
   "Continent": "Africa",
   "Country": "Tanzania",
   "ProvName": "Morogoro",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2718,
   "Continent": "Oceania",
   "Country": "New Zealand",
   "ProvName": "Nelson",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "25-30%",
   "Numerical": 30,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "New Zealand. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_163_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2719,
   "Continent": "Africa",
   "Country": "Somalia",
   "ProvName": "Woqooyi Galbeed",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2720,
   "Continent": "Africa",
   "Country": "Tanzania",
   "ProvName": "Pwani (Coast)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "30-35%",
   "Numerical": 35,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Tanzania. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_219_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2721,
   "Continent": "Africa",
   "Country": "Tanzania",
   "ProvName": "Zanzibar North",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2722,
   "Continent": "Africa",
   "Country": "Tanzania",
   "ProvName": "Zanzibar West",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2723,
   "Continent": "Africa",
   "Country": "Somalia",
   "ProvName": "Togdheer",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2724,
   "Continent": "Africa",
   "Country": "Tanzania",
   "ProvName": "Iringa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "35-40%",
   "Nummeric_1": 40,
   "DataSource": "Tanzania. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_219_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2725,
   "Continent": "Africa",
   "Country": "Tanzania",
   "ProvName": "Tanga",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2726,
   "Continent": "Africa",
   "Country": "Tanzania",
   "ProvName": "Lindi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "30-35%",
   "Numerical": 35,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Tanzania. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_219_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2727,
   "Continent": "North America",
   "Country": "United States",
   "ProvName": "Wyoming",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Adults in Florida\". Pew Research Center.https:\/\/www.pewforum.org\/religious-landscape-study\/state\/Florida\/",
   "Year": 2014
  },
  {
   "OBJECTID": 2728,
   "Continent": "Africa",
   "Country": "Tanzania",
   "ProvName": "Mtwara",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2729,
   "Continent": "Africa",
   "Country": "Tanzania",
   "ProvName": "Manyara",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "30-35%",
   "Numerical": 35,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Tanzania. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_219_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2730,
   "Continent": "Africa",
   "Country": "Somalia",
   "ProvName": "Sool",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2731,
   "Continent": "Africa",
   "Country": "Tanzania",
   "ProvName": "Ruvuma",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "30-35%",
   "Numerical": 35,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Tanzania. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_219_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2732,
   "Continent": "Africa",
   "Country": "Somalia",
   "ProvName": "Sanaag",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2733,
   "Continent": "Oceania",
   "Country": "New Zealand",
   "ProvName": "Gisborne",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "25-30%",
   "Numerical": 30,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "New Zealand. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_163_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2734,
   "Continent": "Oceania",
   "Country": "New Zealand",
   "ProvName": "Hawkes Bay",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "15-20%",
   "Numerical": 20,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "New Zealand. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_163_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2735,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Karabük",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2736,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Bartin",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2737,
   "Continent": "Oceania",
   "Country": "New Zealand",
   "ProvName": "Bay of Plenty",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "15-20%",
   "Numerical": 20,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "New Zealand. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_163_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2738,
   "Continent": "Oceania",
   "Country": "New Zealand",
   "ProvName": "Canterbury",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "15-20%",
   "Numerical": 20,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "New Zealand. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_163_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2739,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Gaziantep",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2740,
   "Continent": "Oceania",
   "Country": "New Zealand",
   "ProvName": "Tasman",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "25-30%",
   "Numerical": 30,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "New Zealand. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_163_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2741,
   "Continent": "Oceania",
   "Country": "New Zealand",
   "ProvName": "Northland",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "25-30%",
   "Numerical": 30,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "New Zealand. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_163_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2742,
   "Continent": "Oceania",
   "Country": "New Zealand",
   "ProvName": "Taranaki",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "25-30%",
   "Numerical": 30,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "New Zealand. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_163_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2743,
   "Continent": "Oceania",
   "Country": "New Zealand",
   "ProvName": "West Coast",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "25-30%",
   "Numerical": 30,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "New Zealand. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_163_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2744,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Kilis",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2745,
   "Continent": "Oceania",
   "Country": "New Zealand",
   "ProvName": "Otago",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "25-30%",
   "Numerical": 30,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "New Zealand. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_163_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2746,
   "Continent": "Oceania",
   "Country": "New Zealand",
   "ProvName": "Southland",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "25-30%",
   "Numerical": 30,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "New Zealand. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_163_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2747,
   "Continent": "Europe",
   "Country": "Spain",
   "ProvName": "Aragón",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Spain. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_208_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2748,
   "Continent": "Oceania",
   "Country": "Cook Islands",
   "ProvName": "Cook Islands",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Cook Islands. Association of Religion Data Archives. (2015) http:\/\/www.thearda.com\/internationalData\/countries\/Country_59_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2749,
   "Continent": "Europe",
   "Country": "Spain",
   "ProvName": "Navarra",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Spain. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_208_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2750,
   "Continent": "South America",
   "Country": "Netherlands Antilles",
   "ProvName": "Curacao",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/en.wikipedia.org\/wiki\/Netherlands_Antilles",
   "Year": 2008
  },
  {
   "OBJECTID": 2751,
   "Continent": "Asia",
   "Country": "Afghanistan",
   "ProvName": "Paktia",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2752,
   "Continent": "Asia",
   "Country": "Taiwan*",
   "ProvName": "P'eng-hu",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2753,
   "Continent": "Asia",
   "Country": "Taiwan*",
   "ProvName": "Chinmen (Kinmen)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2754,
   "Continent": "Europe",
   "Country": "Denmark",
   "ProvName": "Central Jutland (Midtjylland)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Denmark. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_66_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2755,
   "Continent": "Europe",
   "Country": "Denmark",
   "ProvName": "South Denmark (Syddanmark)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Denmark. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_66_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2756,
   "Continent": "North America",
   "Country": "Cayman Islands",
   "ProvName": "Cayman Islands",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "10-20%",
   "Nummeric_1": 20,
   "DataSource": "\"Central America :: Cayman Islands — The World Factbook - Central Intelligence Agency\".",
   "Year": 2019
  },
  {
   "OBJECTID": 2757,
   "Continent": "South America",
   "Country": "Falkland Islands",
   "ProvName": "Falkland Islands",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "30-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "10-20%",
   "Nummeric_1": 20,
   "DataSource": "Falkland Islands. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_79_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2758,
   "Continent": "Oceania",
   "Country": "Guam",
   "ProvName": "Guam",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Guam.The Association of Religion Data Archives. (2015).  http:\/\/www.thearda.com\/internationalData\/countries\/Country_97_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2759,
   "Continent": "Europe",
   "Country": "Denmark",
   "ProvName": "North Jutland (Nordjylland)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Denmark. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_66_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2760,
   "Continent": "Europe",
   "Country": "Denmark",
   "ProvName": "Capital (Hovedstaden)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Denmark. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_66_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2761,
   "Continent": "Europe",
   "Country": "Denmark",
   "ProvName": "Zealand (Sjælland)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Denmark. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_66_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2762,
   "Continent": "Europe",
   "Country": "Switzerland",
   "ProvName": "Basel-Landschaft",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "\"Religions\" (official statistics). Neuchâtel, Switzerland: Federal Statistical Office FSO. 2020.",
   "Year": 2018
  },
  {
   "OBJECTID": 2763,
   "Continent": "Europe",
   "Country": "Switzerland",
   "ProvName": "Bern",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "\"Religions\" (official statistics). Neuchâtel, Switzerland: Federal Statistical Office FSO. 2020.",
   "Year": 2018
  },
  {
   "OBJECTID": 2764,
   "Continent": "Europe",
   "Country": "Switzerland",
   "ProvName": "Basel-Stadt",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "\"Religions\" (official statistics). Neuchâtel, Switzerland: Federal Statistical Office FSO. 2020.",
   "Year": 2018
  },
  {
   "OBJECTID": 2765,
   "Continent": "Europe",
   "Country": "Switzerland",
   "ProvName": "Fribourg",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "\"Religions\" (official statistics). Neuchâtel, Switzerland: Federal Statistical Office FSO. 2020.",
   "Year": 2018
  },
  {
   "OBJECTID": 2766,
   "Continent": "Africa",
   "Country": "Botswana",
   "ProvName": "North East",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Pew Research Center's Religion & Public Life Project: Botswana. Pew Research Center. 2010.",
   "Year": 2010
  },
  {
   "OBJECTID": 2767,
   "Continent": "Europe",
   "Country": "Switzerland",
   "ProvName": "Vaud",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "\"Religions\" (official statistics). Neuchâtel, Switzerland: Federal Statistical Office FSO. 2020.",
   "Year": 2018
  },
  {
   "OBJECTID": 2768,
   "Continent": "Africa",
   "Country": "Cape Verde",
   "ProvName": "Santo Antao",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "nternational Religious Freedom Report 2007: Cape Verde. United States Bureau of Democracy, Human Rights and Labor (September 14, 2007)",
   "Year": 2008
  },
  {
   "OBJECTID": 2769,
   "Continent": "Europe",
   "Country": "Switzerland",
   "ProvName": "Solothurn",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "\"Religions\" (official statistics). Neuchâtel, Switzerland: Federal Statistical Office FSO. 2020.",
   "Year": 2018
  },
  {
   "OBJECTID": 2770,
   "Continent": "Europe",
   "Country": "Switzerland",
   "ProvName": "Obwalden",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "\"Religions\" (official statistics). Neuchâtel, Switzerland: Federal Statistical Office FSO. 2020.",
   "Year": 2018
  },
  {
   "OBJECTID": 2771,
   "Continent": "Europe",
   "Country": "Sweden",
   "ProvName": "Vastra Gotaland",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"The Religious Landscape of Sweden\". www.myndighetensst.se. 2019.",
   "Year": 2016
  },
  {
   "OBJECTID": 2772,
   "Continent": "Africa",
   "Country": "Cape Verde",
   "ProvName": "São Vicente",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "nternational Religious Freedom Report 2007: Cape Verde. United States Bureau of Democracy, Human Rights and Labor (September 14, 2007)",
   "Year": 2008
  },
  {
   "OBJECTID": 2773,
   "Continent": "North America",
   "Country": "Bermuda",
   "ProvName": "Hamilton city",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "50-60%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "10-20%",
   "Nummeric_1": 20,
   "DataSource": "\"Religions in Bermuda | PEW-GRF\". http:\/\/www.globalreligiousfutures.org\/countries\/bermuda#\/?affiliations_religion_id=11&affiliations_year=2010",
   "Year": 2010
  },
  {
   "OBJECTID": 2774,
   "Continent": "Europe",
   "Country": "Sweden",
   "ProvName": "Skåne",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"The Religious Landscape of Sweden\". www.myndighetensst.se. 2019.",
   "Year": 2016
  },
  {
   "OBJECTID": 2775,
   "Continent": "Europe",
   "Country": "Spain",
   "ProvName": "Valencia",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Spain. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_208_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2776,
   "Continent": "Africa",
   "Country": "Cote d'Ivoire",
   "ProvName": "Savanes",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2777,
   "Continent": "Africa",
   "Country": "Cote d'Ivoire",
   "ProvName": "Marahoué",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "10-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2778,
   "Continent": "North America",
   "Country": "Bermuda",
   "ProvName": "Smith's",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "50-60%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "10-20%",
   "Nummeric_1": 20,
   "DataSource": "\"Religions in Bermuda | PEW-GRF\". http:\/\/www.globalreligiousfutures.org\/countries\/bermuda#\/?affiliations_religion_id=11&affiliations_year=2010",
   "Year": 2010
  },
  {
   "OBJECTID": 2779,
   "Continent": "Africa",
   "Country": "Guinea",
   "ProvName": "Labé",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2780,
   "Continent": "Africa",
   "Country": "Guinea",
   "ProvName": "Kankan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2781,
   "Continent": "Africa",
   "Country": "Cote d'Ivoire",
   "ProvName": "Fromager",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2782,
   "Continent": "Africa",
   "Country": "Guinea",
   "ProvName": "Mamou",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2783,
   "Continent": "Africa",
   "Country": "Guinea",
   "ProvName": "Boké",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2784,
   "Continent": "Africa",
   "Country": "Guinea",
   "ProvName": "Kindia",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2785,
   "Continent": "North America",
   "Country": "Panama",
   "ProvName": "Emberá",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Panama. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_174_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2786,
   "Continent": "Africa",
   "Country": "Cote d'Ivoire",
   "ProvName": "Denguélé",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2787,
   "Continent": "Africa",
   "Country": "Guinea",
   "ProvName": "Nzérékoré",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2788,
   "Continent": "Africa",
   "Country": "Guinea",
   "ProvName": "Faranah",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2789,
   "Continent": "Africa",
   "Country": "Cote d'Ivoire",
   "ProvName": "Lagunes",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "10-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2790,
   "Continent": "Africa",
   "Country": "Cote d'Ivoire",
   "ProvName": "Bafing",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2791,
   "Continent": "Africa",
   "Country": "Cape Verde",
   "ProvName": "São Nicolau",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "nternational Religious Freedom Report 2007: Cape Verde. United States Bureau of Democracy, Human Rights and Labor (September 14, 2007)",
   "Year": 2008
  },
  {
   "OBJECTID": 2792,
   "Continent": "Africa",
   "Country": "Cape Verde",
   "ProvName": "Sal",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "nternational Religious Freedom Report 2007: Cape Verde. United States Bureau of Democracy, Human Rights and Labor (September 14, 2007)",
   "Year": 2008
  },
  {
   "OBJECTID": 2793,
   "Continent": "Africa",
   "Country": "Cape Verde",
   "ProvName": "Boa Vista",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "nternational Religious Freedom Report 2007: Cape Verde. United States Bureau of Democracy, Human Rights and Labor (September 14, 2007)",
   "Year": 2008
  },
  {
   "OBJECTID": 2794,
   "Continent": "Africa",
   "Country": "Cote d'Ivoire",
   "ProvName": "Dix-huit Montagnes",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2795,
   "Continent": "Africa",
   "Country": "Guinea",
   "ProvName": "Conakry",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2796,
   "Continent": "Africa",
   "Country": "Cape Verde",
   "ProvName": "Maio",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "nternational Religious Freedom Report 2007: Cape Verde. United States Bureau of Democracy, Human Rights and Labor (September 14, 2007)",
   "Year": 2008
  },
  {
   "OBJECTID": 2797,
   "Continent": "Africa",
   "Country": "Cote d'Ivoire",
   "ProvName": "Worodougou",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2798,
   "Continent": "Africa",
   "Country": "Cape Verde",
   "ProvName": "Santiago",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "nternational Religious Freedom Report 2007: Cape Verde. United States Bureau of Democracy, Human Rights and Labor (September 14, 2007)",
   "Year": 2008
  },
  {
   "OBJECTID": 2799,
   "Continent": "Africa",
   "Country": "Cape Verde",
   "ProvName": "Fogo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "nternational Religious Freedom Report 2007: Cape Verde. United States Bureau of Democracy, Human Rights and Labor (September 14, 2007)",
   "Year": 2008
  },
  {
   "OBJECTID": 2800,
   "Continent": "Africa",
   "Country": "Cote d'Ivoire",
   "ProvName": "Haut-Sassandra",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2801,
   "Continent": "Africa",
   "Country": "Cote d'Ivoire",
   "ProvName": "Sud-Bandama",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "30-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "10-20%",
   "Nummeric_1": 20,
   "DataSource": "Cote d'Ivoire. Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_61_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2802,
   "Continent": "Africa",
   "Country": "Cape Verde",
   "ProvName": "Brava",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "nternational Religious Freedom Report 2007: Cape Verde. United States Bureau of Democracy, Human Rights and Labor (September 14, 2007)",
   "Year": 2008
  },
  {
   "OBJECTID": 2803,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Bolu",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2804,
   "Continent": "Africa",
   "Country": "Cote d'Ivoire",
   "ProvName": "Bas-Sassandra",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2805,
   "Continent": "Africa",
   "Country": "Cote d'Ivoire",
   "ProvName": "Zanzan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2806,
   "Continent": "Africa",
   "Country": "Cote d'Ivoire",
   "ProvName": "Vallée du Bandama",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "20-30%",
   "Numerical": 30,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "10-20%",
   "Nummeric_1": 20,
   "DataSource": "Cote d'Ivoire. Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_61_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2807,
   "Continent": "Africa",
   "Country": "Cote d'Ivoire",
   "ProvName": "Agnébi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "10-20%",
   "Nummeric_1": 20,
   "DataSource": "Cote d'Ivoire. Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_61_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2808,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Düzce",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2809,
   "Continent": "Africa",
   "Country": "Cote d'Ivoire",
   "ProvName": "N'zi-Comoé",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "30-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "10-20%",
   "Nummeric_1": 20,
   "DataSource": "Cote d'Ivoire. Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_61_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2810,
   "Continent": "Africa",
   "Country": "Chad",
   "ProvName": "Borkou",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "50-60%",
   "Numerical": 95,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "\"The World's Muslims: Unity and Diversity\" (PDF). Pew Forum on Religious & Public life. 9 August 2012. pp. 128–129.",
   "Year": 2012
  },
  {
   "OBJECTID": 2811,
   "Continent": "Africa",
   "Country": "Lesotho",
   "ProvName": "Mafeteng",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "40-45%",
   "Nummeric_1": 45,
   "DataSource": "Lesotho.  The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_130_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2812,
   "Continent": "North America",
   "Country": "Panama",
   "ProvName": "Ngäbe Buglé",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Panama. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_174_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2813,
   "Continent": "Africa",
   "Country": "Cote d'Ivoire",
   "ProvName": "Moyen-Cavally",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2814,
   "Continent": "Africa",
   "Country": "Chad",
   "ProvName": "Ennedi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "50-60%",
   "Numerical": 95,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "\"The World's Muslims: Unity and Diversity\" (PDF). Pew Forum on Religious & Public life. 9 August 2012. pp. 128–129.",
   "Year": 2012
  },
  {
   "OBJECTID": 2815,
   "Continent": "Africa",
   "Country": "Cote d'Ivoire",
   "ProvName": "Moyen-Comoé",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2816,
   "Continent": "Africa",
   "Country": "Cote d'Ivoire",
   "ProvName": "Sud-Comoé",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "10-20%",
   "Nummeric_1": 20,
   "DataSource": "Cote d'Ivoire. Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_61_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2817,
   "Continent": "Africa",
   "Country": "Cote d'Ivoire",
   "ProvName": "Lacs",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "20-30%",
   "Numerical": 30,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "10-20%",
   "Nummeric_1": 20,
   "DataSource": "Cote d'Ivoire. Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_61_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2818,
   "Continent": "Asia",
   "Country": "Cyprus",
   "ProvName": "Paphos",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 2819,
   "Continent": "Asia",
   "Country": "Cyprus",
   "ProvName": "Larnaca",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 2820,
   "Continent": "Asia",
   "Country": "Cyprus",
   "ProvName": "Nicosia",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 2821,
   "Continent": "North America",
   "Country": "Guatemala",
   "ProvName": "Quiché",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "Guatemala. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_98_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2822,
   "Continent": "Asia",
   "Country": "Russia",
   "ProvName": "Kamchatka",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "30-35%",
   "Numerical": 35,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Sreda (2012) Arena: Atlas of Religions and Nationalities in Russia",
   "Year": 2012
  },
  {
   "OBJECTID": 2823,
   "Continent": "Africa",
   "Country": "Nigeria",
   "ProvName": "Abuja",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "~40%",
   "Nummeric_1": 40,
   "DataSource": "World Urbanization Prospects (2018). United Nations population estimates and projections of major Urban Agglomerations",
   "Year": 2018
  },
  {
   "OBJECTID": 2824,
   "Continent": "Africa",
   "Country": "Chad",
   "ProvName": "Kanem",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-50%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "10-20%",
   "Nummeric_1": 20,
   "DataSource": "\"The World's Muslims: Unity and Diversity\" (PDF). Pew Forum on Religious & Public life. 9 August 2012. pp. 128–129.",
   "Year": 2012
  },
  {
   "OBJECTID": 2825,
   "Continent": "Asia",
   "Country": "Iraq",
   "ProvName": "Al-Anbar",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Sunni)",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "\"Middle East :: IRAQ\". CIA The World Factbook",
   "Year": 2008
  },
  {
   "OBJECTID": 2826,
   "Continent": "Asia",
   "Country": "Iraq",
   "ProvName": "Babil",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Sunni)",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "\"Middle East :: IRAQ\". CIA The World Factbook",
   "Year": 2008
  },
  {
   "OBJECTID": 2827,
   "Continent": "Europe",
   "Country": "Switzerland",
   "ProvName": "Appenzell Inner-Rhoden",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "\"Religions\" (official statistics). Neuchâtel, Switzerland: Federal Statistical Office FSO. 2020.",
   "Year": 2018
  },
  {
   "OBJECTID": 2828,
   "Continent": "Europe",
   "Country": "Belgium",
   "ProvName": "Brussels",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Special Eurobarometer 493, European Union: European Commission, September 2019, pages 229-230",
   "Year": 2019
  },
  {
   "OBJECTID": 2829,
   "Continent": "Europe",
   "Country": "Netherlands",
   "ProvName": "Noord-Brabant",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "20-25%",
   "Numerical": 25,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Netherlands. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_160_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2830,
   "Continent": "Asia",
   "Country": "Yemen",
   "ProvName": "San'a'",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "Integrated Regional Information Networks (IRIN), Yemen: The conflict in Saada Governorate - analysis, 24 July 2008, available at: http:\/\/www.unhcr.org\/refworld\/docid\/488f180d1e.html",
   "Year": 2008
  },
  {
   "OBJECTID": 2831,
   "Continent": "Africa",
   "Country": "Rwanda",
   "ProvName": "Eastern",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "40-45%",
   "Nummeric_1": 45,
   "DataSource": "Rwanda. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_187_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2832,
   "Continent": "Africa",
   "Country": "Rwanda",
   "ProvName": "Northern",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "40-45%",
   "Nummeric_1": 45,
   "DataSource": "Rwanda. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_187_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2833,
   "Continent": "Asia",
   "Country": "Yemen",
   "ProvName": "Hadramawt",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "Integrated Regional Information Networks (IRIN), Yemen: The conflict in Saada Governorate - analysis, 24 July 2008, available at: http:\/\/www.unhcr.org\/refworld\/docid\/488f180d1e.html",
   "Year": 2008
  },
  {
   "OBJECTID": 2834,
   "Continent": "Asia",
   "Country": "Yemen",
   "ProvName": "Capital Secretariat",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "Integrated Regional Information Networks (IRIN), Yemen: The conflict in Saada Governorate - analysis, 24 July 2008, available at: http:\/\/www.unhcr.org\/refworld\/docid\/488f180d1e.html",
   "Year": 2008
  },
  {
   "OBJECTID": 2835,
   "Continent": "Asia",
   "Country": "Japan",
   "ProvName": "Kagoshima",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2836,
   "Continent": "Asia",
   "Country": "Japan",
   "ProvName": "Okinawa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2837,
   "Continent": "Asia",
   "Country": "Japan",
   "ProvName": "Gumma",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2838,
   "Continent": "Asia",
   "Country": "India",
   "ProvName": "Daman and Diu",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Hinduism",
   "HighRelig": "Hindus",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2839,
   "Continent": "South America",
   "Country": "Peru",
   "ProvName": "Callao",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Peru. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_177_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2840,
   "Continent": "Asia",
   "Country": "Kuwait",
   "ProvName": "Hawalli",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "Burwell, Francis G. (2008) \"The Evolution of U. S.-Turkish Relations in a Transatlantic Context\". Strategic Studies Institute.",
   "Year": 2008
  },
  {
   "OBJECTID": 2841,
   "Continent": "Africa",
   "Country": "Solomon Islands",
   "ProvName": "Western",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Solomon Islands. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_204_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2842,
   "Continent": "Oceania",
   "Country": "Solomon Islands",
   "ProvName": "Choiseul",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Solomon Islands. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_204_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2843,
   "Continent": "Oceania",
   "Country": "Solomon Islands",
   "ProvName": "Makira-Ulawa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Solomon Islands. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_204_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2844,
   "Continent": "Asia",
   "Country": "Yemen",
   "ProvName": "`Adan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "Integrated Regional Information Networks (IRIN), Yemen: The conflict in Saada Governorate - analysis, 24 July 2008, available at: http:\/\/www.unhcr.org\/refworld\/docid\/488f180d1e.html",
   "Year": 2008
  },
  {
   "OBJECTID": 2845,
   "Continent": "Asia",
   "Country": "Yemen",
   "ProvName": "Abyan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "Integrated Regional Information Networks (IRIN), Yemen: The conflict in Saada Governorate - analysis, 24 July 2008, available at: http:\/\/www.unhcr.org\/refworld\/docid\/488f180d1e.html",
   "Year": 2008
  },
  {
   "OBJECTID": 2846,
   "Continent": "North America",
   "Country": "United States",
   "ProvName": "Nevada",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Adults in Nevada\". Pew Research Center.https:\/\/www.pewforum.org\/religious-landscape-study\/state\/Nevada\/",
   "Year": 2014
  },
  {
   "OBJECTID": 2847,
   "Continent": "North America",
   "Country": "United States",
   "ProvName": "Kansas",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "55-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Adults in Kansas\". Pew Research Center.https:\/\/www.pewforum.org\/religious-landscape-study\/state\/Kansas\/",
   "Year": 2014
  },
  {
   "OBJECTID": 2848,
   "Continent": "North America",
   "Country": "United States",
   "ProvName": "Missouri",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "55-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Adults in Missouri\". Pew Research Center.https:\/\/www.pewforum.org\/religious-landscape-study\/state\/Missouri\/",
   "Year": 2014
  },
  {
   "OBJECTID": 2849,
   "Continent": "North America",
   "Country": "United States",
   "ProvName": "New Mexico",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "\"Adults in New Mexico\". Pew Research Center.https:\/\/www.pewforum.org\/religious-landscape-study\/state\/New Mexico\/",
   "Year": 2014
  },
  {
   "OBJECTID": 2850,
   "Continent": "North America",
   "Country": "United States",
   "ProvName": "Oregon",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Adults in Oregon\". Pew Research Center.https:\/\/www.pewforum.org\/religious-landscape-study\/state\/Oregon\/",
   "Year": 2014
  },
  {
   "OBJECTID": 2851,
   "Continent": "North America",
   "Country": "United States",
   "ProvName": "Utah",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Mormons",
   "ReligCatP": "55-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Adults in Utah\". Pew Research Center.https:\/\/www.pewforum.org\/religious-landscape-study\/state\/Utah\/",
   "Year": 2014
  },
  {
   "OBJECTID": 2852,
   "Continent": "North America",
   "Country": "United States",
   "ProvName": "Illinois",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Adults in Illinois\". Pew Research Center.https:\/\/www.pewforum.org\/religious-landscape-study\/state\/Illinois\/",
   "Year": 2014
  },
  {
   "OBJECTID": 2853,
   "Continent": "North America",
   "Country": "United States",
   "ProvName": "Arkansas",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "70-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Adults in Arkansas\". Pew Research Center.https:\/\/www.pewforum.org\/religious-landscape-study\/state\/arkansas\/",
   "Year": 2014
  },
  {
   "OBJECTID": 2854,
   "Continent": "North America",
   "Country": "United States",
   "ProvName": "Iowa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Adults in Iowa\". Pew Research Center.https:\/\/www.pewforum.org\/religious-landscape-study\/state\/Iowa\/",
   "Year": 2014
  },
  {
   "OBJECTID": 2855,
   "Continent": "North America",
   "Country": "United States",
   "ProvName": "Wisconsin",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "\"Adults in Wyoming\". Pew Research Center.https:\/\/www.pewforum.org\/religious-landscape-study\/state\/Wyoming\/",
   "Year": 2014
  },
  {
   "OBJECTID": 2856,
   "Continent": "North America",
   "Country": "United States",
   "ProvName": "West Virginia",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "70-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Adults in West Virginia\". Pew Research Center.https:\/\/www.pewforum.org\/religious-landscape-study\/state\/West Virginia\/",
   "Year": 2014
  },
  {
   "OBJECTID": 2857,
   "Continent": "Africa",
   "Country": "Chad",
   "ProvName": "Barh el Ghazel",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-50%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "10-20%",
   "Nummeric_1": 20,
   "DataSource": "\"The World's Muslims: Unity and Diversity\" (PDF). Pew Forum on Religious & Public life. 9 August 2012. pp. 128–129.",
   "Year": 2012
  },
  {
   "OBJECTID": 2858,
   "Continent": "North America",
   "Country": "United States",
   "ProvName": "Nebraska",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Adults in Nebraska\". Pew Research Center.https:\/\/www.pewforum.org\/religious-landscape-study\/state\/Nebraska\/",
   "Year": 2014
  },
  {
   "OBJECTID": 2859,
   "Continent": "Africa",
   "Country": "Chad",
   "ProvName": "Mayo-Kebbi Ouest",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "30-40%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "10-20%",
   "Nummeric_1": 20,
   "DataSource": "\"The World's Muslims: Unity and Diversity\" (PDF). Pew Forum on Religious & Public life. 9 August 2012. pp. 128–129.",
   "Year": 2012
  },
  {
   "OBJECTID": 2860,
   "Continent": "North America",
   "Country": "United States",
   "ProvName": "Oklahoma",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Adults in Oklahoma\". Pew Research Center.https:\/\/www.pewforum.org\/religious-landscape-study\/state\/Oklahoma\/",
   "Year": 2014
  },
  {
   "OBJECTID": 2861,
   "Continent": "North America",
   "Country": "United States",
   "ProvName": "South Dakota",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "55-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "20-25%",
   "Nummeric_1": 25,
   "DataSource": "\"Adults in South Dakota\". Pew Research Center.https:\/\/www.pewforum.org\/religious-landscape-study\/state\/South Dakota\/",
   "Year": 2014
  },
  {
   "OBJECTID": 2862,
   "Continent": "North America",
   "Country": "United States",
   "ProvName": "Louisiana",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "55-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Adults in Louisiana\". Pew Research Center.https:\/\/www.pewforum.org\/religious-landscape-study\/state\/Louisiana\/",
   "Year": 2014
  },
  {
   "OBJECTID": 2863,
   "Continent": "North America",
   "Country": "United States",
   "ProvName": "Texas",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "20-25%",
   "Nummeric_1": 25,
   "DataSource": "\"Adults in Texas\". Pew Research Center.https:\/\/www.pewforum.org\/religious-landscape-study\/state\/Texas\/",
   "Year": 2014
  },
  {
   "OBJECTID": 2864,
   "Continent": "North America",
   "Country": "Cuba",
   "ProvName": "Artemisa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "30-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Cuba. Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_63_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2865,
   "Continent": "North America",
   "Country": "United States",
   "ProvName": "Connecticut",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "\"Adults in Connecticut\". Pew Research Center.https:\/\/www.pewforum.org\/religious-landscape-study\/state\/connecticut\/",
   "Year": 2014
  },
  {
   "OBJECTID": 2866,
   "Continent": "North America",
   "Country": "United States",
   "ProvName": "New Hampshire",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "30-35%",
   "Numerical": 35,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Adults in New Hampshire\". Pew Research Center.https:\/\/www.pewforum.org\/religious-landscape-study\/state\/New Hampshire\/",
   "Year": 2014
  },
  {
   "OBJECTID": 2867,
   "Continent": "North America",
   "Country": "United States",
   "ProvName": "Rhode Island",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Adults in Rhode Island\". Pew Research Center.https:\/\/www.pewforum.org\/religious-landscape-study\/state\/Rhode Island\/",
   "Year": 2014
  },
  {
   "OBJECTID": 2868,
   "Continent": "North America",
   "Country": "United States",
   "ProvName": "Delaware",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Adults in Delaware\". Pew Research Center.https:\/\/www.pewforum.org\/religious-landscape-study\/state\/delaware\/",
   "Year": 2014
  },
  {
   "OBJECTID": 2869,
   "Continent": "North America",
   "Country": "United States",
   "ProvName": "District of Columbia",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Adults in District of Columbia\". Pew Research Center.https:\/\/www.pewforum.org\/religious-landscape-study\/state\/district-of-columbia\/",
   "Year": 2014
  },
  {
   "OBJECTID": 2870,
   "Continent": "North America",
   "Country": "United States",
   "ProvName": "Maryland",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Adults in Maryland\". Pew Research Center.https:\/\/www.pewforum.org\/religious-landscape-study\/state\/Maryland\/",
   "Year": 2014
  },
  {
   "OBJECTID": 2871,
   "Continent": "North America",
   "Country": "United States",
   "ProvName": "Vermont",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "30-35%",
   "Numerical": 35,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Adults in Vermont\". Pew Research Center.https:\/\/www.pewforum.org\/religious-landscape-study\/state\/Vermont\/",
   "Year": 2014
  },
  {
   "OBJECTID": 2872,
   "Continent": "Asia",
   "Country": "Cyprus",
   "ProvName": "Northern Cyprus",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/en.wikipedia.org\/wiki\/Religion_in_Northern_Cyprus#cite_ref-1",
   "Year": 2019
  },
  {
   "OBJECTID": 2873,
   "Continent": "North America",
   "Country": "United States",
   "ProvName": "Alabama",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Adults in Alabama\". Pew Research Center. https:\/\/en.wikipedia.org\/wiki\/Religion_in_the_United_States#cite_note-Alabama-149",
   "Year": 2014
  },
  {
   "OBJECTID": 2874,
   "Continent": "North America",
   "Country": "United States",
   "ProvName": "Florida",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Adults in Florida\". Pew Research Center.https:\/\/www.pewforum.org\/religious-landscape-study\/state\/Florida\/",
   "Year": 2014
  },
  {
   "OBJECTID": 2875,
   "Continent": "North America",
   "Country": "United States",
   "ProvName": "Georgia",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Adults in Georgia\". Pew Research Center.https:\/\/www.pewforum.org\/religious-landscape-study\/state\/Georgia\/",
   "Year": 2014
  },
  {
   "OBJECTID": 2876,
   "Continent": "North America",
   "Country": "United States",
   "ProvName": "Mississippi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Adults in Mississippi\". Pew Research Center.https:\/\/www.pewforum.org\/religious-landscape-study\/state\/Mississippi\/",
   "Year": 2014
  },
  {
   "OBJECTID": 2877,
   "Continent": "North America",
   "Country": "United States",
   "ProvName": "South Carolina",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Adults in South Carolina\". Pew Research Center.https:\/\/www.pewforum.org\/religious-landscape-study\/state\/South Carolina\/",
   "Year": 2014
  },
  {
   "OBJECTID": 2878,
   "Continent": "North America",
   "Country": "United States",
   "ProvName": "Indiana",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Adults in Indiana\". Pew Research Center.https:\/\/www.pewforum.org\/religious-landscape-study\/state\/Indiana\/",
   "Year": 2014
  },
  {
   "OBJECTID": 2879,
   "Continent": "North America",
   "Country": "United States",
   "ProvName": "Kentucky",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Adults in Kentucky\". Pew Research Center.https:\/\/www.pewforum.org\/religious-landscape-study\/state\/Kentucky\/",
   "Year": 2014
  },
  {
   "OBJECTID": 2880,
   "Continent": "North America",
   "Country": "United States",
   "ProvName": "North Carolina",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Adults in North Carolina\". Pew Research Center.https:\/\/www.pewforum.org\/religious-landscape-study\/state\/North Carolina\/",
   "Year": 2014
  },
  {
   "OBJECTID": 2881,
   "Continent": "North America",
   "Country": "United States",
   "ProvName": "Ohio",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Adults in Ohio\". Pew Research Center.https:\/\/www.pewforum.org\/religious-landscape-study\/state\/Ohio\/",
   "Year": 2014
  },
  {
   "OBJECTID": 2882,
   "Continent": "North America",
   "Country": "United States",
   "ProvName": "Tennessee",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "70-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Adults in Tennessee\". Pew Research Center.https:\/\/www.pewforum.org\/religious-landscape-study\/state\/Tennessee\/",
   "Year": 2014
  },
  {
   "OBJECTID": 2883,
   "Continent": "North America",
   "Country": "United States",
   "ProvName": "Virginia",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "55-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Adults in Virginia\". Pew Research Center.https:\/\/www.pewforum.org\/religious-landscape-study\/state\/Virginia\/",
   "Year": 2014
  },
  {
   "OBJECTID": 2884,
   "Continent": "North America",
   "Country": "United States",
   "ProvName": "New Jersey",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "30-35%",
   "Numerical": 35,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "\"Adults in New Jersey\". Pew Research Center.https:\/\/www.pewforum.org\/religious-landscape-study\/state\/New Jersey\/",
   "Year": 2014
  },
  {
   "OBJECTID": 2885,
   "Continent": "North America",
   "Country": "United States",
   "ProvName": "New York",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "30-35%",
   "Numerical": 35,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Adults in New York\". Pew Research Center.https:\/\/www.pewforum.org\/religious-landscape-study\/state\/New York\/",
   "Year": 2014
  },
  {
   "OBJECTID": 2886,
   "Continent": "North America",
   "Country": "Bermuda",
   "ProvName": "Sandys",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "50-60%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "10-20%",
   "Nummeric_1": 20,
   "DataSource": "\"Religions in Bermuda | PEW-GRF\". http:\/\/www.globalreligiousfutures.org\/countries\/bermuda#\/?affiliations_religion_id=11&affiliations_year=2010",
   "Year": 2010
  },
  {
   "OBJECTID": 2887,
   "Continent": "North America",
   "Country": "United States",
   "ProvName": "Pennsylvania",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Adults in Pennsylvania\". Pew Research Center.https:\/\/www.pewforum.org\/religious-landscape-study\/state\/Pennsylvania\/",
   "Year": 2014
  },
  {
   "OBJECTID": 2888,
   "Continent": "North America",
   "Country": "United States",
   "ProvName": "Maine",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Adults in Maine\". Pew Research Center.https:\/\/www.pewforum.org\/religious-landscape-study\/state\/Maine\/",
   "Year": 2014
  },
  {
   "OBJECTID": 2889,
   "Continent": "North America",
   "Country": "United States",
   "ProvName": "Michigan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Michigan\". Pew Research Center.https:\/\/www.pewforum.org\/religious-landscape-study\/state\/Michigan\/",
   "Year": 2014
  },
  {
   "OBJECTID": 2890,
   "Continent": "North America",
   "Country": "United States",
   "ProvName": "Alaska",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Adults in Alaska\". Pew Research Center. https:\/\/www.pewforum.org\/religious-landscape-study\/state\/alaska\/",
   "Year": 2014
  },
  {
   "OBJECTID": 2891,
   "Continent": "Asia",
   "Country": "Palestine*",
   "ProvName": "West Bank",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2892,
   "Continent": "North America",
   "Country": "Turks & Caicos Is",
   "ProvName": "Turks & Caicos Islands",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "35-40%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Turks & Caicos Islands. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_228_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2893,
   "Continent": "Oceania",
   "Country": "Tuvalu",
   "ProvName": "Tuvalu",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Tuvalu. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_229_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2894,
   "Continent": "Europe",
   "Country": "Holy See",
   "ProvName": "Holy See",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2895,
   "Continent": "North America",
   "Country": "British Virgin Islands",
   "ProvName": "British Virgin Islands",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "The BVI Beacon \"Portrait of a population: 2010 Census published\" p. 4, 20 November 2014",
   "Year": 2010
  },
  {
   "OBJECTID": 2896,
   "Continent": "Europe",
   "Country": "Bosnia-Herzegovina",
   "ProvName": "Brcko District",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Non-denominational)",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Sunni)",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "\"Chapter 1: Religious Affiliation\". The World’s Muslims: Unity and Diversity. Pew Research Center's Religion & Public Life Project. August 9, 2012.",
   "Year": 2012
  },
  {
   "OBJECTID": 2897,
   "Continent": "North America",
   "Country": "Bermuda",
   "ProvName": "Southampton",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "50-60%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "10-20%",
   "Nummeric_1": 20,
   "DataSource": "\"Religions in Bermuda | PEW-GRF\". http:\/\/www.globalreligiousfutures.org\/countries\/bermuda#\/?affiliations_religion_id=11&affiliations_year=2010",
   "Year": 2010
  },
  {
   "OBJECTID": 2898,
   "Continent": "North America",
   "Country": "Bermuda",
   "ProvName": "Warwick",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "50-60%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "10-20%",
   "Nummeric_1": 20,
   "DataSource": "\"Religions in Bermuda | PEW-GRF\". http:\/\/www.globalreligiousfutures.org\/countries\/bermuda#\/?affiliations_religion_id=11&affiliations_year=2010",
   "Year": 2010
  },
  {
   "OBJECTID": 2899,
   "Continent": "North America",
   "Country": "Guadeloupe",
   "ProvName": "Guadeloupe",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Guadeloupe.  The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_96_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2900,
   "Continent": "Africa",
   "Country": "Mayotte",
   "ProvName": "Mayotte",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2901,
   "Continent": "Africa",
   "Country": "Reunion",
   "ProvName": "Reunion",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Reunion. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_184_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2902,
   "Continent": "Europe",
   "Country": "Andorra",
   "ProvName": "Ordino",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"PEW Research Center: Christian Population as Percentages of Total Population by Country 2010\".",
   "Year": 2010
  },
  {
   "OBJECTID": 2903,
   "Continent": "Europe",
   "Country": "Andorra",
   "ProvName": "Canillo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"PEW Research Center: Christian Population as Percentages of Total Population by Country 2010\".",
   "Year": 2010
  },
  {
   "OBJECTID": 2904,
   "Continent": "North America",
   "Country": "Bermuda",
   "ProvName": "Paget",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "50-60%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "10-20%",
   "Nummeric_1": 20,
   "DataSource": "\"Religions in Bermuda | PEW-GRF\". http:\/\/www.globalreligiousfutures.org\/countries\/bermuda#\/?affiliations_religion_id=11&affiliations_year=2010",
   "Year": 2010
  },
  {
   "OBJECTID": 2905,
   "Continent": "Europe",
   "Country": "Liechtenstein",
   "ProvName": "Liechtenstein",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Lesotho. The Association of Religion Data Archives. 2015.http:\/\/www.thearda.com\/internationalData\/countries\/Country_133_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2906,
   "Continent": "Europe",
   "Country": "Monaco",
   "ProvName": "Monaco",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Monaco. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_152_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2907,
   "Continent": "Oceania",
   "Country": "Northern Mariana Is",
   "ProvName": "Northern Mariana Is",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "15-20%",
   "Nummeric_1": 20,
   "DataSource": "Northern Mariana Islands. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_169_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2908,
   "Continent": "North America",
   "Country": "Montserrat",
   "ProvName": "Montserrat",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Montserrat. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_154_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2909,
   "Continent": "Oceania",
   "Country": "Niue",
   "ProvName": "Niue Island",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "10-15%",
   "Nummeric_1": 15,
   "DataSource": "Niue. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_167_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2910,
   "Continent": "Oceania",
   "Country": "Nauru",
   "ProvName": "Nauru",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "55-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "35-40%",
   "Nummeric_1": 40,
   "DataSource": "Namibia. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_158_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2911,
   "Continent": "Oceania",
   "Country": "Palau",
   "ProvName": "Palau",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "Palau. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_173_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2912,
   "Continent": "North America",
   "Country": "Bermuda",
   "ProvName": "Devonshire",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "50-60%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "10-20%",
   "Nummeric_1": 20,
   "DataSource": "\"Religions in Bermuda | PEW-GRF\". http:\/\/www.globalreligiousfutures.org\/countries\/bermuda#\/?affiliations_religion_id=11&affiliations_year=2010",
   "Year": 2010
  },
  {
   "OBJECTID": 2913,
   "Continent": "North America",
   "Country": "Puerto Rico",
   "ProvName": "Puerto Rico",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Puerto Rico. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_182_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2914,
   "Continent": "Asia",
   "Country": "Singapore",
   "ProvName": "Singapore",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Mahayana)",
   "ReligCatP": "30-35%",
   "Numerical": 35,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Statistics Singapore: 2015 General Household Survey. https:\/\/web.archive.org\/web\/20170505143054\/http:\/\/www.singstat.gov.sg\/publications\/publications-and-papers\/GHS\/ghs2015content",
   "Year": 2015
  },
  {
   "OBJECTID": 2915,
   "Continent": "South America",
   "Country": "Netherlands Antilles",
   "ProvName": "Sint Maarten (Dutch)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/en.wikipedia.org\/wiki\/Netherlands_Antilles",
   "Year": 2008
  },
  {
   "OBJECTID": 2916,
   "Continent": "Africa",
   "Country": "Gambia",
   "ProvName": "Lower River",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2917,
   "Continent": "North America",
   "Country": "Bahamas",
   "ProvName": "Abaco, Great and Little",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"Religions in Bahamas - PEW-GRF\". http:\/\/www.globalreligiousfutures.org\/countries\/bahamas#\/?affiliations_religion_id=11&affiliations_year=2010&restrictions_year=2015",
   "Year": 2010
  },
  {
   "OBJECTID": 2918,
   "Continent": "Oceania",
   "Country": "Marshall Islands",
   "ProvName": "Ralik",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Marshall Islands. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_144_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2919,
   "Continent": "Asia",
   "Country": "Bahrain",
   "ProvName": "Southern",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Shia)",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Sunni)",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "Unofficial sources, the Library of Congress Country Studies, and The New York Times, estimate approximately 45% Sunni and 55% Shia",
   "Year": 2008
  },
  {
   "OBJECTID": 2920,
   "Continent": "Asia",
   "Country": "Bangladesh",
   "ProvName": "Chittagong",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2921,
   "Continent": "Africa",
   "Country": "Burkina Faso",
   "ProvName": "Poni",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mapping the Global Muslim Population. Estimate Range of Shia by Country. Pew Forum, 2010. Johnson, T. M., & Grim, B. J. (Eds.).",
   "Year": 2008
  },
  {
   "OBJECTID": 2922,
   "Continent": "Africa",
   "Country": "Burkina Faso",
   "ProvName": "Noumbiel",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mapping the Global Muslim Population. Estimate Range of Shia by Country. Pew Forum, 2010. Johnson, T. M., & Grim, B. J. (Eds.).",
   "Year": 2008
  },
  {
   "OBJECTID": 2923,
   "Continent": "Africa",
   "Country": "Burundi",
   "ProvName": "Bujumbura Rural",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Anthony Appiah; Henry Louis Gates (2010). Encyclopedia of Africa. Oxford University Press. p. 221. ISBN 978-0-19-533770-9.",
   "Year": 2010
  },
  {
   "OBJECTID": 2924,
   "Continent": "Africa",
   "Country": "Burundi",
   "ProvName": "Bujumbura Mairie",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Anthony Appiah; Henry Louis Gates (2010). Encyclopedia of Africa. Oxford University Press. p. 221. ISBN 978-0-19-533770-9.",
   "Year": 2010
  },
  {
   "OBJECTID": 2925,
   "Continent": "Africa",
   "Country": "Burundi",
   "ProvName": "Muramvya",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Anthony Appiah; Henry Louis Gates (2010). Encyclopedia of Africa. Oxford University Press. p. 221. ISBN 978-0-19-533770-9.",
   "Year": 2010
  },
  {
   "OBJECTID": 2926,
   "Continent": "Asia",
   "Country": "Tajikistan",
   "ProvName": "Dushanbe",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2927,
   "Continent": "Asia",
   "Country": "Tajikistan",
   "ProvName": "Karotegin",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2928,
   "Continent": "Africa",
   "Country": "Central African Republic",
   "ProvName": "Ombella-Mpoko",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "10-20%",
   "Nummeric_1": 20,
   "DataSource": "\"International Religious Freedom Report for 2016\". U.S. Department of State.",
   "Year": 2016
  },
  {
   "OBJECTID": 2929,
   "Continent": "Africa",
   "Country": "Central African Republic",
   "ProvName": "Bangui",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "20-30%",
   "Nummeric_1": 20,
   "DataSource": "\"International Religious Freedom Report for 2016\". U.S. Department of State.",
   "Year": 2016
  },
  {
   "OBJECTID": 2930,
   "Continent": "Africa",
   "Country": "Chad",
   "ProvName": "Tibesti",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "50-60%",
   "Numerical": 95,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "20-30%",
   "Nummeric_1": 20,
   "DataSource": "\"The World's Muslims: Unity and Diversity\" (PDF). Pew Forum on Religious & Public life. 9 August 2012. pp. 128–129.",
   "Year": 2012
  },
  {
   "OBJECTID": 2931,
   "Continent": "Africa",
   "Country": "Comoros",
   "ProvName": "Anjouan (Nzwani)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2932,
   "Continent": "Africa",
   "Country": "Chad",
   "ProvName": "Ouaddaï",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "30-40%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "10-20%",
   "Nummeric_1": 20,
   "DataSource": "\"The World's Muslims: Unity and Diversity\" (PDF). Pew Forum on Religious & Public life. 9 August 2012. pp. 128–129.",
   "Year": 2012
  },
  {
   "OBJECTID": 2933,
   "Continent": "Africa",
   "Country": "Chad",
   "ProvName": "Sila",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "30-40%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "10-20%",
   "Nummeric_1": 20,
   "DataSource": "\"The World's Muslims: Unity and Diversity\" (PDF). Pew Forum on Religious & Public life. 9 August 2012. pp. 128–129.",
   "Year": 2012
  },
  {
   "OBJECTID": 2934,
   "Continent": "Africa",
   "Country": "Chad",
   "ProvName": "Ville de N'Djamena",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "20-30%",
   "Numerical": 30,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Pew Research Center's Religion & Public Life Project: Chad. Pew Research Center. 2010.",
   "Year": 2010
  },
  {
   "OBJECTID": 2935,
   "Continent": "Africa",
   "Country": "Guinea-Bissau",
   "ProvName": "Biombo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2936,
   "Continent": "Africa",
   "Country": "Chad",
   "ProvName": "Hadjer-Lamis",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "20-30%",
   "Numerical": 30,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Pew Research Center's Religion & Public Life Project: Chad. Pew Research Center. 2010.",
   "Year": 2010
  },
  {
   "OBJECTID": 2937,
   "Continent": "Africa",
   "Country": "Libya",
   "ProvName": "Wâdî al-Hayât",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2938,
   "Continent": "Africa",
   "Country": "Libya",
   "ProvName": "Gât",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2939,
   "Continent": "Africa",
   "Country": "Chad",
   "ProvName": "Chari-Baguirmi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "20-30%",
   "Numerical": 30,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "Pew Research Center's Religion & Public Life Project: Chad. Pew Research Center. 2010.",
   "Year": 2010
  },
  {
   "OBJECTID": 2940,
   "Continent": "Africa",
   "Country": "Chad",
   "ProvName": "Mandoul",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "30-40%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "10-20%",
   "Nummeric_1": 20,
   "DataSource": "\"The World's Muslims: Unity and Diversity\" (PDF). Pew Forum on Religious & Public life. 9 August 2012. pp. 128–129.",
   "Year": 2012
  },
  {
   "OBJECTID": 2941,
   "Continent": "North America",
   "Country": "Bermuda",
   "ProvName": "St. George's",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "50-60%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "10-20%",
   "Nummeric_1": 20,
   "DataSource": "\"Religions in Bermuda | PEW-GRF\". http:\/\/www.globalreligiousfutures.org\/countries\/bermuda#\/?affiliations_religion_id=11&affiliations_year=2010",
   "Year": 2010
  },
  {
   "OBJECTID": 2942,
   "Continent": "North America",
   "Country": "Bermuda",
   "ProvName": "Carriacou",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "50-60%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "10-20%",
   "Nummeric_1": 20,
   "DataSource": "\"Religions in Bermuda | PEW-GRF\". http:\/\/www.globalreligiousfutures.org\/countries\/bermuda#\/?affiliations_religion_id=11&affiliations_year=2010",
   "Year": 2010
  },
  {
   "OBJECTID": 2943,
   "Continent": "North America",
   "Country": "Bermuda",
   "ProvName": "Hamilton",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "50-60%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "10-20%",
   "Nummeric_1": 20,
   "DataSource": "\"Religions in Bermuda | PEW-GRF\". http:\/\/www.globalreligiousfutures.org\/countries\/bermuda#\/?affiliations_religion_id=11&affiliations_year=2010",
   "Year": 2010
  },
  {
   "OBJECTID": 2944,
   "Continent": "Africa",
   "Country": "Chad",
   "ProvName": "Moyen-Chari",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "30-40%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "10-20%",
   "Nummeric_1": 20,
   "DataSource": "\"The World's Muslims: Unity and Diversity\" (PDF). Pew Forum on Religious & Public life. 9 August 2012. pp. 128–129.",
   "Year": 2012
  },
  {
   "OBJECTID": 2945,
   "Continent": "Oceania",
   "Country": "French Polynesia",
   "ProvName": "Iles du Vent (Windward Islands)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "30-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "French Polynesia. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_85_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2946,
   "Continent": "Africa",
   "Country": "Chad",
   "ProvName": "Mayo-Kebbi Est",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "30-40%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "10-20%",
   "Nummeric_1": 20,
   "DataSource": "\"The World's Muslims: Unity and Diversity\" (PDF). Pew Forum on Religious & Public life. 9 August 2012. pp. 128–129.",
   "Year": 2012
  },
  {
   "OBJECTID": 2947,
   "Continent": "Africa",
   "Country": "Comoros",
   "ProvName": "Grande Comore (Njazidja)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2948,
   "Continent": "Africa",
   "Country": "Comoros",
   "ProvName": "Mohéli (Mwali)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2949,
   "Continent": "Africa",
   "Country": "Congo",
   "ProvName": "Kouilou",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "\"Congo, Republic of the\". Association of Religion Data Archives. 2015 http:\/\/www.thearda.com\/internationalData\/countries\/Country_57_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2950,
   "Continent": "Africa",
   "Country": "Congo",
   "ProvName": "Pool",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "\"Congo, Republic of the\". Association of Religion Data Archives. 2015 http:\/\/www.thearda.com\/internationalData\/countries\/Country_57_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2951,
   "Continent": "Africa",
   "Country": "Congo",
   "ProvName": "Pointe-Noire",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "\"Congo, Republic of the\". Association of Religion Data Archives. 2015 http:\/\/www.thearda.com\/internationalData\/countries\/Country_57_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2952,
   "Continent": "Africa",
   "Country": "Congo",
   "ProvName": "Brazzaville",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "\"Congo, Republic of the\". Association of Religion Data Archives. 2015 http:\/\/www.thearda.com\/internationalData\/countries\/Country_57_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2953,
   "Continent": "Europe",
   "Country": "Czech Republic",
   "ProvName": "Karlovarský",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "<= 10%",
   "Numerical": 10,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"2011 Census: Population by religious belief and by regions\". https:\/\/web.archive.org\/web\/20131104224923\/http:\/\/www.czso.cz\/sldb2011\/eng\/redakce.nsf\/i\/tab_7_2_population_by_religious_belief_and_by_regions\/$File\/PVCR072_ENG.pdf",
   "Year": 2011
  },
  {
   "OBJECTID": 2954,
   "Continent": "Europe",
   "Country": "Czech Republic",
   "ProvName": "Plzenský",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "10-20%",
   "Numerical": 20,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"2011 Census: Population by religious belief and by regions\". https:\/\/web.archive.org\/web\/20131104224923\/http:\/\/www.czso.cz\/sldb2011\/eng\/redakce.nsf\/i\/tab_7_2_population_by_religious_belief_and_by_regions\/$File\/PVCR072_ENG.pdf",
   "Year": 2011
  },
  {
   "OBJECTID": 2955,
   "Continent": "Europe",
   "Country": "Czech Republic",
   "ProvName": "?stecký",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "<= 10%",
   "Numerical": 10,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"2011 Census: Population by religious belief and by regions\". https:\/\/web.archive.org\/web\/20131104224923\/http:\/\/www.czso.cz\/sldb2011\/eng\/redakce.nsf\/i\/tab_7_2_population_by_religious_belief_and_by_regions\/$File\/PVCR072_ENG.pdf",
   "Year": 2011
  },
  {
   "OBJECTID": 2956,
   "Continent": "Europe",
   "Country": "Czech Republic",
   "ProvName": "Liberecký",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "<= 10%",
   "Numerical": 10,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"2011 Census: Population by religious belief and by regions\". https:\/\/web.archive.org\/web\/20131104224923\/http:\/\/www.czso.cz\/sldb2011\/eng\/redakce.nsf\/i\/tab_7_2_population_by_religious_belief_and_by_regions\/$File\/PVCR072_ENG.pdf",
   "Year": 2011
  },
  {
   "OBJECTID": 2957,
   "Continent": "Europe",
   "Country": "Czech Republic",
   "ProvName": "Královéhradecký",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "10-20%",
   "Numerical": 20,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"2011 Census: Population by religious belief and by regions\". https:\/\/web.archive.org\/web\/20131104224923\/http:\/\/www.czso.cz\/sldb2011\/eng\/redakce.nsf\/i\/tab_7_2_population_by_religious_belief_and_by_regions\/$File\/PVCR072_ENG.pdf",
   "Year": 2011
  },
  {
   "OBJECTID": 2958,
   "Continent": "Europe",
   "Country": "Czech Republic",
   "ProvName": "Vysocina",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "20-30%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"2011 Census: Population by religious belief and by regions\". https:\/\/web.archive.org\/web\/20131104224923\/http:\/\/www.czso.cz\/sldb2011\/eng\/redakce.nsf\/i\/tab_7_2_population_by_religious_belief_and_by_regions\/$File\/PVCR072_ENG.pdf",
   "Year": 2011
  },
  {
   "OBJECTID": 2959,
   "Continent": "Oceania",
   "Country": "French Polynesia",
   "ProvName": "Iles sous le Vent (Leeward Islands)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "30-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "French Polynesia. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_85_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2960,
   "Continent": "Europe",
   "Country": "Czech Republic",
   "ProvName": "Jihoceský",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "10-20%",
   "Numerical": 20,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"2011 Census: Population by religious belief and by regions\". https:\/\/web.archive.org\/web\/20131104224923\/http:\/\/www.czso.cz\/sldb2011\/eng\/redakce.nsf\/i\/tab_7_2_population_by_religious_belief_and_by_regions\/$File\/PVCR072_ENG.pdf",
   "Year": 2011
  },
  {
   "OBJECTID": 2961,
   "Continent": "South America",
   "Country": "Ecuador",
   "ProvName": "Santa Elena",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 2962,
   "Continent": "Europe",
   "Country": "Czech Republic",
   "ProvName": "Pardubický",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "10-20%",
   "Numerical": 20,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"2011 Census: Population by religious belief and by regions\". https:\/\/web.archive.org\/web\/20131104224923\/http:\/\/www.czso.cz\/sldb2011\/eng\/redakce.nsf\/i\/tab_7_2_population_by_religious_belief_and_by_regions\/$File\/PVCR072_ENG.pdf",
   "Year": 2011
  },
  {
   "OBJECTID": 2963,
   "Continent": "Europe",
   "Country": "Czech Republic",
   "ProvName": "Moravskoslezský",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "20-30%",
   "Numerical": 30,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"2011 Census: Population by religious belief and by regions\". https:\/\/web.archive.org\/web\/20131104224923\/http:\/\/www.czso.cz\/sldb2011\/eng\/redakce.nsf\/i\/tab_7_2_population_by_religious_belief_and_by_regions\/$File\/PVCR072_ENG.pdf",
   "Year": 2011
  },
  {
   "OBJECTID": 2964,
   "Continent": "Africa",
   "Country": "Egypt",
   "ProvName": "Qina (Qena)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2965,
   "Continent": "Europe",
   "Country": "Czech Republic",
   "ProvName": "Olomoucký",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "20-30%",
   "Numerical": 30,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"2011 Census: Population by religious belief and by regions\". https:\/\/web.archive.org\/web\/20131104224923\/http:\/\/www.czso.cz\/sldb2011\/eng\/redakce.nsf\/i\/tab_7_2_population_by_religious_belief_and_by_regions\/$File\/PVCR072_ENG.pdf",
   "Year": 2011
  },
  {
   "OBJECTID": 2966,
   "Continent": "Europe",
   "Country": "Czech Republic",
   "ProvName": "Zlínský",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "20-30%",
   "Numerical": 30,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "\"2011 Census: Population by religious belief and by regions\". https:\/\/web.archive.org\/web\/20131104224923\/http:\/\/www.czso.cz\/sldb2011\/eng\/redakce.nsf\/i\/tab_7_2_population_by_religious_belief_and_by_regions\/$File\/PVCR072_ENG.pdf",
   "Year": 2011
  },
  {
   "OBJECTID": 2967,
   "Continent": "Africa",
   "Country": "Gambia",
   "ProvName": "Western",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2968,
   "Continent": "South America",
   "Country": "Ecuador",
   "ProvName": "Guayas",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 2969,
   "Continent": "South America",
   "Country": "Ecuador",
   "ProvName": "Pichincha",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 2970,
   "Continent": "South America",
   "Country": "Ecuador",
   "ProvName": "Santo Domingo de los Tsáchilas",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "70-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Religion in Latin America: Widespread Change in a Historically Catholic Region.  Pew Research Center (2014). https:\/\/www.pewresearch.org\/wp-content\/uploads\/sites\/7\/2014\/11\/Religion-in-Latin-America-11-12-PM-full-PDF.pdf",
   "Year": 2014
  },
  {
   "OBJECTID": 2971,
   "Continent": "Africa",
   "Country": "Mali",
   "ProvName": "Koulikoro",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2972,
   "Continent": "Europe",
   "Country": "Malta",
   "ProvName": "Gozo and Comino",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "90-95%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Malta. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_142_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2973,
   "Continent": "Europe",
   "Country": "San Marino",
   "ProvName": "Faetano",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2974,
   "Continent": "Asia",
   "Country": "Israel",
   "ProvName": "Northern (Ha Zafon)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2975,
   "Continent": "Asia",
   "Country": "Taiwan*",
   "ProvName": "Lienchang",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2976,
   "Continent": "Africa",
   "Country": "Guinea-Bissau",
   "ProvName": "Bolama",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2977,
   "Continent": "Asia",
   "Country": "Kazakhstan",
   "ProvName": "Astana",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2978,
   "Continent": "Asia",
   "Country": "Kazakhstan",
   "ProvName": "Aqmola (Akmola)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2979,
   "Continent": "Asia",
   "Country": "Kazakhstan",
   "ProvName": "Almaty city",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2980,
   "Continent": "Africa",
   "Country": "Malawi",
   "ProvName": "Nkhata Bay",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "Malawi. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_138_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2981,
   "Continent": "Asia",
   "Country": "Kazakhstan",
   "ProvName": "Almaty (Alma-Ata)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2982,
   "Continent": "Asia",
   "Country": "Malaysia",
   "ProvName": "Negeri Sembilan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2983,
   "Continent": "Asia",
   "Country": "Malaysia",
   "ProvName": "Kuala Lumpur",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Buddhism",
   "SecRelig": "Buddhists(Mahayana)",
   "SReligCatp": "35-40%",
   "Nummeric_1": 40,
   "DataSource": "\"2010 Population and Housing Census of Malaysia\". Department of Statistics, Malaysia. https:\/\/web.archive.org\/web\/20130205104835\/http:\/\/www.statistics.gov.my\/portal\/download_Population\/files\/census2010\/Taburan_Penduduk_dan_Ciri-ciri_Asas_Demografi.pdf",
   "Year": 2010
  },
  {
   "OBJECTID": 2984,
   "Continent": "Asia",
   "Country": "Malaysia",
   "ProvName": "Putrajaya",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2985,
   "Continent": "Asia",
   "Country": "Malaysia",
   "ProvName": "Sabah",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2986,
   "Continent": "Asia",
   "Country": "Malaysia",
   "ProvName": "Labuan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2987,
   "Continent": "Europe",
   "Country": "Moldova",
   "ProvName": "Gagauzia",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 2988,
   "Continent": "Africa",
   "Country": "Mali",
   "ProvName": "Bamako",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2989,
   "Continent": "South America",
   "Country": "Paraguay",
   "ProvName": "Central",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.statista.com\/statistics\/1067159\/paraguay-religion-affiliation-share-type\/\/ Religion affiliation in Paraguay as of 2018.",
   "Year": 2018
  },
  {
   "OBJECTID": 2990,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Nong Khai",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2991,
   "Continent": "Europe",
   "Country": "Malta",
   "ProvName": "Malta Island",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "90-95%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Malta. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_142_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2992,
   "Continent": "Oceania",
   "Country": "Marshall Islands",
   "ProvName": "Ratak",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Marshall Islands. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_144_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2993,
   "Continent": "South America",
   "Country": "Paraguay",
   "ProvName": "Asunción",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.statista.com\/statistics\/1067159\/paraguay-religion-affiliation-share-type\/\/ Religion affiliation in Paraguay as of 2018.",
   "Year": 2018
  },
  {
   "OBJECTID": 2994,
   "Continent": "Asia",
   "Country": "Qatar",
   "ProvName": "al-Wakrah",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 2995,
   "Continent": "Africa",
   "Country": "Mozambique",
   "ProvName": "Maputo",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "35-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "20-25%",
   "Nummeric_1": 25,
   "DataSource": "Mozambique. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_156_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2996,
   "Continent": "Africa",
   "Country": "Mozambique",
   "ProvName": "Maputo city",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "Mozambique. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_156_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 2997,
   "Continent": "South America",
   "Country": "Netherlands Antilles",
   "ProvName": "Bonaire",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/en.wikipedia.org\/wiki\/Netherlands_Antilles",
   "Year": 2008
  },
  {
   "OBJECTID": 2998,
   "Continent": "South America",
   "Country": "Netherlands Antilles",
   "ProvName": "Sint Eustatius or Statia",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/en.wikipedia.org\/wiki\/Netherlands_Antilles",
   "Year": 2008
  },
  {
   "OBJECTID": 2999,
   "Continent": "South America",
   "Country": "Netherlands Antilles",
   "ProvName": "Saba",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/en.wikipedia.org\/wiki\/Netherlands_Antilles",
   "Year": 2008
  },
  {
   "OBJECTID": 3000,
   "Continent": "Asia",
   "Country": "North Korea",
   "ProvName": "Rason (Najin)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "No Data",
   "HighRelig": "No Data",
   "ReligCatP": null,
   "Numerical": 0,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": null,
   "Year": null
  },
  {
   "OBJECTID": 3001,
   "Continent": "Oceania",
   "Country": "New Zealand",
   "ProvName": "Manawatu-Wanganui",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "15-20%",
   "Numerical": 20,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "New Zealand. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_163_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 3002,
   "Continent": "Oceania",
   "Country": "New Zealand",
   "ProvName": "Wellington",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "15-20%",
   "Numerical": 20,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "New Zealand. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_163_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 3003,
   "Continent": "Oceania",
   "Country": "New Zealand",
   "ProvName": "Waikato",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "15-20%",
   "Numerical": 20,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "New Zealand. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_163_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 3004,
   "Continent": "Asia",
   "Country": "Qatar",
   "ProvName": "ad-Dawhah (Doha)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 3005,
   "Continent": "Asia",
   "Country": "Qatar",
   "ProvName": "al-Daayen",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 3006,
   "Continent": "Oceania",
   "Country": "New Zealand",
   "ProvName": "Auckland",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "15-20%",
   "Numerical": 20,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "New Zealand. The Association of Religion Data Archives. (2015).http:\/\/www.thearda.com\/internationalData\/countries\/Country_163_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 3007,
   "Continent": "Asia",
   "Country": "North Korea",
   "ProvName": "Hamgyong North",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "No Data",
   "HighRelig": "No Data",
   "ReligCatP": null,
   "Numerical": 0,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": null,
   "Year": null
  },
  {
   "OBJECTID": 3008,
   "Continent": "Asia",
   "Country": "Qatar",
   "ProvName": "al-Khawr",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 3009,
   "Continent": "Asia",
   "Country": "Thailand",
   "ProvName": "Bung Kan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 3010,
   "Continent": "Africa",
   "Country": "Tunisia",
   "ProvName": "Al-Arianah",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Shia)",
   "SReligCatp": "40-50%",
   "Nummeric_1": 50,
   "DataSource": "\"Chapter 1: Religious Affiliation\". The World’s Muslims: Unity and Diversity. Pew Research Center's Religion & Public Life Project. August 9, 2012.",
   "Year": 2012
  },
  {
   "OBJECTID": 3011,
   "Continent": "Europe",
   "Country": "San Marino",
   "ProvName": "Montegiardino",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 3012,
   "Continent": "Asia",
   "Country": "Qatar",
   "ProvName": "ar-Rayyan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 3013,
   "Continent": "Europe",
   "Country": "Romania",
   "ProvName": "Bucharest",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "0.87",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 3014,
   "Continent": "Europe",
   "Country": "Romania",
   "ProvName": "Constanta",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "0.87",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 3015,
   "Continent": "Europe",
   "Country": "Romania",
   "ProvName": "Tulcea",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "0.87",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 3016,
   "Continent": "Africa",
   "Country": "Senegal",
   "ProvName": "Saint-Louis",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 3017,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Adana",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 3018,
   "Continent": "Africa",
   "Country": "Senegal",
   "ProvName": "Matam",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 3019,
   "Continent": "Africa",
   "Country": "Senegal",
   "ProvName": "Kédougou",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 3020,
   "Continent": "Africa",
   "Country": "Senegal",
   "ProvName": "Tambacounda",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 3021,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Osmaniye",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 3022,
   "Continent": "Africa",
   "Country": "Senegal",
   "ProvName": "Kolda",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 3023,
   "Continent": "Africa",
   "Country": "Senegal",
   "ProvName": "Sédhiou",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 3024,
   "Continent": "North America",
   "Country": "Bermuda",
   "ProvName": "Pembroke",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "40-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "10-20%",
   "Nummeric_1": 20,
   "DataSource": "\"Religions in Bermuda | PEW-GRF\". http:\/\/www.globalreligiousfutures.org\/countries\/bermuda#\/?affiliations_religion_id=11&affiliations_year=2010",
   "Year": 2010
  },
  {
   "OBJECTID": 3025,
   "Continent": "Asia",
   "Country": "Syria",
   "ProvName": "Dimashq",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/gulf2000.columbia.edu\/images\/maps\/Syria_Religion_Detailed_lg.png",
   "Year": 2010
  },
  {
   "OBJECTID": 3026,
   "Continent": "Asia",
   "Country": "Syria",
   "ProvName": "Damascus",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "60-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "http:\/\/gulf2000.columbia.edu\/images\/maps\/Syria_Religion_Detailed_lg.png",
   "Year": 2010
  },
  {
   "OBJECTID": 3027,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Zonguldak",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 3028,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Istanbul",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 3029,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Bursa",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 3030,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Kocaeli",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 3031,
   "Continent": "Asia",
   "Country": "Turkey",
   "ProvName": "Yalova",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "80-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 3032,
   "Continent": "Asia",
   "Country": "Turkmenistan",
   "ProvName": "Ahal",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 3033,
   "Continent": "Europe",
   "Country": "Russia",
   "ProvName": "Crimea (Krym)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "55-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Sunni)",
   "SReligCatp": "15-20%",
   "Nummeric_1": 20,
   "DataSource": "The International Republican Institute (2013).Public Opinion Survey Residents of the\nAutonomous Republic of Crimea\nMay 16 – 30, 2013",
   "Year": 2011
  },
  {
   "OBJECTID": 3034,
   "Continent": "Europe",
   "Country": "Ukraine",
   "ProvName": "Sevastopol",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 3035,
   "Continent": "Europe",
   "Country": "Ukraine",
   "ProvName": "Kiev city",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 3036,
   "Continent": "Europe",
   "Country": "Ukraine",
   "ProvName": "Kyyiv (Kiev)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "75-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 3037,
   "Continent": "Asia",
   "Country": "Uzbekistan",
   "ProvName": "Tashkent city",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Non-denominational)",
   "ReligCatP": "30-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": "Islam",
   "SecRelig": "Muslims(Sunni)",
   "SReligCatp": "20-30%",
   "Nummeric_1": 30,
   "DataSource": "\"Chapter 1: Religious Affiliation\". The World’s Muslims: Unity and Diversity. Pew Research Center's Religion & Public Life Project. August 9, 2012.",
   "Year": 2012
  },
  {
   "OBJECTID": 3038,
   "Continent": "Africa",
   "Country": "Western Sahara",
   "ProvName": "Oued el Dahab",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 3039,
   "Continent": "Africa",
   "Country": "Western Sahara",
   "ProvName": "Boujdour",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 3040,
   "Continent": "Africa",
   "Country": "Western Sahara",
   "ProvName": "Laayoune",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 3041,
   "Continent": "Africa",
   "Country": "Western Sahara",
   "ProvName": "Es Semara",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 3042,
   "Continent": "Oceania",
   "Country": "French Polynesia",
   "ProvName": "Iles Marquises (Marquesas)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "30-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "French Polynesia. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_85_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 3043,
   "Continent": "Oceania",
   "Country": "French Polynesia",
   "ProvName": "Iles Australes (Tubai Islands)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "30-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "French Polynesia. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_85_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 3044,
   "Continent": "Oceania",
   "Country": "French Polynesia",
   "ProvName": "Archipelago Tuamotu",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "30-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "French Polynesia. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_85_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 3045,
   "Continent": "North America",
   "Country": "Grenada",
   "ProvName": "St. Patrick",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "Grenada. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_95_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 3046,
   "Continent": "North America",
   "Country": "Grenada",
   "ProvName": "St. Andrew",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "Grenada. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_95_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 3047,
   "Continent": "North America",
   "Country": "Grenada",
   "ProvName": "St. Mark",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "Grenada. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_95_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 3048,
   "Continent": "North America",
   "Country": "Grenada",
   "ProvName": "St. John",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "Grenada. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_95_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 3049,
   "Continent": "North America",
   "Country": "Grenada",
   "ProvName": "St. David",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "Grenada. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_95_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 3050,
   "Continent": "North America",
   "Country": "Grenada",
   "ProvName": "Carriacou",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "Grenada. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_95_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 3051,
   "Continent": "North America",
   "Country": "Grenada",
   "ProvName": "Carriacou",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "50-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "30-40%",
   "Nummeric_1": 40,
   "DataSource": "Grenada. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_95_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 3052,
   "Continent": "Oceania",
   "Country": "Kiribati",
   "ProvName": "Line and Phoenix Group",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "55-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "35-40%",
   "Nummeric_1": 40,
   "DataSource": "Kiribati. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_122_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 3053,
   "Continent": "Asia",
   "Country": "Maldives",
   "ProvName": "Central",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 3054,
   "Continent": "Oceania",
   "Country": "Kiribati",
   "ProvName": "Gilberts Group",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "55-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "35-40%",
   "Nummeric_1": 40,
   "DataSource": "Kiribati. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_122_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 3055,
   "Continent": "Asia",
   "Country": "Maldives",
   "ProvName": "South",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 3056,
   "Continent": "Asia",
   "Country": "Maldives",
   "ProvName": "Upper South",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 3057,
   "Continent": "Africa",
   "Country": "Mauritius",
   "ProvName": "Savanne",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Hinduism",
   "HighRelig": "Hindus",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 3058,
   "Continent": "Asia",
   "Country": "Maldives",
   "ProvName": "Upper North",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 3059,
   "Continent": "Africa",
   "Country": "Mauritius",
   "ProvName": "Grand Port",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Hinduism",
   "HighRelig": "Hindus",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 3060,
   "Continent": "Africa",
   "Country": "Mauritius",
   "ProvName": "Flacq",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Hinduism",
   "HighRelig": "Hindus",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 3061,
   "Continent": "Oceania",
   "Country": "Micronesia",
   "ProvName": "Kosrae",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "55-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Protestants",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "Micronesia. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationaldata\/regions\/profiles\/Region_9_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 3062,
   "Continent": "Asia",
   "Country": "Maldives",
   "ProvName": "North",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 3063,
   "Continent": "Africa",
   "Country": "Mauritius",
   "ProvName": "Rivière du Rampart",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Hinduism",
   "HighRelig": "Hindus",
   "ReligCatP": "60-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 3064,
   "Continent": "Africa",
   "Country": "Mauritius",
   "ProvName": "Pamplemousses",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Hinduism",
   "HighRelig": "Hindus",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 3065,
   "Continent": "Africa",
   "Country": "Mauritius",
   "ProvName": "Port Louis",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "10-40%",
   "Numerical": 40,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 3066,
   "Continent": "Africa",
   "Country": "Mauritius",
   "ProvName": "Black River",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Hinduism",
   "HighRelig": "Hindus",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 3067,
   "Continent": "Africa",
   "Country": "Mauritius",
   "ProvName": "Plaines Wilhems",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Catholics",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mauritius. The Association of Religion Data Archives. 2015. http:\/\/www.thearda.com\/internationalData\/countries\/Country_147_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 3068,
   "Continent": "Asia",
   "Country": "Maldives",
   "ProvName": "North Central",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 3069,
   "Continent": "Asia",
   "Country": "Maldives",
   "ProvName": "South Central",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 3070,
   "Continent": "Asia",
   "Country": "Maldives",
   "ProvName": "Male",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 3071,
   "Continent": "Africa",
   "Country": "Mauritius",
   "ProvName": "Moka",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Hinduism",
   "HighRelig": "Hindus",
   "ReligCatP": "40-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Johnson, T. M., & Grim, B. J. (Eds.). (2008). World Religion Database: International religious demographic statistics and sources. Brill.",
   "Year": 2008
  },
  {
   "OBJECTID": 3072,
   "Continent": "Europe",
   "Country": "Moldova",
   "ProvName": "Cahul (Kachul)",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 3073,
   "Continent": "Europe",
   "Country": "Moldova",
   "ProvName": "Basarabeasca",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Eastern orthodox",
   "ReligCatP": "90-100%",
   "Numerical": 100,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "https:\/\/www.pewforum.org\/2017\/11\/08\/orthodox-christianitys-geographic-center-remains-in-central-and-eastern-europe\/",
   "Year": 2011
  },
  {
   "OBJECTID": 3074,
   "Continent": "Oceania",
   "Country": "Tokelau Islands",
   "ProvName": "Tokelau Islands",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Christianity",
   "HighRelig": "Protestants",
   "ReligCatP": "55-60%",
   "Numerical": 60,
   "Ethnic2": null,
   "SecRelig0": "Christianity",
   "SecRelig": "Catholics",
   "SReligCatp": "35-40%",
   "Nummeric_1": 40,
   "DataSource": "Religious affiliation of Tokelau residents by atoll of usual residence, 2011. https:\/\/en.wikipedia.org\/wiki\/Religion_in_Tokelau",
   "Year": 2011
  },
  {
   "OBJECTID": 3075,
   "Continent": "Asia",
   "Country": "Mongolia",
   "ProvName": "Omnogovi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Tibetan Buddhism)",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mongolia. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_153_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 3076,
   "Continent": "Asia",
   "Country": "Mongolia",
   "ProvName": "Dundgovi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Tibetan Buddhism)",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mongolia. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_153_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 3077,
   "Continent": "Asia",
   "Country": "Mongolia",
   "ProvName": "Selenge",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Tibetan Buddhism)",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mongolia. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_153_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 3078,
   "Continent": "Asia",
   "Country": "Mongolia",
   "ProvName": "Ovörhangay",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Tibetan Buddhism)",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mongolia. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_153_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 3079,
   "Continent": "Asia",
   "Country": "Mongolia",
   "ProvName": "Hentiy",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Tibetan Buddhism)",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mongolia. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_153_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 3080,
   "Continent": "Asia",
   "Country": "Mongolia",
   "ProvName": "Arhangay",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Tibetan Buddhism)",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mongolia. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_153_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 3081,
   "Continent": "Asia",
   "Country": "Mongolia",
   "ProvName": "Bayanhongor",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Tibetan Buddhism)",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mongolia. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_153_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 3082,
   "Continent": "Asia",
   "Country": "Mongolia",
   "ProvName": "Dzavhan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Tibetan Buddhism)",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mongolia. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_153_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 3083,
   "Continent": "Asia",
   "Country": "Mongolia",
   "ProvName": "Govi-Altay",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Tibetan Buddhism)",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mongolia. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_153_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 3084,
   "Continent": "Asia",
   "Country": "Mongolia",
   "ProvName": "Hovd",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Tibetan Buddhism)",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mongolia. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_153_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 3085,
   "Continent": "Asia",
   "Country": "Mongolia",
   "ProvName": "Hövsgöl",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Tibetan Buddhism)",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mongolia. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_153_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 3086,
   "Continent": "Asia",
   "Country": "Mongolia",
   "ProvName": "Uvs",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Tibetan Buddhism)",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mongolia. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_153_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 3087,
   "Continent": "Asia",
   "Country": "Mongolia",
   "ProvName": "Bulgan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Tibetan Buddhism)",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mongolia. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_153_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 3088,
   "Continent": "Asia",
   "Country": "Mongolia",
   "ProvName": "Orhan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Tibetan Buddhism)",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mongolia. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_153_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 3089,
   "Continent": "Asia",
   "Country": "Mongolia",
   "ProvName": "Darhan",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Tibetan Buddhism)",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mongolia. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_153_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 3090,
   "Continent": "Asia",
   "Country": "Mongolia",
   "ProvName": "Ulaanbaatar",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Tibetan Buddhism)",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mongolia. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_153_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 3091,
   "Continent": "Asia",
   "Country": "Mongolia",
   "ProvName": "Dornod",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Tibetan Buddhism)",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mongolia. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_153_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 3092,
   "Continent": "Asia",
   "Country": "Mongolia",
   "ProvName": "Suhbaatar",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Tibetan Buddhism)",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mongolia. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_153_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 3093,
   "Continent": "Asia",
   "Country": "Mongolia",
   "ProvName": "Dornogovi",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Tibetan Buddhism)",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mongolia. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_153_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 3094,
   "Continent": "Asia",
   "Country": "Mongolia",
   "ProvName": "Govi-Sumber",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Tibetan Buddhism)",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mongolia. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_153_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 3095,
   "Continent": "Asia",
   "Country": "Mongolia",
   "ProvName": "Töv",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Tibetan Buddhism)",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Mongolia. The Association of Religion Data Archives. (2015). http:\/\/www.thearda.com\/internationalData\/countries\/Country_153_1.asp",
   "Year": 2015
  },
  {
   "OBJECTID": 1,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Add, Houaphan",
   "NAME_1": null,
   "Ethnic1": "Tai, Khmuic",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 2,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Anouvong, Xaisomboon",
   "NAME_1": null,
   "Ethnic1": "Mong",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 3,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Atsaphangthong, Savannakhet",
   "NAME_1": null,
   "Ethnic1": "Lao",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": "Kautic",
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 4,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Atsaphone, Savannakhet",
   "NAME_1": null,
   "Ethnic1": "Tai",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "70-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 5,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Bachiangchaleunsook, Champasack",
   "NAME_1": null,
   "Ethnic1": "Lao",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": "Bahnaric Khmer, Tai",
   "SecRelig0": "Buddhism",
   "SecRelig": "Buddhists(Theravada)",
   "SReligCatp": "0.2025",
   "Nummeric_1": 25,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 6,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Beng, Oudomxai",
   "NAME_1": null,
   "Ethnic1": "Khmuic, Tai",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 7,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Bolikhanh, Bolikhamxai",
   "NAME_1": null,
   "Ethnic1": "Khmuic, Tai",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 8,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Boon Neua, Phongsaly",
   "NAME_1": null,
   "Ethnic1": "Tibeto-Burman",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 9,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Boontay, Phongsaly",
   "NAME_1": null,
   "Ethnic1": "Tibeto-Burman",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "70-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 10,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Botene, Xaignabouly",
   "NAME_1": null,
   "Ethnic1": "Lao",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-95%",
   "Numerical": 95,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 11,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Bualapha, Khammouan",
   "NAME_1": null,
   "Ethnic1": "Kautic",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "55-60%",
   "Numerical": 60,
   "Ethnic2": "Tai, Lao",
   "SecRelig0": "Buddhism",
   "SecRelig": "Buddhists(Theravada)",
   "SReligCatp": "35-40%",
   "Nummeric_1": 40,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 12,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Champasack, Champasack",
   "NAME_1": null,
   "Ethnic1": "Lao",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 13,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Champhone, Savannakhet",
   "NAME_1": null,
   "Ethnic1": "Lao",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "70-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 14,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Chanthabuly, Vientiane Capital",
   "NAME_1": null,
   "Ethnic1": "Lao",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-95%",
   "Numerical": 95,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 15,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Chomphet, Louangphabang",
   "NAME_1": null,
   "Ethnic1": "Khmuic, Lao",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 16,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Dakcheung, Sekong",
   "NAME_1": null,
   "Ethnic1": "Bahnaric Khmer",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 17,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Feuang, Vientiane",
   "NAME_1": null,
   "Ethnic1": "Tai, Khmuic",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 18,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Hadxaifong, Vientiane Capital",
   "NAME_1": null,
   "Ethnic1": "Lao",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 19,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Hiem, Houaphan",
   "NAME_1": null,
   "Ethnic1": "Tai, Khmuic",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-95%",
   "Numerical": 95,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 20,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Hinboon, Khammouan",
   "NAME_1": null,
   "Ethnic1": "Tai",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 21,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Hinherb, Vientiane",
   "NAME_1": null,
   "Ethnic1": "Tai, Khmuic",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-95%",
   "Numerical": 95,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 22,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Home, Xaisomboon",
   "NAME_1": null,
   "Ethnic1": "Mong",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "90-95%",
   "Numerical": 95,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 23,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Hongsa, Xaignabouly",
   "NAME_1": null,
   "Ethnic1": "Khmuic, Lao",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 24,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Hoon, Oudomxai",
   "NAME_1": null,
   "Ethnic1": "Khmuic, Lao",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 25,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Huameuang, Houaphan",
   "NAME_1": null,
   "Ethnic1": "Khmuic",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 26,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Huoixai, Bokeo",
   "NAME_1": null,
   "Ethnic1": "Khmuic, Tai, Lao",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "55-60%",
   "Numerical": 60,
   "Ethnic2": "Palanungic, Mong",
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 27,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Kaleum, Sekong",
   "NAME_1": null,
   "Ethnic1": "Kautic",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 28,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Kasy, Vientiane",
   "NAME_1": null,
   "Ethnic1": "Khmuic, Tai",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 29,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Kaysone Phomvihane, Savannakhet",
   "NAME_1": null,
   "Ethnic1": "Lao",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 30,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Kenethao, Xaignabouly",
   "NAME_1": null,
   "Ethnic1": "Lao",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 31,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Keo Oudom, Vientiane",
   "NAME_1": null,
   "Ethnic1": "Tai",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 32,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Kham, Xiengkhouang",
   "NAME_1": null,
   "Ethnic1": "Tai, Khmuic",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "70-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 33,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Khamkeuth, Bolikhamxai",
   "NAME_1": null,
   "Ethnic1": "Tai",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "70-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 34,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Khong, Champasack",
   "NAME_1": null,
   "Ethnic1": "Lao",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 35,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Khongxedone, Salavan",
   "NAME_1": null,
   "Ethnic1": "Lao",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-95%",
   "Numerical": 95,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 36,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Khop, Xaignabouly",
   "NAME_1": null,
   "Ethnic1": "Tai",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": "Mong",
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "20-25%",
   "Nummeric_1": 25,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 37,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Khoune, Xiengkhouang",
   "NAME_1": null,
   "Ethnic1": "Mong",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": "Tai, Khmuic",
   "SecRelig0": "Buddhism",
   "SecRelig": "Buddhists(Theravada)",
   "SReligCatp": "45-50%",
   "Nummeric_1": 50,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 38,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Khounkham, Khammouan",
   "NAME_1": null,
   "Ethnic1": "Lao",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 39,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Khua, Phongsaly",
   "NAME_1": null,
   "Ethnic1": "Khmuic, Tai, Lao",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 40,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Kuan, Houaphan",
   "NAME_1": null,
   "Ethnic1": "Mong",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": "Tai, Khmuic",
   "SecRelig0": "Buddhism",
   "SecRelig": "Buddhists(Theravada)",
   "SReligCatp": "40-45%",
   "Nummeric_1": 45,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 41,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "La, Oudomxai",
   "NAME_1": null,
   "Ethnic1": "Khmuic",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "70-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 42,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Lakhonepheng, Salavan",
   "NAME_1": null,
   "Ethnic1": "Lao",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 43,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Lamarm, Sekong",
   "NAME_1": null,
   "Ethnic1": "Bahnaric Khmer",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 44,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Lao Ngarm, Salavan",
   "NAME_1": null,
   "Ethnic1": "Lao, Bahnaric Khmer",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": "Kautic",
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 45,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Long, Louangnamtha",
   "NAME_1": null,
   "Ethnic1": "Tibeto-Burman",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "70-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 46,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Longcheng, Xaisomboon",
   "NAME_1": null,
   "Ethnic1": "Khmuic, Lao",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 47,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Longsane, Xaisomboon",
   "NAME_1": null,
   "Ethnic1": "Mong",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 48,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Luangprabang, Louangphabang",
   "NAME_1": null,
   "Ethnic1": "Lao, Khmuic",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 49,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Mad, Vientiane",
   "NAME_1": null,
   "Ethnic1": "Tai, Khmuic",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 50,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Mahaxay, Khammouan",
   "NAME_1": null,
   "Ethnic1": "Lao, Tai",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 51,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "May, Phongsaly",
   "NAME_1": null,
   "Ethnic1": "Tai, Khmuic",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": "Tibeto-Burman",
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 52,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Mayparkngum, Vientiane Capital",
   "NAME_1": null,
   "Ethnic1": "Lao",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-95%",
   "Numerical": 95,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 53,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Meun, Vientiane",
   "NAME_1": null,
   "Ethnic1": "Tai, Khmuic",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "55-60%",
   "Numerical": 60,
   "Ethnic2": "Mong",
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "35-40%",
   "Nummeric_1": 40,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 54,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Meung, Bokeo",
   "NAME_1": null,
   "Ethnic1": "Tibeto-Burman",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": "Tai, Khmuic",
   "SecRelig0": "Buddhism",
   "SecRelig": "Buddhists(Theravada)",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 55,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Moonlapamok, Champasack",
   "NAME_1": null,
   "Ethnic1": "Lao",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "70-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 56,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Mork, Xiengkhouang",
   "NAME_1": null,
   "Ethnic1": "Mong",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 57,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Nakay, Khammouan",
   "NAME_1": null,
   "Ethnic1": "Lao, Tai",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": "Kautic",
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "45-50%",
   "Nummeric_1": 50,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 58,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Nalae, Louangnamtha",
   "NAME_1": null,
   "Ethnic1": "Khmuic, Tai",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 59,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Nambak, Louangphabang",
   "NAME_1": null,
   "Ethnic1": "Khmuic, Tai",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": "Mong",
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "20-25%",
   "Nummeric_1": 25,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 60,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Namor, Oudomxai",
   "NAME_1": null,
   "Ethnic1": "Khmuic, Tai",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": "Mong, Tibeto-Burman",
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 61,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Namtha, Louangnamtha",
   "NAME_1": null,
   "Ethnic1": "Tai, Khmuic",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "55-60%",
   "Numerical": 60,
   "Ethnic2": "Tibeto-Burman",
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "15-20%",
   "Nummeric_1": 20,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 62,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Nan, Louangphabang",
   "NAME_1": null,
   "Ethnic1": "Lao, Khmuic",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 63,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Naxaithong, Vientiane Capital",
   "NAME_1": null,
   "Ethnic1": "Lao",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 64,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Nga, Oudomxai",
   "NAME_1": null,
   "Ethnic1": "Khmuic, Tai, Lao",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 65,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Ngeun, Xaignabouly",
   "NAME_1": null,
   "Ethnic1": "Khmuic, Tai",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": "Mong",
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 66,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Ngoi, Louangphabang",
   "NAME_1": null,
   "Ethnic1": "Khmuic, Lao",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 67,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Nhommalath, Khammouan",
   "NAME_1": null,
   "Ethnic1": "Lao, Tai",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "55-60%",
   "Numerical": 60,
   "Ethnic2": "Kautic",
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "35-40%",
   "Nummeric_1": 40,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 68,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Nhot Ou, Phongsaly",
   "NAME_1": null,
   "Ethnic1": "Tibeto-Burman",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": "Mien",
   "SecRelig0": "East Asian Religiosity",
   "SecRelig": "East Asian Religiosity",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 69,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Nong, Savannakhet",
   "NAME_1": null,
   "Ethnic1": "Kautic",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 70,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Nongbok, Khammouan",
   "NAME_1": null,
   "Ethnic1": "Lao, Tai",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 71,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Nonghed, Xiengkhouang",
   "NAME_1": null,
   "Ethnic1": "Mong",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "55-60%",
   "Numerical": 60,
   "Ethnic2": "Khmuic, Tai",
   "SecRelig0": "Buddhism",
   "SecRelig": "Buddhists(Theravada)",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 72,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Outhoomphone, Savannakhet",
   "NAME_1": null,
   "Ethnic1": "Lao, Tai",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 73,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Pak Xeng, Louangphabang",
   "NAME_1": null,
   "Ethnic1": "Khmuic, Lao",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-95%",
   "Numerical": 95,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 74,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Pakbeng, Oudomxai",
   "NAME_1": null,
   "Ethnic1": "Khmuic, Lao",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-95%",
   "Numerical": 95,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 75,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Pakkading, Bolikhamxai",
   "NAME_1": null,
   "Ethnic1": "Tai",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-95%",
   "Numerical": 95,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 76,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Pakse, Champasack",
   "NAME_1": null,
   "Ethnic1": "Lao",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-95%",
   "Numerical": 95,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 77,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Paksxong, Champasack",
   "NAME_1": null,
   "Ethnic1": "Bahnaric Khmer, Lao",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-95%",
   "Numerical": 95,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 78,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Paktha, Bokeo",
   "NAME_1": null,
   "Ethnic1": "Khmuic, Tai, Lao",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": "Mong",
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 79,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Pakxane, Bolikhamxai",
   "NAME_1": null,
   "Ethnic1": "Tai",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 80,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Park Ou, Louangphabang",
   "NAME_1": null,
   "Ethnic1": "Khmuic, Lao, Tai",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 81,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Parklai, Xaignabouly",
   "NAME_1": null,
   "Ethnic1": "Lao",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-95%",
   "Numerical": 95,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 82,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Pathoomphone, Champasack",
   "NAME_1": null,
   "Ethnic1": "Lao",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 83,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Pek, Xiengkhouang",
   "NAME_1": null,
   "Ethnic1": "Tai",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 84,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Pha Oudom, Bokeo",
   "NAME_1": null,
   "Ethnic1": "Khmuic, Lao, Tai",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 85,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Phalanxay, Savannakhet",
   "NAME_1": null,
   "Ethnic1": "Kautic",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": "Lao, Tai",
   "SecRelig0": "Buddhism",
   "SecRelig": "Buddhists(Theravada)",
   "SReligCatp": "45-50%",
   "Nummeric_1": 50,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 86,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Phaxay, Xiengkhouang",
   "NAME_1": null,
   "Ethnic1": "Tai, Khmuic",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "70-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 87,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Phiang, Xaignabouly",
   "NAME_1": null,
   "Ethnic1": "Lao, Khmuic, Tai",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 88,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Phine, Savannakhet",
   "NAME_1": null,
   "Ethnic1": "Kautic",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "70-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 89,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Phongsaly, Phongsaly",
   "NAME_1": null,
   "Ethnic1": "Tibeto-Burman",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 90,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Phonhong, Vientiane",
   "NAME_1": null,
   "Ethnic1": "Tai, Khmuic",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 91,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Phonthong, Louangphabang",
   "NAME_1": null,
   "Ethnic1": "Khmuic, Tai",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": "Mong",
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 92,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Phonthong, Champasack",
   "NAME_1": null,
   "Ethnic1": "Lao",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 93,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Phonxay, Louangphabang",
   "NAME_1": null,
   "Ethnic1": "Khmuic, Lao",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "70-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 94,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Phookood, Xiengkhouang",
   "NAME_1": null,
   "Ethnic1": "Tai, Khmuic",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 95,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Phoukhoune, Louangphabang",
   "NAME_1": null,
   "Ethnic1": "Khmuic",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 96,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Phouvong, Attapeu",
   "NAME_1": null,
   "Ethnic1": "Bahnaric Khmer",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 97,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Samakkhixay, Attapeu",
   "NAME_1": null,
   "Ethnic1": "Lao, Bahnaric Khmer",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 98,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Samphanh, Phongsaly",
   "NAME_1": null,
   "Ethnic1": "Tibeto-Burman",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": "Khmuic",
   "SecRelig0": "Buddhism",
   "SecRelig": "Buddhists(Theravada)",
   "SReligCatp": "35-40%",
   "Nummeric_1": 40,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 99,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Samuoi, Salavan",
   "NAME_1": null,
   "Ethnic1": "Kautic",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 100,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Sanamxay, Attapeu",
   "NAME_1": null,
   "Ethnic1": "Bahnaric Khmer, Lao",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 101,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Sanasomboon, Champasack",
   "NAME_1": null,
   "Ethnic1": "Lao",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-95%",
   "Numerical": 95,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 102,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Sangthong, Vientiane Capital",
   "NAME_1": null,
   "Ethnic1": "Lao, Khmuic",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 103,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Sanxay, Attapeu",
   "NAME_1": null,
   "Ethnic1": "Bahnaric Khmer",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 104,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Saravane, Salavan",
   "NAME_1": null,
   "Ethnic1": "Lao",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "55-60%",
   "Numerical": 60,
   "Ethnic2": "Kautic",
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "35-40%",
   "Nummeric_1": 40,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 105,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Sepone, Savannakhet",
   "NAME_1": null,
   "Ethnic1": "Kautic",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 106,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Sikhottabong, Vientiane Capital",
   "NAME_1": null,
   "Ethnic1": "Lao",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-95%",
   "Numerical": 95,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 107,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Sing, Louangnamtha",
   "NAME_1": null,
   "Ethnic1": "Tibeto-Burman",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "55-60%",
   "Numerical": 60,
   "Ethnic2": "Tai",
   "SecRelig0": "Buddhism",
   "SecRelig": "Buddhists(Theravada)",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 108,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Sisattanak, Vientiane Capital",
   "NAME_1": null,
   "Ethnic1": "Lao",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 109,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Songkhone, Savannakhet",
   "NAME_1": null,
   "Ethnic1": "Lao, Tai",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 110,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Sopbao, Houaphan",
   "NAME_1": null,
   "Ethnic1": "Tai, Khmuic",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": "Mong",
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "20-25%",
   "Nummeric_1": 25,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 111,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Sukhuma, Champasack",
   "NAME_1": null,
   "Ethnic1": "Lao",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 112,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Ta Oi, Salavan",
   "NAME_1": null,
   "Ethnic1": "Kautic",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 113,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Thakhek, Khammouan",
   "NAME_1": null,
   "Ethnic1": "Lao",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 114,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Thapangthong, Savannakhet",
   "NAME_1": null,
   "Ethnic1": "Kautic",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": "Lao",
   "SecRelig0": "Buddhism",
   "SecRelig": "Buddhists(Theravada)",
   "SReligCatp": "40-45%",
   "Nummeric_1": 45,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 115,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Thaphabath, Bolikhamxai",
   "NAME_1": null,
   "Ethnic1": "Tai",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-95%",
   "Numerical": 95,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 116,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Thateng, Sekong",
   "NAME_1": null,
   "Ethnic1": "Kautic",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": "Bahnaric Khmer, Lao",
   "SecRelig0": "Buddhism",
   "SecRelig": "Buddhists(Theravada)",
   "SReligCatp": "45-50%",
   "Nummeric_1": 50,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 117,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Thathom, Xaisomboon",
   "NAME_1": null,
   "Ethnic1": "Lao, Khmuic, Tai",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 118,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Thongmyxay, Xaignabouly",
   "NAME_1": null,
   "Ethnic1": "Lao",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 119,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Thoulakhom, Vientiane",
   "NAME_1": null,
   "Ethnic1": "Tai",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 120,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Tonpheung, Bokeo",
   "NAME_1": null,
   "Ethnic1": "Tai, Khmuic, Lao",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "55-60%",
   "Numerical": 60,
   "Ethnic2": "Tibeto-Burman",
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "20-25%",
   "Nummeric_1": 25,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 121,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Toomlarn, Salavan",
   "NAME_1": null,
   "Ethnic1": "Kautic",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "90-95%",
   "Numerical": 95,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 122,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Vangvieng, Vientiane",
   "NAME_1": null,
   "Ethnic1": "Tai, Khmuic",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 123,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Vapy, Salavan",
   "NAME_1": null,
   "Ethnic1": "Lao",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-95%",
   "Numerical": 95,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 124,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Viengkham, Louangphabang",
   "NAME_1": null,
   "Ethnic1": "Khmuic, Lao",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 125,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Viengkham, Vientiane",
   "NAME_1": null,
   "Ethnic1": "Tai",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 126,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Viengphoukha, Louangnamtha",
   "NAME_1": null,
   "Ethnic1": "Khmuic, Tai",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": "Tibeto-Burman",
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "15-20%",
   "Nummeric_1": 20,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 127,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Viengthong, Bolikhamxai",
   "NAME_1": null,
   "Ethnic1": "Mong",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "40-45%",
   "Numerical": 45,
   "Ethnic2": "Tai",
   "SecRelig0": "Buddhism",
   "SecRelig": "Buddhists(Theravada)",
   "SReligCatp": "35-40%",
   "Nummeric_1": 40,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 128,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Viengxay, Houaphan",
   "NAME_1": null,
   "Ethnic1": "Tai, Khmuic",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 129,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Vilabuly, Savannakhet",
   "NAME_1": null,
   "Ethnic1": "Tai",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": "Kautic",
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 130,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Xamneua, Houaphan",
   "NAME_1": null,
   "Ethnic1": "Tai, Khmuic",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "65-70%",
   "Numerical": 70,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 131,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Xamtay, Houaphan",
   "NAME_1": null,
   "Ethnic1": "Tai",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "55-60%",
   "Numerical": 60,
   "Ethnic2": "Mong",
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "35-40%",
   "Nummeric_1": 40,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 132,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Xanakharm, Vientiane",
   "NAME_1": null,
   "Ethnic1": "Tai, Khmuic",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-95%",
   "Numerical": 95,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 133,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Xay, Oudomxai",
   "NAME_1": null,
   "Ethnic1": "Khmuic, Tai, Lao",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 134,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Xayabury, Xaignabouly",
   "NAME_1": null,
   "Ethnic1": "Lao, Khmuic",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 135,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Xaybuathong, Khammouan",
   "NAME_1": null,
   "Ethnic1": "Tai, Lao",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 136,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Xaybuly, Savannakhet",
   "NAME_1": null,
   "Ethnic1": "Lao, Tai",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 137,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Xaychamphone, Bolikhamxai",
   "NAME_1": null,
   "Ethnic1": "Vietic",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": "Mong",
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 138,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Xayphoothong, Savannakhet",
   "NAME_1": null,
   "Ethnic1": "Lao",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-95%",
   "Numerical": 95,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 139,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Xaysathan, Xaignabouly",
   "NAME_1": null,
   "Ethnic1": "Khmuic",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-95%",
   "Numerical": 95,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 140,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Xaysetha, Vientiane Capital",
   "NAME_1": null,
   "Ethnic1": "Lao",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "90-95%",
   "Numerical": 95,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 141,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Xaysetha, Attapeu",
   "NAME_1": null,
   "Ethnic1": "Lao, Bahnaric Khmer",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 142,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Xaythany, Vientiane Capital",
   "NAME_1": null,
   "Ethnic1": "Lao",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 143,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Xebangfay, Khammouan",
   "NAME_1": null,
   "Ethnic1": "Lao, Tai",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "70-75%",
   "Numerical": 75,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 144,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Xieng Ngeun, Louangphabang",
   "NAME_1": null,
   "Ethnic1": "Khmuic, Lao",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 145,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Xienghone, Xaignabouly",
   "NAME_1": null,
   "Ethnic1": "Tai, Khmuic",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 146,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Xiengkhor, Houaphan",
   "NAME_1": null,
   "Ethnic1": "Tai, Khmuic",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 147,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Xon, Houaphan",
   "NAME_1": null,
   "Ethnic1": "Tai, Khmuic",
   "HighRelig0": "Buddhism",
   "HighRelig": "Buddhists(Theravada)",
   "ReligCatP": "55-60%",
   "Numerical": 60,
   "Ethnic2": "Mong",
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 148,
   "Continent": "Asia",
   "Country": "Laos",
   "ProvName": "Xonbuly, Savannakhet",
   "NAME_1": null,
   "Ethnic1": "Kautic",
   "HighRelig0": "Ethnic and other religionists",
   "HighRelig": "Ethnic and other religionists",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": "Lao",
   "SecRelig0": "Buddhism",
   "SecRelig": "Buddhists(Theravada)",
   "SReligCatp": "45-50%",
   "Nummeric_1": 50,
   "DataSource": "Laos Government (2015) Socio-Economic Atlas of the Lao PDR. Patterns and trends from 2005 to 2015",
   "Year": 2015
  },
  {
   "OBJECTID": 149,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Soc Trang",
   "NAME_1": null,
   "Ethnic1": "Kinh",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": "Khmuic",
   "SecRelig0": "Buddhism",
   "SecRelig": "Buddhists(Theravada)",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 150,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Tra Vinh",
   "NAME_1": null,
   "Ethnic1": "Kinh",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": "Khmuic",
   "SecRelig0": "Buddhism",
   "SecRelig": "Buddhists(Theravada)",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 151,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Vinh Long",
   "NAME_1": null,
   "Ethnic1": "Kinh",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 152,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Ha Noi",
   "NAME_1": null,
   "Ethnic1": "Kinh",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "90-95%",
   "Numerical": 95,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 153,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Bac Ninh",
   "NAME_1": null,
   "Ethnic1": "Kinh",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 154,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Vinh Phuc",
   "NAME_1": null,
   "Ethnic1": "Kinh",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 155,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Nam Dinh",
   "NAME_1": null,
   "Ethnic1": "Kinh",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 156,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Phu Tho",
   "NAME_1": null,
   "Ethnic1": "Kinh",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 157,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Bac Giang",
   "NAME_1": null,
   "Ethnic1": "Kinh",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 158,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Ben Tre",
   "NAME_1": null,
   "Ethnic1": "Kinh",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 159,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Tay Ninh",
   "NAME_1": null,
   "Ethnic1": "Kinh",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 160,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Thai Nguyen",
   "NAME_1": null,
   "Ethnic1": "King",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "90-95%",
   "Numerical": 95,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 161,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Hoa Binh",
   "NAME_1": null,
   "Ethnic1": "Muong",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": "Kinh",
   "SecRelig0": "East Asian Religiosity",
   "SecRelig": "East Asian Religiosity",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 162,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Hau Giang",
   "NAME_1": null,
   "Ethnic1": "Kinh",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 163,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Can Tho",
   "NAME_1": null,
   "Ethnic1": "Kinh",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 164,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Hai Duong",
   "NAME_1": null,
   "Ethnic1": "Kinh",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 165,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Hung Yen",
   "NAME_1": null,
   "Ethnic1": "Kinh",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 166,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Bac Kan",
   "NAME_1": null,
   "Ethnic1": "Kinh",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 167,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Lang Son",
   "NAME_1": null,
   "Ethnic1": "Tay, Kinh",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "50-55%",
   "Numerical": 55,
   "Ethnic2": "Nung",
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "40-45%",
   "Nummeric_1": 45,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 168,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Son La",
   "NAME_1": null,
   "Ethnic1": "Thai, Kinh",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 169,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Thanh Hoa",
   "NAME_1": null,
   "Ethnic1": "Kinh",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 170,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Tuyen Quang",
   "NAME_1": null,
   "Ethnic1": "Kinh, Tay",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 171,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Yen Bai",
   "NAME_1": null,
   "Ethnic1": "Kinh, Tay",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "85-90%",
   "Numerical": 90,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 172,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Thai Binh",
   "NAME_1": null,
   "Ethnic1": "Kinh",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 173,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Da Nang",
   "NAME_1": null,
   "Ethnic1": "Kinh",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 174,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Ninh Binh",
   "NAME_1": null,
   "Ethnic1": "Kinh",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 175,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Ha Nam",
   "NAME_1": null,
   "Ethnic1": "Kinh",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 176,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Ha Tinh",
   "NAME_1": null,
   "Ethnic1": "Kinh",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 177,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Nghe An",
   "NAME_1": null,
   "Ethnic1": "Kinh",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 178,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Quang Binh",
   "NAME_1": null,
   "Ethnic1": "Kinh",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 179,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Gia Lai",
   "NAME_1": null,
   "Ethnic1": "Kinh",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 180,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Phu Yen",
   "NAME_1": null,
   "Ethnic1": "Kinh",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 181,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Khanh Hoa",
   "NAME_1": null,
   "Ethnic1": "Kinh",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 182,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Quang Ninh",
   "NAME_1": null,
   "Ethnic1": "Kinh",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 183,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Binh Duong",
   "NAME_1": null,
   "Ethnic1": "Kinh",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 184,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Lam Dong",
   "NAME_1": null,
   "Ethnic1": "Kinh",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 185,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Ninh Thuan",
   "NAME_1": null,
   "Ethnic1": "Kinh",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 186,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "An Giang",
   "NAME_1": null,
   "Ethnic1": "Kinh",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 187,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Binh Phuoc",
   "NAME_1": null,
   "Ethnic1": "Kinh",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 188,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Binh Dinh",
   "NAME_1": null,
   "Ethnic1": "Kinh",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 189,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Kon Tum",
   "NAME_1": null,
   "Ethnic1": "Kinh",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 190,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Quang Nam",
   "NAME_1": null,
   "Ethnic1": "Kinh",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 191,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Quang Ngai",
   "NAME_1": null,
   "Ethnic1": "Kinh",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 192,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Quang Tri",
   "NAME_1": null,
   "Ethnic1": "Kinh",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 193,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Thua Thien Hue",
   "NAME_1": null,
   "Ethnic1": "Kinh",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 194,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Ba Ria-Vung Tau",
   "NAME_1": null,
   "Ethnic1": "Kinh",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 195,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Dong Thap",
   "NAME_1": null,
   "Ethnic1": "Kinh",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 196,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Binh Thuan",
   "NAME_1": null,
   "Ethnic1": "Kinh",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 197,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Dong Nai",
   "NAME_1": null,
   "Ethnic1": "Kinh",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 198,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Ho Chi Minh City",
   "NAME_1": null,
   "Ethnic1": "Kinh",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 199,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Kien Giang",
   "NAME_1": null,
   "Ethnic1": "Kinh",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "80-85%",
   "Numerical": 85,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 200,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Long An",
   "NAME_1": null,
   "Ethnic1": "Kinh",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 201,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Bac Lieu",
   "NAME_1": null,
   "Ethnic1": "Kinh",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 202,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Ca Mau",
   "NAME_1": null,
   "Ethnic1": "Kinh",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 203,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Hai Phong",
   "NAME_1": null,
   "Ethnic1": "Kinh",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 204,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Cao Bang",
   "NAME_1": null,
   "Ethnic1": "Kinh, Tay",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": "Nung",
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "25-30%",
   "Nummeric_1": 30,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 205,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Ha Giang",
   "NAME_1": null,
   "Ethnic1": "Kinh, Tay",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": "Mong",
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 206,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Tien Giang",
   "NAME_1": null,
   "Ethnic1": "Kinh",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 207,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Dien Bien",
   "NAME_1": null,
   "Ethnic1": "Thai, Kinh",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "60-65%",
   "Numerical": 65,
   "Ethnic2": "Mong",
   "SecRelig0": "Ethnic and other religionists",
   "SecRelig": "Ethnic and other religionists",
   "SReligCatp": "30-35%",
   "Nummeric_1": 35,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 208,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Lai Chau",
   "NAME_1": null,
   "Ethnic1": "Kinh, Thai",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 209,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Lao Cai",
   "NAME_1": null,
   "Ethnic1": "Kinh, Tay",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "75-80%",
   "Numerical": 80,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 210,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Dak Lak",
   "NAME_1": null,
   "Ethnic1": "Kinh",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 211,
   "Continent": "Asia",
   "Country": "Vietnam",
   "ProvName": "Dak Nong",
   "NAME_1": null,
   "Ethnic1": "Kinh",
   "HighRelig0": "East Asian Religiosity",
   "HighRelig": "East Asian Religiosity",
   "ReligCatP": "95-99%",
   "Numerical": 99,
   "Ethnic2": null,
   "SecRelig0": null,
   "SecRelig": null,
   "SReligCatp": null,
   "Nummeric_1": 0,
   "DataSource": "Committee for Ethnic Minority Affairs, Vietnam Government (2015). https:\/\/data.opendevelopmentmekong.net\/dataset\/population-and-distribution-of-ethnic-minorities-in-vietnam",
   "Year": 2015
  },
  {
   "OBJECTID": 2164,
   "Continent": "Asia",
   "Country": "India*",
   "ProvName": "Ladakh",
   "NAME_1": null,
   "Ethnic1": null,
   "HighRelig0": "Islam",
   "HighRelig": "Muslims(Sunni)",
   "ReligCatP": "45-50%",
   "Numerical": 50,
   "Ethnic2": null,
   "SecRelig0": "Buddhism",
   "SecRelig": "Buddhists(Tibetan Buddhism)",
   "SReligCatp": "40-45%",
   "Nummeric_1": 45,
   "DataSource": "C-1 Population By Religious Community – Jammu & Kashmir (Report). Office of the Registrar General & Census Commissioner, India. Retrieved 28 July 2020.",
   "Year": 2011
  }
 ]

 export default religious_data;